
/* ══════════ components/tokens.jsx ══════════ */
var T = {
  // Palette (mirror styles.css for JS-side use)
  bg0: "#0A0D12",
  bg1: "#111620",
  bg2: "#1A2130",
  bg3: "#232C3D",
  bg4: "#2D384E",
  border: "#2A3446",
  borderStrong: "#3A465E",
  text0: "#F4F6FB",
  text1: "#B4BECF",
  text2: "#7A8699",
  text3: "#4E5A70",
  accent: "#1A5CE6",
  accentHover: "#3B76F0",
  accentTint: "rgba(26,92,230,0.14)",
  green: "#22C55E",
  greenTint: "rgba(34,197,94,0.16)",
  yellow: "#F5A524",
  yellowTint: "rgba(245,165,36,0.16)",
  // Orange sits between yellow-reserved and red-overdue — used for
  // no-show state on the calendar and dashboard.
  orange: "#F97316",
  orangeTint: "rgba(249,115,22,0.18)",
  red: "#EF4444",
  redTint: "rgba(239,68,68,0.16)",
  blue: "#3B76F0",
  blueTint: "rgba(59,118,240,0.16)",
  gray: "#7A8699",
  grayTint: "rgba(122,134,153,0.16)",
  // Kiosk (customer-facing light theme)
  kioskBg: "#F7F6F2",
  kioskInk: "#0F1420",
  kioskInkSoft: "#4A5262",
  kioskBorder: "#D8D3C7",
  kioskAccent: "#1A5CE6",
  kioskWarn: "#B8860B"
};
function fmtEuro(n, { showSymbol = true, dp = 2 } = {}) {
  if (n == null || Number.isNaN(n)) return showSymbol ? "\u2014 \u20AC" : "\u2014";
  const neg = n < 0;
  const abs = Math.abs(n);
  const [intPart, decPart] = abs.toFixed(dp).split(".");
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, "\u202F");
  const s = grouped + (dp > 0 ? "," + decPart : "");
  return (neg ? "\u2212" : "") + s + (showSymbol ? "\xA0\u20AC" : "");
}
function fmtKm(n) {
  if (n == null) return "\u2014";
  return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "\u202F") + "\xA0\u043A\u043C";
}
function fmtDateBG(d2, { withYear = true, withYearSuffix = false } = {}) {
  if (!(d2 instanceof Date)) d2 = new Date(d2);
  const day = String(d2.getDate()).padStart(2, "0");
  const mo = String(d2.getMonth() + 1).padStart(2, "0");
  const y = d2.getFullYear();
  let s = `${day}.${mo}`;
  if (withYear) s += `.${y}`;
  if (withYearSuffix) s += " \u0433.";
  return s;
}
function fmtDateShort(d2) {
  if (!(d2 instanceof Date)) d2 = new Date(d2);
  return String(d2.getDate()).padStart(2, "0") + "." + String(d2.getMonth() + 1).padStart(2, "0");
}
function fmtTime(d2) {
  if (!(d2 instanceof Date)) d2 = new Date(d2);
  return String(d2.getHours()).padStart(2, "0") + ":" + String(d2.getMinutes()).padStart(2, "0");
}
function fmtDateTimeBG(d2) {
  if (!(d2 instanceof Date)) d2 = new Date(d2);
  return fmtDateBG(d2) + " " + fmtTime(d2);
}
function daysBetween(a, b) {
  if (!(a instanceof Date)) a = new Date(a);
  if (!(b instanceof Date)) b = new Date(b);
  const ms = b - a;
  return Math.max(1, Math.ceil(ms / (1e3 * 60 * 60 * 24)));
}
var TODAY = /* @__PURE__ */ new Date();
function d(offset, h = 10, m = 0) {
  const nd = new Date(TODAY);
  nd.setDate(nd.getDate() + offset);
  nd.setHours(h, m, 0, 0);
  return nd;
}
var VEHICLES = [
  {
    id: "v1",
    make: "Renault",
    model: "Express Cargo",
    plate: "CB 4821 KM",
    vin: "VF1FW000668XXXXXX",
    year: 2024,
    type: "cargo",
    seats: 2,
    drivetrain: "diesel",
    odo: 42815,
    status: "available",
    dailyRate: 45,
    weeklyRate: 280,
    monthlyRate: 950,
    kmPerDay: 200,
    extraKmPrice: 0.18,
    fuelPerPercent: 0.65,
    color: "\u0431\u044F\u043B",
    notes: "\u0421\u0442\u043E\u0439\u043A\u0430 \u0437\u0430 \u0442\u0435\u043B\u0435\u0444\u043E\u043D, GPS.",
    docs: { insurance: "2027-04-12", casco: "2027-04-12", gtp: "2026-09-20", vignette: "2026-12-31", tax: "2026-04-01" },
    oil: { dueDate: "2026-11-01", dueKm: 6e4 }
  },
  {
    id: "v2",
    make: "Dacia",
    model: "Dokker",
    plate: "CB 7743 MN",
    vin: "UU16SDA6564XXXXXX",
    year: 2023,
    type: "cargo",
    seats: 2,
    drivetrain: "diesel",
    odo: 78290,
    status: "rented",
    dailyRate: 40,
    weeklyRate: 245,
    monthlyRate: 820,
    kmPerDay: 200,
    extraKmPrice: 0.16,
    fuelPerPercent: 0.55,
    color: "\u0431\u044F\u043B",
    docs: { insurance: "2026-07-30", casco: "2026-07-30", gtp: "2026-08-05", vignette: "2026-12-31", tax: "2026-04-01" },
    oil: { dueDate: "2026-08-15", dueKm: 82e3 }
  },
  {
    id: "v3",
    make: "Citro\xEBn",
    model: "Berlingo Van",
    plate: "CB 9012 PT",
    vin: "VF7ESKFVC12XXXXXX",
    year: 2024,
    type: "cargo",
    seats: 2,
    drivetrain: "diesel",
    odo: 31450,
    status: "available",
    dailyRate: 48,
    weeklyRate: 295,
    monthlyRate: 990,
    kmPerDay: 200,
    extraKmPrice: 0.18,
    fuelPerPercent: 0.68,
    color: "\u0431\u044F\u043B",
    docs: { insurance: "2027-01-10", casco: "2027-01-10", gtp: "2027-01-10", vignette: "2026-12-31", tax: "2026-04-01" },
    oil: { dueDate: "2027-01-01", dueKm: 45e3 }
  },
  {
    id: "v4",
    make: "Renault",
    model: "Kangoo E-Tech",
    plate: "CB 5567 KE",
    vin: "VF1FW00E668XXXXXX",
    year: 2025,
    type: "cargo",
    seats: 2,
    drivetrain: "electric",
    odo: 8420,
    status: "available",
    dailyRate: 55,
    weeklyRate: 340,
    monthlyRate: 1150,
    kmPerDay: 180,
    extraKmPrice: 0.2,
    fuelPerPercent: 0.4,
    color: "\u0431\u044F\u043B",
    docs: { insurance: "2027-06-01", casco: "2027-06-01", gtp: "2027-06-01", vignette: "2026-12-31", tax: "2026-04-01" },
    oil: { dueDate: null, dueKm: null }
  },
  {
    id: "v5",
    make: "Ford",
    model: "Transit Custom",
    plate: "CB 3388 TC",
    vin: "WF0XXXTTGXXXXXX",
    year: 2022,
    type: "minibus",
    seats: 8,
    drivetrain: "diesel",
    odo: 121430,
    status: "in_service",
    dailyRate: 75,
    weeklyRate: 460,
    monthlyRate: 1550,
    kmPerDay: 250,
    extraKmPrice: 0.22,
    fuelPerPercent: 0.85,
    color: "\u0431\u044F\u043B",
    docs: { insurance: "2026-07-20", casco: "2026-07-20", gtp: "2026-07-18", vignette: "2026-12-31", tax: "2026-04-01" },
    oil: { dueDate: "2026-07-15", dueKm: 122e3 },
    serviceNote: "\u0421\u043C\u044F\u043D\u0430 \u043D\u0430 \u043C\u0430\u0441\u043B\u043E + \u0444\u0438\u043B\u0442\u0440\u0438"
  },
  {
    id: "v6",
    make: "Peugeot",
    model: "Partner",
    plate: "CB 6109 PA",
    vin: "VF3XXXXXXXXXXXXX",
    year: 2023,
    type: "cargo",
    seats: 2,
    drivetrain: "diesel",
    odo: 58720,
    status: "cleaning",
    dailyRate: 42,
    weeklyRate: 260,
    monthlyRate: 870,
    kmPerDay: 200,
    extraKmPrice: 0.16,
    fuelPerPercent: 0.6,
    color: "\u0431\u044F\u043B",
    docs: { insurance: "2026-11-15", casco: "2026-11-15", gtp: "2026-11-15", vignette: "2026-12-31", tax: "2026-04-01" },
    oil: { dueDate: "2026-10-01", dueKm: 65e3 }
  }
];
var CUSTOMERS = [
  {
    id: "c1",
    name: "\u0418\u0432\u0430\u043D \u041F\u0435\u0442\u0440\u043E\u0432 \u0421\u0442\u043E\u044F\u043D\u043E\u0432",
    egn: "8503124568",
    phone: "+359 88 412 7734",
    email: "i.petrov@gmail.com",
    address: "\u0433\u0440. \u0421\u043E\u0444\u0438\u044F, \u0436.\u043A. \u041B\u044E\u043B\u0438\u043D 4, \u0431\u043B. 412, \u0432\u0445. \u0411, \u0430\u043F. 23",
    idCard: { number: "641852374", issue: "2019-04-15", expiry: "2029-04-15", authority: "\u041C\u0412\u0420 \u0421\u043E\u0444\u0438\u044F" },
    driverLicense: { number: "284561930", categories: "B, B1, AM", expiry: "2030-05-10" },
    blacklisted: false,
    rentalsCount: 6,
    lastRental: "2026-05-14",
    docsOnFile: 12
  },
  {
    id: "c2",
    name: "\u041C\u0430\u0440\u0438\u044F \u0413\u0435\u043E\u0440\u0433\u0438\u0435\u0432\u0430 \u0418\u0432\u0430\u043D\u043E\u0432\u0430",
    egn: "9107245912",
    phone: "+359 87 233 5580",
    email: "maria.g@abv.bg",
    address: "\u0433\u0440. \u0421\u043E\u0444\u0438\u044F, \u0443\u043B. \u0413\u0440\u0430\u0444 \u0418\u0433\u043D\u0430\u0442\u0438\u0435\u0432 34, \u0435\u0442. 3",
    idCard: { number: "712334581", issue: "2021-07-24", expiry: "2031-07-24", authority: "\u041C\u0412\u0420 \u0421\u043E\u0444\u0438\u044F" },
    driverLicense: { number: "331298475", categories: "B, B1", expiry: "2029-03-20" },
    blacklisted: false,
    rentalsCount: 3,
    lastRental: "2026-06-02",
    docsOnFile: 6
  },
  {
    id: "c3",
    name: "\u0421\u0442\u043E\u044F\u043D \u0414\u0438\u043C\u0438\u0442\u0440\u043E\u0432 \u041F\u0435\u0442\u0440\u043E\u0432",
    egn: "7809034421",
    phone: "+359 89 118 4432",
    email: "stoyandim@mail.bg",
    address: "\u0433\u0440. \u041F\u043B\u043E\u0432\u0434\u0438\u0432, \u0443\u043B. \u041A\u0438\u0447\u0435\u0432\u043E 12",
    idCard: { number: "512889040", issue: "2015-09-03", expiry: "2025-09-03", authority: "\u041C\u0412\u0420 \u041F\u043B\u043E\u0432\u0434\u0438\u0432" },
    // EXPIRED
    driverLicense: { number: "198443221", categories: "B, C1", expiry: "2028-01-15" },
    blacklisted: false,
    rentalsCount: 11,
    lastRental: "2026-04-22",
    docsOnFile: 22,
    warnings: ["\u041B\u041A \u0438\u0437\u0442\u0435\u043A\u043B\u0430"]
  },
  {
    id: "c4",
    name: "\u041D\u0438\u043A\u043E\u043B\u0430\u0439 \u0418\u0432\u0430\u043D\u043E\u0432 \u0425\u0440\u0438\u0441\u0442\u043E\u0432",
    egn: "9503189907",
    phone: "+359 88 992 1123",
    email: "nikolayh@gmail.com",
    address: "\u0433\u0440. \u0412\u0430\u0440\u043D\u0430, \u0431\u0443\u043B. \u0412\u043B\u0430\u0434\u0438\u0441\u043B\u0430\u0432 \u0412\u0430\u0440\u043D\u0435\u043D\u0447\u0438\u043A 45",
    idCard: { number: "821445678", issue: "2020-03-18", expiry: "2030-03-18", authority: "\u041C\u0412\u0420 \u0412\u0430\u0440\u043D\u0430" },
    driverLicense: { number: "445127789", categories: "B", expiry: "2026-08-01" },
    // expiring soon
    blacklisted: false,
    rentalsCount: 2,
    lastRental: "2026-03-11",
    docsOnFile: 4,
    warnings: ["\u0421\u0423\u041C\u041F\u0421 \u0438\u0437\u0442\u0438\u0447\u0430 \u0434\u043E 30 \u0434\u043D\u0438"]
  },
  {
    id: "c5",
    name: "\u0413\u0435\u043E\u0440\u0433\u0438 \u0422\u043E\u0434\u043E\u0440\u043E\u0432 \u0410\u043D\u0433\u0435\u043B\u043E\u0432",
    egn: "8203176623",
    phone: "+359 89 445 2201",
    email: "\u2014",
    address: "\u0433\u0440. \u0421\u043E\u0444\u0438\u044F",
    idCard: { number: "451223890", issue: "2018-02-01", expiry: "2028-02-01", authority: "\u041C\u0412\u0420 \u0421\u043E\u0444\u0438\u044F" },
    driverLicense: { number: "112345667", categories: "B", expiry: "2027-10-05" },
    blacklisted: true,
    blacklistReason: "\u0412\u044A\u0440\u043D\u0430\u0442 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B \u0441 \u0449\u0435\u0442\u0430 \u043F\u043E \u043F\u0440\u0435\u0434\u043D\u0430 \u0434\u044F\u0441\u043D\u0430 \u0432\u0440\u0430\u0442\u0430, \u043E\u0442\u043A\u0430\u0437 \u0437\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435. 12.11.2025.",
    rentalsCount: 1,
    lastRental: "2025-11-10",
    docsOnFile: 2
  },
  {
    id: "c6",
    name: "\u0415\u043B\u0435\u043D\u0430 \u0421\u0442\u0435\u0444\u0430\u043D\u043E\u0432\u0430 \u041D\u0438\u043A\u043E\u043B\u043E\u0432\u0430",
    egn: "9312058844",
    phone: "+359 88 771 9903",
    email: "elena.n@outlook.com",
    address: "\u0433\u0440. \u0411\u0443\u0440\u0433\u0430\u0441, \u0443\u043B. \u0410\u043B\u0435\u043A\u0441\u0430\u043D\u0434\u0440\u043E\u0432\u0441\u043A\u0430 118",
    idCard: { number: "733984123", issue: "2022-05-30", expiry: "2032-05-30", authority: "\u041C\u0412\u0420 \u0411\u0443\u0440\u0433\u0430\u0441" },
    driverLicense: { number: "567234891", categories: "B, B1", expiry: "2031-04-12" },
    blacklisted: false,
    rentalsCount: 4,
    lastRental: "2026-06-20",
    docsOnFile: 8
  },
  {
    id: "c7",
    name: "\u0414\u0438\u043C\u0438\u0442\u044A\u0440 \u0410\u043B\u0435\u043A\u0441\u0430\u043D\u0434\u0440\u043E\u0432 \u041A\u043E\u0441\u0442\u043E\u0432",
    egn: "8801237712",
    phone: "+359 87 664 1188",
    email: "dkostov@yahoo.com",
    address: "\u0433\u0440. \u0421\u043E\u0444\u0438\u044F, \u0436.\u043A. \u041C\u043B\u0430\u0434\u043E\u0441\u0442 1, \u0431\u043B. 45",
    idCard: { number: "651882347", issue: "2019-11-08", expiry: "2029-11-08", authority: "\u041C\u0412\u0420 \u0421\u043E\u0444\u0438\u044F" },
    driverLicense: { number: "289776541", categories: "B, C, CE", expiry: "2029-02-28" },
    blacklisted: false,
    rentalsCount: 8,
    lastRental: "2026-06-28",
    docsOnFile: 16
  }
];
var RENTALS = [
  {
    id: "r1",
    customerId: "c1",
    vehicleId: "v1",
    start: d(0, 10, 0),
    end: d(3, 18, 0),
    status: "reserved",
    dailyRate: 45,
    total: 45 * 3,
    deposit: 200,
    kmPerDay: 200,
    extraKmPrice: 0.18,
    contractNo: "148/2026"
  },
  {
    id: "r2",
    customerId: "c2",
    vehicleId: "v2",
    start: d(-2, 9, 0),
    end: d(1, 12, 0),
    status: "active",
    dailyRate: 40,
    total: 40 * 3,
    deposit: 150,
    kmPerDay: 200,
    extraKmPrice: 0.16,
    contractNo: "145/2026",
    handoverOdo: 78290,
    handoverFuel: 90
  },
  {
    id: "r3",
    customerId: "c7",
    vehicleId: "v3",
    start: d(-1, 14, 0),
    end: d(0, 17, 0),
    status: "overdue",
    dailyRate: 48,
    total: 48 * 1,
    deposit: 200,
    kmPerDay: 200,
    extraKmPrice: 0.18,
    contractNo: "147/2026",
    handoverOdo: 31450,
    handoverFuel: 100
  },
  {
    id: "r4",
    customerId: "c4",
    vehicleId: "v4",
    start: d(1, 9, 0),
    end: d(5, 18, 0),
    status: "reserved",
    dailyRate: 55,
    total: 55 * 4,
    deposit: 250,
    kmPerDay: 180,
    extraKmPrice: 0.2,
    contractNo: "149/2026"
  },
  {
    id: "r5",
    customerId: "c6",
    vehicleId: "v6",
    start: d(2, 10, 0),
    end: d(4, 17, 0),
    status: "reserved",
    dailyRate: 42,
    total: 42 * 2,
    deposit: 180,
    kmPerDay: 200,
    extraKmPrice: 0.16,
    contractNo: "150/2026"
  },
  {
    id: "r6",
    customerId: "c1",
    vehicleId: "v1",
    start: d(-14, 10, 0),
    end: d(-10, 18, 0),
    status: "completed",
    dailyRate: 45,
    total: 45 * 4,
    deposit: 200,
    kmPerDay: 200,
    extraKmPrice: 0.18,
    contractNo: "132/2026",
    handoverOdo: 41120,
    handoverFuel: 100,
    returnOdo: 41850,
    returnFuel: 85
  },
  {
    id: "r7",
    customerId: "c2",
    vehicleId: "v3",
    start: d(-9, 8, 0),
    end: d(-7, 17, 0),
    status: "completed",
    dailyRate: 48,
    total: 48 * 2,
    deposit: 200,
    kmPerDay: 200,
    extraKmPrice: 0.18,
    contractNo: "136/2026"
  },
  {
    id: "r8",
    customerId: "c7",
    vehicleId: "v2",
    start: d(6, 9, 0),
    end: d(9, 12, 0),
    status: "reserved",
    dailyRate: 40,
    total: 40 * 3,
    deposit: 150,
    kmPerDay: 200,
    extraKmPrice: 0.16,
    contractNo: "151/2026"
  },
  {
    id: "r9",
    customerId: "c6",
    vehicleId: "v1",
    start: d(8, 14, 0),
    end: d(11, 17, 0),
    status: "reserved",
    dailyRate: 45,
    total: 45 * 3,
    deposit: 200,
    kmPerDay: 200,
    extraKmPrice: 0.18,
    contractNo: "152/2026"
  },
  {
    id: "r10",
    customerId: "c4",
    vehicleId: "v3",
    start: d(11, 10, 0),
    end: d(14, 18, 0),
    status: "reserved",
    dailyRate: 48,
    total: 48 * 3,
    deposit: 200,
    kmPerDay: 200,
    extraKmPrice: 0.18,
    contractNo: "153/2026"
  }
];
var PAYMENTS = [
  { id: "p1", rentalId: "r2", amount: 120, date: d(-2, 9, 30), method: "cash", purpose: "rent" },
  { id: "p2", rentalId: "r2", amount: 150, date: d(-2, 9, 30), method: "cash", purpose: "deposit" },
  { id: "p3", rentalId: "r6", amount: 180, date: d(-14, 10, 15), method: "bank", purpose: "rent" },
  { id: "p4", rentalId: "r6", amount: 200, date: d(-14, 10, 15), method: "cash", purpose: "deposit" },
  { id: "p5", rentalId: "r6", amount: -200, date: d(-10, 18, 30), method: "cash", purpose: "deposit-return" },
  { id: "p6", rentalId: "r6", amount: 8.1, date: d(-10, 18, 15), method: "cash", purpose: "extra-km" },
  { id: "p7", rentalId: "r6", amount: 9.75, date: d(-10, 18, 15), method: "cash", purpose: "fuel" }
];
var LEADS = [
  { id: "l1", name: "\u041F\u0435\u0442\u044A\u0440 \u041D\u0438\u043A\u043E\u043B\u043E\u0432", phone: "+359 88 445 1123", period: "10.07 \u2013 14.07", vehicleType: "cargo", date: "2026-07-04", status: "waiting" },
  { id: "l2", name: "\u0412\u0435\u0441\u0435\u043B\u0438\u043D\u0430 \u041C\u0438\u0442\u043E\u0432\u0430", phone: "+359 87 991 2244", period: "15.07 \u2013 18.07", vehicleType: "minibus", date: "2026-07-03", status: "contacted" },
  { id: "l3", name: "\u041A\u0440\u0430\u0441\u0438\u043C\u0438\u0440 \u0422\u043E\u0434\u043E\u0440\u043E\u0432", phone: "+359 89 331 0087", period: "20.07 \u2013 22.07", vehicleType: "cargo", date: "2026-07-01", status: "voucher-issued" }
];
var COMPANY = {
  legal: '\u201E\u0413\u0415\u041D\u0423\u0421-2017" \u0415\u041E\u041E\u0414',
  brand: "banicharka.bg",
  address: "\u0433\u0440. \u0421\u043E\u0444\u0438\u044F, \u0443\u043B. \u041F\u0438\u0440\u043E\u0442\u0441\u043A\u0430 12, \u0435\u0442. 4",
  eik: "204812445",
  vatId: "BG204812445",
  phone: "+359 88 555 1122",
  email: "office@banicharka.bg",
  smtp: "mail.banicharka.bg:587",
  reviewLink: "https://g.page/r/banicharka-review"
};
var PLACEHOLDERS = [
  { key: "CUSTOMER_NAME", desc: "\u0418\u043C\u0435, \u043F\u0440\u0435\u0437\u0438\u043C\u0435 \u0438 \u0444\u0430\u043C\u0438\u043B\u0438\u044F \u043D\u0430 \u043D\u0430\u0435\u043C\u0430\u0442\u0435\u043B\u044F" },
  { key: "EGN", desc: "\u0415\u0413\u041D \u043D\u0430 \u043D\u0430\u0435\u043C\u0430\u0442\u0435\u043B\u044F" },
  { key: "ID_NUMBER", desc: "\u041D\u043E\u043C\u0435\u0440 \u043D\u0430 \u043B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430" },
  { key: "ID_VALID_UNTIL", desc: "\u0412\u0430\u043B\u0438\u0434\u043D\u043E\u0441\u0442 \u043D\u0430 \u043B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430 (\u0434\u0430\u0442\u0430)" },
  { key: "DL_NUMBER", desc: "\u041D\u043E\u043C\u0435\u0440 \u043D\u0430 \u0421\u0423\u041C\u041F\u0421" },
  { key: "DL_VALID_UNTIL", desc: "\u0412\u0430\u043B\u0438\u0434\u043D\u043E\u0441\u0442 \u043D\u0430 \u0421\u0423\u041C\u041F\u0421 (\u0434\u0430\u0442\u0430)" },
  { key: "CUSTOMER_ADDRESS", desc: "\u0410\u0434\u0440\u0435\u0441 \u043D\u0430 \u043D\u0430\u0435\u043C\u0430\u0442\u0435\u043B\u044F" },
  { key: "CUSTOMER_PHONE", desc: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D \u043D\u0430 \u043D\u0430\u0435\u043C\u0430\u0442\u0435\u043B\u044F" },
  { key: "VEHICLE_MAKE_MODEL", desc: "\u041C\u0430\u0440\u043A\u0430 \u0438 \u043C\u043E\u0434\u0435\u043B \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0430" },
  { key: "PLATE", desc: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440" },
  { key: "VIN", desc: "VIN \u043D\u043E\u043C\u0435\u0440 (\u0448\u0430\u0441\u0438)" },
  { key: "DATE_FROM", desc: "\u041D\u0430\u0447\u0430\u043B\u043D\u0430 \u0434\u0430\u0442\u0430 \u0438 \u0447\u0430\u0441 \u043D\u0430 \u043D\u0430\u0435\u043C\u0430" },
  { key: "DATE_TO", desc: "\u041A\u0440\u0430\u0439\u043D\u0430 \u0434\u0430\u0442\u0430 \u0438 \u0447\u0430\u0441 \u043D\u0430 \u043D\u0430\u0435\u043C\u0430" },
  { key: "DAILY_RATE", desc: "\u0414\u043D\u0435\u0432\u043D\u0430 \u0446\u0435\u043D\u0430 \u0432 \u20AC \u0441 \u0444\u043E\u0440\u043C\u0430\u0442 45,00" },
  { key: "TOTAL_PRICE", desc: "\u041E\u0431\u0449\u0430 \u0446\u0435\u043D\u0430 \u0432 \u20AC (\u0431\u0435\u0437 \u0434\u0435\u043F\u043E\u0437\u0438\u0442)" },
  { key: "DEPOSIT", desc: "\u0420\u0430\u0437\u043C\u0435\u0440 \u043D\u0430 \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u0430 \u0432 \u20AC" },
  { key: "KM_LIMIT_PER_DAY", desc: "\u0421\u0440\u0435\u0434\u0435\u043D \u0434\u043D\u0435\u0432\u0435\u043D \u043A\u0438\u043B\u043E\u043C\u0435\u0442\u0440\u0430\u0436 (\u043A\u043C)" },
  { key: "EXTRA_KM_PRICE", desc: "\u0426\u0435\u043D\u0430 \u0437\u0430 \u0434\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u0435\u043D \u043A\u043C \u0432 \u20AC" },
  { key: "FUEL_LEVEL", desc: "\u041D\u0438\u0432\u043E \u043D\u0430 \u0433\u043E\u0440\u0438\u0432\u043E/\u0431\u0430\u0442\u0435\u0440\u0438\u044F \u043F\u0440\u0438 \u043F\u0440\u0435\u0434\u0430\u0432\u0430\u043D\u0435 (%)" },
  { key: "ODOMETER", desc: "\u041A\u0438\u043B\u043E\u043C\u0435\u0442\u0440\u0430\u0436 \u043F\u0440\u0438 \u043F\u0440\u0435\u0434\u0430\u0432\u0430\u043D\u0435" },
  { key: "CONTRACT_NUMBER", desc: "\u041D\u043E\u043C\u0435\u0440 \u043D\u0430 \u0434\u043E\u0433\u043E\u0432\u043E\u0440, \u0444\u043E\u0440\u043C\u0430\u0442 NNN/YYYY" },
  { key: "DATE_TODAY", desc: "\u0414\u043D\u0435\u0448\u043D\u0430 \u0434\u0430\u0442\u0430" },
  { key: "OPERATOR_NAME", desc: "\u041F\u044A\u043B\u043D\u043E \u0438\u043C\u0435 \u043D\u0430 \u043D\u0430\u0435\u043C\u043E\u0434\u0430\u0442\u0435\u043B\u044F (\u043E\u0442 Settings \u2192 Operator profile)" }
];
function normalizeSearchable(s) {
  if (s == null) return "";
  return String(s).toLowerCase().replace(/[\s+\-().]/g, "");
}
function searchCustomer(c, rawQuery) {
  if (!rawQuery) return { hit: true, matched: null };
  const q = normalizeSearchable(rawQuery);
  if (!q) return { hit: true, matched: null };
  const fields = [
    { key: "name", value: c.name },
    { key: "egn", value: c.egn },
    { key: "phone", value: c.phone },
    { key: "email", value: c.email },
    { key: "id", value: c.idCard && c.idCard.number },
    { key: "dl", value: c.driverLicense && c.driverLicense.number },
    { key: "address", value: c.address }
  ];
  for (const f of fields) {
    const norm = normalizeSearchable(f.value);
    if (norm && norm.includes(q)) {
      return { hit: true, matched: f.key, value: f.value };
    }
  }
  return { hit: false };
}
var CUSTOMER_FIELD_LABELS = {
  name: null,
  // no label needed — the name is already the primary text
  egn: "\u0415\u0413\u041D",
  phone: "\u0422\u0435\u043B.",
  email: "Email",
  id: "\u041B\u041A",
  dl: "\u0421\u0423\u041C\u041F\u0421",
  address: "\u0410\u0434\u0440\u0435\u0441"
};
window.T = T;
window.normalizeSearchable = normalizeSearchable;
window.searchCustomer = searchCustomer;
window.CUSTOMER_FIELD_LABELS = CUSTOMER_FIELD_LABELS;
window.fmtEuro = fmtEuro;
window.fmtKm = fmtKm;
window.fmtDateBG = fmtDateBG;
window.fmtDateShort = fmtDateShort;
window.fmtTime = fmtTime;
window.fmtDateTimeBG = fmtDateTimeBG;
window.daysBetween = daysBetween;
window.TODAY = TODAY;
window.VEHICLES = VEHICLES;
window.CUSTOMERS = CUSTOMERS;
window.RENTALS = RENTALS;
window.PAYMENTS = PAYMENTS;
window.LEADS = LEADS;
window.COMPANY = COMPANY;
window.PLACEHOLDERS = PLACEHOLDERS;

/* ══════════ components/store.jsx ══════════ */
(() => {
  function resolveApiBase() {
    if (window.__API_BASE__) return window.__API_BASE__;
    const { hostname, protocol } = window.location;
    const sandboxMatch = hostname.match(/^\d+-(.+\.sandbox\.novita\.ai)$/);
    if (sandboxMatch) {
      return `${protocol}//8787-${sandboxMatch[1]}/api`;
    }
    return "http://localhost:8787/api";
  }
  const API_BASE = resolveApiBase();
  const listeners = /* @__PURE__ */ new Set();
  const emit = () => listeners.forEach((fn) => {
    try {
      fn();
    } catch (_) {
    }
  });
  async function apiFetch(path, { method = "GET", body } = {}) {
    const res = await fetch(API_BASE + path, {
      method,
      credentials: "include",
      headers: body !== void 0 ? { "Content-Type": "application/json" } : void 0,
      body: body !== void 0 ? JSON.stringify(body) : void 0
    });
    let data = null;
    const text = await res.text();
    if (text) {
      try {
        data = JSON.parse(text);
      } catch (_) {
        data = null;
      }
    }
    if (!res.ok) {
      const message = data && data.message || data && data.error || `Request failed (${res.status})`;
      const err = new Error(message);
      err.status = res.status;
      err.body = data;
      throw err;
    }
    return data;
  }
  function reportError(err, fallbackTitle) {
    console.error(err);
    logClientError({
      message: err && err.message || String(err),
      // VERBATIM server response body when this error came from
      // apiFetch's non-2xx path (err.body is the raw parsed JSON,
      // distinct from err.message which apiFetch already massaged
      // into a single display string) — stringified as-is, not
      // re-extracted/summarized, per the spec's "server response text
      // VERBATIM when applicable".
      serverText: err && err.body ? JSON.stringify(err.body) : null,
      context: fallbackTitle || null,
      severity: "error",
      stack: err && err.stack
    });
    if (window.toast && window.toast.error) {
      window.toast.error(
        err && err.message || String(err),
        { title: fallbackTitle || "\u0413\u0440\u0435\u0448\u043A\u0430", duration: 5e3 }
      );
    }
  }
  const ERROR_LOG_BUFFER_KEY = "bnc-error-log-buffer";
  const ERROR_LOG_BUFFER_MAX = 200;
  function readErrorBuffer() {
    try {
      const raw = localStorage.getItem(ERROR_LOG_BUFFER_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (_) {
      return [];
    }
  }
  function writeErrorBuffer(arr) {
    try {
      localStorage.setItem(ERROR_LOG_BUFFER_KEY, JSON.stringify(arr.slice(-ERROR_LOG_BUFFER_MAX)));
    } catch (_) {
    }
  }
  async function postErrorLogEntry(entry) {
    const res = await fetch(API_BASE + "/error-log", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(entry)
    });
    if (!res.ok) throw new Error("error-log POST failed: " + res.status);
  }
  let flushingErrorBuffer = false;
  async function flushErrorLogBuffer() {
    if (flushingErrorBuffer) return;
    flushingErrorBuffer = true;
    try {
      let buffer = readErrorBuffer();
      while (buffer.length) {
        const next = buffer[0];
        try {
          await postErrorLogEntry(next);
          buffer = buffer.slice(1);
          writeErrorBuffer(buffer);
        } catch (_) {
          break;
        }
      }
    } finally {
      flushingErrorBuffer = false;
    }
  }
  function logClientError({ message, serverText, context, severity, stack } = {}) {
    const entry = {
      message: String(message == null ? "Unknown error" : message).slice(0, 4e3),
      serverText: serverText != null ? String(serverText).slice(0, 8e3) : null,
      context: context != null ? String(context).slice(0, 500) : null,
      severity: severity === "warn" ? "warn" : "error",
      stack: stack != null ? String(stack).slice(0, 8e3) : null,
      url: window.location && window.location.href || null,
      userAgent: navigator && navigator.userAgent || null,
      occurredAt: (/* @__PURE__ */ new Date()).toISOString()
    };
    postErrorLogEntry(entry).catch(() => {
      const buffer = readErrorBuffer();
      buffer.push(entry);
      writeErrorBuffer(buffer);
    });
  }
  async function fetchErrorLog() {
    return apiFetch("/error-log");
  }
  if (!window.__bncGlobalErrorHandlersInstalled) {
    let refreshFromServer2 = function() {
      if (!state._ready) return;
      if (navigator.onLine === false) return;
      if (document.visibilityState === "hidden") return;
      if (refreshInFlight) return;
      refreshInFlight = loadBootstrap().catch(() => {
      }).finally(() => {
        refreshInFlight = null;
      });
    };
    var refreshFromServer = refreshFromServer2;
    window.__bncGlobalErrorHandlersInstalled = true;
    window.addEventListener("error", (event) => {
      logClientError({
        message: event.message || "window.onerror",
        context: event.filename ? `${event.filename}:${event.lineno}:${event.colno}` : "window.onerror",
        severity: "error",
        stack: event.error && event.error.stack
      });
    });
    window.addEventListener("unhandledrejection", (event) => {
      const reason = event.reason;
      logClientError({
        message: reason && reason.message || String(reason) || "Unhandled promise rejection",
        context: "unhandledrejection",
        severity: "error",
        stack: reason && reason.stack
      });
    });
    window.addEventListener("online", () => {
      flushErrorLogBuffer().catch(() => {
      });
      flushScanQueue().catch(() => {
      });
    });
    let refreshInFlight = null;
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") refreshFromServer2();
    });
    setInterval(refreshFromServer2, 5 * 60 * 1e3);
    window.__bncRefreshFromServer = refreshFromServer2;
  }
  const SCAN_DB_NAME = "bnc-scan-queue";
  const SCAN_DB_STORE = "scans";
  function openScanDb() {
    return new Promise((resolveDb, rejectDb) => {
      const req = indexedDB.open(SCAN_DB_NAME, 1);
      req.onupgradeneeded = () => {
        if (!req.result.objectStoreNames.contains(SCAN_DB_STORE)) {
          req.result.createObjectStore(SCAN_DB_STORE, { keyPath: "scanId" });
        }
      };
      req.onsuccess = () => resolveDb(req.result);
      req.onerror = () => rejectDb(req.error || new Error("IndexedDB open failed"));
    });
  }
  function scanDbOp(mode, fn) {
    return openScanDb().then((db) => new Promise((resolveOp, rejectOp) => {
      const tx = db.transaction(SCAN_DB_STORE, mode);
      const os = tx.objectStore(SCAN_DB_STORE);
      const out = fn(os);
      tx.oncomplete = () => {
        db.close();
        resolveOp(out && out.result !== void 0 ? out.result : void 0);
      };
      tx.onerror = () => {
        db.close();
        rejectOp(tx.error || new Error("IndexedDB tx failed"));
      };
    }));
  }
  function scanQueueList() {
    return openScanDb().then((db) => new Promise((resolveList, rejectList) => {
      const tx = db.transaction(SCAN_DB_STORE, "readonly");
      const req = tx.objectStore(SCAN_DB_STORE).getAll();
      req.onsuccess = () => {
        db.close();
        resolveList(req.result || []);
      };
      req.onerror = () => {
        db.close();
        rejectList(req.error);
      };
    })).catch(() => []);
  }
  function scanQueuePut(entry) {
    return scanDbOp("readwrite", (os) => os.put(entry));
  }
  function scanQueueDelete(scanId) {
    return scanDbOp("readwrite", (os) => os.delete(scanId));
  }
  function dataUrlToBlob(dataUrl) {
    const [head, b64] = dataUrl.split(",");
    const mime = (/data:([^;]+)/.exec(head) || [])[1] || "image/jpeg";
    const bin = atob(b64);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return new Blob([bytes], { type: mime });
  }
  async function uploadScanPhotos(scanId, photos) {
    const slots = Object.keys(photos);
    const { uploads } = await apiFetch("/scans/upload-urls", {
      method: "POST",
      body: { slots, scanId }
    });
    const photoKeys = {};
    for (const slot of slots) {
      const u = uploads[slot];
      const put = await fetch(u.uploadUrl, {
        method: "PUT",
        headers: { "Content-Type": "image/jpeg" },
        body: dataUrlToBlob(photos[slot])
      });
      if (!put.ok) throw new Error(`\u041A\u0430\u0447\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 ${slot} \u043D\u0435 \u0443\u0441\u043F\u044F (HTTP ${put.status})`);
      photoKeys[slot] = u.storageKey;
    }
    return photoKeys;
  }
  let scanQueueFlushInFlight = null;
  async function flushScanQueue() {
    if (scanQueueFlushInFlight) return scanQueueFlushInFlight;
    scanQueueFlushInFlight = (async () => {
      const entries = await scanQueueList();
      for (const entry of entries) {
        try {
          const photoKeys = await uploadScanPhotos(entry.scanId, entry.photos);
          await apiFetch(`/scans/${entry.scanId}/confirm`, {
            method: "POST",
            body: {
              customerName: entry.customerName || "\u0431\u0435\u0437-\u0438\u043C\u0435",
              deferred: true,
              photoKeys
            }
          });
          await scanQueueDelete(entry.scanId);
          window.toast && window.toast.success(
            `\u041E\u0442\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u0442 \u0441\u043A\u0430\u043D ${entry.scanId} \u0435 \u043A\u0430\u0447\u0435\u043D \u0438 \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u0430\u043D.`,
            { duration: 4e3 }
          );
        } catch (err) {
          try {
            entry.lastError = String(err && err.message || err).slice(0, 500);
            entry.lastTriedAt = (/* @__PURE__ */ new Date()).toISOString();
            await scanQueuePut(entry);
          } catch (_) {
          }
        }
      }
    })().finally(() => {
      scanQueueFlushInFlight = null;
    });
    return scanQueueFlushInFlight;
  }
  const pendingRentalCreates = /* @__PURE__ */ new Map();
  async function awaitPendingRentalCreate(rentalId) {
    const pending = pendingRentalCreates.get(rentalId);
    if (!pending) return true;
    try {
      await pending;
      return true;
    } catch (_) {
      return false;
    }
  }
  const pendingCustomerCreates = /* @__PURE__ */ new Map();
  async function awaitPendingCustomerCreate(customerId) {
    const pending = customerId && pendingCustomerCreates.get(customerId);
    if (!pending) return true;
    try {
      await pending;
      return true;
    } catch (_) {
      return false;
    }
  }
  const RENTAL_DATE_FIELDS = [
    "reservedAt",
    "start",
    "end",
    "originalEnd",
    "handoverStartedAt",
    "handoverCompletedAt",
    "gdprSignedAt",
    "declarationSignedAt",
    "contractSignedAt",
    "completedAt",
    "noShowMarkedAt",
    "cancelledAt",
    "extendedAt",
    "createdAt",
    "updatedAt"
  ];
  const STATUS_FROM_API = { no_show: "no-show" };
  const STATUS_TO_API = { "no-show": "no_show" };
  function reviveDate(v) {
    return v == null ? v : new Date(v);
  }
  function revivePhoto(p) {
    if (!p) return p;
    return { ...p, capturedAt: reviveDate(p.capturedAt) };
  }
  function reviveDocument(d) {
    if (!d) return d;
    return { ...d, generatedAt: reviveDate(d.generatedAt) };
  }
  function mergeAttachedDocuments(documents, prevAttached) {
    const ATTACHED_KINDS = ["addendum", "return_protocol"];
    const persisted = (documents || []).filter((d) => ATTACHED_KINDS.includes(d.kind));
    const persistedIds = new Set(persisted.map((d) => d.id));
    const prevById = new Map((prevAttached || []).map((d) => [d.id, d]));
    const fromPersisted = persisted.map((d) => {
      const prev = prevById.get(d.id);
      return {
        id: d.id,
        kind: d.kind,
        name: d.name,
        base64: prev && prev.base64 || null,
        bytes: d.bytes,
        generatedAt: d.generatedAt instanceof Date ? d.generatedAt.toISOString() : d.generatedAt,
        meta: d.meta
      };
    });
    const stillPending = (prevAttached || []).filter((d) => !persistedIds.has(d.id));
    return [...fromPersisted, ...stillPending];
  }
  function arrayBufferToBase64(buf) {
    const bytes = new Uint8Array(buf);
    let binary = "";
    const chunkSize = 32768;
    for (let i = 0; i < bytes.length; i += chunkSize) {
      binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunkSize));
    }
    return btoa(binary);
  }
  async function fetchDocumentBase64(docId) {
    const { url } = await apiFetch("/documents/" + docId + "/url");
    const res = await fetch(url);
    if (!res.ok) throw new Error("Storage fetch failed (" + res.status + ")");
    const buf = await res.arrayBuffer();
    return arrayBufferToBase64(buf);
  }
  async function hydrateAttachedDocuments(rentals) {
    const jobs = [];
    for (const r of rentals) {
      for (const d of r.attachedDocuments || []) {
        if (!d.base64) {
          jobs.push(
            fetchDocumentBase64(d.id).then((base64) => {
              d.base64 = base64;
            }).catch((err) => {
              console.error("Failed to hydrate addendum bytes", d.id, err);
            })
          );
        }
      }
    }
    if (jobs.length) await Promise.all(jobs);
  }
  function reviveRental(r, existing) {
    if (!r) return r;
    const out = { ...r };
    for (const f of RENTAL_DATE_FIELDS) {
      if (out[f] !== void 0) out[f] = reviveDate(out[f]);
    }
    if (out.status in STATUS_FROM_API) out.status = STATUS_FROM_API[out.status];
    if (Array.isArray(out.photos)) out.photos = out.photos.map(revivePhoto);
    if (Array.isArray(out.documents)) out.documents = out.documents.map(reviveDocument);
    out.attachedDocuments = mergeAttachedDocuments(out.documents, existing && existing.attachedDocuments);
    return out;
  }
  function revivePayment(p) {
    if (!p) return p;
    return { ...p, date: reviveDate(p.date), createdAt: reviveDate(p.createdAt) };
  }
  function reviveCustomer(c) {
    return c;
  }
  function reviveVehicle(v) {
    return v;
  }
  function reviveNoShowEntry(e) {
    if (!e) return e;
    return { ...e, reservedFor: reviveDate(e.reservedFor), markedAt: reviveDate(e.markedAt), resolvedAt: reviveDate(e.resolvedAt) };
  }
  function statusToApi(status) {
    return STATUS_TO_API[status] || status;
  }
  function dataUrlToBytes(dataUrl) {
    const base64 = dataUrl.slice(dataUrl.indexOf(",") + 1);
    const bin = atob(base64);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return bytes;
  }
  async function uploadHandoverPhoto(rentalId, kind, record) {
    if (!record || !record.dataUrl) return null;
    const contentType = /^data:([^;]+);/.exec(record.dataUrl)?.[1] || "image/jpeg";
    const { uploadUrl, storageKey } = await apiFetch("/photos/upload-url", {
      method: "POST",
      body: { rentalId, kind, contentType }
    });
    const bytes = dataUrlToBytes(record.dataUrl);
    const putRes = await fetch(uploadUrl, { method: "PUT", headers: { "Content-Type": contentType }, body: bytes });
    if (!putRes.ok) throw new Error("Storage upload failed (" + putRes.status + ")");
    const created = await apiFetch("/photos", {
      method: "POST",
      body: {
        rentalId,
        kind,
        storageKey,
        width: record.width ?? null,
        height: record.height ?? null,
        bytes: record.bytes ?? bytes.length,
        capturedAt: record.capturedAt || (/* @__PURE__ */ new Date()).toISOString(),
        // Damages-at-return (v5.13): short operator description of a
        // damage photo — persisted on the rental_photos row so the
        // Phase 2 Damage register can consume it directly. null for
        // every other photo kind (register schema: optional).
        description: record.description || null
      }
    });
    return { id: created && created.id, storageKey };
  }
  async function persistHandoverMedia(r) {
    const jobs = [];
    const slots = ["front", "rear", "left", "right", "odometer", "cargo"];
    if (r.handoverPhotos) {
      for (const slot of slots) {
        const record = r.handoverPhotos[slot];
        if (record && record.dataUrl) {
          jobs.push(
            uploadHandoverPhoto(r.id, slot, record).catch((err) => {
              reportError(err, '\u0421\u043D\u0438\u043C\u043A\u0430 "' + slot + '" \u043D\u0435 \u0441\u0435 \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u0430');
            })
          );
        }
      }
    }
    if (Array.isArray(r.extraPhotos)) {
      for (const record of r.extraPhotos) {
        jobs.push(
          uploadHandoverPhoto(r.id, "damage_close_up", record).then((photo) => {
            if (!photo || !photo.id || !r.vehicleId) return;
            return apiFetch("/vehicle-damages", {
              method: "POST",
              body: {
                vehicleId: r.vehicleId,
                origin: "handover",
                rentalId: r.id,
                photoId: photo.id,
                description: record.description || "",
                width: record.width ?? null,
                height: record.height ?? null,
                bytes: record.bytes ?? null,
                capturedAt: record.capturedAt || null
              }
            });
          }).catch((err) => {
            reportError(err, "\u0414\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u043D\u0430 \u0441\u043D\u0438\u043C\u043A\u0430 \u043D\u0435 \u0441\u0435 \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u0430");
          })
        );
      }
    }
    const signatureFields = [
      { field: "gdprSignature", kind: "gdpr_signature", keyField: "gdprSignatureKey" },
      { field: "declarationSignature", kind: "declaration_signature", keyField: "declarationSignatureKey" },
      { field: "contractSignature", kind: "contract_signature", keyField: "contractSignatureKey" }
    ];
    for (const { field, kind, keyField } of signatureFields) {
      const dataUrl = r[field];
      if (!dataUrl) continue;
      jobs.push(
        uploadHandoverPhoto(r.id, kind, { dataUrl, capturedAt: (/* @__PURE__ */ new Date()).toISOString() }).then((photo) => {
          if (!photo || !photo.storageKey) return;
          return apiFetch("/rentals/" + r.id, { method: "PATCH", body: { [keyField]: photo.storageKey } });
        }).catch((err) => {
          reportError(err, "\u041F\u043E\u0434\u043F\u0438\u0441 \u043D\u0435 \u0441\u0435 \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u0430");
        })
      );
    }
    await Promise.all(jobs);
  }
  const RETURN_PHOTO_SLOTS = ["front", "rear", "left", "right", "odometer", "cargo"];
  async function persistReturnMedia(rentalId, returnPhotos, damagePhotos, returnSignature) {
    if (!returnPhotos && !(damagePhotos && damagePhotos.length) && !returnSignature) return;
    const jobs = [];
    if (returnSignature) {
      jobs.push(
        uploadHandoverPhoto(rentalId, "return_signature", { dataUrl: returnSignature, capturedAt: (/* @__PURE__ */ new Date()).toISOString() }).then((photo) => {
          if (!photo || !photo.storageKey) return;
          return apiFetch("/rentals/" + rentalId, { method: "PATCH", body: { returnSignatureKey: photo.storageKey } });
        }).catch((err) => {
          reportError(err, "\u041F\u043E\u0434\u043F\u0438\u0441\u044A\u0442 \u043E\u0442 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u043D\u0435 \u0441\u0435 \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u0430");
        })
      );
    }
    if (returnPhotos) {
      for (const slot of RETURN_PHOTO_SLOTS) {
        const record = returnPhotos[slot];
        if (record && record.dataUrl) {
          jobs.push(
            uploadHandoverPhoto(rentalId, "return_" + slot, record).catch((err) => {
              reportError(err, '\u0421\u043D\u0438\u043C\u043A\u0430 \u043E\u0442 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E "' + slot + '" \u043D\u0435 \u0441\u0435 \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u0430');
            })
          );
        }
      }
    }
    if (Array.isArray(damagePhotos)) {
      const rentalForDamages = state.rentals.find((x) => x.id === rentalId);
      const damageVehicleId = rentalForDamages && rentalForDamages.vehicleId;
      for (const record of damagePhotos) {
        if (record && record.dataUrl) {
          jobs.push(
            uploadHandoverPhoto(rentalId, "return_damage_close_up", record).then((photo) => {
              if (!photo || !photo.id || !damageVehicleId) return;
              return apiFetch("/vehicle-damages", {
                method: "POST",
                body: {
                  vehicleId: damageVehicleId,
                  origin: "return",
                  rentalId,
                  photoId: photo.id,
                  description: record.description || "",
                  width: record.width ?? null,
                  height: record.height ?? null,
                  bytes: record.bytes ?? null,
                  capturedAt: record.capturedAt || null
                }
              });
            }).catch((err) => {
              reportError(err, "\u0421\u043D\u0438\u043C\u043A\u0430 \u043D\u0430 \u0449\u0435\u0442\u0430 \u043E\u0442 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u043D\u0435 \u0441\u0435 \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u0430");
            })
          );
        }
      }
    }
    await Promise.all(jobs);
  }
  async function archiveReturnProtocol(rentalId, r, returnFields, returnPhotos, damagePhotos) {
    const customer = state.customers.find((c) => c.id === r.customerId) || { name: r.reservationName || null, phone: r.reservationPhone || null };
    const vehicle = state.vehicles.find((v) => v.id === r.vehicleId) || {};
    const data = {
      contractNo: r.contractNo,
      customer: { name: customer.name, egn: customer.egn, phone: customer.phone },
      vehicle: { make: vehicle.make, model: vehicle.model, plate: vehicle.plate, vin: vehicle.vin, drivetrain: vehicle.drivetrain },
      handoverOdo: r.handoverOdo,
      handoverFuel: r.handoverFuel,
      deposit: r.deposit,
      returnOdo: returnFields.returnOdo,
      returnFuel: returnFields.returnFuel,
      extraKmCharge: returnFields.extraKmCharge,
      fuelCharge: returnFields.fuelCharge,
      depositAction: returnFields.depositAction,
      withheldAmount: returnFields.withheldAmount,
      returnNotes: returnFields.notes,
      // v28 — cleanliness line + cleaning fee + bilateral signatures.
      // returnSignature (live kiosk dataUrl) renders in the Наемател
      // slot; retro/API regenerations lack it and render an empty line.
      returnClean: returnFields.returnClean,
      cleaningFee: returnFields.cleaningFee,
      cleaningFeeWaived: returnFields.cleaningFeeWaived,
      returnSignature: returnFields.returnSignature || null,
      returnPhotos: returnPhotos || {},
      // Damages-at-return (v5.13): rendered in the separate
      // „Установени щети при връщане" PDF block, description under
      // each photo.
      damagePhotos: (damagePhotos || []).filter((p) => p && p.dataUrl).map((p) => ({
        dataUrl: p.dataUrl,
        description: p.description || "",
        capturedAt: p.capturedAt
      }))
    };
    try {
      const doc = await serverGenerate("return_protocol", data, { rentalId, persist: true });
      const revived = reviveDocument(doc);
      let base64 = null;
      try {
        base64 = await fetchDocumentBase64(revived.id);
      } catch (e) {
        console.warn("return_protocol immediate hydration failed (will hydrate on next bootstrap):", e);
      }
      revived.base64 = base64;
      state.rentals = state.rentals.map((x) => {
        if (x.id !== rentalId) return x;
        const documents = [...(x.documents || []).filter((d) => d.id !== revived.id), revived];
        const attachedDocuments = mergeAttachedDocuments(documents, x.attachedDocuments);
        if (base64) {
          const entry = attachedDocuments.find((d) => d.id === revived.id);
          if (entry) entry.base64 = base64;
        }
        return { ...x, documents, attachedDocuments };
      });
      emit();
    } catch (err) {
      console.error("[docgen] return_protocol archive failed:", err);
      if (window.toast && window.toast.error) {
        window.toast.error(
          (err && err.message || String(err)) + " \u2014 \u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u044A\u0442 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u041D\u0415 \u0435 \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u0430\u043D.",
          { title: "\u0413\u0440\u0435\u0448\u043A\u0430 \u043F\u0440\u0438 \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u0430\u043D\u0435", duration: 8e3 }
        );
      }
      reportError(err, '\u0410\u0440\u0445\u0438\u0432\u0438\u0440\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u201E\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435" \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E');
    }
  }
  const HEAVY_MEDIA_FIELDS = ["handoverPhotos", "extraPhotos", "gdprSignature", "declarationSignature", "contractSignature"];
  function stripHeavyMediaFields(obj) {
    const out = { ...obj };
    for (const f of HEAVY_MEDIA_FIELDS) delete out[f];
    return out;
  }
  window.VEHICLES = [];
  window.CUSTOMERS = [];
  window.RENTALS = [];
  window.PAYMENTS = [];
  window.LEADS = [];
  const state = {
    vehicles: [],
    customers: [],
    rentals: [],
    payments: [],
    leads: [],
    noShowLog: [],
    legalTexts: { gdpr: "", declaration: "" },
    contractTemplate: null,
    companySettings: { ...window.COMPANY },
    smtpSettings: { host: "", port: "", username: "", password: "", senderName: "", replyTo: "" },
    emailTemplates: {},
    // Phase 2Б email module: sent-mail log (lazy-loaded by the
    // Settings → Имейли panel via fetchEmails) + extension requests
    // (hydrated from bootstrap; dashboard „Заявки за удължаване" card).
    emailLog: [],
    emailsEnabled: false,
    extensionRequests: [],
    operations: { bufferHours: 2, overdueMinutes: 30, defaultKmLimit: 200, noShowGraceHours: 2 },
    operatorProfile: {
      name: "\u041D\u0438\u043A\u043E\u043B\u0430\u0439 \u041C\u0443\u0442\u0430\u0444\u0447\u0438\u0435\u0432",
      role: "\u0423\u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B",
      phone: "",
      email: "",
      signatureDataUrl: null,
      signatureCapturedAt: null
    },
    // PRODUCTION BUG FIX (docs/06 acceptance row #20, found + fixed this
    // pass): this used to be an independent, per-session counter that
    // was NEVER seeded from the server and NEVER updated by
    // setNextContractSeq() — meaning Settings' "Set next contract
    // number" override had literally zero effect on any UI-created
    // rental's actual contractNo (proven via a real end-to-end UI +
    // Postgres-level repro: Set next -> 300, confirm via the real
    // modal, then a real Quick-Reservation-equivalent save() persisted
    // contract_no='001/2026' to Postgres — not 300/2026 — because this
    // field was still sitting at its untouched initial value of 1).
    // That's a direct violation of non-negotiable #13 (atomic per-year
    // counter, no duplicates): two tabs/sessions each carried their OWN
    // independent counter starting at 1, so two operators (or the same
    // operator in two tabs) could each create a rental believing it's
    // 001/2026, 002/2026, etc. -- real duplicate contract numbers on
    // signed legal documents.
    //
    // Fixed by making this field a SYNCED CACHE of the server's real
    // atomic sequence, never an independent counter:
    //   - loadBootstrap() now seeds it from GET /rentals/next-number
    //     (server truth) before first render.
    //   - setNextContractSeq() now updates it synchronously (not just
    //     server-side) so an override takes effect within the SAME
    //     session, with no reload required.
    //   - nextContractNumber()'s background reconciliation now
    //     self-heals any detected drift by adopting the server's
    //     returned sequence if it is ever ahead of the local cache
    //     (e.g. a second concurrent tab/session already consumed
    //     numbers this cache didn't know about) -- the server always
    //     wins on discrepancy, per the single-source-of-truth design.
    _localContractFallbackSeq: 1,
    // True once GET /bootstrap has resolved at least once. AuthGate /
    // screens can check store.isReady() to avoid rendering against an
    // empty-but-not-yet-loaded state as if it were a genuine empty
    // database. (New selector — additive, does not remove/rename
    // anything docs/03 lists, so it cannot break an existing call site.)
    _ready: false
  };
  const subscribe = (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
  };
  async function loadBootstrap() {
    const data = await apiFetch("/bootstrap");
    state.vehicles = (data.vehicles || []).map(reviveVehicle);
    state.customers = (data.customers || []).map(reviveCustomer);
    state.rentals = (data.rentals || []).map((r) => reviveRental(r));
    state.payments = (data.payments || []).map(revivePayment);
    state.leads = data.leads || [];
    state.noShowLog = (data.noShowLog || []).map(reviveNoShowEntry);
    state.legalTexts = data.legalTexts || state.legalTexts;
    state.contractTemplate = data.contractTemplate || null;
    state.companySettings = data.companySettings || state.companySettings;
    window.COMPANY = state.companySettings;
    state.smtpSettings = data.smtpSettings || state.smtpSettings;
    state.emailTemplates = data.emailTemplates || state.emailTemplates;
    state.operations = data.operations || state.operations;
    state.extensionRequests = data.extensionRequests || [];
    if (data.operator) state.operatorProfile = data.operator;
    await hydrateAttachedDocuments(state.rentals);
    try {
      const { contractNo } = await apiFetch("/rentals/next-number");
      const m = /^(\d+)\//.exec(contractNo || "");
      if (m) state._localContractFallbackSeq = parseInt(m[1], 10);
    } catch (err) {
      console.warn("[store] failed to seed contract-number cache from server:", err);
    }
    try {
      const { contexts } = await apiFetch("/documents/placeholders");
      if (contexts && Array.isArray(contexts.contract) && contexts.contract.length) {
        window.PLACEHOLDERS = contexts.contract;
      }
    } catch (err) {
      console.warn("[store] failed to sync placeholder list from server (static fallback list remains):", err);
    }
    state._ready = true;
    emit();
    flushErrorLogBuffer().catch(() => {
    });
    flushScanQueue().catch(() => {
    });
  }
  async function bootstrap() {
    return loadBootstrap();
  }
  function isReady() {
    return state._ready;
  }
  function genId(_prefix) {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0;
      const v = c === "x" ? r : r & 3 | 8;
      return v.toString(16);
    });
  }
  function localFallbackContractNumber() {
    const y = (window.TODAY || /* @__PURE__ */ new Date()).getFullYear();
    const seq = state._localContractFallbackSeq++;
    return String(seq).padStart(3, "0") + "/" + y;
  }
  function nextContractNumber() {
    const n = localFallbackContractNumber();
    apiFetch("/rentals/next-number", { method: "POST" }).then((res) => {
      const m = /^(\d+)\//.exec(res && res.contractNo || "");
      if (!m) return;
      const serverSeq = parseInt(m[1], 10);
      if (serverSeq + 1 > state._localContractFallbackSeq) {
        state._localContractFallbackSeq = serverSeq + 1;
      }
    }).catch((err) => {
      console.warn("[store] background contract-number reservation failed:", err);
    });
    return n;
  }
  function base64ToBytes(base64) {
    const bin = atob(base64);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return bytes;
  }
  const DOCGEN_KIND_LABELS = {
    contract: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440",
    protocol: "\u041F\u0440\u0438\u0435\u043C\u043E-\u043F\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u0435\u043B\u0435\u043D \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B",
    gdpr: "\u0414\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0438\u044F GDPR",
    declaration: "\u0414\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0438\u044F \u0437\u0430 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u043D\u0430\u0435\u043C\u0430\u043D\u0435",
    addendum: "\u0410\u043D\u0435\u043A\u0441 \u0437\u0430 \u0443\u0434\u044A\u043B\u0436\u0430\u0432\u0430\u043D\u0435"
  };
  const DOCGEN_CLIENT_FALLBACK = {
    contract: "generateContractPdf",
    protocol: "generateProtocolPdf",
    gdpr: "generateGdprPdf",
    declaration: "generateDeclarationPdf"
  };
  const HANDOVER_PHOTO_SLOTS = ["front", "rear", "left", "right", "odometer", "cargo"];
  function toServerDocgenPayload(st) {
    const out = { ...st };
    delete out.attachedDocuments;
    delete out.documents;
    const persistedPhotos = st.id && (state.rentals.find((r) => r.id === st.id) || {}).photos || st.photos || [];
    const hasLiveHandover = out.handoverPhotos && Object.values(out.handoverPhotos).some((p) => p && (p.dataUrl || p.storageKey));
    if (!hasLiveHandover && persistedPhotos.length) {
      const hp = {};
      for (const slot of HANDOVER_PHOTO_SLOTS) {
        const p = persistedPhotos.find((ph) => ph && ph.kind === slot && ph.storageKey);
        if (p) hp[slot] = { storageKey: p.storageKey };
      }
      if (Object.keys(hp).length) out.handoverPhotos = hp;
    }
    const hasLiveExtras = Array.isArray(out.extraPhotos) && out.extraPhotos.some((p) => p && (p.dataUrl || p.storageKey));
    if (!hasLiveExtras && persistedPhotos.length) {
      const extras = persistedPhotos.filter((ph) => ph && ph.kind === "damage_close_up" && ph.storageKey).map((ph) => ({ storageKey: ph.storageKey }));
      if (extras.length) out.extraPhotos = extras;
    }
    delete out.photos;
    return out;
  }
  function docgenKindsFor(rentalState) {
    const kinds = ["contract"];
    if (rentalState.gdprSigned) kinds.push("gdpr");
    if (rentalState.declarationSigned) kinds.push("declaration");
    return kinds;
  }
  async function serverGenerate(kind, data, { rentalId, persist, meta } = {}) {
    return apiFetch("/documents/generate", {
      method: "POST",
      body: { kind, rentalId, persist: !!persist, meta, data }
    });
  }
  function isOperatorFixableDocgenError(err) {
    return !!(err && err.status === 422);
  }
  function notifyReserveMode(err) {
    console.warn("[docgen] server generation failed \u2014 falling back to LOCAL pdf-lib generators:", err);
    logClientError({
      message: "Server document generation unavailable, falling back to local pdf-lib: " + (err && err.message || err),
      serverText: err && err.body ? JSON.stringify(err.body) : null,
      context: "notifyReserveMode (docgen server-first fallback)",
      severity: "warn",
      stack: err && err.stack
    });
    if (window.toast && window.toast.error) {
      window.toast.error(
        "\u0421\u044A\u0440\u0432\u044A\u0440\u043D\u043E\u0442\u043E \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435 \u0435 \u043D\u0435\u0434\u043E\u0441\u0442\u044A\u043F\u043D\u043E (" + (err && err.message || err) + "). \u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438\u0442\u0435 \u0441\u0430 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0438 \u041B\u041E\u041A\u0410\u041B\u041D\u041E \u0441 \u0432\u0433\u0440\u0430\u0434\u0435\u043D\u0438\u044F \u0442\u0435\u043A\u0441\u0442 \u2014 \u0448\u0430\u0431\u043B\u043E\u043D\u044A\u0442 \u043E\u0442 \u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u041D\u0415 \u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D.",
        { title: "\u0420\u0435\u0437\u0435\u0440\u0432\u0435\u043D \u0440\u0435\u0436\u0438\u043C", duration: 8e3 }
      );
    }
  }
  let originalGenerateRentalDocuments = null;
  let originalGenerateExtensionAddendumPdf = null;
  async function serverFirstGenerateRentalDocuments(rentalState) {
    const kinds = docgenKindsFor(rentalState);
    try {
      const data = toServerDocgenPayload(rentalState);
      const results = [];
      for (const kind of kinds) {
        const res = await serverGenerate(kind, data, { persist: false });
        results.push({ bytes: base64ToBytes(res.base64), name: res.name });
      }
      return results;
    } catch (err) {
      if (isOperatorFixableDocgenError(err)) throw err;
      if (!originalGenerateRentalDocuments) throw err;
      notifyReserveMode(err);
      return originalGenerateRentalDocuments(rentalState);
    }
  }
  serverFirstGenerateRentalDocuments.__serverFirst = true;
  async function serverFirstGenerateExtensionAddendumPdf(st) {
    try {
      const res = await serverGenerate("addendum", toServerDocgenPayload(st), { persist: false });
      return { bytes: base64ToBytes(res.base64), name: res.name };
    } catch (err) {
      if (isOperatorFixableDocgenError(err)) throw err;
      if (!originalGenerateExtensionAddendumPdf) throw err;
      notifyReserveMode(err);
      return originalGenerateExtensionAddendumPdf(st);
    }
  }
  serverFirstGenerateExtensionAddendumPdf.__serverFirst = true;
  const docgenWrapPoll = setInterval(() => {
    const gen = window.generateRentalDocuments;
    if (typeof gen !== "function" || gen.__serverFirst) return;
    originalGenerateRentalDocuments = gen;
    originalGenerateExtensionAddendumPdf = typeof window.generateExtensionAddendumPdf === "function" ? window.generateExtensionAddendumPdf : null;
    window.generateRentalDocuments = serverFirstGenerateRentalDocuments;
    window.generateExtensionAddendumPdf = serverFirstGenerateExtensionAddendumPdf;
    clearInterval(docgenWrapPoll);
    console.info("[docgen] server-first document generation wrappers installed");
  }, 200);
  const photoUrlCache = /* @__PURE__ */ new Map();
  const PHOTO_URL_SAFETY_MS = 60 * 1e3;
  const actions = {
    // Mints a short-lived signed GET URL for one photo (docs/06
    // acceptance test #17's "thumbnails render in Rental Detail,
    // retrieval via signed URL works" clause). Memoized (item 6 Part
    // A) — see photoUrlCache above; the API round-trip happens at
    // most once per photo per URL lifetime, not once per render.
    async getPhotoUrl(photoId) {
      const cached = photoUrlCache.get(photoId);
      if (cached) {
        if (cached.promise) return cached.promise;
        if (Date.now() < cached.expiresAtMs) return cached.url;
        photoUrlCache.delete(photoId);
      }
      const promise = (async () => {
        const { url, expiresIn } = await apiFetch("/photos/" + photoId + "/url");
        const ttlMs = Math.max(0, (expiresIn || 300) * 1e3 - PHOTO_URL_SAFETY_MS);
        photoUrlCache.set(photoId, { url, expiresAtMs: Date.now() + ttlMs });
        return url;
      })();
      photoUrlCache.set(photoId, { promise });
      promise.catch(() => {
        photoUrlCache.delete(photoId);
      });
      return promise;
    },
    // ── Damage Register (Phase 2, v5.15) ─────────────────────────
    // Vehicle damages are fetched ON DEMAND (wizard damage step +
    // fleet.jsx Щети panel), deliberately NOT part of bootstrap — the
    // spec's offline degradation ("Регистърът на щетите не се зареди…")
    // is a distinct, testable event on this fetch.
    async fetchVehicleDamages(vehicleId, { activeOnly = false } = {}) {
      const qs = "?vehicleId=" + encodeURIComponent(vehicleId) + (activeOnly ? "&status=active" : "");
      return apiFetch("/vehicle-damages" + qs);
    },
    // Manual add: signed upload-url → PUT bytes → POST the entry with
    // its OWN storageKey (vehicles/{vehicleId}/damages/…). Mirrors
    // uploadHandoverPhoto's three-step, but vehicle-scoped.
    async addManualVehicleDamage(vehicleId, record, description) {
      if (!record || !record.dataUrl) throw new Error("\u041B\u0438\u043F\u0441\u0432\u0430 \u0441\u043D\u0438\u043C\u043A\u0430 \u043D\u0430 \u0449\u0435\u0442\u0430\u0442\u0430.");
      const contentType = /^data:([^;]+);/.exec(record.dataUrl)?.[1] || "image/jpeg";
      const { uploadUrl, storageKey } = await apiFetch("/vehicle-damages/upload-url", {
        method: "POST",
        body: { vehicleId, contentType }
      });
      const bytes = dataUrlToBytes(record.dataUrl);
      const putRes = await fetch(uploadUrl, { method: "PUT", headers: { "Content-Type": contentType }, body: bytes });
      if (!putRes.ok) throw new Error("Storage upload failed (" + putRes.status + ")");
      return apiFetch("/vehicle-damages", {
        method: "POST",
        body: {
          vehicleId,
          origin: "manual",
          storageKey,
          description: description || "",
          width: record.width ?? null,
          height: record.height ?? null,
          bytes: record.bytes ?? bytes.length,
          capturedAt: record.capturedAt || (/* @__PURE__ */ new Date()).toISOString()
        }
      });
    },
    async updateVehicleDamage(damageId, patch) {
      return apiFetch("/vehicle-damages/" + damageId, { method: "PATCH", body: patch });
    },
    async markVehicleDamageRepaired(damageId) {
      return apiFetch("/vehicle-damages/" + damageId, { method: "PATCH", body: { status: "repaired" } });
    },
    async deleteVehicleDamage(damageId) {
      return apiFetch("/vehicle-damages/" + damageId, { method: "DELETE" });
    },
    // Memoized signed-GET minting for damage photos — same cache
    // discipline as getPhotoUrl above (single-flight + TTL), keyed
    // separately since damage ids live in their own namespace.
    async getVehicleDamagePhotoUrl(damageId) {
      const cacheKey = "dmg:" + damageId;
      const cached = photoUrlCache.get(cacheKey);
      if (cached) {
        if (cached.promise) return cached.promise;
        if (Date.now() < cached.expiresAtMs) return cached.url;
        photoUrlCache.delete(cacheKey);
      }
      const promise = (async () => {
        const { url, expiresIn } = await apiFetch("/vehicle-damages/" + damageId + "/photo-url");
        const ttlMs = Math.max(0, (expiresIn || 300) * 1e3 - PHOTO_URL_SAFETY_MS);
        photoUrlCache.set(cacheKey, { url, expiresAtMs: Date.now() + ttlMs });
        return url;
      })();
      photoUrlCache.set(cacheKey, { promise });
      promise.catch(() => {
        photoUrlCache.delete(cacheKey);
      });
      return promise;
    },
    // In 1A this is a client no-op — server runs recomputeStatuses on
    // its own 60s cron (backend/src/services/recomputeStatuses.ts +
    // server.ts's node-cron registration) and every GET /bootstrap
    // also recomputes server-side first. Kept as a callable stub per
    // docs/03 ("becomes a no-op on the client... Kept as a callable
    // stub so any residual UI code that calls it doesn't break") so
    // calendar.jsx / dashboard.jsx's `store.useStore()` subscriptions
    // and any leftover call sites don't throw. Optionally forces a
    // fresh bootstrap re-fetch so a manual "refresh" affordance still
    // does something visible.
    recomputeStatuses() {
      loadBootstrap().catch((err) => reportError(err, "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u0430"));
    },
    updateLegalTexts(patch) {
      const prev = state.legalTexts;
      state.legalTexts = { ...state.legalTexts, ...patch };
      emit();
      apiFetch("/settings/legal-texts", { method: "PATCH", body: patch }).then((updated) => {
        state.legalTexts = updated;
        emit();
      }).catch((err) => {
        state.legalTexts = prev;
        emit();
        reportError(err, "\u0417\u0430\u043F\u0430\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u0435\u0442\u0435 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    resetLegalTexts() {
      const prev = state.legalTexts;
      apiFetch("/settings/legal-texts/reset", { method: "POST" }).then((updated) => {
        state.legalTexts = updated;
        emit();
      }).catch((err) => {
        state.legalTexts = prev;
        emit();
        reportError(err, "\u0412\u044A\u0437\u0441\u0442\u0430\u043D\u043E\u0432\u044F\u0432\u0430\u043D\u0435\u0442\u043E \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    setContractTemplate(template) {
      const prev = state.contractTemplate;
      state.contractTemplate = template;
      emit();
      apiFetch("/settings/contract-template", { method: "PUT", body: template }).then((saved) => {
        state.contractTemplate = saved;
        emit();
      }).catch((err) => {
        state.contractTemplate = prev;
        emit();
        reportError(err, "\u0417\u0430\u043F\u0430\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0448\u0430\u0431\u043B\u043E\u043D\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    clearContractTemplate() {
      const prev = state.contractTemplate;
      state.contractTemplate = null;
      emit();
      apiFetch("/settings/contract-template", { method: "DELETE" }).catch((err) => {
        state.contractTemplate = prev;
        emit();
        reportError(err, "\u0418\u0437\u0442\u0440\u0438\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0448\u0430\u0431\u043B\u043E\u043D\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    updateCompany(patch) {
      const prev = state.companySettings;
      state.companySettings = { ...state.companySettings, ...patch };
      window.COMPANY = state.companySettings;
      emit();
      apiFetch("/settings/company", { method: "PATCH", body: patch }).then((updated) => {
        state.companySettings = updated;
        window.COMPANY = updated;
        emit();
      }).catch((err) => {
        state.companySettings = prev;
        window.COMPANY = prev;
        emit();
        reportError(err, "\u0417\u0430\u043F\u0430\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0444\u0438\u0440\u043C\u0435\u043D\u0438\u0442\u0435 \u0434\u0430\u043D\u043D\u0438 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    updateSMTP(patch) {
      const prev = state.smtpSettings;
      state.smtpSettings = { ...state.smtpSettings, ...patch };
      emit();
      apiFetch("/settings/smtp", { method: "PATCH", body: patch }).then((updated) => {
        state.smtpSettings = updated;
        emit();
      }).catch((err) => {
        state.smtpSettings = prev;
        emit();
        reportError(err, "\u0417\u0430\u043F\u0430\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 SMTP \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u0442\u0435 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    updateEmailTemplate(id, patch) {
      const prev = state.emailTemplates;
      state.emailTemplates = { ...state.emailTemplates, [id]: { ...state.emailTemplates[id], ...patch } };
      emit();
      apiFetch("/settings/email-templates/" + id, { method: "PATCH", body: patch }).then((updated) => {
        state.emailTemplates = updated;
        emit();
      }).catch((err) => {
        state.emailTemplates = prev;
        emit();
        reportError(err, "\u0417\u0430\u043F\u0430\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0448\u0430\u0431\u043B\u043E\u043D\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    resetEmailTemplates() {
      const prev = state.emailTemplates;
      apiFetch("/settings/email-templates/reset", { method: "POST" }).then((updated) => {
        state.emailTemplates = updated;
        emit();
      }).catch((err) => {
        state.emailTemplates = prev;
        emit();
        reportError(err, "\u0412\u044A\u0437\u0441\u0442\u0430\u043D\u043E\u0432\u044F\u0432\u0430\u043D\u0435\u0442\u043E \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    // ── Phase 2Б email module actions ──────────────────────────
    // Sent-mail log is lazy: fetched when the Имейли panel opens (not
    // part of bootstrap — it can grow and is only needed in Settings).
    async fetchEmails() {
      try {
        const data = await apiFetch("/emails");
        state.emailLog = data.emails || [];
        state.emailsEnabled = !!data.emailsEnabled;
        emit();
      } catch (err) {
        reportError(err, "\u0417\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0438\u043C\u0435\u0439\u043B \u0434\u043D\u0435\u0432\u043D\u0438\u043A\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      }
    },
    async resendEmail(logId) {
      try {
        const res = await apiFetch("/emails/" + logId + "/resend", { method: "POST" });
        await actions.fetchEmails();
        return res;
      } catch (err) {
        reportError(err, "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u0442\u043E \u0438\u0437\u043F\u0440\u0430\u0449\u0430\u043D\u0435 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
        throw err;
      }
    },
    async sendTestEmails() {
      try {
        const res = await apiFetch("/emails/test", { method: "POST" });
        await actions.fetchEmails();
        return res;
      } catch (err) {
        reportError(err, "\u0422\u0435\u0441\u0442\u043E\u0432\u043E\u0442\u043E \u0438\u0437\u043F\u0440\u0430\u0449\u0430\u043D\u0435 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
        throw err;
      }
    },
    markExtensionHandled(id) {
      const prev = state.extensionRequests;
      state.extensionRequests = state.extensionRequests.map((r) => r.id === id ? { ...r, status: "handled", handledAt: (/* @__PURE__ */ new Date()).toISOString() } : r);
      emit();
      apiFetch("/extension-requests/" + id + "/handled", { method: "POST" }).then((updated) => {
        state.extensionRequests = state.extensionRequests.map((r) => r.id === id ? updated : r);
        emit();
      }).catch((err) => {
        state.extensionRequests = prev;
        emit();
        reportError(err, "\u041E\u0442\u0431\u0435\u043B\u044F\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0437\u0430\u044F\u0432\u043A\u0430\u0442\u0430 \u043A\u0430\u0442\u043E \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0435\u043D\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    updateOperations(patch) {
      const prev = state.operations;
      state.operations = { ...state.operations, ...patch };
      emit();
      apiFetch("/settings/operations", { method: "PATCH", body: patch }).then((updated) => {
        state.operations = updated;
        emit();
      }).catch((err) => {
        state.operations = prev;
        emit();
        reportError(err, "\u0417\u0430\u043F\u0430\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u0442\u0435 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    updateOperatorProfile(patch) {
      const prev = state.operatorProfile;
      state.operatorProfile = { ...state.operatorProfile, ...patch };
      emit();
      apiFetch("/settings/operator-profile", { method: "PATCH", body: patch }).then((updated) => {
        state.operatorProfile = updated;
        emit();
      }).catch((err) => {
        state.operatorProfile = prev;
        emit();
        reportError(err, "\u0417\u0430\u043F\u0430\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u043F\u0440\u043E\u0444\u0438\u043B\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    // Self-service password change (Settings -> Operator profile ->
    // Change password card). Deliberately NOT an optimistic-update /
    // fire-and-forget action like its siblings below — the caller
    // needs to await this directly so it can show the server's error
    // (wrong current password / too short / reused) inline, the same
    // way login.jsx's own submit handler does.
    async changePassword(currentPassword, newPassword) {
      return apiFetch("/auth/change-password", { method: "POST", body: { currentPassword, newPassword } });
    },
    setOperatorSignature(dataUrl) {
      const prev = state.operatorProfile;
      state.operatorProfile = {
        ...state.operatorProfile,
        signatureDataUrl: dataUrl,
        signatureCapturedAt: dataUrl ? (/* @__PURE__ */ new Date()).toISOString() : null
      };
      emit();
      apiFetch("/settings/operator-profile/signature", { method: "PUT", body: { signatureDataUrl: dataUrl } }).then((updated) => {
        state.operatorProfile = updated;
        emit();
      }).catch((err) => {
        state.operatorProfile = prev;
        emit();
        reportError(err, "\u0417\u0430\u043F\u0430\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u043F\u043E\u0434\u043F\u0438\u0441\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    setNextContractSeq(seq) {
      const n = Math.max(1, Math.floor(Number(seq) || 0));
      const prev = state._localContractFallbackSeq;
      state._localContractFallbackSeq = n;
      emit();
      apiFetch("/rentals/set-next-number", { method: "POST", body: { seq: n } }).catch((err) => {
        state._localContractFallbackSeq = prev;
        emit();
        reportError(err, "\u041F\u0440\u043E\u043C\u044F\u043D\u0430\u0442\u0430 \u043D\u0430 \u043D\u043E\u043C\u0435\u0440\u0430\u0446\u0438\u044F\u0442\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u0430");
      });
    },
    addCustomer(customer) {
      let c = { ...customer };
      if (!c.id) c = { ...c, id: genId("c") };
      state.customers = [...state.customers, c];
      emit();
      const createRequest = apiFetch("/customers", { method: "POST", body: c });
      pendingCustomerCreates.set(c.id, createRequest);
      createRequest.then((saved) => {
        state.customers = state.customers.map((x) => x.id === c.id ? reviveCustomer(saved) : x);
        emit();
      }).catch((err) => {
        state.customers = state.customers.filter((x) => x.id !== c.id);
        emit();
        reportError(err, "\u0414\u043E\u0431\u0430\u0432\u044F\u043D\u0435\u0442\u043E \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      }).finally(() => {
        pendingCustomerCreates.delete(c.id);
      });
      return c;
    },
    updateCustomer(id, patch) {
      const prev = state.customers;
      state.customers = state.customers.map((c) => c.id === id ? { ...c, ...patch } : c);
      emit();
      apiFetch("/customers/" + id, { method: "PATCH", body: patch }).then((saved) => {
        state.customers = state.customers.map((c) => c.id === id ? reviveCustomer(saved) : c);
        emit();
      }).catch((err) => {
        state.customers = prev;
        emit();
        reportError(err, "\u041E\u0431\u043D\u043E\u0432\u044F\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    anonymizeCustomer(id) {
      const prev = state.customers;
      state.customers = state.customers.map((c) => c.id === id ? {
        ...c,
        name: "[Anonim\u0438\u0437\u0438\u0440\u0430\u043D \u043A\u043B\u0438\u0435\u043D\u0442]",
        egn: "**********",
        phone: "**",
        email: "**",
        address: "**",
        idCard: { number: "**", issue: null, expiry: null, authority: "**" },
        driverLicense: { number: "**", categories: "", expiry: null },
        anonymized: true,
        anonymizedAt: (/* @__PURE__ */ new Date()).toISOString()
      } : c);
      emit();
      apiFetch("/customers/" + id + "/anonymize", { method: "POST" }).then((saved) => {
        state.customers = state.customers.map((c) => c.id === id ? reviveCustomer(saved) : c);
        emit();
      }).catch((err) => {
        state.customers = prev;
        emit();
        reportError(err, "\u0410\u043D\u043E\u043D\u0438\u043C\u0438\u0437\u0438\u0440\u0430\u043D\u0435\u0442\u043E \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    addRental(rental) {
      let r = { ...rental };
      if (!r.id) r = { ...r, id: genId("r") };
      if (!r.contractNo) r = { ...r, contractNo: nextContractNumber() };
      const callerProvidedStatus = !!r.status;
      if (!r.status) {
        const now = /* @__PURE__ */ new Date();
        r.status = r.start <= now && r.end > now ? "active" : "reserved";
      }
      state.rentals = [...state.rentals, r];
      emit();
      const payload = stripHeavyMediaFields({ ...r, status: statusToApi(r.status) });
      if (!callerProvidedStatus) delete payload.status;
      function isContractNoConflict(err) {
        const code = err && err.body && err.body.code;
        const msg = err && err.message || "";
        return code === "P2002" && msg.indexOf("contract_no") !== -1;
      }
      const createRequest = Promise.resolve().then(() => awaitPendingCustomerCreate(r.customerId)).then((customerOk) => {
        if (!customerOk) {
          throw new Error("\u041A\u043B\u0438\u0435\u043D\u0442\u044A\u0442 \u043D\u0435 \u0435 \u0437\u0430\u043F\u0438\u0441\u0430\u043D \u043D\u0430 \u0441\u044A\u0440\u0432\u044A\u0440\u0430 \u2014 \u043D\u0430\u0435\u043C\u044A\u0442 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0431\u044A\u0434\u0435 \u0441\u044A\u0437\u0434\u0430\u0434\u0435\u043D.");
        }
        return apiFetch("/rentals", { method: "POST", body: payload });
      }).catch((err) => {
        if (!isContractNoConflict(err)) throw err;
        console.warn("[store] contract number " + r.contractNo + " already taken \u2014 retrying with a fresh server number");
        return apiFetch("/rentals/next-number", { method: "POST" }).then((res) => {
          const freshNo = res && res.contractNo;
          if (!freshNo) throw err;
          const m = /^(\d+)\//.exec(freshNo);
          if (m && parseInt(m[1], 10) + 1 > state._localContractFallbackSeq) {
            state._localContractFallbackSeq = parseInt(m[1], 10) + 1;
          }
          r = { ...r, contractNo: freshNo };
          state.rentals = state.rentals.map((x) => x.id === r.id ? { ...x, contractNo: freshNo } : x);
          emit();
          return apiFetch("/rentals", { method: "POST", body: { ...payload, contractNo: freshNo } });
        });
      });
      pendingRentalCreates.set(r.id, createRequest);
      createRequest.then((saved) => {
        state.rentals = state.rentals.map((x) => x.id === r.id ? reviveRental(saved, x) : x);
        emit();
        persistHandoverMedia(r).catch((err) => {
          reportError(err, "\u0410\u0440\u0445\u0438\u0432\u0438\u0440\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0441\u043D\u0438\u043C\u043A\u0438/\u043F\u043E\u0434\u043F\u0438\u0441\u0438 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
        });
      }).catch((err) => {
        state.rentals = state.rentals.filter((x) => x.id !== r.id);
        emit();
        reportError(err, "\u0414\u043E\u0431\u0430\u0432\u044F\u043D\u0435\u0442\u043E \u043D\u0430 \u043D\u0430\u0435\u043C\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      }).finally(() => {
        if (pendingRentalCreates.get(r.id) === createRequest) {
          pendingRentalCreates.delete(r.id);
        }
      });
      return r;
    },
    updateRental(id, patch) {
      const prev = state.rentals;
      state.rentals = state.rentals.map((r) => r.id === id ? { ...r, ...patch } : r);
      emit();
      const apiPatch = stripHeavyMediaFields(patch.status ? { ...patch, status: statusToApi(patch.status) } : patch);
      Promise.resolve().then(() => awaitPendingCustomerCreate(apiPatch.customerId)).then((customerOk) => {
        if (!customerOk) {
          throw new Error("\u041A\u043B\u0438\u0435\u043D\u0442\u044A\u0442 \u043D\u0435 \u0435 \u0437\u0430\u043F\u0438\u0441\u0430\u043D \u043D\u0430 \u0441\u044A\u0440\u0432\u044A\u0440\u0430 \u2014 \u043D\u0430\u0435\u043C\u044A\u0442 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0431\u044A\u0434\u0435 \u043E\u0431\u043D\u043E\u0432\u0435\u043D.");
        }
        return apiFetch("/rentals/" + id, { method: "PATCH", body: apiPatch });
      }).then((saved) => {
        state.rentals = state.rentals.map((r) => r.id === id ? reviveRental(saved, r) : r);
        emit();
      }).catch((err) => {
        state.rentals = prev;
        emit();
        reportError(err, "\u041E\u0431\u043D\u043E\u0432\u044F\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u043D\u0430\u0435\u043C\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    cancelRental(id, { reason } = {}) {
      const prev = state.rentals;
      const prevNoShowLog = state.noShowLog;
      const now = /* @__PURE__ */ new Date();
      state.rentals = state.rentals.map((r) => {
        if (r.id !== id) return r;
        return {
          ...r,
          status: "cancelled",
          cancelledAt: now,
          cancellationReason: reason || null,
          previousStatus: r.status
        };
      });
      state.noShowLog = state.noShowLog.map(
        (entry) => entry.rentalId === id && !entry.resolution ? { ...entry, resolution: "cancelled", resolvedAt: now } : entry
      );
      emit();
      apiFetch("/rentals/" + id + "/cancel", { method: "POST", body: { reason } }).then((saved) => {
        state.rentals = state.rentals.map((r) => r.id === id ? reviveRental(saved, r) : r);
        emit();
      }).catch((err) => {
        state.rentals = prev;
        state.noShowLog = prevNoShowLog;
        emit();
        reportError(err, "\u041E\u0442\u043A\u0430\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u043D\u0430\u0435\u043C\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    startHandover(rentalId) {
      const prev = state.rentals;
      const now = /* @__PURE__ */ new Date();
      state.rentals = state.rentals.map((r) => r.id === rentalId ? { ...r, handoverStartedAt: now } : r);
      emit();
      apiFetch("/rentals/" + rentalId + "/start-handover", { method: "POST" }).then((saved) => {
        state.rentals = state.rentals.map((r) => r.id === rentalId ? reviveRental(saved, r) : r);
        emit();
      }).catch((err) => {
        state.rentals = prev;
        emit();
        reportError(err, "\u0421\u0442\u0430\u0440\u0442\u0438\u0440\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u043F\u0440\u0435\u0434\u0430\u0432\u0430\u043D\u0435\u0442\u043E \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    cancelHandover(rentalId) {
      const prev = state.rentals;
      state.rentals = state.rentals.map((r) => r.id === rentalId ? { ...r, handoverStartedAt: null } : r);
      emit();
      apiFetch("/rentals/" + rentalId + "/cancel-handover", { method: "POST" }).then((saved) => {
        state.rentals = state.rentals.map((r) => r.id === rentalId ? reviveRental(saved, r) : r);
        emit();
      }).catch((err) => {
        state.rentals = prev;
        emit();
        reportError(err, "\u041E\u0442\u043A\u0430\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u043F\u0440\u0435\u0434\u0430\u0432\u0430\u043D\u0435\u0442\u043E \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    // STAGE 1B (Package 1): archive the finalized rental's signed
    // documents SERVER-SIDE — one POST /documents/generate with
    // persist:true per kind (EXPLICIT kind end-to-end; retires
    // app.jsx's filename-inference block). The server generates from
    // the operator's uploaded template (or builtins), stores the PDF
    // in MinIO and registers the rental_documents row itself — no
    // client upload-url/PUT/POST three-step for these.
    //
    // Fallback policy differs from the preview/share wrappers above ON
    // PURPOSE: this runs fire-and-forget right after finalize, with a
    // customer standing at the counter — a rental whose documents
    // silently failed to archive is worse than one archived with the
    // builtin wording. So on ANY server failure (including 422) we
    // toast the server's Bulgarian message loudly, then still archive
    // via the LOCAL pdf-lib generator for that kind (explicit
    // kind→generator map, labeled "Резервен режим"). If both paths
    // fail, reportError — never silent.
    async archiveRentalDocuments(rentalId, finalState) {
      const kinds = docgenKindsFor(finalState);
      if (rentalId && !await awaitPendingRentalCreate(rentalId)) return;
      const data = toServerDocgenPayload(finalState);
      for (const kind of kinds) {
        try {
          const doc = await serverGenerate(kind, data, { rentalId, persist: true });
          const revived = reviveDocument(doc);
          state.rentals = state.rentals.map((r) => {
            if (r.id !== rentalId) return r;
            const documents = [...(r.documents || []).filter((d) => d.id !== revived.id), revived];
            return {
              ...r,
              documents,
              attachedDocuments: mergeAttachedDocuments(documents, r.attachedDocuments)
            };
          });
          emit();
        } catch (err) {
          console.error('[docgen] server archive failed for kind "' + kind + '":', err);
          const label = DOCGEN_KIND_LABELS[kind] || kind;
          if (window.toast && window.toast.error) {
            window.toast.error(
              (err && err.message || String(err)) + " \u2014 \u201E" + label + '" \u0449\u0435 \u0431\u044A\u0434\u0435 \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u0430\u043D \u041B\u041E\u041A\u0410\u041B\u041D\u041E (\u0440\u0435\u0437\u0435\u0440\u0432\u0435\u043D \u0440\u0435\u0436\u0438\u043C, \u0432\u0433\u0440\u0430\u0434\u0435\u043D \u0442\u0435\u043A\u0441\u0442).',
              { title: "\u0420\u0435\u0437\u0435\u0440\u0432\u0435\u043D \u0440\u0435\u0436\u0438\u043C \xB7 " + label, duration: 8e3 }
            );
          }
          try {
            const genName = DOCGEN_CLIENT_FALLBACK[kind];
            const generator = genName && window[genName];
            if (typeof generator !== "function") throw new Error("\u041B\u043E\u043A\u0430\u043B\u043D\u0438\u044F\u0442 \u0433\u0435\u043D\u0435\u0440\u0430\u0442\u043E\u0440 \u043B\u0438\u043F\u0441\u0432\u0430.");
            const pdf = await generator(finalState);
            actions.attachDocument(rentalId, {
              id: genId("doc"),
              // attachDocument re-mints anyway; kept for shape parity
              kind,
              // EXPLICIT — no filename inference
              name: pdf.name,
              base64: arrayBufferToBase64(pdf.bytes),
              bytes: pdf.bytes.byteLength,
              generatedAt: (/* @__PURE__ */ new Date()).toISOString(),
              meta: { fallback: "client-pdf-lib" }
            });
          } catch (fallbackErr) {
            reportError(fallbackErr, "\u0410\u0440\u0445\u0438\u0432\u0438\u0440\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u201E" + label + '" \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E');
          }
        }
      }
    },
    attachDocument(rentalId, doc) {
      const docId = genId("doc");
      const d = { ...doc, id: docId };
      const prev = state.rentals;
      state.rentals = state.rentals.map((r) => {
        if (r.id !== rentalId) return r;
        const docs = r.attachedDocuments || [];
        return { ...r, attachedDocuments: [...docs, d] };
      });
      emit();
      (async () => {
        try {
          if (rentalId && !await awaitPendingRentalCreate(rentalId)) {
            state.rentals = state.rentals.map((r) => {
              if (r.id !== rentalId) return r;
              return { ...r, attachedDocuments: (r.attachedDocuments || []).filter((x) => x.id !== docId) };
            });
            emit();
            return;
          }
          const { uploadUrl, storageKey } = await apiFetch("/documents/upload-url", {
            method: "POST",
            body: { rentalId, kind: d.kind, contentType: "application/pdf" }
          });
          const bytes = Uint8Array.from(atob(d.base64), (c) => c.charCodeAt(0));
          const putRes = await fetch(uploadUrl, { method: "PUT", headers: { "Content-Type": "application/pdf" }, body: bytes });
          if (!putRes.ok) throw new Error("Storage upload failed (" + putRes.status + ")");
          await apiFetch("/documents", {
            method: "POST",
            body: {
              id: docId,
              rentalId,
              kind: d.kind,
              name: d.name,
              storageKey,
              bytes: d.bytes,
              generatedAt: d.generatedAt,
              meta: d.meta
            }
          });
        } catch (err) {
          state.rentals = prev;
          emit();
          reportError(err, "\u041F\u0440\u0438\u043A\u0430\u0447\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
        }
      })();
    },
    detachDocument(rentalId, docId) {
      const prev = state.rentals;
      state.rentals = state.rentals.map((r) => {
        if (r.id !== rentalId) return r;
        return { ...r, attachedDocuments: (r.attachedDocuments || []).filter((d) => d.id !== docId) };
      });
      emit();
      apiFetch("/documents/" + docId, { method: "DELETE" }).catch((err) => {
        state.rentals = prev;
        emit();
        reportError(err, "\u041F\u0440\u0435\u043C\u0430\u0445\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    nextContractNumber,
    completeRental(id, returnData) {
      const prev = state.rentals;
      state.rentals = state.rentals.map((r) => r.id === id ? {
        ...r,
        ...returnData,
        status: "completed",
        completedAt: (/* @__PURE__ */ new Date()).toISOString()
      } : r);
      emit();
      apiFetch("/rentals/" + id + "/complete", { method: "POST", body: returnData }).then((saved) => {
        state.rentals = state.rentals.map((r) => r.id === id ? reviveRental(saved, r) : r);
        emit();
      }).catch((err) => {
        state.rentals = prev;
        emit();
        reportError(err, "\u041F\u0440\u0438\u043A\u043B\u044E\u0447\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u043D\u0430\u0435\u043C\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    extendRental(id, newEnd) {
      const prev = state.rentals;
      state.rentals = state.rentals.map((r) => r.id === id ? {
        ...r,
        originalEnd: r.originalEnd || r.end,
        end: newEnd,
        extendedAt: (/* @__PURE__ */ new Date()).toISOString()
      } : r);
      emit();
      apiFetch("/rentals/" + id + "/extend", { method: "POST", body: { newEnd } }).then((saved) => {
        state.rentals = state.rentals.map((r) => r.id === id ? reviveRental(saved, r) : r);
        emit();
      }).catch((err) => {
        state.rentals = prev;
        emit();
        reportError(err, "\u0423\u0434\u044A\u043B\u0436\u0430\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u043D\u0430\u0435\u043C\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    addPayment(payment) {
      let p = { ...payment };
      if (!p.id) p = { ...p, id: genId("p") };
      if (!p.date) p = { ...p, date: /* @__PURE__ */ new Date() };
      state.payments = [...state.payments, p];
      emit();
      (async () => {
        try {
          if (p.rentalId && !await awaitPendingRentalCreate(p.rentalId)) {
            state.payments = state.payments.filter((x) => x.id !== p.id);
            emit();
            return;
          }
          const saved = await apiFetch("/payments", { method: "POST", body: p });
          state.payments = state.payments.map((x) => x.id === p.id ? revivePayment(saved) : x);
          emit();
        } catch (err) {
          state.payments = state.payments.filter((x) => x.id !== p.id);
          emit();
          reportError(err, "\u0414\u043E\u0431\u0430\u0432\u044F\u043D\u0435\u0442\u043E \u043D\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
        }
      })();
      return p;
    },
    setVehicleStatus(id, status) {
      const prev = state.vehicles;
      state.vehicles = state.vehicles.map((v) => v.id === id ? { ...v, status } : v);
      emit();
      apiFetch("/vehicles/" + id + "/status", { method: "PATCH", body: { status } }).then((saved) => {
        state.vehicles = state.vehicles.map((v) => v.id === id ? reviveVehicle(saved) : v);
        emit();
      }).catch((err) => {
        state.vehicles = prev;
        emit();
        reportError(err, "\u0421\u043C\u044F\u043D\u0430\u0442\u0430 \u043D\u0430 \u0441\u0442\u0430\u0442\u0443\u0441\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u0430");
      });
    },
    addVehicle(vehicle) {
      let v = { ...vehicle };
      if (!v.id) v = { ...v, id: genId("v") };
      state.vehicles = [...state.vehicles, v];
      emit();
      apiFetch("/vehicles", { method: "POST", body: v }).then((saved) => {
        state.vehicles = state.vehicles.map((x) => x.id === v.id ? reviveVehicle(saved) : x);
        emit();
      }).catch((err) => {
        state.vehicles = state.vehicles.filter((x) => x.id !== v.id);
        emit();
        reportError(err, "\u0414\u043E\u0431\u0430\u0432\u044F\u043D\u0435\u0442\u043E \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
      return v;
    },
    updateVehicle(id, patch) {
      const prev = state.vehicles;
      state.vehicles = state.vehicles.map((v) => v.id === id ? { ...v, ...patch } : v);
      emit();
      apiFetch("/vehicles/" + id, { method: "PATCH", body: patch }).then((saved) => {
        state.vehicles = state.vehicles.map((v) => v.id === id ? reviveVehicle(saved) : v);
        emit();
      }).catch((err) => {
        state.vehicles = prev;
        emit();
        reportError(err, "\u041E\u0431\u043D\u043E\u0432\u044F\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    },
    // Bulk-apply completion + payments + vehicle-free atomically via
    // the single composite backend endpoint POST /rentals/:id/complete
    // (backend/src/routes/rentals.ts — confirmed this pass to already
    // implement the full equivalent of this action server-side inside
    // one Prisma $transaction), rather than orchestrating 4 separate
    // calls from the client. Local optimistic mutation mirrors the old
    // in-memory version's 4 sub-steps so the UI updates instantly.
    finalizeReturn({ rentalId, returnOdo, returnFuel, extraKmCharge, fuelCharge, depositAction, withheldAmount, withholdReason, notes, returnPhotos, hasNewDamages, damagePhotos, returnSignature, returnClean, cleaningFee, cleaningFeeWaived }) {
      const r = state.rentals.find((x) => x.id === rentalId);
      if (!r) return;
      const prevRentals = state.rentals;
      const prevPayments = state.payments;
      const prevVehicles = state.vehicles;
      state.rentals = state.rentals.map((x) => x.id === rentalId ? {
        ...x,
        returnOdo,
        returnFuel,
        extraKmCharge,
        fuelCharge,
        depositAction,
        withheldAmount,
        withholdReason,
        notes,
        status: "completed",
        completedAt: (/* @__PURE__ */ new Date()).toISOString()
      } : x);
      const now = /* @__PURE__ */ new Date();
      const optimisticPayments = [];
      if (extraKmCharge > 0) optimisticPayments.push({ id: genId("p"), rentalId, amount: extraKmCharge, method: "cash", purpose: "extra-km", date: now });
      if (fuelCharge > 0) optimisticPayments.push({ id: genId("p"), rentalId, amount: fuelCharge, method: "cash", purpose: "fuel", date: now });
      if (cleaningFee > 0 && !cleaningFeeWaived) optimisticPayments.push({ id: genId("p"), rentalId, amount: cleaningFee, method: "cash", purpose: "cleaning", date: now });
      const dep = r.deposit || 0;
      if (depositAction === "return" && dep > 0) {
        optimisticPayments.push({ id: genId("p"), rentalId, amount: -dep, method: "cash", purpose: "deposit-return", date: now });
      } else if (depositAction === "withhold-partial" && dep - (withheldAmount || 0) > 0) {
        optimisticPayments.push({ id: genId("p"), rentalId, amount: -(dep - withheldAmount), method: "cash", purpose: "deposit-return", date: now });
      }
      if (optimisticPayments.length) state.payments = [...state.payments, ...optimisticPayments];
      state.vehicles = state.vehicles.map((v) => v.id === r.vehicleId ? {
        ...v,
        odo: returnOdo != null ? returnOdo : r.handoverOdo,
        status: "available"
      } : v);
      emit();
      apiFetch("/rentals/" + rentalId + "/complete", {
        method: "POST",
        body: { returnOdo, returnFuel, extraKmCharge, fuelCharge, depositAction, withheldAmount, withholdReason, notes, returnClean, cleaningFee, cleaningFeeWaived }
      }).then((saved) => {
        state.rentals = state.rentals.map((x) => x.id === rentalId ? reviveRental(saved, x) : x);
        emit();
        Promise.all([
          apiFetch("/payments").catch(() => null),
          apiFetch("/vehicles/" + r.vehicleId).catch(() => null)
        ]).then(([allPayments, vehicle]) => {
          if (Array.isArray(allPayments)) {
            state.payments = allPayments.map(revivePayment);
          }
          if (vehicle) {
            state.vehicles = state.vehicles.map((v) => v.id === vehicle.id ? reviveVehicle(vehicle) : v);
          }
          emit();
        });
        const effectiveDamagePhotos = hasNewDamages && Array.isArray(damagePhotos) ? damagePhotos : [];
        persistReturnMedia(rentalId, returnPhotos, effectiveDamagePhotos, returnSignature).catch((err) => {
          reportError(err, "\u0410\u0440\u0445\u0438\u0432\u0438\u0440\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0441\u043D\u0438\u043C\u043A\u0438 \u043E\u0442 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
        }).then(() => {
          archiveReturnProtocol(rentalId, r, {
            returnOdo,
            returnFuel,
            extraKmCharge,
            fuelCharge,
            depositAction,
            withheldAmount,
            notes,
            returnClean,
            cleaningFee,
            cleaningFeeWaived,
            returnSignature
          }, returnPhotos, effectiveDamagePhotos);
        });
      }).catch((err) => {
        state.rentals = prevRentals;
        state.payments = prevPayments;
        state.vehicles = prevVehicles;
        emit();
        reportError(err, "\u0424\u0438\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E");
      });
    }
  };
  const selectors = {
    all: () => state,
    vehicles: () => state.vehicles,
    customers: () => state.customers,
    rentals: () => state.rentals,
    payments: () => state.payments,
    leads: () => state.leads,
    noShowLog: () => state.noShowLog,
    findNoShowsByPhone: (phone) => {
      if (!phone) return [];
      const norm = window.normalizeSearchable ? window.normalizeSearchable(phone) : phone.replace(/\s+/g, "");
      if (!norm) return [];
      return state.noShowLog.filter((entry) => {
        const p = entry.reservationPhone;
        if (!p) return false;
        const pn = window.normalizeSearchable ? window.normalizeSearchable(p) : p.replace(/\s+/g, "");
        return pn.includes(norm) || norm.includes(pn);
      });
    },
    legalTexts: () => state.legalTexts,
    contractTemplate: () => state.contractTemplate,
    companySettings: () => state.companySettings,
    smtpSettings: () => state.smtpSettings,
    emailTemplates: () => state.emailTemplates,
    // Phase 2Б email module
    emailLog: () => state.emailLog,
    emailsEnabled: () => state.emailsEnabled,
    extensionRequests: () => state.extensionRequests,
    pendingExtensionRequests: () => state.extensionRequests.filter((r) => r.status === "pending"),
    operations: () => state.operations,
    operatorProfile: () => state.operatorProfile,
    peekNextContractNumber: () => {
      const y = (window.TODAY || /* @__PURE__ */ new Date()).getFullYear();
      return String(state._localContractFallbackSeq).padStart(3, "0") + "/" + y;
    },
    findVehicle: (id) => state.vehicles.find((v) => v.id === id),
    findCustomer: (id) => state.customers.find((c) => c.id === id),
    findRental: (id) => state.rentals.find((r) => r.id === id),
    activeRentals: () => state.rentals.filter((r) => r.status === "active" || r.status === "overdue"),
    overdueRentals: () => state.rentals.filter((r) => r.status === "overdue"),
    rentalsForCustomer: (customerId) => state.rentals.filter((r) => r.customerId === customerId),
    outstanding: () => {
      const owed = {};
      for (const r of state.rentals) {
        if (r.status !== "active" && r.status !== "completed" && r.status !== "overdue") continue;
        owed[r.id] = r.total || 0;
      }
      for (const p of state.payments) {
        if (!p.rentalId || !(p.rentalId in owed)) continue;
        if (p.amount > 0 && p.purpose !== "deposit") {
          owed[p.rentalId] -= p.amount;
        }
      }
      return Object.entries(owed).filter(([, amount]) => amount > 5e-3).map(([rentalId, amount]) => ({ rentalId, amount }));
    },
    // Additive — not in docs/03, does not shadow/rename anything.
    // Lets login.jsx's AuthGate + any screen distinguish "bootstrap
    // hasn't loaded yet" from "genuinely empty database".
    isReady
  };
  const useStore = (selector) => {
    const [, force] = React.useReducer((x) => x + 1, 0);
    React.useEffect(() => subscribe(() => force()), []);
    return selector ? selector(selectors) : selectors;
  };
  const store = {
    ...selectors,
    ...actions,
    subscribe,
    nextContractNumber,
    useStore,
    bootstrap,
    // Additive — Stage 1C/backlog queue item 4. logClientError is also
    // called directly by app.jsx's ErrorBoundary (outside this
    // closure), which is why it's exposed here rather than kept
    // private like reportError used to be.
    logClientError,
    fetchErrorLog,
    // ── Phase 2A: document scanning (additive — all NEW names) ────
    // scan-documents.jsx (new component) and settings.jsx's scan panel
    // call these; nothing pre-existing is renamed or shadowed.
    scansHealth: () => apiFetch("/scans/health"),
    scanUploadPhotos: uploadScanPhotos,
    scanExtract: (scanId, photoKeys) => apiFetch("/scans", { method: "POST", body: { scanId, photoKeys } }),
    scanConfirm: (scanId, { customerId, customerName } = {}) => apiFetch(`/scans/${scanId}/confirm`, {
      method: "POST",
      body: { customerId, customerName }
    }),
    scanRetryExport: (scanId) => apiFetch(`/scans/${scanId}/retry-export`, { method: "POST", body: {} }),
    scanExportsList: () => apiFetch("/scans/exports"),
    scanQueueAdd: (entry) => scanQueuePut(entry),
    scanQueueList,
    scanQueueDelete,
    flushScanQueue,
    // Client-side scanId mint for the OFFLINE path (server mints when
    // online via /scans/upload-urls; offline needs the id before any
    // network exists). Same S-YYYYMMDD-HHMMSS-4hex format the backend
    // format-validates.
    newScanId: () => {
      const d = /* @__PURE__ */ new Date();
      const p = (n) => String(n).padStart(2, "0");
      const hex = Array.from(crypto.getRandomValues(new Uint8Array(2))).map((b) => b.toString(16).padStart(2, "0")).join("");
      return "S-" + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + "-" + p(d.getHours()) + p(d.getMinutes()) + p(d.getSeconds()) + "-" + hex;
    },
    // Bug fix (operator airplane-mode test, Stage 1C+, investigation
    // #2): reportError() was previously kept private to this closure
    // (every existing call site lives inside store.jsx's own actions).
    // rental-detail.jsx's doc-gen catch blocks (previewOne/shareOne/
    // shareAll — protected-file edit, disclosed and approved) now need
    // to call it from OUTSIDE this closure, the same way app.jsx's
    // ErrorBoundary already calls logClientError directly. Exposing it
    // here is the minimal fix; reportError's own behavior (console.error
    // + logClientError + toast) is completely unchanged.
    reportError
  };
  window.store = store;
  const syncGlobals = () => {
    window.RENTALS = state.rentals;
    window.CUSTOMERS = state.customers;
    window.VEHICLES = state.vehicles;
    window.PAYMENTS = state.payments;
    window.LEADS = state.leads;
  };
  syncGlobals();
  subscribe(syncGlobals);
})();

/* ══════════ components/primitives.jsx ══════════ */
var { useState, useRef, useEffect, useMemo, useCallback } = React;
function Icon({ name, size = 20, color = "currentColor", strokeWidth = 1.75, style = {} }) {
  const s = strokeWidth;
  const stroke = { fill: "none", stroke: color, strokeWidth: s, strokeLinecap: "round", strokeLinejoin: "round" };
  const paths = ICONS[name];
  if (!paths) return /* @__PURE__ */ React.createElement("span", { style: { display: "inline-block", width: size, height: size, ...style } });
  return /* @__PURE__ */ React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", style: { display: "block", flexShrink: 0, ...style } }, /* @__PURE__ */ React.createElement("g", { ...stroke }, paths));
}
var ICONS = {
  dashboard: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("rect", { x: "3.5", y: "3.5", width: "7", height: "9", rx: "1.5" }), /* @__PURE__ */ React.createElement("rect", { x: "13.5", y: "3.5", width: "7", height: "5", rx: "1.5" }), /* @__PURE__ */ React.createElement("rect", { x: "13.5", y: "11.5", width: "7", height: "9", rx: "1.5" }), /* @__PURE__ */ React.createElement("rect", { x: "3.5", y: "15.5", width: "7", height: "5", rx: "1.5" })),
  calendar: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("rect", { x: "3.5", y: "5", width: "17", height: "15.5", rx: "2" }), /* @__PURE__ */ React.createElement("path", { d: "M3.5 10h17" }), /* @__PURE__ */ React.createElement("path", { d: "M8 3v4M16 3v4" })),
  van: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M2 16V9.5A1.5 1.5 0 0 1 3.5 8h9V16" }), /* @__PURE__ */ React.createElement("path", { d: "M12.5 8h4.6a2 2 0 0 1 1.7.94L21 12.5V16" }), /* @__PURE__ */ React.createElement("path", { d: "M2 16h2M9 16h5M19 16h2" }), /* @__PURE__ */ React.createElement("circle", { cx: "6.5", cy: "16.5", r: "1.75" }), /* @__PURE__ */ React.createElement("circle", { cx: "16.5", cy: "16.5", r: "1.75" })),
  users: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("circle", { cx: "9", cy: "8", r: "3.5" }), /* @__PURE__ */ React.createElement("path", { d: "M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" }), /* @__PURE__ */ React.createElement("path", { d: "M15 6.5a3 3 0 1 1 0 6" }), /* @__PURE__ */ React.createElement("path", { d: "M17 14c2.8 0.5 5 2.9 5 6" })),
  euro: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M17.5 6.5A6.5 6.5 0 0 0 7 12a6.5 6.5 0 0 0 10.5 5.5" }), /* @__PURE__ */ React.createElement("path", { d: "M4 10.5h8M4 13.5h8" })),
  cog: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "12", r: "3" }), /* @__PURE__ */ React.createElement("path", { d: "M12 2v3M12 19v3M22 12h-3M5 12H2M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1M18.4 18.4l-2.1-2.1M7.7 7.7L5.6 5.6" })),
  bell: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6z" }), /* @__PURE__ */ React.createElement("path", { d: "M10 21a2 2 0 0 0 4 0" })),
  chart: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M3 21h18" }), /* @__PURE__ */ React.createElement("rect", { x: "5", y: "12", width: "3", height: "7" }), /* @__PURE__ */ React.createElement("rect", { x: "10.5", y: "8", width: "3", height: "11" }), /* @__PURE__ */ React.createElement("rect", { x: "16", y: "4", width: "3", height: "15" })),
  camera: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M4 8h3l2-2.5h6L17 8h3a1.5 1.5 0 0 1 1.5 1.5V19a1.5 1.5 0 0 1-1.5 1.5H4A1.5 1.5 0 0 1 2.5 19V9.5A1.5 1.5 0 0 1 4 8z" }), /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "13.5", r: "3.5" })),
  image: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("rect", { x: "3", y: "5", width: "18", height: "15", rx: "1.5" }), /* @__PURE__ */ React.createElement("circle", { cx: "8.5", cy: "10", r: "1.75" }), /* @__PURE__ */ React.createElement("path", { d: "M3 17l5-4.5 3.5 3 4-4.5L21 17" })),
  signature: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M3 18c3-1 5-3 7-6s3-6 5-6c1 0 2 1 1 3s-6 6-6 9c0 1 1 1.5 2 1" }), /* @__PURE__ */ React.createElement("path", { d: "M3 21h18" })),
  fuel: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("rect", { x: "4", y: "4", width: "9", height: "16", rx: "1.5" }), /* @__PURE__ */ React.createElement("path", { d: "M4 10h9" }), /* @__PURE__ */ React.createElement("path", { d: "M13 8l3 3v6a2 2 0 0 0 4 0V9l-3-3" })),
  battery: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("rect", { x: "3", y: "7", width: "16", height: "10", rx: "1.5" }), /* @__PURE__ */ React.createElement("path", { d: "M19 10v4h2v-4z" }), /* @__PURE__ */ React.createElement("rect", { x: "6", y: "9.5", width: "9", height: "5", rx: "0.5", fill: "currentColor", stroke: "none" })),
  gauge: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M4 18a8 8 0 1 1 16 0" }), /* @__PURE__ */ React.createElement("path", { d: "M12 18l4-5" }), /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "18", r: "1" })),
  arrowRight: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M5 12h14" }), /* @__PURE__ */ React.createElement("path", { d: "M13 6l6 6-6 6" })),
  arrowLeft: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M19 12H5" }), /* @__PURE__ */ React.createElement("path", { d: "M11 18l-6-6 6-6" })),
  plus: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M12 5v14M5 12h14" })),
  check: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M4 12l5 5L20 6" })),
  x: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M6 6l12 12M18 6L6 18" })),
  warn: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M12 3.5L22 20H2z" }), /* @__PURE__ */ React.createElement("path", { d: "M12 10v5M12 17.5v.5" })),
  info: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "12", r: "9" }), /* @__PURE__ */ React.createElement("path", { d: "M12 11v6M12 8v.5" })),
  search: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("circle", { cx: "11", cy: "11", r: "6.5" }), /* @__PURE__ */ React.createElement("path", { d: "M16 16l4 4" })),
  clock: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "12", r: "9" }), /* @__PURE__ */ React.createElement("path", { d: "M12 7v5.5l3.5 2.5" })),
  phone: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A15 15 0 0 1 3 6a2 2 0 0 1 2-2z" })),
  mail: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("rect", { x: "3", y: "5", width: "18", height: "14", rx: "1.5" }), /* @__PURE__ */ React.createElement("path", { d: "M3.5 6l8.5 7 8.5-7" })),
  file: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M14 3H6.5A1.5 1.5 0 0 0 5 4.5v15A1.5 1.5 0 0 0 6.5 21h11a1.5 1.5 0 0 0 1.5-1.5V8z" }), /* @__PURE__ */ React.createElement("path", { d: "M14 3v5h5" })),
  filePdf: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M14 3H6.5A1.5 1.5 0 0 0 5 4.5v15A1.5 1.5 0 0 0 6.5 21h11a1.5 1.5 0 0 0 1.5-1.5V8z" }), /* @__PURE__ */ React.createElement("path", { d: "M14 3v5h5" }), /* @__PURE__ */ React.createElement("path", { d: "M8 14h1a1 1 0 0 1 0 2H8v2M12 14v4M12 14h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-1M16 14h2M16 14v4M16 16h1.5" })),
  share: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("circle", { cx: "6", cy: "12", r: "2.5" }), /* @__PURE__ */ React.createElement("circle", { cx: "18", cy: "6", r: "2.5" }), /* @__PURE__ */ React.createElement("circle", { cx: "18", cy: "18", r: "2.5" }), /* @__PURE__ */ React.createElement("path", { d: "M8.2 10.9l7.6-3.8M8.2 13.1l7.6 3.8" })),
  menu: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M3 6h18M3 12h18M3 18h18" })),
  chevronR: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M9 6l6 6-6 6" })),
  chevronL: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M15 6l-6 6 6 6" })),
  chevronD: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M6 9l6 6 6-6" })),
  chevronU: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M6 15l6-6 6 6" })),
  edit: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M4 20h4l10-10-4-4L4 16z" }), /* @__PURE__ */ React.createElement("path", { d: "M14 6l4 4" })),
  trash: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M4 7h16" }), /* @__PURE__ */ React.createElement("path", { d: "M9 7V4h6v3" }), /* @__PURE__ */ React.createElement("path", { d: "M6 7l1 13a1.5 1.5 0 0 0 1.5 1.5h7A1.5 1.5 0 0 0 17 20l1-13" })),
  filter: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M4 5h16l-6 8v6l-4-2v-4z" })),
  copy: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("rect", { x: "8", y: "8", width: "12", height: "12", rx: "1.5" }), /* @__PURE__ */ React.createElement("path", { d: "M16 8V5.5A1.5 1.5 0 0 0 14.5 4h-9A1.5 1.5 0 0 0 4 5.5v9A1.5 1.5 0 0 0 5.5 16H8" })),
  key: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("circle", { cx: "8", cy: "15", r: "4" }), /* @__PURE__ */ React.createElement("path", { d: "M11 13l8-8M17 5l2 2M14 8l2 2" })),
  location: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M12 21c4-5 7-8.7 7-12a7 7 0 1 0-14 0c0 3.3 3 7 7 12z" }), /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "9.5", r: "2.5" })),
  home: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M4 11l8-6 8 6v9a1 1 0 0 1-1 1h-4v-6h-6v6H5a1 1 0 0 1-1-1z" })),
  logout: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M10 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4" }), /* @__PURE__ */ React.createElement("path", { d: "M15 8l4 4-4 4M9 12h10" })),
  refresh: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M4 12a8 8 0 0 1 14-5.5L20 4v6h-6" }), /* @__PURE__ */ React.createElement("path", { d: "M20 12a8 8 0 0 1-14 5.5L4 20v-6h6" })),
  eye: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" }), /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "12", r: "3" })),
  eyeOff: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M17.94 17.94A10.94 10.94 0 0 1 12 19c-6.5 0-10-7-10-7a19.7 19.7 0 0 1 4.06-5.06M9.9 4.24A10.94 10.94 0 0 1 12 4c6.5 0 10 7 10 7a19.7 19.7 0 0 1-3.16 4.19M1 1l22 22M9.88 9.88a3 3 0 1 0 4.24 4.24" })),
  bolt: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M13 3L4 14h6l-1 7 9-11h-6z" })),
  wrench: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M14.5 4.5a4 4 0 0 1 5 5l-2-2-2 2-2-2 2-2z" }), /* @__PURE__ */ React.createElement("path", { d: "M13 8L5 16a2.5 2.5 0 0 0 3.5 3.5L16.5 11.5" })),
  paint: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("rect", { x: "3", y: "4", width: "14", height: "6", rx: "1" }), /* @__PURE__ */ React.createElement("path", { d: "M17 7h2a2 2 0 0 1 2 2v3a1 1 0 0 1-1 1h-8" }), /* @__PURE__ */ React.createElement("path", { d: "M12 13v3a1 1 0 0 1-1 1h-2v3h-3v-3H4v-4" })),
  voucher: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3a2 2 0 0 0 0-4z" }), /* @__PURE__ */ React.createElement("path", { d: "M9 8v8", strokeDasharray: "1.5 2.5" })),
  send: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M4 12L20 4l-6 16-3-7z" })),
  block: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "12", r: "9" }), /* @__PURE__ */ React.createElement("path", { d: "M5.5 5.5l13 13" })),
  star: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6L12 16.9 6.6 19.8l1-6L3.2 9.5l6.1-.9z" })),
  drive: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M8 4h8l6 10-4 6H6l-4-6z" }), /* @__PURE__ */ React.createElement("path", { d: "M8 4l-6 10M16 4l6 10M6 20l6-10M14 4l-6 10" })),
  sheet: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("rect", { x: "3.5", y: "3.5", width: "17", height: "17", rx: "1.5" }), /* @__PURE__ */ React.createElement("path", { d: "M3.5 9h17M3.5 14.5h17M9 3.5v17M15 3.5v17" })),
  add_photo: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("rect", { x: "3", y: "6", width: "18", height: "14", rx: "1.5" }), /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "13", r: "4" }), /* @__PURE__ */ React.createElement("path", { d: "M12 11v4M10 13h4" }), /* @__PURE__ */ React.createElement("path", { d: "M8 6l1.5-2h5L16 6" }))
};
function Button({
  children,
  onClick,
  kind = "ghost",
  size = "md",
  block = false,
  disabled = false,
  icon = null,
  iconRight = null,
  style = {},
  title,
  danger = false
}) {
  const [hover, setHover] = useState(false);
  const [press, setPress] = useState(false);
  const sizes = {
    xs: { h: 28, px: 10, fs: 12, gap: 6, ir: 14, r: 6 },
    sm: { h: 36, px: 12, fs: 13, gap: 8, ir: 16, r: 8 },
    md: { h: 44, px: 16, fs: 14, gap: 8, ir: 18, r: 10 },
    lg: { h: 52, px: 20, fs: 16, gap: 10, ir: 20, r: 12 },
    xl: { h: 64, px: 28, fs: 18, gap: 12, ir: 22, r: 14 }
  }[size];
  const kinds = {
    primary: {
      bg: danger ? T.red : T.accent,
      bgHover: danger ? "#F26565" : T.accentHover,
      color: "#fff",
      border: "transparent"
    },
    secondary: {
      bg: T.bg2,
      bgHover: T.bg3,
      color: T.text0,
      border: T.border
    },
    ghost: {
      bg: "transparent",
      bgHover: T.bg2,
      color: T.text1,
      border: "transparent"
    },
    outline: {
      bg: "transparent",
      bgHover: T.bg2,
      color: T.text0,
      border: T.border
    },
    danger: {
      bg: T.red,
      bgHover: "#F26565",
      color: "#fff",
      border: "transparent"
    }
  }[kind] || {};
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      title,
      disabled,
      onClick,
      onMouseEnter: () => setHover(true),
      onMouseLeave: () => {
        setHover(false);
        setPress(false);
      },
      onMouseDown: () => setPress(true),
      onMouseUp: () => setPress(false),
      style: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: sizes.gap,
        height: sizes.h,
        padding: `0 ${sizes.px}px`,
        fontSize: sizes.fs,
        fontWeight: 600,
        letterSpacing: 0.1,
        borderRadius: sizes.r,
        background: disabled ? T.bg2 : hover ? kinds.bgHover : kinds.bg,
        color: disabled ? T.text3 : kinds.color,
        border: `1px solid ${kinds.border === "transparent" ? "transparent" : kinds.border}`,
        cursor: disabled ? "not-allowed" : "pointer",
        width: block ? "100%" : "auto",
        transform: press ? "translateY(1px)" : "none",
        transition: "background 0.12s, transform 0.05s",
        whiteSpace: "nowrap",
        ...style
      }
    },
    icon && /* @__PURE__ */ React.createElement(Icon, { name: icon, size: sizes.ir }),
    children,
    iconRight && /* @__PURE__ */ React.createElement(Icon, { name: iconRight, size: sizes.ir })
  );
}
function IconBtn({ icon, onClick, size = 40, title, active = false, style = {} }) {
  const [hover, setHover] = useState(false);
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      title,
      onClick,
      onMouseEnter: () => setHover(true),
      onMouseLeave: () => setHover(false),
      style: {
        width: size,
        height: size,
        borderRadius: 10,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: active ? T.accentTint : hover ? T.bg2 : "transparent",
        color: active ? T.accent : T.text1,
        border: "1px solid transparent",
        transition: "background 0.12s",
        ...style
      }
    },
    /* @__PURE__ */ React.createElement(Icon, { name: icon, size: Math.round(size * 0.5) })
  );
}
var STATUS_COLORS = {
  available: { c: T.green, label: "Available" },
  rented: { c: T.blue, label: "Rented" },
  reserved: { c: T.yellow, label: "Reserved" },
  active: { c: T.green, label: "Active" },
  completed: { c: T.gray, label: "Completed" },
  cancelled: { c: T.gray, label: "Cancelled" },
  overdue: { c: T.red, label: "Overdue" },
  "no-show": { c: T.orange, label: "No-show" },
  in_service: { c: T.gray, label: "In service" },
  cleaning: { c: T.gray, label: "Cleaning" },
  inactive: { c: T.gray, label: "Inactive" },
  ok: { c: T.green, label: "OK" },
  warn: { c: T.yellow, label: "Warning" },
  danger: { c: T.red, label: "Blocked" }
};
function StatusDot({ status, size = 10, style = {} }) {
  const c = (STATUS_COLORS[status] || { c: T.gray }).c;
  return /* @__PURE__ */ React.createElement("span", { style: {
    display: "inline-block",
    width: size,
    height: size,
    borderRadius: 999,
    background: c,
    boxShadow: `0 0 0 3px ${c}22`,
    flexShrink: 0,
    ...style
  } });
}
function Chip({ children, tone = "gray", size = "md", icon, style = {} }) {
  const tones = {
    gray: { bg: T.grayTint, c: T.text1, b: "transparent" },
    green: { bg: T.greenTint, c: "#4ADE80", b: "transparent" },
    yellow: { bg: T.yellowTint, c: "#FBBF24", b: "transparent" },
    orange: { bg: T.orangeTint, c: "#FB923C", b: "transparent" },
    red: { bg: T.redTint, c: "#F87171", b: "transparent" },
    blue: { bg: T.blueTint, c: "#60A5FA", b: "transparent" },
    accent: { bg: T.accentTint, c: "#7EA8FF", b: "transparent" },
    outline: { bg: "transparent", c: T.text1, b: T.border }
  }[tone] || {};
  const sizes = {
    sm: { h: 22, px: 8, fs: 11, gap: 5 },
    md: { h: 26, px: 10, fs: 12, gap: 6 },
    lg: { h: 32, px: 12, fs: 13, gap: 7 }
  }[size];
  return /* @__PURE__ */ React.createElement("span", { style: {
    display: "inline-flex",
    alignItems: "center",
    gap: sizes.gap,
    height: sizes.h,
    padding: `0 ${sizes.px}px`,
    background: tones.bg,
    color: tones.c,
    border: `1px solid ${tones.b}`,
    borderRadius: 999,
    fontSize: sizes.fs,
    fontWeight: 600,
    letterSpacing: 0.2,
    whiteSpace: "nowrap",
    ...style
  } }, icon && /* @__PURE__ */ React.createElement(Icon, { name: icon, size: sizes.fs + 2 }), children);
}
function Card({ children, style = {}, pad = 20, tone = "panel", hover = false, onClick }) {
  const [hov, setHov] = useState(false);
  const bg = tone === "panel" ? T.bg1 : tone === "raised" ? T.bg2 : "transparent";
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      onClick,
      onMouseEnter: () => setHov(true),
      onMouseLeave: () => setHov(false),
      style: {
        background: hover && hov ? T.bg2 : bg,
        border: `1px solid ${T.border}`,
        borderRadius: 14,
        padding: pad,
        cursor: onClick ? "pointer" : "default",
        transition: "background 0.12s",
        ...style
      }
    },
    children
  );
}
function Field({ label, hint, error, children, style = {} }) {
  return /* @__PURE__ */ React.createElement("label", { style: { display: "block", ...style } }, label && /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 12,
    fontWeight: 600,
    color: T.text2,
    textTransform: "uppercase",
    letterSpacing: 0.06 * 12,
    marginBottom: 6
  } }, label), children, hint && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginTop: 6 } }, hint), error && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.red, marginTop: 6 } }, error));
}
function Input({ value, onChange, placeholder, size = "md", style = {}, mono = false, type = "text", suffix, prefix, disabled, readOnly, inputMode }) {
  const [focus, setFocus] = useState(false);
  const heights = { sm: 36, md: 44, lg: 52 };
  const fss = { sm: 13, md: 14, lg: 16 };
  return /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    background: T.bg2,
    border: `1px solid ${focus ? T.accent : T.border}`,
    borderRadius: 10,
    height: heights[size],
    padding: "0 14px",
    transition: "border 0.12s",
    opacity: disabled ? 0.5 : 1,
    ...style
  } }, prefix && /* @__PURE__ */ React.createElement("div", { style: { color: T.text2, marginRight: 8, fontSize: fss[size] } }, prefix), /* @__PURE__ */ React.createElement(
    "input",
    {
      type,
      inputMode,
      value: value == null ? "" : value,
      onChange,
      onFocus: () => setFocus(true),
      onBlur: () => setFocus(false),
      placeholder,
      readOnly,
      disabled,
      style: {
        flex: 1,
        background: "transparent",
        border: "none",
        outline: "none",
        color: T.text0,
        fontSize: fss[size],
        fontWeight: 500,
        fontFamily: mono ? "var(--font-mono)" : "var(--font-ui)",
        minWidth: 0
      }
    }
  ), suffix && /* @__PURE__ */ React.createElement("div", { style: { color: T.text2, marginLeft: 8, fontSize: fss[size] } }, suffix));
}
function NumberInput({
  value,
  onChange,
  decimals = 2,
  allowNegative = false,
  min,
  max,
  size = "md",
  suffix,
  prefix,
  disabled,
  readOnly,
  style = {},
  placeholder,
  // money: when true, on-blur canonicalization renders the full
  // Bulgarian money format (fixed decimals + thousands separator, e.g.
  // "198" -> "198,00", "1250.5" -> "1 250,50") instead of the
  // trailing-zero-stripped compact form used for km/hours/plain counts.
  money = false
}) {
  const fmtForDisplay = (n) => money ? numToMoneyStr(n, decimals) : numToStr(n, decimals);
  const [draft, setDraft] = useState(() => value == null || Number.isNaN(value) ? "" : fmtForDisplay(value));
  const [focus, setFocus] = useState(false);
  useEffect(() => {
    if (!focus) {
      const next = value == null || Number.isNaN(value) ? "" : fmtForDisplay(value);
      if (next !== draft) setDraft(next);
    }
  }, [value]);
  const handleChange = (e) => {
    let raw = e.target.value;
    raw = raw.replace(/\./g, ",");
    if (allowNegative) {
      raw = raw.replace(/[^0-9,\-]/g, "");
      raw = raw.replace(/(?!^)-/g, "");
    } else {
      raw = raw.replace(/[^0-9,]/g, "");
    }
    const firstComma = raw.indexOf(",");
    if (firstComma !== -1) {
      raw = raw.slice(0, firstComma + 1) + raw.slice(firstComma + 1).replace(/,/g, "");
    }
    if (decimals === 0) {
      raw = raw.split(",")[0];
    } else if (firstComma !== -1) {
      const [intp, frac] = raw.split(",");
      raw = intp + "," + (frac || "").slice(0, decimals);
    }
    setDraft(raw);
    const parsed = parseBGNumber(raw);
    if (parsed === null) {
      onChange && onChange(null);
    } else {
      onChange && onChange(parsed);
    }
  };
  const handleBlur = () => {
    setFocus(false);
    let n = parseBGNumber(draft);
    if (n === null) {
      setDraft("");
      return;
    }
    if (typeof min === "number" && n < min) n = min;
    if (typeof max === "number" && n > max) n = max;
    onChange && onChange(n);
    setDraft(money ? numToMoneyStr(n, decimals) : numToStr(n, decimals));
  };
  const heights = { sm: 36, md: 44, lg: 52 };
  const fss = { sm: 13, md: 14, lg: 16 };
  return /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    background: T.bg2,
    border: `1px solid ${focus ? T.accent : T.border}`,
    borderRadius: 10,
    height: heights[size],
    padding: "0 14px",
    transition: "border 0.12s",
    opacity: disabled ? 0.5 : 1,
    ...style
  } }, prefix && /* @__PURE__ */ React.createElement("div", { style: { color: T.text2, marginRight: 8, fontSize: fss[size] } }, prefix), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      inputMode: "decimal",
      pattern: "[0-9]*[.,]?[0-9]*",
      value: draft,
      onChange: handleChange,
      onFocus: () => setFocus(true),
      onBlur: handleBlur,
      placeholder,
      readOnly,
      disabled,
      style: {
        flex: 1,
        background: "transparent",
        border: "none",
        outline: "none",
        color: T.text0,
        fontSize: fss[size],
        fontWeight: 500,
        fontFamily: "var(--font-mono)",
        fontVariantNumeric: "tabular-nums",
        minWidth: 0,
        textAlign: "left"
      }
    }
  ), suffix && /* @__PURE__ */ React.createElement("div", { style: { color: T.text2, marginLeft: 8, fontSize: fss[size] } }, suffix));
}
function parseBGNumber(raw) {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (s === "" || s === "-" || s === "," || s === "-,") return null;
  const dotted = s.replace(",", ".");
  const n = Number(dotted);
  return Number.isFinite(n) ? n : null;
}
function numToStr(n, decimals) {
  if (n == null || Number.isNaN(n)) return "";
  if (decimals == null) {
    if (Number.isInteger(n)) return String(n);
    return String(n).replace(".", ",");
  }
  const fixed = n.toFixed(decimals);
  const trimmed = decimals > 0 ? fixed.replace(/\.?0+$/, "") : fixed;
  return trimmed.replace(".", ",");
}
function numToMoneyStr(n, decimals) {
  if (n == null || Number.isNaN(n)) return "";
  if (!window.fmtEuro) return numToStr(n, decimals);
  return window.fmtEuro(n, { dp: decimals, showSymbol: false });
}
function Textarea({ value, onChange, placeholder, rows = 4, style = {}, mono = false }) {
  const [focus, setFocus] = useState(false);
  return /* @__PURE__ */ React.createElement(
    "textarea",
    {
      value: value || "",
      onChange,
      onFocus: () => setFocus(true),
      onBlur: () => setFocus(false),
      placeholder,
      rows,
      style: {
        width: "100%",
        background: T.bg2,
        border: `1px solid ${focus ? T.accent : T.border}`,
        borderRadius: 10,
        padding: "10px 14px",
        color: T.text0,
        fontSize: 14,
        fontFamily: mono ? "var(--font-mono)" : "var(--font-ui)",
        resize: "vertical",
        outline: "none",
        transition: "border 0.12s",
        ...style
      }
    }
  );
}
function Segmented({ value, onChange, options, size = "md", block = false, style = {} }) {
  const heights = { sm: 32, md: 40, lg: 48 };
  return /* @__PURE__ */ React.createElement("div", { style: {
    display: "inline-flex",
    background: T.bg2,
    border: `1px solid ${T.border}`,
    borderRadius: 10,
    padding: 3,
    height: heights[size],
    width: block ? "100%" : "auto",
    ...style
  } }, options.map((opt) => {
    const active = opt.value === value;
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: opt.value,
        onClick: () => onChange && onChange(opt.value),
        style: {
          flex: block ? 1 : "initial",
          padding: "0 14px",
          borderRadius: 8,
          background: active ? T.bg4 : "transparent",
          color: active ? T.text0 : T.text1,
          fontWeight: 600,
          fontSize: size === "sm" ? 12 : 13,
          transition: "background 0.12s, color 0.12s"
        }
      },
      opt.label
    );
  }));
}
function SectionHeader({ title, subtitle, right, style = {} }) {
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "flex-end", justifyContent: "space-between", marginBottom: 16, ...style } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 22, fontWeight: 700, letterSpacing: -0.2 } }, title), subtitle && /* @__PURE__ */ React.createElement("div", { style: { color: T.text2, fontSize: 13, marginTop: 4 } }, subtitle)), right);
}
function VanGlyph({ size = 40, drivetrain = "diesel", color }) {
  const bodyColor = color || (drivetrain === "electric" ? "#7EA8FF" : T.text1);
  return /* @__PURE__ */ React.createElement("svg", { width: size, height: size * 0.6, viewBox: "0 0 60 36", style: { display: "block" } }, /* @__PURE__ */ React.createElement("g", { fill: "none", stroke: bodyColor, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ React.createElement("path", { d: "M4 26V13a2 2 0 0 1 2-2h27v15" }), /* @__PURE__ */ React.createElement("path", { d: "M33 11h9a3 3 0 0 1 2.5 1.4L52 21v5" }), /* @__PURE__ */ React.createElement("path", { d: "M4 26h5M18 26h20M46 26h6" }), /* @__PURE__ */ React.createElement("circle", { cx: "13", cy: "27", r: "3.5" }), /* @__PURE__ */ React.createElement("circle", { cx: "43", cy: "27", r: "3.5" }), /* @__PURE__ */ React.createElement("path", { d: "M9 15h20M35 15h9l4 5h-13z" }), drivetrain === "electric" && /* @__PURE__ */ React.createElement("path", { d: "M23 5l-4 6h4l-2 6", strokeWidth: "1.6", stroke: "#7EA8FF" })));
}
Object.assign(window, {
  Icon,
  Button,
  IconBtn,
  StatusDot,
  Chip,
  Card,
  Field,
  Input,
  NumberInput,
  Textarea,
  Segmented,
  SectionHeader,
  VanGlyph,
  STATUS_COLORS,
  parseBGNumber,
  numToStr
});

/* ══════════ components/toast.jsx ══════════ */
var ToastContext = React.createContext({ push: () => {
} });
function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const push = React.useCallback((toast) => {
    const id = "t" + Date.now() + Math.random().toString(36).slice(2, 5);
    const item = { id, tone: "info", duration: 4200, ...toast };
    setToasts((prev) => [...prev, item]);
    if (item.duration > 0) {
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, item.duration);
    }
  }, []);
  const dismiss = React.useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);
  useEffect(() => {
    window.toast = {
      info: (msg, opts) => push({ tone: "info", message: msg, ...opts }),
      success: (msg, opts) => push({ tone: "success", message: msg, ...opts }),
      warn: (msg, opts) => push({ tone: "warn", message: msg, ...opts }),
      error: (msg, opts) => push({ tone: "error", message: msg, ...opts }),
      phase2: (msg, opts) => push({ tone: "phase2", message: msg, ...opts })
    };
  }, [push]);
  return /* @__PURE__ */ React.createElement(ToastContext.Provider, { value: { push, dismiss } }, children, /* @__PURE__ */ React.createElement(ToastRail, { toasts, onDismiss: dismiss }));
}
function ToastRail({ toasts, onDismiss }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    bottom: 20,
    left: 20,
    right: 20,
    display: "flex",
    flexDirection: "column-reverse",
    gap: 8,
    alignItems: "center",
    pointerEvents: "none",
    zIndex: 400
  } }, toasts.map((t) => /* @__PURE__ */ React.createElement(ToastCard, { key: t.id, toast: t, onDismiss: () => onDismiss(t.id) })));
}
var TOAST_STYLES = {
  info: { bg: T.blueTint, border: "rgba(59,118,240,0.4)", color: "#93C5FD", icon: "info" },
  success: { bg: T.greenTint, border: "rgba(34,197,94,0.4)", color: "#86EFAC", icon: "check" },
  warn: { bg: T.yellowTint, border: "rgba(245,165,36,0.4)", color: "#FBBF24", icon: "warn" },
  error: { bg: T.redTint, border: "rgba(239,68,68,0.4)", color: "#F87171", icon: "warn" },
  phase2: { bg: "rgba(139,92,246,0.14)", border: "rgba(139,92,246,0.4)", color: "#C4B5FD", icon: "info" }
};
function ToastCard({ toast, onDismiss }) {
  const s = TOAST_STYLES[toast.tone] || TOAST_STYLES.info;
  return /* @__PURE__ */ React.createElement("div", { style: {
    pointerEvents: "auto",
    minWidth: 300,
    maxWidth: 480,
    padding: "12px 14px",
    background: T.bg1,
    border: `1px solid ${s.border}`,
    borderRadius: 12,
    boxShadow: "0 12px 32px rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
    animation: "toastSlide 0.25s ease-out"
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 32,
    height: 32,
    borderRadius: 8,
    background: s.bg,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
  } }, /* @__PURE__ */ React.createElement(Icon, { name: s.icon, size: 16, color: s.color })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, toast.title && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 700, color: T.text0, marginBottom: 2 } }, toast.title), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: T.text1, lineHeight: 1.5 } }, toast.message), toast.tone === "phase2" && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10.5, color: T.text3, marginTop: 4, letterSpacing: 0.5, fontWeight: 600, textTransform: "uppercase" } }, "Phase 2 \xB7 to be wired to backend")), /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: onDismiss,
      style: {
        background: "transparent",
        border: "none",
        color: T.text2,
        cursor: "pointer",
        padding: 4
      }
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "x", size: 14, color: T.text2 })
  ));
}
var style = document.createElement("style");
style.textContent = `
  @keyframes toastSlide {
    from { transform: translateY(20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
`;
document.head.appendChild(style);
Object.assign(window, { ToastProvider, ToastContext });

/* ══════════ components/nav.jsx ══════════ */
var NAV_ITEMS = [
  { id: "dashboard", label: "Dashboard", icon: "dashboard" },
  { id: "calendar", label: "Calendar", icon: "calendar" },
  { id: "fleet", label: "Fleet", icon: "van" },
  { id: "customers", label: "Customers", icon: "users" },
  { id: "payments", label: "Payments", icon: "euro" },
  { id: "journal", label: "Journal", icon: "sheet" }
];
var NAV_SECONDARY = [
  { id: "damage", label: "Damage", icon: "warn", badge: 1 },
  { id: "vouchers", label: "Vouchers", icon: "voucher" },
  { id: "reports", label: "Reports", icon: "chart" },
  { id: "settings", label: "Settings", icon: "cog" }
];
function LeftRail({ route, onGo, notifications = 3 }) {
  store.useStore();
  const profile = window.store && window.store.operatorProfile ? window.store.operatorProfile() : { name: "\u041D\u0438\u043A\u043E\u043B\u0430\u0439 \u041C\u0443\u0442\u0430\u0444\u0447\u0438\u0435\u0432", role: "\u0423\u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B" };
  const initials = (profile.name || "\u041D\u041C").split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0] || "").join("").toUpperCase() || "\u041D\u041C";
  return /* @__PURE__ */ React.createElement("div", { style: {
    width: 240,
    height: "100%",
    background: T.bg1,
    borderRight: `1px solid ${T.border}`,
    display: "flex",
    flexDirection: "column",
    padding: "18px 12px",
    flexShrink: 0
  } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, padding: "4px 8px 20px" } }, /* @__PURE__ */ React.createElement(BrandMark, { size: 32 }), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 800, fontSize: 15, letterSpacing: -0.2 } }, "banicharka.bg"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10.5, color: T.text2, letterSpacing: 0.4, textTransform: "uppercase" } }, "Rental Ops"))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 2 } }, NAV_ITEMS.map((it) => /* @__PURE__ */ React.createElement(NavItem, { key: it.id, item: it, active: route === it.id, onClick: () => onGo(it.id) }))), /* @__PURE__ */ React.createElement("div", { style: { height: 1, background: T.border, margin: "18px 8px 12px" } }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10.5, color: T.text3, letterSpacing: 0.5, textTransform: "uppercase", padding: "0 8px 6px" } }, "Phase 2"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 2 } }, NAV_SECONDARY.map((it) => /* @__PURE__ */ React.createElement(NavItem, { key: it.id, item: it, active: route === it.id, onClick: () => onGo(it.id) }))), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }), /* @__PURE__ */ React.createElement("div", { style: {
    marginTop: 12,
    background: T.bg2,
    border: `1px solid ${T.border}`,
    borderRadius: 12,
    padding: 12,
    display: "flex",
    alignItems: "center",
    gap: 10
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 36,
    height: 36,
    borderRadius: 999,
    background: T.accent,
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: 14
  } }, initials), /* @__PURE__ */ React.createElement("div", { style: { minWidth: 0, flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } }, profile.name || "\u2014"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2 } }, profile.role || "Operator", " \xB7 online")), /* @__PURE__ */ React.createElement(IconBtn, { icon: "logout", size: 30, title: "Sign out", onClick: () => window.dispatchEvent(new CustomEvent("bnc-logout")) })));
}
function NavItem({ item, active, onClick }) {
  const [hover, setHover] = useState(false);
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick,
      onMouseEnter: () => setHover(true),
      onMouseLeave: () => setHover(false),
      style: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 12px",
        borderRadius: 10,
        background: active ? T.accentTint : hover ? T.bg2 : "transparent",
        color: active ? T.text0 : T.text1,
        fontWeight: 600,
        fontSize: 14,
        letterSpacing: 0.1,
        border: `1px solid ${active ? "rgba(26,92,230,0.35)" : "transparent"}`,
        position: "relative",
        transition: "background 0.12s",
        textAlign: "left"
      }
    },
    /* @__PURE__ */ React.createElement(Icon, { name: item.icon, size: 18, color: active ? T.accent : "currentColor" }),
    /* @__PURE__ */ React.createElement("span", { style: { flex: 1 } }, item.label),
    item.badge && /* @__PURE__ */ React.createElement("span", { style: {
      background: T.red,
      color: "#fff",
      fontSize: 10,
      fontWeight: 700,
      borderRadius: 999,
      padding: "2px 6px",
      minWidth: 18,
      textAlign: "center"
    } }, item.badge)
  );
}
function BrandMark({ size = 32 }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    width: size,
    height: size,
    borderRadius: 8,
    background: T.accent,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 800,
    color: "#fff",
    letterSpacing: -0.5,
    fontSize: size * 0.5,
    fontFamily: "var(--font-ui)"
  } }, "b.");
}
function TopBar({ title, subtitle, right, onMenu, showMenu = false }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    height: 64,
    padding: "0 24px",
    display: "flex",
    alignItems: "center",
    gap: 16,
    borderBottom: `1px solid ${T.border}`,
    background: T.bg0,
    flexShrink: 0
  } }, showMenu && /* @__PURE__ */ React.createElement(IconBtn, { icon: "menu", onClick: onMenu }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 17, fontWeight: 700, letterSpacing: -0.2 } }, title), subtitle && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginTop: 1 } }, subtitle)), right);
}
var PHONE_TABS = [
  { id: "dashboard", label: "Home", icon: "home" },
  { id: "calendar", label: "Calendar", icon: "calendar" },
  { id: "wizard-launcher", label: "New", icon: "plus", primary: true },
  { id: "customers", label: "People", icon: "users" },
  { id: "more", label: "More", icon: "menu" }
];
function BottomTabs({ route, onGo }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    height: 74,
    background: T.bg1,
    borderTop: `1px solid ${T.border}`,
    display: "flex",
    alignItems: "stretch",
    padding: "6px 6px 10px",
    flexShrink: 0
  } }, PHONE_TABS.map((t) => {
    const active = route === t.id || t.id === "dashboard" && route === "dashboard";
    if (t.primary) {
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          key: t.id,
          onClick: () => onGo(t.id),
          style: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 2
          }
        },
        /* @__PURE__ */ React.createElement("div", { style: {
          width: 48,
          height: 48,
          borderRadius: 14,
          background: T.accent,
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 14px rgba(26,92,230,0.4)"
        } }, /* @__PURE__ */ React.createElement(Icon, { name: "plus", size: 24 }))
      );
    }
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: t.id,
        onClick: () => onGo(t.id),
        style: {
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 3,
          color: active ? T.accent : T.text2,
          fontWeight: 600,
          fontSize: 10.5
        }
      },
      /* @__PURE__ */ React.createElement(Icon, { name: t.icon, size: 22, color: active ? T.accent : T.text2 }),
      t.label
    );
  }));
}
Object.assign(window, { LeftRail, TopBar, BottomTabs, BrandMark, NAV_ITEMS });

/* ══════════ components/login.jsx ══════════ */
(() => {
  const API_BASE = window.__API_BASE__ || "http://localhost:8787/api";
  async function apiPost(path, body) {
    const res = await fetch(API_BASE + path, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body || {})
    });
    let data = null;
    const text = await res.text();
    if (text) {
      try {
        data = JSON.parse(text);
      } catch (_) {
        data = null;
      }
    }
    if (!res.ok) {
      const message = data && data.message || data && data.error || `Request failed (${res.status})`;
      const err = new Error(message);
      err.status = res.status;
      throw err;
    }
    return data;
  }
  async function apiGetMe() {
    const res = await fetch(API_BASE + "/auth/me", { credentials: "include" });
    if (res.status === 401) return null;
    if (!res.ok) throw new Error("Session check failed (" + res.status + ")");
    const data = await res.json();
    return data.operator;
  }
  async function apiLogout() {
    try {
      await apiPost("/auth/logout");
    } catch (err) {
      console.warn("[login] logout call failed (continuing to log out client-side):", err);
    }
  }
  function AuthGate({ children }) {
    const [phase, setPhase] = React.useState("checking");
    const [error, setError] = React.useState(null);
    const enterApp = React.useCallback(async () => {
      setPhase("loading");
      try {
        await window.store.bootstrap();
        setPhase("ready");
      } catch (err) {
        console.error(err);
        setError("Could not load application data. Please retry.");
        setPhase("login");
      }
    }, []);
    React.useEffect(() => {
      let cancelled = false;
      (async () => {
        try {
          const operator = await apiGetMe();
          if (cancelled) return;
          if (operator) {
            await enterApp();
          } else {
            setPhase("login");
          }
        } catch (err) {
          if (cancelled) return;
          console.error(err);
          setError("Could not reach the server. Please check your connection and retry.");
          setPhase("login");
        }
      })();
      return () => {
        cancelled = true;
      };
    }, []);
    React.useEffect(() => {
      const handleLogout = () => {
        (async () => {
          await apiLogout();
          setPhase("login");
          setError(null);
          window.toast && window.toast.info("You have been signed out.", { title: "Signed out", duration: 3e3 });
        })();
      };
      window.addEventListener("bnc-logout", handleLogout);
      return () => window.removeEventListener("bnc-logout", handleLogout);
    }, []);
    if (phase === "checking" || phase === "loading") {
      return /* @__PURE__ */ React.createElement(FullScreenStatus, { label: phase === "checking" ? "Checking session\u2026" : "Loading data\u2026" });
    }
    if (phase === "login") {
      return /* @__PURE__ */ React.createElement(LoginScreen, { initialError: error, onLoggedIn: enterApp });
    }
    return children;
  }
  function FullScreenStatus({ label }) {
    return /* @__PURE__ */ React.createElement("div", { style: {
      position: "fixed",
      inset: 0,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 12,
      background: T.bg0,
      color: T.text1,
      fontFamily: "var(--font-ui)"
    } }, /* @__PURE__ */ React.createElement("div", { style: {
      width: 28,
      height: 28,
      borderRadius: 999,
      border: `3px solid ${T.border}`,
      borderTopColor: T.accent,
      animation: "authSpin 0.8s linear infinite"
    } }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2 } }, label), /* @__PURE__ */ React.createElement("style", null, "@keyframes authSpin { to { transform: rotate(360deg); } }"));
  }
  function LoginScreen({ initialError, onLoggedIn }) {
    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [showPassword, setShowPassword] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);
    const [error, setError] = React.useState(initialError || null);
    const submit = async (e) => {
      e && e.preventDefault();
      if (submitting) return;
      if (!email.trim() || !password) {
        setError("Please enter both email and password.");
        return;
      }
      setSubmitting(true);
      setError(null);
      try {
        await apiPost("/auth/login", { email: email.trim(), password });
        window.toast && window.toast.success("Signed in.", { title: "Welcome back", duration: 2500 });
        await onLoggedIn();
      } catch (err) {
        setSubmitting(false);
        const msg = err && err.message || "Sign in failed.";
        setError(msg);
        window.toast && window.toast.error(msg, { title: "Sign in failed", duration: 5e3 });
      }
    };
    return /* @__PURE__ */ React.createElement("div", { style: {
      position: "fixed",
      inset: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: T.bg0,
      fontFamily: "var(--font-ui)",
      padding: 20
    } }, /* @__PURE__ */ React.createElement("div", { style: { width: "100%", maxWidth: 380 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 24 } }, typeof BrandMark === "function" ? /* @__PURE__ */ React.createElement(BrandMark, null) : /* @__PURE__ */ React.createElement("div", { style: { fontSize: 20, fontWeight: 700, color: T.text0 } }, "banicharka.bg"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, marginTop: 6 } }, "Rental Operations \u2014 Sign in")), /* @__PURE__ */ React.createElement(Card, { pad: 24 }, /* @__PURE__ */ React.createElement("form", { onSubmit: submit }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 16 } }, /* @__PURE__ */ React.createElement(Field, { label: "Email" }, /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "email",
        value: email,
        onChange: (e) => setEmail(e.target.value),
        placeholder: "operator@banicharka.bg",
        size: "lg"
      }
    )), /* @__PURE__ */ React.createElement(Field, { label: "Password" }, /* @__PURE__ */ React.createElement(
      Input,
      {
        type: showPassword ? "text" : "password",
        value: password,
        onChange: (e) => setPassword(e.target.value),
        placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
        size: "lg",
        suffix: /* @__PURE__ */ React.createElement(
          "button",
          {
            type: "button",
            onClick: () => setShowPassword((v) => !v),
            style: { background: "transparent", border: "none", cursor: "pointer", display: "flex", alignItems: "center", padding: 0 },
            title: showPassword ? "Hide password" : "Show password"
          },
          /* @__PURE__ */ React.createElement(Icon, { name: showPassword ? "eyeOff" : "eye", size: 16, color: T.text2 })
        )
      }
    )), error && /* @__PURE__ */ React.createElement("div", { style: {
      fontSize: 12.5,
      color: "#F87171",
      background: T.redTint,
      border: "1px solid rgba(239,68,68,0.4)",
      borderRadius: 10,
      padding: "10px 12px"
    } }, error), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "lg", block: true, disabled: submitting, onClick: submit }, submitting ? "Signing in\u2026" : "Sign in")))), /* @__PURE__ */ React.createElement("div", { style: { textAlign: "center", fontSize: 11.5, color: T.text3, marginTop: 16 } }, '\u201E\u0413\u0415\u041D\u0423\u0421-2017" \u0415\u041E\u041E\u0414 \xB7 Operator access only')));
  }
  Object.assign(window, { AuthGate, LoginScreen });
})();

/* ══════════ tweaks_panel.jsx ══════════ */
var __TWEAKS_STYLE = `
  .twk-panel{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:280px;
    max-height:calc(100vh - 32px);display:flex;flex-direction:column;
    transform:scale(var(--dc-inv-zoom,1));transform-origin:bottom right;
    background:rgba(250,249,247,.78);color:#29261b;
    -webkit-backdrop-filter:blur(24px) saturate(160%);backdrop-filter:blur(24px) saturate(160%);
    border:.5px solid rgba(255,255,255,.6);border-radius:14px;
    box-shadow:0 1px 0 rgba(255,255,255,.5) inset,0 12px 40px rgba(0,0,0,.18);
    font:11.5px/1.4 ui-sans-serif,system-ui,-apple-system,sans-serif;overflow:hidden}
  .twk-hd{display:flex;align-items:center;justify-content:space-between;
    padding:10px 8px 10px 14px;cursor:move;user-select:none}
  .twk-hd b{font-size:12px;font-weight:600;letter-spacing:.01em}
  .twk-x{appearance:none;border:0;background:transparent;color:rgba(41,38,27,.55);
    width:22px;height:22px;border-radius:6px;cursor:default;font-size:13px;line-height:1}
  .twk-x:hover{background:rgba(0,0,0,.06);color:#29261b}
  .twk-body{padding:2px 14px 14px;display:flex;flex-direction:column;gap:10px;
    overflow-y:auto;overflow-x:hidden;min-height:0;
    scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.15) transparent}
  .twk-body::-webkit-scrollbar{width:8px}
  .twk-body::-webkit-scrollbar-track{background:transparent;margin:2px}
  .twk-body::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px;
    border:2px solid transparent;background-clip:content-box}
  .twk-body::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.25);
    border:2px solid transparent;background-clip:content-box}
  .twk-row{display:flex;flex-direction:column;gap:5px}
  .twk-row-h{flex-direction:row;align-items:center;justify-content:space-between;gap:10px}
  .twk-lbl{display:flex;justify-content:space-between;align-items:baseline;
    color:rgba(41,38,27,.72)}
  .twk-lbl>span:first-child{font-weight:500}
  .twk-val{color:rgba(41,38,27,.5);font-variant-numeric:tabular-nums}

  .twk-sect{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
    color:rgba(41,38,27,.45);padding:10px 0 0}
  .twk-sect:first-child{padding-top:0}

  .twk-field{appearance:none;box-sizing:border-box;width:100%;min-width:0;height:26px;padding:0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;
    background:rgba(255,255,255,.6);color:inherit;font:inherit;outline:none}
  .twk-field:focus{border-color:rgba(0,0,0,.25);background:rgba(255,255,255,.85)}
  select.twk-field{padding-right:22px;
    background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(0,0,0,.5)' d='M0 0h10L5 6z'/></svg>");
    background-repeat:no-repeat;background-position:right 8px center}

  .twk-slider{appearance:none;-webkit-appearance:none;width:100%;height:4px;margin:6px 0;
    border-radius:999px;background:rgba(0,0,0,.12);outline:none}
  .twk-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;
    width:14px;height:14px;border-radius:50%;background:#fff;
    border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}
  .twk-slider::-moz-range-thumb{width:14px;height:14px;border-radius:50%;
    background:#fff;border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}

  .twk-seg{position:relative;display:flex;padding:2px;border-radius:8px;
    background:rgba(0,0,0,.06);user-select:none}
  .twk-seg-thumb{position:absolute;top:2px;bottom:2px;border-radius:6px;
    background:rgba(255,255,255,.9);box-shadow:0 1px 2px rgba(0,0,0,.12);
    transition:left .15s cubic-bezier(.3,.7,.4,1),width .15s}
  .twk-seg.dragging .twk-seg-thumb{transition:none}
  .twk-seg button{appearance:none;position:relative;z-index:1;flex:1;border:0;
    background:transparent;color:inherit;font:inherit;font-weight:500;min-height:22px;
    border-radius:6px;cursor:default;padding:4px 6px;line-height:1.2;
    overflow-wrap:anywhere}

  .twk-toggle{position:relative;width:32px;height:18px;border:0;border-radius:999px;
    background:rgba(0,0,0,.15);transition:background .15s;cursor:default;padding:0}
  .twk-toggle[data-on="1"]{background:#34c759}
  .twk-toggle i{position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;
    background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:transform .15s}
  .twk-toggle[data-on="1"] i{transform:translateX(14px)}

  .twk-num{display:flex;align-items:center;box-sizing:border-box;min-width:0;height:26px;padding:0 0 0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;background:rgba(255,255,255,.6)}
  .twk-num-lbl{font-weight:500;color:rgba(41,38,27,.6);cursor:ew-resize;
    user-select:none;padding-right:8px}
  .twk-num input{flex:1;min-width:0;height:100%;border:0;background:transparent;
    font:inherit;font-variant-numeric:tabular-nums;text-align:right;padding:0 8px 0 0;
    outline:none;color:inherit;-moz-appearance:textfield}
  .twk-num input::-webkit-inner-spin-button,.twk-num input::-webkit-outer-spin-button{
    -webkit-appearance:none;margin:0}
  .twk-num-unit{padding-right:8px;color:rgba(41,38,27,.45)}

  .twk-btn{appearance:none;height:26px;padding:0 12px;border:0;border-radius:7px;
    background:rgba(0,0,0,.78);color:#fff;font:inherit;font-weight:500;cursor:default}
  .twk-btn:hover{background:rgba(0,0,0,.88)}
  .twk-btn.secondary{background:rgba(0,0,0,.06);color:inherit}
  .twk-btn.secondary:hover{background:rgba(0,0,0,.1)}

  .twk-swatch{appearance:none;-webkit-appearance:none;width:56px;height:22px;
    border:.5px solid rgba(0,0,0,.1);border-radius:6px;padding:0;cursor:default;
    background:transparent;flex-shrink:0}
  .twk-swatch::-webkit-color-swatch-wrapper{padding:0}
  .twk-swatch::-webkit-color-swatch{border:0;border-radius:5.5px}
  .twk-swatch::-moz-color-swatch{border:0;border-radius:5.5px}

  .twk-chips{display:flex;gap:6px}
  .twk-chip{position:relative;appearance:none;flex:1;min-width:0;height:46px;
    padding:0;border:0;border-radius:6px;overflow:hidden;cursor:default;
    box-shadow:0 0 0 .5px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.06);
    transition:transform .12s cubic-bezier(.3,.7,.4,1),box-shadow .12s}
  .twk-chip:hover{transform:translateY(-1px);
    box-shadow:0 0 0 .5px rgba(0,0,0,.18),0 4px 10px rgba(0,0,0,.12)}
  .twk-chip[data-on="1"]{box-shadow:0 0 0 1.5px rgba(0,0,0,.85),
    0 2px 6px rgba(0,0,0,.15)}
  .twk-chip>span{position:absolute;top:0;bottom:0;right:0;width:34%;
    display:flex;flex-direction:column;box-shadow:-1px 0 0 rgba(0,0,0,.1)}
  .twk-chip>span>i{flex:1;box-shadow:0 -1px 0 rgba(0,0,0,.1)}
  .twk-chip>span>i:first-child{box-shadow:none}
  .twk-chip svg{position:absolute;top:6px;left:6px;width:13px;height:13px;
    filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}
`;
function useTweaks(defaults) {
  const [values, setValues] = React.useState(defaults);
  const setTweak = React.useCallback((keyOrEdits, val) => {
    const edits = typeof keyOrEdits === "object" && keyOrEdits !== null ? keyOrEdits : { [keyOrEdits]: val };
    setValues((prev) => ({ ...prev, ...edits }));
    window.parent.postMessage({ type: "__edit_mode_set_keys", edits }, "*");
    window.dispatchEvent(new CustomEvent("tweakchange", { detail: edits }));
  }, []);
  return [values, setTweak];
}
function TweaksPanel({ title = "Tweaks", noDeckControls = false, children }) {
  const [open, setOpen] = React.useState(false);
  const dragRef = React.useRef(null);
  const hasDeckStage = React.useMemo(
    () => typeof document !== "undefined" && !!document.querySelector("deck-stage"),
    []
  );
  const [railEnabled, setRailEnabled] = React.useState(
    () => hasDeckStage && !!document.querySelector("deck-stage")?._railEnabled
  );
  React.useEffect(() => {
    if (!hasDeckStage || railEnabled) return void 0;
    const onMsg = (e) => {
      if (e.data && e.data.type === "__omelette_rail_enabled") setRailEnabled(true);
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, [hasDeckStage, railEnabled]);
  const [railVisible, setRailVisible] = React.useState(() => {
    try {
      return localStorage.getItem("deck-stage.railVisible") !== "0";
    } catch (e) {
      return true;
    }
  });
  const toggleRail = (on) => {
    setRailVisible(on);
    window.postMessage({ type: "__deck_rail_visible", on }, "*");
  };
  const offsetRef = React.useRef({ x: 16, y: 16 });
  const PAD = 16;
  const clampToViewport = React.useCallback(() => {
    const panel = dragRef.current;
    if (!panel) return;
    const w = panel.offsetWidth, h = panel.offsetHeight;
    const maxRight = Math.max(PAD, window.innerWidth - w - PAD);
    const maxBottom = Math.max(PAD, window.innerHeight - h - PAD);
    offsetRef.current = {
      x: Math.min(maxRight, Math.max(PAD, offsetRef.current.x)),
      y: Math.min(maxBottom, Math.max(PAD, offsetRef.current.y))
    };
    panel.style.right = offsetRef.current.x + "px";
    panel.style.bottom = offsetRef.current.y + "px";
  }, []);
  React.useEffect(() => {
    if (!open) return;
    clampToViewport();
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", clampToViewport);
      return () => window.removeEventListener("resize", clampToViewport);
    }
    const ro = new ResizeObserver(clampToViewport);
    ro.observe(document.documentElement);
    return () => ro.disconnect();
  }, [open, clampToViewport]);
  React.useEffect(() => {
    const onMsg = (e) => {
      const t = e?.data?.type;
      if (t === "__activate_edit_mode") setOpen(true);
      else if (t === "__deactivate_edit_mode") setOpen(false);
    };
    window.addEventListener("message", onMsg);
    window.parent.postMessage({ type: "__edit_mode_available" }, "*");
    return () => window.removeEventListener("message", onMsg);
  }, []);
  const dismiss = () => {
    setOpen(false);
    window.parent.postMessage({ type: "__edit_mode_dismissed" }, "*");
  };
  const onDragStart = (e) => {
    const panel = dragRef.current;
    if (!panel) return;
    const r = panel.getBoundingClientRect();
    const sx = e.clientX, sy = e.clientY;
    const startRight = window.innerWidth - r.right;
    const startBottom = window.innerHeight - r.bottom;
    const move = (ev) => {
      offsetRef.current = {
        x: startRight - (ev.clientX - sx),
        y: startBottom - (ev.clientY - sy)
      };
      clampToViewport();
    };
    const up = () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseup", up);
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseup", up);
  };
  if (!open) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("style", null, __TWEAKS_STYLE), /* @__PURE__ */ React.createElement(
    "div",
    {
      ref: dragRef,
      className: "twk-panel",
      "data-noncommentable": "",
      style: { right: offsetRef.current.x, bottom: offsetRef.current.y }
    },
    /* @__PURE__ */ React.createElement("div", { className: "twk-hd", onMouseDown: onDragStart }, /* @__PURE__ */ React.createElement("b", null, title), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "twk-x",
        "aria-label": "Close tweaks",
        onMouseDown: (e) => e.stopPropagation(),
        onClick: dismiss
      },
      "\u2715"
    )),
    /* @__PURE__ */ React.createElement("div", { className: "twk-body" }, children, hasDeckStage && railEnabled && !noDeckControls && /* @__PURE__ */ React.createElement(TweakSection, { label: "Deck" }, /* @__PURE__ */ React.createElement(TweakToggle, { label: "Thumbnail rail", value: railVisible, onChange: toggleRail })))
  ));
}
function TweakSection({ label, children }) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "twk-sect" }, label), children);
}
function TweakRow({ label, value, children, inline = false }) {
  return /* @__PURE__ */ React.createElement("div", { className: inline ? "twk-row twk-row-h" : "twk-row" }, /* @__PURE__ */ React.createElement("div", { className: "twk-lbl" }, /* @__PURE__ */ React.createElement("span", null, label), value != null && /* @__PURE__ */ React.createElement("span", { className: "twk-val" }, value)), children);
}
function TweakSlider({ label, value, min = 0, max = 100, step = 1, unit = "", onChange }) {
  return /* @__PURE__ */ React.createElement(TweakRow, { label, value: `${value}${unit}` }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "range",
      className: "twk-slider",
      min,
      max,
      step,
      value,
      onChange: (e) => onChange(Number(e.target.value))
    }
  ));
}
function TweakToggle({ label, value, onChange }) {
  return /* @__PURE__ */ React.createElement("div", { className: "twk-row twk-row-h" }, /* @__PURE__ */ React.createElement("div", { className: "twk-lbl" }, /* @__PURE__ */ React.createElement("span", null, label)), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: "twk-toggle",
      "data-on": value ? "1" : "0",
      role: "switch",
      "aria-checked": !!value,
      onClick: () => onChange(!value)
    },
    /* @__PURE__ */ React.createElement("i", null)
  ));
}
function TweakRadio({ label, value, options, onChange }) {
  const trackRef = React.useRef(null);
  const [dragging, setDragging] = React.useState(false);
  const valueRef = React.useRef(value);
  valueRef.current = value;
  const labelLen = (o) => String(typeof o === "object" ? o.label : o).length;
  const maxLen = options.reduce((m, o) => Math.max(m, labelLen(o)), 0);
  const fitsAsSegments = maxLen <= ({ 2: 16, 3: 10 }[options.length] ?? 0);
  if (!fitsAsSegments) {
    const resolve = (s) => {
      const m = options.find((o) => String(typeof o === "object" ? o.value : o) === s);
      return m === void 0 ? s : typeof m === "object" ? m.value : m;
    };
    return /* @__PURE__ */ React.createElement(
      TweakSelect,
      {
        label,
        value,
        options,
        onChange: (s) => onChange(resolve(s))
      }
    );
  }
  const opts = options.map((o) => typeof o === "object" ? o : { value: o, label: o });
  const idx = Math.max(0, opts.findIndex((o) => o.value === value));
  const n = opts.length;
  const segAt = (clientX) => {
    const r = trackRef.current.getBoundingClientRect();
    const inner = r.width - 4;
    const i = Math.floor((clientX - r.left - 2) / inner * n);
    return opts[Math.max(0, Math.min(n - 1, i))].value;
  };
  const onPointerDown = (e) => {
    setDragging(true);
    const v0 = segAt(e.clientX);
    if (v0 !== valueRef.current) onChange(v0);
    const move = (ev) => {
      if (!trackRef.current) return;
      const v = segAt(ev.clientX);
      if (v !== valueRef.current) onChange(v);
    };
    const up = () => {
      setDragging(false);
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerup", up);
    };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
  };
  return /* @__PURE__ */ React.createElement(TweakRow, { label }, /* @__PURE__ */ React.createElement(
    "div",
    {
      ref: trackRef,
      role: "radiogroup",
      onPointerDown,
      className: dragging ? "twk-seg dragging" : "twk-seg"
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "twk-seg-thumb",
        style: {
          left: `calc(2px + ${idx} * (100% - 4px) / ${n})`,
          width: `calc((100% - 4px) / ${n})`
        }
      }
    ),
    opts.map((o) => /* @__PURE__ */ React.createElement("button", { key: o.value, type: "button", role: "radio", "aria-checked": o.value === value }, o.label))
  ));
}
function TweakSelect({ label, value, options, onChange }) {
  return /* @__PURE__ */ React.createElement(TweakRow, { label }, /* @__PURE__ */ React.createElement("select", { className: "twk-field", value, onChange: (e) => onChange(e.target.value) }, options.map((o) => {
    const v = typeof o === "object" ? o.value : o;
    const l = typeof o === "object" ? o.label : o;
    return /* @__PURE__ */ React.createElement("option", { key: v, value: v }, l);
  })));
}
function TweakText({ label, value, placeholder, onChange }) {
  return /* @__PURE__ */ React.createElement(TweakRow, { label }, /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "twk-field",
      type: "text",
      value,
      placeholder,
      onChange: (e) => onChange(e.target.value)
    }
  ));
}
function TweakNumber({ label, value, min, max, step = 1, unit = "", onChange }) {
  const clamp = (n) => {
    if (min != null && n < min) return min;
    if (max != null && n > max) return max;
    return n;
  };
  const startRef = React.useRef({ x: 0, val: 0 });
  const onScrubStart = (e) => {
    e.preventDefault();
    startRef.current = { x: e.clientX, val: value };
    const decimals = (String(step).split(".")[1] || "").length;
    const move = (ev) => {
      const dx = ev.clientX - startRef.current.x;
      const raw = startRef.current.val + dx * step;
      const snapped = Math.round(raw / step) * step;
      onChange(clamp(Number(snapped.toFixed(decimals))));
    };
    const up = () => {
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerup", up);
    };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
  };
  return /* @__PURE__ */ React.createElement("div", { className: "twk-num" }, /* @__PURE__ */ React.createElement("span", { className: "twk-num-lbl", onPointerDown: onScrubStart }, label), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      value,
      min,
      max,
      step,
      onChange: (e) => onChange(clamp(Number(e.target.value)))
    }
  ), unit && /* @__PURE__ */ React.createElement("span", { className: "twk-num-unit" }, unit));
}
function __twkIsLight(hex) {
  const h = String(hex).replace("#", "");
  const x = h.length === 3 ? h.replace(/./g, (c) => c + c) : h.padEnd(6, "0");
  const n = parseInt(x.slice(0, 6), 16);
  if (Number.isNaN(n)) return true;
  const r = n >> 16 & 255, g = n >> 8 & 255, b = n & 255;
  return r * 299 + g * 587 + b * 114 > 148e3;
}
var __TwkCheck = ({ light }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 14 14", "aria-hidden": "true" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M3 7.2 5.8 10 11 4.2",
    fill: "none",
    strokeWidth: "2.2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: light ? "rgba(0,0,0,.78)" : "#fff"
  }
));
function TweakColor({ label, value, options, onChange }) {
  if (!options || !options.length) {
    return /* @__PURE__ */ React.createElement("div", { className: "twk-row twk-row-h" }, /* @__PURE__ */ React.createElement("div", { className: "twk-lbl" }, /* @__PURE__ */ React.createElement("span", null, label)), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "color",
        className: "twk-swatch",
        value,
        onChange: (e) => onChange(e.target.value)
      }
    ));
  }
  const key = (o) => String(JSON.stringify(o)).toLowerCase();
  const cur = key(value);
  return /* @__PURE__ */ React.createElement(TweakRow, { label }, /* @__PURE__ */ React.createElement("div", { className: "twk-chips", role: "radiogroup" }, options.map((o, i) => {
    const colors = Array.isArray(o) ? o : [o];
    const [hero, ...rest] = colors;
    const sup = rest.slice(0, 4);
    const on = key(o) === cur;
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: i,
        type: "button",
        className: "twk-chip",
        role: "radio",
        "aria-checked": on,
        "data-on": on ? "1" : "0",
        "aria-label": colors.join(", "),
        title: colors.join(" \xB7 "),
        style: { background: hero },
        onClick: () => onChange(o)
      },
      sup.length > 0 && /* @__PURE__ */ React.createElement("span", null, sup.map((c, j) => /* @__PURE__ */ React.createElement("i", { key: j, style: { background: c } }))),
      on && /* @__PURE__ */ React.createElement(__TwkCheck, { light: __twkIsLight(hero) })
    );
  })));
}
function TweakButton({ label, onClick, secondary = false }) {
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: secondary ? "twk-btn secondary" : "twk-btn",
      onClick
    },
    label
  );
}
Object.assign(window, {
  useTweaks,
  TweaksPanel,
  TweakSection,
  TweakRow,
  TweakSlider,
  TweakToggle,
  TweakRadio,
  TweakSelect,
  TweakText,
  TweakNumber,
  TweakColor,
  TweakButton
});
(function() {
  const s = document.createElement("style");
  s.textContent = `
    @keyframes twk-blink{50%{opacity:0}}
    @keyframes twk-fadein{from{opacity:0;transform:translateX(4px)}to{opacity:1;transform:none}}
    .twk-sugg{display:flex;align-items:center;gap:6px;padding:5px 8px;border-radius:8px;
      background:rgba(0,0,0,.04);border:.5px solid rgba(0,0,0,.06);transition:all .15s}
    .twk-sugg:focus-within{background:rgba(0,0,0,.06);border-color:rgba(0,0,0,.12)}
    .twk-sugg-field{position:relative;flex:1;min-width:0}
    .twk-sugg-field input{width:100%;height:20px;border:0;background:transparent;
      font:inherit;outline:none;color:inherit}
    .twk-sugg-ghost{position:absolute;inset:0;display:flex;align-items:center;
      color:rgba(41,38,27,.42);pointer-events:none;white-space:nowrap;overflow:hidden}
    .twk-sugg-ghost.hint{color:rgba(41,38,27,.28)}
    .twk-sugg-caret{display:inline-block;width:1px;height:13px;margin-left:1px;
      border-right:1.5px solid currentColor;opacity:.5;animation:twk-blink 1s step-end infinite}
    .twk-sugg-ideas{appearance:none;border:0;background:transparent;font:inherit;
      font-size:10.5px;font-weight:600;color:rgba(41,38,27,.6);cursor:default;padding:0 2px;
      white-space:nowrap;animation:twk-fadein .25s ease}
    .twk-sugg-ideas:hover{color:rgba(41,38,27,.85)}
    .twk-sugg-ideas svg{color:#7A5AE0}
    .twk-sugg-send{appearance:none;border:0;height:20px;padding:0 8px;border-radius:5px;
      background:#29261b;color:#fff;font:inherit;font-size:10px;font-weight:600;cursor:default}
  `;
  document.head.appendChild(s);
})();
var __twkSendChat = (text) => window.parent.postMessage({ type: "__edit_mode_chat", text }, "*");
var __TWK_SPARK_STAR = "M14.8299 10.378C15.1555 10.499 15.1827 10.9337 14.8747 11.0918L11.401 12.8747C11.3125 12.9202 11.2445 12.9955 11.2099 13.0864L9.95228 16.3963C9.82177 16.7397 9.31884 16.7397 9.18834 16.3963L7.93069 13.0864C7.89616 12.9955 7.82814 12.9202 7.73965 12.8747L4.2659 11.0918C3.95787 10.9337 3.98513 10.499 4.31067 10.378L7.69556 9.11947C7.81035 9.0768 7.89899 8.98625 7.93669 8.87317L9.18301 5.13503C9.30417 4.77165 9.83645 4.77165 9.9576 5.13503L11.2039 8.87317C11.2416 8.98626 11.3303 9.0768 11.4451 9.11947L14.8299 10.378Z";
var __TWK_SPARK_DOT = "M6.0114 3.58637C6.35897 3.71564 6.35897 4.19061 6.0114 4.31988L4.98024 4.70337C4.86547 4.74605 4.77685 4.83659 4.73915 4.94965L4.33943 6.14853C4.21828 6.51191 3.686 6.51191 3.56485 6.14853L3.16513 4.94965C3.12743 4.83659 3.03881 4.74605 2.92404 4.70337L1.89288 4.31988C1.54531 4.19061 1.54531 3.71564 1.89288 3.58637L2.92404 3.20288C3.03881 3.1602 3.12743 3.06966 3.16513 2.9566L3.56485 1.75772C3.686 1.39434 4.21828 1.39434 4.33943 1.75772L4.73915 2.9566C4.77685 3.06966 4.86547 3.1602 4.98024 3.20288L6.0114 3.58637Z";
function __TwkSpark({ size = 12 }) {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: size,
      height: size,
      viewBox: "0 0 17 18",
      fill: "currentColor",
      style: { display: "inline-block", verticalAlign: "-1px" }
    },
    /* @__PURE__ */ React.createElement("path", { d: __TWK_SPARK_STAR }),
    /* @__PURE__ */ React.createElement("path", { d: __TWK_SPARK_DOT })
  );
}
function TweakSuggestionBar({
  suggestions = [],
  placeholder = "Describe a tweak\u2026",
  ideasPrompt = "Suggest three more tweak ideas for this design and update the suggestions on TweakSuggestionBar."
}) {
  const [val, setVal] = React.useState("");
  const [ghost, setGhost] = React.useState("");
  const [focused, setFocused] = React.useState(false);
  const inputRef = React.useRef(null);
  const tw = useTwkTypewriter(suggestions, { placeholder, enabled: !val && !ghost && !focused });
  const freeze = () => {
    tw.markPlayed();
    if (val || ghost) return;
    const target = !tw.done ? suggestions[tw.idx] : "";
    if (target) setGhost(target);
    inputRef.current?.focus();
  };
  const submit = () => {
    const v = (val || ghost).trim();
    if (!v) return;
    __twkSendChat(v);
    setVal("");
    setGhost("");
  };
  const onKeyDown = (e) => {
    if (e.key === "Tab" && ghost && !val) {
      e.preventDefault();
      setVal(ghost);
      setGhost("");
    } else if (e.key === "Enter") {
      e.preventDefault();
      submit();
    } else if (e.key === "Escape") {
      setGhost("");
    }
  };
  const requestIdeas = () => __twkSendChat(ideasPrompt);
  const showAnim = !val && !ghost && !focused && !tw.done;
  const showStatic = !val && !ghost && !focused && tw.done;
  return /* @__PURE__ */ React.createElement("div", { className: "twk-sugg", onMouseDown: freeze }, /* @__PURE__ */ React.createElement("div", { className: "twk-sugg-field" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      ref: inputRef,
      value: val,
      placeholder: focused && !ghost ? placeholder : "",
      onChange: (e) => {
        setVal(e.target.value);
        setGhost("");
      },
      onFocus: () => {
        setFocused(true);
        tw.markPlayed();
      },
      onBlur: () => {
        setFocused(false);
        if (!val) setGhost("");
      },
      onKeyDown
    }
  ), showAnim && /* @__PURE__ */ React.createElement("div", { className: "twk-sugg-ghost" }, tw.text, /* @__PURE__ */ React.createElement("span", { className: "twk-sugg-caret" })), showStatic && /* @__PURE__ */ React.createElement("div", { className: "twk-sugg-ghost" }, tw.tail, tw.tail.length < placeholder.length && /* @__PURE__ */ React.createElement("span", { className: "twk-sugg-caret" })), ghost && !val && /* @__PURE__ */ React.createElement("div", { className: "twk-sugg-ghost hint" }, ghost)), val || ghost ? /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "twk-sugg-send",
      onMouseDown: (e) => {
        e.stopPropagation();
        e.preventDefault();
      },
      onClick: submit
    },
    "Add"
  ) : tw.done && !focused ? /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "twk-sugg-ideas",
      onMouseDown: (e) => {
        e.stopPropagation();
        e.preventDefault();
      },
      onClick: requestIdeas
    },
    "Ideas ",
    /* @__PURE__ */ React.createElement(__TwkSpark, null)
  ) : null);
}
function useTwkTypewriter(items, { placeholder, typeMs = 35, eraseMs = 22, pauseMs = 1800, enabled = true } = {}) {
  const key = React.useMemo(() => "__twk_played:" + JSON.stringify(items), [JSON.stringify(items)]);
  const played = () => {
    try {
      return sessionStorage.getItem(key) === "1";
    } catch {
      return false;
    }
  };
  const [text, setText] = React.useState("");
  const [tail, setTail] = React.useState(() => items.length === 0 || played() ? placeholder : "");
  const [idx, setIdx] = React.useState(0);
  const [done, setDone] = React.useState(() => items.length === 0 || played());
  const phase = React.useRef("type");
  const n = React.useRef(0);
  const markPlayed = React.useCallback(() => {
    try {
      sessionStorage.setItem(key, "1");
    } catch {
    }
    setDone(true);
  }, [key]);
  React.useEffect(() => {
    const skip = items.length === 0 || played();
    setText("");
    setIdx(0);
    setDone(skip);
    setTail(skip ? placeholder : "");
    phase.current = "type";
    n.current = 0;
  }, [key]);
  React.useEffect(() => {
    if (done || !enabled) return;
    const item = items[idx] ?? "";
    let t;
    const tick = () => {
      if (phase.current === "type") {
        n.current++;
        setText(item.slice(0, n.current));
        if (n.current >= item.length) {
          phase.current = "pause";
          t = setTimeout(tick, pauseMs);
        } else t = setTimeout(tick, typeMs + Math.random() * 20);
      } else if (phase.current === "pause") {
        phase.current = "erase";
        t = setTimeout(tick, eraseMs);
      } else {
        n.current--;
        setText(item.slice(0, n.current));
        if (n.current <= 0) {
          if (idx === items.length - 1) {
            markPlayed();
            return;
          }
          phase.current = "type";
          setIdx((i) => i + 1);
        } else t = setTimeout(tick, eraseMs);
      }
    };
    phase.current = "type";
    n.current = 0;
    setText("");
    t = setTimeout(tick, 400);
    return () => clearTimeout(t);
  }, [idx, done, key, enabled, typeMs, eraseMs, pauseMs]);
  React.useEffect(() => {
    if (!done || tail === placeholder) return;
    let i = 0;
    const t = setInterval(() => {
      i++;
      setTail(placeholder.slice(0, i));
      if (i >= placeholder.length) clearInterval(t);
    }, 28);
    return () => clearInterval(t);
  }, [done, placeholder]);
  return { text, tail, idx, done, markPlayed };
}
Object.assign(window, { TweakSuggestionBar });

/* ══════════ components/dashboard.jsx ══════════ */
function Dashboard({ isPhone, onGo, onOpenRental, onNewRental }) {
  store.useStore();
  const today = TODAY;
  const isSameDay = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  const todayHandovers = RENTALS.filter((r) => isSameDay(r.start, today) && (r.status === "reserved" || r.status === "active"));
  const todayReturns = RENTALS.filter((r) => isSameDay(r.end, today) && (r.status === "active" || r.status === "overdue"));
  const overdue = RENTALS.filter((r) => r.status === "overdue");
  const noShows = RENTALS.filter((r) => r.status === "no-show");
  const activeRentals = RENTALS.filter((r) => r.status === "active").length;
  const outstandingBalance = store.outstanding().reduce((s, o) => s + o.amount, 0);
  const cV = (id) => VEHICLES.find((v) => v.id === id);
  const cC = (id) => CUSTOMERS.find((c) => c.id === id);
  const extensionRequests = store.extensionRequests();
  const pendingExtensions = extensionRequests.filter((r) => r.status === "pending");
  const MONTH_NAMES_BG = ["\u042F\u043D\u0443\u0430\u0440\u0438", "\u0424\u0435\u0432\u0440\u0443\u0430\u0440\u0438", "\u041C\u0430\u0440\u0442", "\u0410\u043F\u0440\u0438\u043B", "\u041C\u0430\u0439", "\u042E\u043D\u0438", "\u042E\u043B\u0438", "\u0410\u0432\u0433\u0443\u0441\u0442", "\u0421\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438", "\u041E\u043A\u0442\u043E\u043C\u0432\u0440\u0438", "\u041D\u043E\u0435\u043C\u0432\u0440\u0438", "\u0414\u0435\u043A\u0435\u043C\u0432\u0440\u0438"];
  const monthLabel = MONTH_NAMES_BG[today.getMonth()];
  const revenueMonth = PAYMENTS.filter((p) => p.amount > 0 && p.date.getFullYear() === today.getFullYear() && p.date.getMonth() === today.getMonth()).reduce((sum, p) => sum + p.amount, 0);
  const rentalsMonth = RENTALS.filter(
    (r) => r.status !== "cancelled" && r.start.getFullYear() === today.getFullYear() && r.start.getMonth() === today.getMonth()
  ).length;
  const windowEnd = today;
  const windowStart = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1e3);
  const overlapDays = (aStart, aEnd, bStart, bEnd) => {
    const start = aStart > bStart ? aStart : bStart;
    const end = aEnd < bEnd ? aEnd : bEnd;
    const ms = end - start;
    return ms > 0 ? ms / (1e3 * 60 * 60 * 24) : 0;
  };
  const rentedDaysInWindow = RENTALS.filter((r) => r.status !== "cancelled").reduce((sum, r) => sum + overlapDays(r.start, r.end, windowStart, windowEnd), 0);
  const availableVehicleDays = VEHICLES.length * 30;
  const utilization = availableVehicleDays > 0 ? Math.max(0, Math.min(100, Math.round(rentedDaysInWindow / availableVehicleDays * 100))) : 0;
  return /* @__PURE__ */ React.createElement("div", { className: "scroll-y", style: { flex: 1, padding: isPhone ? 16 : 24, background: T.bg0 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "flex-end", justifyContent: "space-between", marginBottom: isPhone ? 16 : 20, flexWrap: "wrap", gap: 12 } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { color: T.text2, fontSize: 13, letterSpacing: 0.4, textTransform: "uppercase", fontWeight: 600 } }, ["\u041D\u0435\u0434\u0435\u043B\u044F", "\u041F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A", "\u0412\u0442\u043E\u0440\u043D\u0438\u043A", "\u0421\u0440\u044F\u0434\u0430", "\u0427\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A", "\u041F\u0435\u0442\u044A\u043A", "\u0421\u044A\u0431\u043E\u0442\u0430"][today.getDay()], " \xB7 ", fmtDateBG(today)), /* @__PURE__ */ React.createElement("div", { style: { fontSize: isPhone ? 22 : 28, fontWeight: 700, letterSpacing: -0.4, marginTop: 4 } }, (() => {
    const h = today.getHours();
    const greet = h < 12 ? "\u0414\u043E\u0431\u0440\u043E \u0443\u0442\u0440\u043E" : h < 18 ? "\u0414\u043E\u0431\u044A\u0440 \u0434\u0435\u043D" : "\u0414\u043E\u0431\u044A\u0440 \u0432\u0435\u0447\u0435\u0440";
    const first = (window.store.operatorProfile().name || "").split(/\s+/)[0] || "\u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440";
    return greet + ", " + first;
  })())), /* @__PURE__ */ React.createElement(Button, { kind: "primary", icon: "plus", size: isPhone ? "md" : "lg", onClick: onNewRental }, "New rental")), /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: isPhone ? "1fr 1fr" : "repeat(4, 1fr)",
    gap: 12,
    marginBottom: 20
  } }, /* @__PURE__ */ React.createElement(Kpi, { label: "Active rentals", value: activeRentals, suffix: "rentals", tone: "blue", icon: "van" }), /* @__PURE__ */ React.createElement(Kpi, { label: "Overdue", value: overdue.length, suffix: overdue.length === 1 ? "return" : "returns", tone: "red", icon: "warn" }), /* @__PURE__ */ React.createElement(Kpi, { label: `Revenue \xB7 ${monthLabel}`, value: fmtEuro(revenueMonth, { dp: 0 }), suffix: `${rentalsMonth} rentals`, tone: "green", icon: "euro" }), /* @__PURE__ */ React.createElement(Kpi, { label: "Fleet utilization", value: utilization + "%", suffix: "past 30 days", tone: "accent", icon: "chart" })), overdue.length > 0 && /* @__PURE__ */ React.createElement("div", { style: {
    background: T.redTint,
    border: `1px solid rgba(239,68,68,0.35)`,
    borderRadius: 12,
    padding: "14px 16px",
    marginBottom: 20,
    display: "flex",
    alignItems: "center",
    gap: 12
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 36,
    height: 36,
    borderRadius: 10,
    background: "rgba(239,68,68,0.25)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "warn", size: 20, color: T.red })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 700, color: "#FCA5A5", fontSize: 14 } }, overdue.length, " overdue return", overdue.length > 1 ? "s" : ""), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: T.text1, marginTop: 2 } }, overdue.map((r) => {
    const v = cV(r.vehicleId);
    const c = cC(r.customerId) || { name: r.reservationName || "\u2014" };
    const parts = (c.name || "\u2014").split(" ");
    return `${v && v.make || ""} ${v && v.model || ""} \xB7 ${parts[0] || ""} ${parts[2] || parts[1] || ""} \xB7 due ${fmtDateTimeBG(r.end)}`;
  }).join(" \xB7 "))), /* @__PURE__ */ React.createElement(Button, { kind: "secondary", size: "sm", onClick: () => onOpenRental && onOpenRental(overdue[0]) }, "Open")), noShows.length > 0 && /* @__PURE__ */ React.createElement("div", { style: {
    background: T.orangeTint,
    border: "1px solid rgba(249,115,22,0.35)",
    borderRadius: 12,
    padding: "12px 14px",
    marginBottom: 20
  } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 8 } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 36,
    height: 36,
    borderRadius: 10,
    background: "rgba(249,115,22,0.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "warn", size: 20, color: T.orange })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 700, color: "#FDBA74", fontSize: 14 } }, noShows.length, " \u043D\u0435\u044F\u0432\u044F\u0432\u0430\u043D\u0438\u044F \xB7 No-show"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text1, marginTop: 2 } }, "\u0420\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F\u0442\u0430 \u043D\u0435 \u0435 \u043A\u043E\u043D\u0432\u0435\u0440\u0442\u0438\u0440\u0430\u043D\u0430 \u0432 \u043D\u0430\u0435\u043C \u0432 \u0440\u0430\u043C\u043A\u0438\u0442\u0435 \u043D\u0430 grace \u043F\u0435\u0440\u0438\u043E\u0434\u0430. \u041E\u0431\u0430\u0434\u0435\u0442\u0435 \u0441\u0435 \u0438\u043B\u0438 \u043E\u0442\u043C\u0435\u043D\u0435\u0442\u0435."))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 8 } }, noShows.map((r) => {
    const v = cV(r.vehicleId);
    const clientName = r.reservationName || cC(r.customerId) && cC(r.customerId).name || "\u2014";
    const phone = r.reservationPhone || cC(r.customerId) && cC(r.customerId).phone || null;
    return /* @__PURE__ */ React.createElement("div", { key: r.id, style: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      padding: "10px 12px",
      background: T.bg1,
      border: `1px solid ${T.border}`,
      borderRadius: 10
    } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600 } }, r.contractNo, " \xB7 ", clientName), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 11.5, color: T.text2, marginTop: 2 } }, v ? v.make + " " + v.model + " \xB7 " + v.plate + " \xB7 " : "", "\u0441\u0442\u0430\u0440\u0442 ", fmtDateTimeBG(r.start), phone ? " \xB7 " + phone : "")), phone && /* @__PURE__ */ React.createElement(
      Button,
      {
        kind: "outline",
        size: "sm",
        icon: "phone",
        onClick: () => {
          window.location.href = "tel:" + phone.replace(/\s+/g, "");
        }
      },
      "\u041F\u043E\u0437\u0432\u044A\u043D\u0438"
    ), /* @__PURE__ */ React.createElement(
      Button,
      {
        kind: "outline",
        size: "sm",
        icon: "x",
        danger: true,
        onClick: () => {
          window.store.cancelRental(r.id, { reason: "no-show-cancelled" });
          const stillBusy = window.store.rentals().some(
            (x) => x.vehicleId === r.vehicleId && x.id !== r.id && (x.status === "active" || x.status === "reserved")
          );
          if (!stillBusy) window.store.updateVehicle(r.vehicleId, { status: "available" });
          window.toast && window.toast.info(
            "\u0420\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F " + r.contractNo + " \u0435 \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u0430 (no-show).",
            { title: "\u041E\u0442\u043C\u0435\u043D\u0435\u043D\u0430", duration: 3200 }
          );
        }
      },
      "\u041E\u0442\u043C\u0435\u043D\u0438"
    ), /* @__PURE__ */ React.createElement(IconBtn, { icon: "chevronR", onClick: () => onOpenRental && onOpenRental(r) }));
  }))), /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: isPhone ? "1fr" : "1fr 1fr",
    gap: 16,
    marginBottom: 20
  } }, /* @__PURE__ */ React.createElement(
    ScheduleCard,
    {
      title: "Today's handovers",
      count: todayHandovers.length,
      items: todayHandovers,
      empty: "No handovers scheduled today.",
      direction: "out",
      onOpen: onOpenRental
    }
  ), /* @__PURE__ */ React.createElement(
    ScheduleCard,
    {
      title: "Today's returns",
      count: todayReturns.length,
      items: todayReturns,
      empty: "No returns scheduled today.",
      direction: "in",
      onOpen: onOpenRental
    }
  ), extensionRequests.length > 0 && /* @__PURE__ */ React.createElement("div", { style: { gridColumn: isPhone ? "auto" : "1 / -1" } }, /* @__PURE__ */ React.createElement(
    ExtensionRequestsCard,
    {
      requests: extensionRequests,
      pendingCount: pendingExtensions.length,
      onOpenRental,
      isPhone
    }
  ))), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 14 : 20, style: { marginBottom: 20 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700 } }, "Fleet status"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginTop: 2 } }, VEHICLES.length, " ", VEHICLES.length === 1 ? "vehicle" : "vehicles")), /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "sm", iconRight: "arrowRight", onClick: () => onGo("fleet") }, "All vehicles")), /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: isPhone ? "1fr 1fr" : "repeat(3, 1fr)",
    gap: 10
  } }, VEHICLES.map((v) => /* @__PURE__ */ React.createElement(FleetTile, { key: v.id, vehicle: v, onClick: () => onGo("fleet") })))), /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: isPhone ? "1fr" : "1fr 1fr",
    gap: 16
  } }, /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 14 : 20 }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700 } }, "Outstanding payments"), /* @__PURE__ */ React.createElement(Chip, { tone: outstandingBalance > 0 ? "yellow" : "gray", size: "sm" }, fmtEuro(outstandingBalance))), (() => {
    const rows = store.outstanding();
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: T.text2, marginBottom: 12 } }, rows.length === 0 ? "\u0412\u0441\u0438\u0447\u043A\u0438 \u043D\u0430\u0435\u043C\u0438 \u0441\u0430 \u043F\u043B\u0430\u0442\u0435\u043D\u0438." : `${rows.length} rental${rows.length === 1 ? "" : "s"} with a positive balance.`), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 8 } }, rows.slice(0, 3).map((o) => {
      const r = RENTALS.find((x) => x.id === o.rentalId);
      const cus = r && CUSTOMERS.find((x) => x.id === r.customerId);
      return /* @__PURE__ */ React.createElement(OutstandingRow, { key: o.rentalId, customer: cus ? cus.name : "\u2014", contract: r ? r.contractNo : "\u2014", amount: o.amount });
    })));
  })()), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 14 : 20 }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700 } }, "Waiting leads"), /* @__PURE__ */ React.createElement(Chip, { tone: "blue", size: "sm" }, LEADS.filter((l) => l.status === "waiting").length, " waiting")), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: T.text2, marginBottom: 12 } }, "Turned-away customers to follow up on."), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 8 } }, LEADS.slice(0, 2).map((l) => /* @__PURE__ */ React.createElement("div", { key: l.id, style: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "10px 12px",
    background: T.bg2,
    borderRadius: 10,
    border: `1px solid ${T.border}`
  } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13.5, fontWeight: 600 } }, l.name), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2, marginTop: 2 }, className: "mono" }, l.phone, " \xB7 ", l.period)), /* @__PURE__ */ React.createElement(Chip, { tone: l.status === "waiting" ? "yellow" : "gray", size: "sm" }, l.status === "waiting" ? "waiting" : l.status === "contacted" ? "contacted" : "voucher")))))), /* @__PURE__ */ React.createElement("div", { style: { height: isPhone ? 40 : 24 } }));
}
function Kpi({ label, value, suffix, tone = "accent", icon }) {
  const bg = {
    blue: T.blueTint,
    red: T.redTint,
    green: T.greenTint,
    yellow: T.yellowTint,
    accent: T.accentTint
  }[tone];
  const c = {
    blue: "#60A5FA",
    red: "#F87171",
    green: "#4ADE80",
    yellow: "#FBBF24",
    accent: "#7EA8FF"
  }[tone];
  return /* @__PURE__ */ React.createElement("div", { style: {
    background: T.bg1,
    border: `1px solid ${T.border}`,
    borderRadius: 12,
    padding: "14px 16px",
    position: "relative",
    overflow: "hidden"
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    right: -6,
    top: -6,
    width: 44,
    height: 44,
    borderRadius: 12,
    background: bg,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: icon, size: 20, color: c })), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2, letterSpacing: 0.4, textTransform: "uppercase", fontWeight: 600 } }, label), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 26, fontWeight: 700, letterSpacing: -0.4, marginTop: 6 }, className: "tabular" }, value), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginTop: 2 } }, suffix));
}
function ScheduleCard({ title, count, items, empty, direction, onOpen }) {
  const cV = (id) => VEHICLES.find((v) => v.id === id);
  const cC = (id) => CUSTOMERS.find((c) => c.id === id);
  return /* @__PURE__ */ React.createElement(Card, { pad: 20 }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10 } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 32,
    height: 32,
    borderRadius: 8,
    background: direction === "out" ? T.accentTint : T.greenTint,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: direction === "out" ? "key" : "refresh", size: 16, color: direction === "out" ? T.accent : T.green })), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700 } }, title)), /* @__PURE__ */ React.createElement(Chip, { tone: count > 0 ? "accent" : "gray", size: "sm" }, count)), items.length === 0 ? /* @__PURE__ */ React.createElement("div", { style: { padding: "20px 0", color: T.text2, fontSize: 13, textAlign: "center" } }, empty) : /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 8 } }, items.map((r) => {
    const v = cV(r.vehicleId);
    const c = cC(r.customerId) || { name: r.reservationName || "\u2014" };
    const t = direction === "out" ? r.start : r.end;
    return /* @__PURE__ */ React.createElement("button", { key: r.id, onClick: () => onOpen && onOpen(r), style: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      padding: "10px 12px",
      background: T.bg2,
      border: `1px solid ${T.border}`,
      borderRadius: 10,
      textAlign: "left"
    } }, /* @__PURE__ */ React.createElement("div", { style: { width: 46, textAlign: "center" } }, /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 15, fontWeight: 700, color: T.text0 } }, fmtTime(t))), /* @__PURE__ */ React.createElement("div", { style: { width: 1, height: 32, background: T.border } }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13.5, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } }, c.name), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2, marginTop: 2 }, className: "mono" }, v.make, " ", v.model, " \xB7 ", v.plate)), r.status === "overdue" && /* @__PURE__ */ React.createElement(Chip, { tone: "red", size: "sm" }, "overdue"), /* @__PURE__ */ React.createElement(Icon, { name: "chevronR", size: 16, color: T.text3 }));
  })));
}
function FleetTile({ vehicle, onClick }) {
  const v = vehicle;
  const stat = STATUS_COLORS[v.status] || STATUS_COLORS.available;
  return /* @__PURE__ */ React.createElement("button", { onClick, style: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: 12,
    background: T.bg2,
    border: `1px solid ${T.border}`,
    borderRadius: 10,
    textAlign: "left",
    position: "relative"
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 44,
    height: 32,
    borderRadius: 6,
    background: "rgba(255,255,255,0.04)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
  } }, /* @__PURE__ */ React.createElement(VanGlyph, { size: 38, drivetrain: v.drivetrain })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } }, v.make, " ", v.model), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 10.5, color: T.text2, letterSpacing: 0.4 } }, v.plate)), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 6 } }, /* @__PURE__ */ React.createElement(StatusDot, { status: v.status, size: 8 })));
}
function OutstandingRow({ customer, contract, amount }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    padding: "8px 12px",
    background: T.bg2,
    borderRadius: 10,
    border: `1px solid ${T.border}`
  } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13.5, fontWeight: 600 } }, customer), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 11.5, color: T.text2, marginTop: 2 } }, contract)), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 14, fontWeight: 700, color: "#FBBF24" } }, fmtEuro(amount)));
}
function ExtensionRequestsCard({ requests, pendingCount, onOpenRental, isPhone }) {
  const fmtDT = (iso) => {
    const d = new Date(iso);
    return d.toLocaleDateString("bg-BG", { day: "2-digit", month: "2-digit" }) + " " + d.toLocaleTimeString("bg-BG", { hour: "2-digit", minute: "2-digit" });
  };
  const now = Date.now();
  const pending = requests.filter((r) => r.status === "pending");
  const handled = requests.filter((r) => r.status === "handled").slice(0, 5);
  const shown = [...pending, ...handled];
  return /* @__PURE__ */ React.createElement("div", { "data-testid": "extension-requests-card" }, /* @__PURE__ */ React.createElement(Card, { pad: 0 }, /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: isPhone ? "12px 14px" : "14px 18px",
    borderBottom: `1px solid ${T.border}`
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "clock", size: 17, color: pendingCount > 0 ? "#FBBF24" : T.text2 }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700, flex: 1 } }, "\u0417\u0430\u044F\u0432\u043A\u0438 \u0437\u0430 \u0443\u0434\u044A\u043B\u0436\u0430\u0432\u0430\u043D\u0435"), pendingCount > 0 && /* @__PURE__ */ React.createElement("span", { style: {
    background: "#EF4444",
    color: "#fff",
    fontSize: 11.5,
    fontWeight: 700,
    borderRadius: 999,
    padding: "2px 10px"
  } }, pendingCount, " ", pendingCount === 1 ? "\u0447\u0430\u043A\u0430\u0449\u0430" : "\u0447\u0430\u043A\u0430\u0449\u0438")), shown.map((req, i) => {
    const stale = req.status === "pending" && now - new Date(req.createdAt).getTime() > 30 * 60 * 1e3;
    return /* @__PURE__ */ React.createElement("div", { key: req.id, style: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      padding: isPhone ? "10px 14px" : "12px 18px",
      borderBottom: i < shown.length - 1 ? `1px solid ${T.border}` : "none",
      flexWrap: "wrap",
      background: stale ? "rgba(239,68,68,0.06)" : "transparent"
    } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: isPhone ? 150 : 220 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13.5, fontWeight: 600 } }, req.customerName, /* @__PURE__ */ React.createElement("span", { className: "mono", style: { fontSize: 11.5, color: T.text2, marginLeft: 8 } }, req.contractNo)), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginTop: 2 } }, fmtDT(req.currentEndAt), " \u2192 ", /* @__PURE__ */ React.createElement("strong", { style: { color: T.text0 } }, fmtDT(req.requestedEndAt)), req.customerPhone ? /* @__PURE__ */ React.createElement("span", null, " \xB7 ", req.customerPhone) : null), stale && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: "#EF4444", fontWeight: 600, marginTop: 2 } }, "\u041D\u0430\u0434 30 \u043C\u0438\u043D \u0431\u0435\u0437 \u043E\u0431\u0430\u0436\u0434\u0430\u043D\u0435!")), req.status === "pending" ? /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, flexWrap: "wrap" } }, req.customerPhone && /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "sm", icon: "phone", onClick: () => {
      window.location.href = "tel:" + req.customerPhone;
    } }, "\u041F\u043E\u0437\u0432\u044A\u043D\u0438"), /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "sm", onClick: () => onOpenRental && onOpenRental(req.rentalId) }, "\u041D\u0430\u0435\u043C"), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "sm", icon: "check", onClick: () => store.markExtensionHandled(req.id) }, "\u041E\u0431\u0440\u0430\u0431\u043E\u0442\u0435\u043D\u0430")) : /* @__PURE__ */ React.createElement(Chip, { tone: "green", size: "sm", icon: "check" }, "\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0435\u043D\u0430 ", req.handledAt ? fmtDT(req.handledAt) : ""));
  })));
}
Object.assign(window, { Dashboard });

/* ══════════ components/calendar.jsx ══════════ */
function CalendarScreen({ isPhone, onOpenRental, onNewRental, onGo }) {
  store.useStore();
  const [anchor, setAnchor] = useState(new Date(TODAY));
  anchor.setHours(0, 0, 0, 0);
  const days = isPhone ? 7 : 14;
  const dayCols = [];
  for (let i = 0; i < days; i++) {
    const dd = new Date(anchor);
    dd.setDate(anchor.getDate() + i);
    dayCols.push(dd);
  }
  const shiftDays = (n) => {
    const nd = new Date(anchor);
    nd.setDate(anchor.getDate() + n);
    setAnchor(nd);
  };
  const dayW = isPhone ? 62 : 82;
  const rowH = 68;
  const nameColW = isPhone ? 130 : 200;
  const inWindow = (r) => {
    const winStart = anchor;
    const winEnd = new Date(anchor);
    winEnd.setDate(anchor.getDate() + days);
    return r.end >= winStart && r.start < winEnd;
  };
  const startCol = (r) => {
    const startOfR = new Date(r.start);
    startOfR.setHours(0, 0, 0, 0);
    let col = Math.floor((startOfR - anchor) / (1e3 * 60 * 60 * 24));
    const hourOffset = r.start.getHours() / 24;
    return Math.max(0, col + hourOffset);
  };
  const endCol = (r) => {
    const endOfR = new Date(r.end);
    endOfR.setHours(0, 0, 0, 0);
    let col = Math.floor((endOfR - anchor) / (1e3 * 60 * 60 * 24));
    const hourOffset = r.end.getHours() / 24;
    return Math.min(days, col + hourOffset);
  };
  return /* @__PURE__ */ React.createElement("div", { style: { flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", background: T.bg0 } }, /* @__PURE__ */ React.createElement("div", { style: {
    padding: isPhone ? "14px 16px" : "18px 24px",
    display: "flex",
    alignItems: "center",
    gap: 12,
    borderBottom: `1px solid ${T.border}`,
    flexWrap: "wrap"
  } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: isPhone ? 18 : 22, fontWeight: 700, letterSpacing: -0.2 } }, "Calendar"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginTop: 2 } }, fmtDateBG(dayCols[0]), " \u2014 ", fmtDateBG(dayCols[dayCols.length - 1]))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center" } }, /* @__PURE__ */ React.createElement(IconBtn, { icon: "chevronL", onClick: () => shiftDays(-days), title: "Previous" }), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "sm", onClick: () => {
    const n = new Date(TODAY);
    n.setHours(0, 0, 0, 0);
    setAnchor(n);
  } }, "Today"), /* @__PURE__ */ React.createElement(IconBtn, { icon: "chevronR", onClick: () => shiftDays(days), title: "Next" }), !isPhone && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { width: 12 } }), /* @__PURE__ */ React.createElement(Button, { kind: "primary", icon: "plus", onClick: onNewRental }, "New rental")))), !isPhone && /* @__PURE__ */ React.createElement("div", { style: { padding: "8px 24px", display: "flex", gap: 16, alignItems: "center", borderBottom: `1px solid ${T.border}`, background: T.bg1 } }, /* @__PURE__ */ React.createElement(LegendChip, { color: T.blue, label: "Active rental" }), /* @__PURE__ */ React.createElement(LegendChip, { color: T.yellow, label: "Reserved" }), /* @__PURE__ */ React.createElement(LegendChip, { color: T.red, label: "Overdue" }), /* @__PURE__ */ React.createElement(LegendChip, { color: T.gray, label: "Service / cleaning" }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2 } }, "Tap a free slot to create a rental \xB7 Tap a block to open it")), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, overflow: "auto" } }, /* @__PURE__ */ React.createElement("div", { style: { minWidth: nameColW + dayW * days, position: "relative" } }, /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: `${nameColW}px repeat(${days}, ${dayW}px)`,
    position: "sticky",
    top: 0,
    zIndex: 10,
    background: T.bg1,
    borderBottom: `1px solid ${T.border}`
  } }, /* @__PURE__ */ React.createElement("div", { style: { padding: "10px 14px", fontSize: 11, color: T.text2, letterSpacing: 0.4, textTransform: "uppercase", fontWeight: 600, borderRight: `1px solid ${T.border}` } }, "Vehicle"), dayCols.map((d, i) => {
    const isToday = d.getTime() === new Date(TODAY.getFullYear(), TODAY.getMonth(), TODAY.getDate()).getTime();
    const isWeekend = d.getDay() === 0 || d.getDay() === 6;
    return /* @__PURE__ */ React.createElement("div", { key: i, style: {
      padding: "8px 6px",
      textAlign: "center",
      borderRight: `1px solid ${T.border}`,
      background: isToday ? T.accentTint : isWeekend ? "rgba(255,255,255,0.02)" : "transparent"
    } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, color: T.text2, textTransform: "uppercase", letterSpacing: 0.4, fontWeight: 600 } }, ["\u043D\u0434", "\u043F\u043D", "\u0432\u0442", "\u0441\u0440", "\u0447\u0442", "\u043F\u0442", "\u0441\u0431"][d.getDay()]), /* @__PURE__ */ React.createElement("div", { className: "mono", style: {
      fontSize: 15,
      fontWeight: 700,
      marginTop: 2,
      color: isToday ? T.accent : T.text0
    } }, d.getDate()));
  })), VEHICLES.length === 0 && /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    padding: isPhone ? "48px 20px" : "64px 20px",
    textAlign: "center"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "van", size: 32, color: T.text2 }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700 } }, "No vehicles in your fleet yet"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: T.text2, maxWidth: 320 } }, "Add a vehicle to your fleet to start scheduling rentals on the calendar."), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 6 } }, /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "sm", icon: "plus", onClick: () => onGo && onGo("fleet") }, "Add a vehicle"))), VEHICLES.map((v) => {
    const rows = RENTALS.filter((r) => r.vehicleId === v.id).filter(inWindow).filter((r) => r.status === "reserved" || r.status === "active" || r.status === "overdue");
    return /* @__PURE__ */ React.createElement("div", { key: v.id, style: {
      display: "grid",
      gridTemplateColumns: `${nameColW}px repeat(${days}, ${dayW}px)`,
      borderBottom: `1px solid ${T.border}`,
      height: rowH,
      position: "relative"
    } }, /* @__PURE__ */ React.createElement("div", { style: {
      padding: "8px 12px",
      borderRight: `1px solid ${T.border}`,
      background: T.bg1,
      display: "flex",
      alignItems: "center",
      gap: 10,
      position: "sticky",
      left: 0,
      zIndex: 5
    } }, /* @__PURE__ */ React.createElement(VanGlyph, { size: 30, drivetrain: v.drivetrain }), /* @__PURE__ */ React.createElement("div", { style: { minWidth: 0, flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } }, v.make, " ", v.model), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 10.5, color: T.text2 } }, v.plate)), /* @__PURE__ */ React.createElement(StatusDot, { status: v.status, size: 8 })), dayCols.map((d, i) => {
      const isToday = d.getTime() === new Date(TODAY.getFullYear(), TODAY.getMonth(), TODAY.getDate()).getTime();
      const isWeekend = d.getDay() === 0 || d.getDay() === 6;
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          key: i,
          onClick: () => onNewRental && onNewRental({ vehicleId: v.id, date: d }),
          style: {
            borderRight: `1px solid ${T.border}`,
            background: isToday ? "rgba(26,92,230,0.08)" : isWeekend ? "rgba(255,255,255,0.015)" : "transparent",
            position: "relative",
            transition: "background 0.1s"
          },
          onMouseEnter: (e) => e.currentTarget.style.background = T.accentTint,
          onMouseLeave: (e) => e.currentTarget.style.background = isToday ? "rgba(26,92,230,0.08)" : isWeekend ? "rgba(255,255,255,0.015)" : "transparent"
        }
      );
    }), (v.status === "in_service" || v.status === "cleaning") && /* @__PURE__ */ React.createElement("div", { style: {
      position: "absolute",
      left: nameColW,
      top: 0,
      height: rowH,
      width: dayW * days,
      background: "repeating-linear-gradient(45deg, rgba(122,134,153,0.15) 0 6px, transparent 6px 12px)",
      pointerEvents: "none"
    } }, /* @__PURE__ */ React.createElement("div", { style: { position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", fontSize: 11.5, color: T.text2, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.6 } }, v.status === "in_service" ? "\u2699 In service \xB7 Oil change + filters" : "\u{1F9FD} Cleaning")), rows.map((r) => {
      const sc = startCol(r);
      const ec = endCol(r);
      const left = nameColW + sc * dayW;
      const width = Math.max(20, (ec - sc) * dayW);
      const stat = STATUS_COLORS[r.status];
      const c = CUSTOMERS.find((cc) => cc.id === r.customerId) || { name: r.reservationName || "\u2014", phone: r.reservationPhone || "" };
      const color = r.status === "overdue" ? T.red : r.status === "no-show" ? T.orange : r.status === "active" ? T.blue : r.status === "reserved" ? T.yellow : T.gray;
      const bg = r.status === "overdue" ? "rgba(239,68,68,0.20)" : r.status === "no-show" ? "rgba(249,115,22,0.22)" : r.status === "active" ? "rgba(59,118,240,0.22)" : r.status === "reserved" ? "rgba(245,165,36,0.18)" : "rgba(122,134,153,0.20)";
      const timeRange = fmtTime(r.start) + "\u2013" + fmtTime(r.end);
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          key: r.id,
          onClick: (e) => {
            e.stopPropagation();
            onOpenRental && onOpenRental(r);
          },
          title: c.name + " \xB7 " + r.contractNo + " \xB7 " + timeRange,
          style: {
            position: "absolute",
            left,
            top: 8,
            height: rowH - 16,
            width,
            background: bg,
            border: `1px solid ${color}`,
            borderLeft: `4px solid ${color}`,
            borderRadius: 8,
            padding: "4px 8px",
            textAlign: "left",
            overflow: "hidden",
            color: T.text0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 3
          }
        },
        /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } }, c.name.split(" ")[0], " ", c.name.split(" ").slice(-1)[0]),
        /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 10, color: T.text1, opacity: 0.9, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } }, r.contractNo, width >= 70 ? " \xB7 " + timeRange : "")
      );
    }));
  }))), isPhone && /* @__PURE__ */ React.createElement("div", { style: { padding: 12, borderTop: `1px solid ${T.border}` } }, /* @__PURE__ */ React.createElement(Button, { block: true, kind: "primary", icon: "plus", onClick: onNewRental }, "New rental")));
}
function LegendChip({ color, label }) {
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 6 } }, /* @__PURE__ */ React.createElement("div", { style: { width: 12, height: 12, borderRadius: 3, background: color, opacity: 0.9 } }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text1 } }, label));
}
Object.assign(window, { CalendarScreen });

/* ══════════ components/capture.jsx ══════════ */
var MAX_EDGE = 1920;
var JPEG_QUALITY = 0.85;
function loadFileAsImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = (err) => {
      URL.revokeObjectURL(url);
      reject(err);
    };
    img.src = url;
  });
}
async function processCapturedImage(file, { contractNo, slotLabel, noStamp } = {}) {
  const img = await loadFileAsImage(file);
  const srcW = img.naturalWidth || img.width;
  const srcH = img.naturalHeight || img.height;
  if (!srcW || !srcH) throw new Error("Empty image");
  const scale = Math.min(1, MAX_EDGE / Math.max(srcW, srcH));
  const outW = Math.round(srcW * scale);
  const outH = Math.round(srcH * scale);
  const canvas = document.createElement("canvas");
  canvas.width = outW;
  canvas.height = outH;
  const ctx = canvas.getContext("2d");
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(img, 0, 0, outW, outH);
  const now = /* @__PURE__ */ new Date();
  if (!noStamp) {
    const stamp1 = fmtDateTimeBG(now);
    const brand = window.store && window.store.companySettings && window.store.companySettings().brand || "banicharka.bg";
    const stamp2 = (contractNo ? `\u0414\u043E\u0433\u043E\u0432\u043E\u0440 ${contractNo}` : brand) + (slotLabel ? "  \xB7  " + slotLabel : "");
    const fontPx = Math.max(14, Math.round(outW / 60));
    const pad = Math.round(fontPx * 0.55);
    ctx.font = `600 ${fontPx}px "JetBrains Mono", monospace`;
    const w1 = ctx.measureText(stamp1).width;
    ctx.font = `500 ${Math.round(fontPx * 0.85)}px "JetBrains Mono", monospace`;
    const w2 = ctx.measureText(stamp2).width;
    const boxW = Math.max(w1, w2) + pad * 2;
    const boxH = fontPx * 2 + pad * 2.4;
    ctx.fillStyle = "rgba(0,0,0,0.65)";
    ctx.fillRect(pad, outH - boxH - pad, boxW, boxH);
    ctx.textBaseline = "top";
    ctx.fillStyle = "#fff";
    ctx.font = `600 ${fontPx}px "JetBrains Mono", monospace`;
    ctx.fillText(stamp1, pad * 2, outH - boxH - pad + pad);
    ctx.font = `500 ${Math.round(fontPx * 0.85)}px "JetBrains Mono", monospace`;
    ctx.fillStyle = "rgba(255,255,255,0.85)";
    ctx.fillText(stamp2, pad * 2, outH - boxH - pad + pad + fontPx * 1.15);
  }
  const dataUrl = canvas.toDataURL("image/jpeg", JPEG_QUALITY);
  return {
    dataUrl,
    width: outW,
    height: outH,
    // Approx bytes: base64 length * 0.75 minus header.
    bytes: Math.round((dataUrl.length - "data:image/jpeg;base64,".length) * 0.75),
    capturedAt: now.toISOString()
  };
}
function CaptureTrigger({ children, onCapture, onError, contractNo, slotLabel, noStamp, disabled, style, block }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const trigger = () => {
    if (disabled || busy) return;
    if (inputRef.current) inputRef.current.value = "";
    inputRef.current && inputRef.current.click();
  };
  const handleChange = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    setBusy(true);
    try {
      const processed = await processCapturedImage(file, { contractNo, slotLabel, noStamp });
      onCapture && onCapture(processed);
    } catch (err) {
      console.error("capture failed:", err);
      onError && onError(err);
    } finally {
      setBusy(false);
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: trigger,
      disabled: disabled || busy,
      style: {
        width: block ? "100%" : void 0,
        cursor: disabled || busy ? "default" : "pointer",
        background: "transparent",
        border: "none",
        padding: 0,
        color: "inherit",
        font: "inherit",
        textAlign: "inherit",
        opacity: busy ? 0.6 : 1,
        ...style
      }
    },
    typeof children === "function" ? children({ busy }) : children
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      ref: inputRef,
      type: "file",
      accept: "image/*",
      capture: "environment",
      onChange: handleChange,
      style: {
        position: "absolute",
        width: 1,
        height: 1,
        opacity: 0,
        pointerEvents: "none",
        overflow: "hidden"
      }
    }
  ));
}
function GalleryTrigger({ children, onCapture, onError, contractNo, slotLabel, noStamp, disabled, style, block }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const trigger = () => {
    if (disabled || busy) return;
    if (inputRef.current) inputRef.current.value = "";
    inputRef.current && inputRef.current.click();
  };
  const handleChange = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    if (file.type && !file.type.startsWith("image/")) {
      onError && onError(new Error("\u0424\u0430\u0439\u043B\u044A\u0442 \u043D\u0435 \u0435 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u2014 \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0441\u043D\u0438\u043C\u043A\u0430."));
      return;
    }
    setBusy(true);
    try {
      const processed = await processCapturedImage(file, { contractNo, slotLabel, noStamp });
      onCapture && onCapture(processed);
    } catch (err) {
      console.error("gallery pick failed:", err);
      onError && onError(new Error("\u0421\u043D\u0438\u043C\u043A\u0430\u0442\u0430 \u043D\u0435 \u043C\u043E\u0436\u0430 \u0434\u0430 \u0431\u044A\u0434\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0435\u043D\u0430 \u2014 \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0434\u0440\u0443\u0433\u0430."));
    } finally {
      setBusy(false);
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: trigger,
      disabled: disabled || busy,
      style: {
        width: block ? "100%" : void 0,
        cursor: disabled || busy ? "default" : "pointer",
        background: "transparent",
        border: "none",
        padding: 0,
        color: "inherit",
        font: "inherit",
        textAlign: "inherit",
        opacity: busy ? 0.6 : 1,
        ...style
      }
    },
    typeof children === "function" ? children({ busy }) : children
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      ref: inputRef,
      type: "file",
      accept: "image/*",
      "data-gallery": "1",
      onChange: handleChange,
      style: {
        position: "absolute",
        width: 1,
        height: 1,
        opacity: 0,
        pointerEvents: "none",
        overflow: "hidden"
      }
    }
  ));
}
Object.assign(window, { CaptureTrigger, GalleryTrigger, processCapturedImage });

/* ══════════ components/scan-documents.jsx ══════════ */
var SCAN_SLOTS = [
  { key: "idFront", label: "\u041B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430 \u2014 \u041F\u0420\u0415\u0414\u041D\u0410 \u0441\u0442\u0440\u0430\u043D\u0430", short: "\u041B\u041A \u043F\u0440\u0435\u0434\u043D\u0430" },
  { key: "idBack", label: "\u041B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430 \u2014 \u0417\u0410\u0414\u041D\u0410 \u0441\u0442\u0440\u0430\u043D\u0430", short: "\u041B\u041A \u0437\u0430\u0434\u043D\u0430", hint: "\u0417\u043E\u043D\u0430\u0442\u0430 \u0441 < \u0441\u0438\u043C\u0432\u043E\u043B\u0438\u0442\u0435 (MRZ) \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0441\u0435 \u0432\u0438\u0436\u0434\u0430 \u044F\u0441\u043D\u043E" },
  { key: "dlFront", label: "\u0421\u0423\u041C\u041F\u0421 \u2014 \u041F\u0420\u0415\u0414\u041D\u0410 \u0441\u0442\u0440\u0430\u043D\u0430", short: "\u0421\u0423\u041C\u041F\u0421 \u043F\u0440\u0435\u0434\u043D\u0430" },
  { key: "dlBack", label: "\u0421\u0423\u041C\u041F\u0421 \u2014 \u0417\u0410\u0414\u041D\u0410 \u0441\u0442\u0440\u0430\u043D\u0430", short: "\u0421\u0423\u041C\u041F\u0421 \u0437\u0430\u0434\u043D\u0430" }
];
var SCAN_SOURCE_STYLES = {
  mrz: { border: "#22C55E", label: "MRZ \u2713", title: "\u041E\u0442 \u043C\u0430\u0448\u0438\u043D\u043D\u043E\u0447\u0438\u0442\u0430\u0435\u043C\u0430\u0442\u0430 \u0437\u043E\u043D\u0430 \u2014 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u043D\u0438\u0442\u0435 \u0446\u0438\u0444\u0440\u0438 \u0441\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u0438." },
  ocr: { border: "#3B82F6", label: "OCR", title: "\u0420\u0430\u0437\u0447\u0435\u0442\u0435\u043D\u043E \u043E\u0442 \u0442\u0435\u043A\u0441\u0442\u0430 \u043D\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u2014 \u0431\u0435\u0437 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u043D\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430." },
  uncertain: { border: "#F59E0B", label: "\u041F\u0440\u043E\u0432\u0435\u0440\u0438", title: "\u041D\u0438\u0441\u043A\u0430 \u0443\u0432\u0435\u0440\u0435\u043D\u043E\u0441\u0442 \u0438\u043B\u0438 \u043D\u0435\u0441\u044A\u0432\u043F\u0430\u0434\u0430\u0449\u0430 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u043D\u0430 \u0446\u0438\u0444\u0440\u0430 \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u0442\u0435 \u0432\u043D\u0438\u043C\u0430\u0442\u0435\u043B\u043D\u043E." }
};
window.SCAN_SOURCE_STYLES = SCAN_SOURCE_STYLES;
function ScanDocumentsOverlay({ onClose, onExtracted, customerName }) {
  const [photos, setPhotos] = useState({});
  const [skipped, setSkipped] = useState({});
  const [phase, setPhase] = useState("capture");
  const [error, setError] = useState(null);
  const [offline, setOffline] = useState(!navigator.onLine);
  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  const captured = SCAN_SLOTS.filter((s) => photos[s.key]);
  const canExtract = captured.length >= 1 && phase === "capture";
  const doExtract = async () => {
    setPhase("extracting");
    setError(null);
    try {
      const photoDataUrls = {};
      for (const s of SCAN_SLOTS) {
        if (photos[s.key]) photoDataUrls[s.key] = photos[s.key].dataUrl;
      }
      const scanId = window.store.newScanId();
      const photoKeys = await window.store.scanUploadPhotos(scanId, photoDataUrls);
      const result = await window.store.scanExtract(scanId, photoKeys);
      setPhase("done");
      onExtracted && onExtracted(result);
    } catch (err) {
      try {
        const photoDataUrls = {};
        for (const s of SCAN_SLOTS) {
          if (photos[s.key]) photoDataUrls[s.key] = photos[s.key].dataUrl;
        }
        await window.store.scanQueueAdd({
          scanId: window.store.newScanId(),
          customerName: customerName || "",
          photos: photoDataUrls,
          queuedAt: (/* @__PURE__ */ new Date()).toISOString()
        });
        setPhase("queued");
        window.toast && window.toast.warn(
          "\u041D\u044F\u043C\u0430 \u0432\u0440\u044A\u0437\u043A\u0430. \u0421\u043D\u0438\u043C\u043A\u0438\u0442\u0435 \u0441\u0430 \u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0438; \u043F\u043E\u043F\u044A\u043B\u043D\u0435\u0442\u0435 \u043F\u043E\u043B\u0435\u0442\u0430\u0442\u0430 \u0440\u044A\u0447\u043D\u043E. \u0429\u0435 \u0441\u0435 \u043A\u0430\u0447\u0430\u0442 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u043F\u0440\u0438 \u0432\u0440\u044A\u0437\u043A\u0430.",
          { duration: 6e3 }
        );
      } catch (qErr) {
        setPhase("capture");
        setError("\u0420\u0430\u0437\u043F\u043E\u0437\u043D\u0430\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0435 \u0443\u0441\u043F\u044F \u0438 \u0441\u043D\u0438\u043C\u043A\u0438\u0442\u0435 \u043D\u0435 \u043C\u043E\u0436\u0430\u0445\u0430 \u0434\u0430 \u0441\u0435 \u0437\u0430\u043F\u0430\u0437\u044F\u0442: " + (err && err.message || err));
        window.store.reportError && window.store.reportError(err, "\u0421\u043A\u0430\u043D\u0438\u0440\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u043D\u0435 \u0443\u0441\u043F\u044F");
      }
    }
  };
  const saveForLater = async () => {
    setError(null);
    try {
      const photoDataUrls = {};
      for (const s of SCAN_SLOTS) {
        if (photos[s.key]) photoDataUrls[s.key] = photos[s.key].dataUrl;
      }
      await window.store.scanQueueAdd({
        scanId: window.store.newScanId(),
        customerName: customerName || "",
        photos: photoDataUrls,
        queuedAt: (/* @__PURE__ */ new Date()).toISOString()
      });
      setPhase("queued");
      window.toast && window.toast.info(
        "\u0421\u043D\u0438\u043C\u043A\u0438\u0442\u0435 \u0441\u0430 \u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0438 \u0438 \u0449\u0435 \u0441\u0435 \u043A\u0430\u0447\u0430\u0442 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u043F\u0440\u0438 \u0432\u0440\u044A\u0437\u043A\u0430.",
        { duration: 5e3 }
      );
    } catch (err) {
      setError("\u0417\u0430\u043F\u0430\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0435 \u0443\u0441\u043F\u044F: " + (err && err.message || err));
    }
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      "data-screen-label": "Scan documents",
      style: {
        position: "fixed",
        inset: 0,
        zIndex: 400,
        background: "rgba(5,7,11,0.92)",
        backdropFilter: "blur(4px)",
        display: "flex",
        flexDirection: "column"
      }
    },
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", borderBottom: `1px solid ${T.border}` } }, /* @__PURE__ */ React.createElement(Icon, { name: "camera", size: 22, color: T.accent }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700, color: T.text0 } }, "\u0421\u043A\u0430\u043D\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2 } }, captured.length, "/4 \u0441\u043D\u0438\u043C\u0430\u043D\u0438 \xB7 \u043F\u0440\u043E\u043F\u0443\u0441\u043D\u0430\u0442\u0438\u0442\u0435 \u043E\u0441\u0442\u0430\u0432\u0430\u0442 \u0437\u0430 \u0440\u044A\u0447\u043D\u043E \u043F\u043E\u043F\u044A\u043B\u0432\u0430\u043D\u0435")), /* @__PURE__ */ React.createElement(IconBtn, { icon: "x", title: "\u0417\u0430\u0442\u0432\u043E\u0440\u0438", onClick: onClose })),
    offline && /* @__PURE__ */ React.createElement("div", { style: { padding: "10px 16px", background: "rgba(245,158,11,0.12)", borderBottom: "1px solid rgba(245,158,11,0.4)", color: "#F59E0B", fontSize: 13, fontWeight: 600 } }, "\u041D\u044F\u043C\u0430 \u0432\u0440\u044A\u0437\u043A\u0430. \u0421\u043D\u0438\u043C\u043A\u0438\u0442\u0435 \u0441\u0430 \u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0438; \u043F\u043E\u043F\u044A\u043B\u043D\u0435\u0442\u0435 \u043F\u043E\u043B\u0435\u0442\u0430\u0442\u0430 \u0440\u044A\u0447\u043D\u043E. \u0429\u0435 \u0441\u0435 \u043A\u0430\u0447\u0430\u0442 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u043F\u0440\u0438 \u0432\u0440\u044A\u0437\u043A\u0430."),
    /* @__PURE__ */ React.createElement("div", { style: { flex: 1, overflowY: "auto", padding: 16, display: "grid", gap: 12 } }, SCAN_SLOTS.map((slot, i) => {
      const shot = photos[slot.key];
      const isSkipped = skipped[slot.key];
      return /* @__PURE__ */ React.createElement(Card, { key: slot.key, pad: 12, style: {
        borderColor: shot ? "rgba(34,197,94,0.5)" : isSkipped ? "rgba(245,158,11,0.5)" : T.border
      } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { style: {
        width: 84,
        height: 56,
        borderRadius: 8,
        flexShrink: 0,
        background: T.bg1,
        border: `1px solid ${T.border}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden"
      } }, shot ? /* @__PURE__ */ React.createElement("img", { src: shot.dataUrl, alt: slot.short, style: { width: "100%", height: "100%", objectFit: "cover" } }) : /* @__PURE__ */ React.createElement(Icon, { name: "camera", size: 20, color: isSkipped ? "#F59E0B" : T.text2 })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600, color: T.text0 } }, i + 1, ". ", slot.label), slot.hint && !shot && !isSkipped && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, marginTop: 2 } }, slot.hint), isSkipped && !shot && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: "#F59E0B", marginTop: 2, fontWeight: 600 } }, "\u041F\u0440\u043E\u043F\u0443\u0441\u043D\u0430\u0442\u0430 \u2014 \u043F\u043E\u043B\u0435\u0442\u0430\u0442\u0430 \u043E\u0441\u0442\u0430\u0432\u0430\u0442 \u0437\u0430 \u0440\u044A\u0447\u043D\u043E \u043F\u043E\u043F\u044A\u043B\u0432\u0430\u043D\u0435"), shot && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, marginTop: 2 } }, shot.width, "\xD7", shot.height, " \xB7 ", Math.round(shot.bytes / 1024), " KB")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, flexShrink: 0 } }, /* @__PURE__ */ React.createElement(
        CaptureTrigger,
        {
          slotLabel: slot.short,
          noStamp: true,
          onCapture: (processed) => {
            setPhotos((p) => ({ ...p, [slot.key]: processed }));
            setSkipped((s) => ({ ...s, [slot.key]: false }));
          },
          onError: (err) => {
            setError("\u0421\u043D\u0438\u043C\u043A\u0430\u0442\u0430 \u043D\u0435 \u0443\u0441\u043F\u044F: " + (err && err.message || err));
          }
        },
        /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 6 } }, /* @__PURE__ */ React.createElement(Icon, { name: "camera", size: 15 }), shot ? "\u041F\u0440\u0435\u0441\u043D\u0438\u043C\u0430\u0439" : "\u0421\u043D\u0438\u043C\u0430\u0439")
      ), /* @__PURE__ */ React.createElement(
        GalleryTrigger,
        {
          slotLabel: slot.short,
          noStamp: true,
          onCapture: (processed) => {
            setPhotos((p) => ({ ...p, [slot.key]: processed }));
            setSkipped((s) => ({ ...s, [slot.key]: false }));
          },
          onError: (err) => {
            setError(err && err.message || String(err));
          }
        },
        /* @__PURE__ */ React.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 6 } }, /* @__PURE__ */ React.createElement(Icon, { name: "image", size: 15 }), "\u0413\u0430\u043B\u0435\u0440\u0438\u044F")
      ), !shot && !isSkipped && /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "sm", onClick: () => setSkipped((s) => ({ ...s, [slot.key]: true })) }, "\u041F\u0440\u043E\u043F\u0443\u0441\u043D\u0438"))));
    }), error && /* @__PURE__ */ React.createElement(Card, { pad: 12, style: { borderColor: "rgba(239,68,68,0.5)", background: "rgba(239,68,68,0.08)" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: "#EF4444", fontWeight: 600 } }, error)), phase === "queued" && /* @__PURE__ */ React.createElement(Card, { pad: 12, style: { borderColor: "rgba(245,158,11,0.5)", background: "rgba(245,158,11,0.08)" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: "#F59E0B", fontWeight: 600 } }, "\u0421\u043D\u0438\u043C\u043A\u0438\u0442\u0435 \u0441\u0430 \u0432 \u043E\u043F\u0430\u0448\u043A\u0430\u0442\u0430 \u0438 \u0449\u0435 \u0441\u0435 \u043A\u0430\u0447\u0430\u0442 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u043F\u0440\u0438 \u0432\u0440\u044A\u0437\u043A\u0430. \u041F\u043E\u043F\u044A\u043B\u043D\u0435\u0442\u0435 \u043F\u043E\u043B\u0435\u0442\u0430\u0442\u0430 \u0440\u044A\u0447\u043D\u043E."))),
    /* @__PURE__ */ React.createElement("div", { style: { padding: 16, borderTop: `1px solid ${T.border}`, display: "flex", gap: 10 } }, /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "lg", onClick: onClose }, phase === "done" || phase === "queued" ? "\u0417\u0430\u0442\u0432\u043E\u0440\u0438" : "\u041E\u0442\u043A\u0430\u0437"), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }), offline ? /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "lg", icon: "check", disabled: captured.length < 1 || phase === "queued", onClick: saveForLater }, "\u0417\u0430\u043F\u0430\u0437\u0438 \u0437\u0430 \u043F\u043E-\u043A\u044A\u0441\u043D\u043E") : /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "lg", icon: "check", disabled: !canExtract, onClick: doExtract }, phase === "extracting" ? "\u0420\u0430\u0437\u043F\u043E\u0437\u043D\u0430\u0432\u0430\u043D\u0435\u2026" : "\u0418\u0437\u0432\u043B\u0435\u0447\u0438 \u0434\u0430\u043D\u043D\u0438"))
  );
}
function ScanFieldHighlight({ source, note, children }) {
  if (!source) return children;
  const s = SCAN_SOURCE_STYLES[source] || SCAN_SOURCE_STYLES.ocr;
  return /* @__PURE__ */ React.createElement("div", { style: { position: "relative", borderLeft: `3px solid ${s.border}`, paddingLeft: 8, borderRadius: 2 }, title: note || s.title }, children, /* @__PURE__ */ React.createElement("span", { style: {
    position: "absolute",
    top: -6,
    right: 0,
    fontSize: 10,
    fontWeight: 700,
    color: s.border,
    background: T.bg0,
    padding: "0 5px",
    borderRadius: 4,
    border: `1px solid ${s.border}`,
    lineHeight: "14px"
  } }, s.label));
}
window.ScanDocumentsOverlay = ScanDocumentsOverlay;
window.ScanFieldHighlight = ScanFieldHighlight;
var BNC_DATE_KEYS = { idIssue: 1, idExpiry: 1, dlExpiry: 1 };
var BNC_SCAN_DATE_NOTE = "\u26A0 \u0414\u0430\u0442\u0430\u0442\u0430 \u043D\u0435 \u0441\u0435 \u0440\u0430\u0437\u0447\u0435\u0442\u0435 \u2014 \u0432\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0440\u044A\u0447\u043D\u043E";
function bncParseDocDate(s) {
  if (!s) return null;
  const t = String(s).trim();
  let y, mo, d, m;
  if (m = /^(\d{4})-(\d{2})-(\d{2})(?:[T ].*)?$/.exec(t)) {
    y = +m[1];
    mo = +m[2];
    d = +m[3];
  } else if (m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(t)) {
    d = +m[1];
    mo = +m[2];
    y = +m[3];
  } else return null;
  const chk = new Date(Date.UTC(y, mo - 1, d));
  return chk.getUTCFullYear() === y && chk.getUTCMonth() === mo - 1 && chk.getUTCDate() === d ? chk : null;
}
function bncValidateDocDates(form) {
  const out = {};
  for (const k of ["idIssue", "idExpiry", "dlExpiry"]) {
    const dt = bncParseDocDate(form[k]);
    if (!dt) {
      window.toast && window.toast.warn("\u041C\u043E\u043B\u044F \u0432\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0432\u0430\u043B\u0438\u0434\u043D\u0438 \u0434\u0430\u0442\u0438 \u0437\u0430 \u041B\u041A \u0438 \u0421\u0423\u041C\u041F\u0421 (\u0434\u0434.\u043C\u043C.\u0433\u0433\u0433\u0433).", { duration: 4e3 });
      return null;
    }
    out[k] = dt.toISOString().slice(0, 10);
  }
  return out;
}
window.BNC_DATE_KEYS = BNC_DATE_KEYS;
window.BNC_SCAN_DATE_NOTE = BNC_SCAN_DATE_NOTE;
window.bncParseDocDate = bncParseDocDate;
window.bncValidateDocDates = bncValidateDocDates;
function SectionScans() {
  const [queue, setQueue] = useState([]);
  const [exports, setExports] = useState(null);
  const [exportsError, setExportsError] = useState(null);
  const [busy, setBusy] = useState(false);
  const reload = () => {
    window.store.scanQueueList().then(setQueue);
    window.store.scanExportsList().then((r) => {
      setExports(r.scans || []);
      setExportsError(null);
    }).catch((err) => {
      setExports([]);
      setExportsError(String(err && err.message || err));
    });
  };
  useEffect(reload, []);
  const flushNow = async () => {
    setBusy(true);
    try {
      await window.store.flushScanQueue();
    } finally {
      setBusy(false);
      reload();
    }
  };
  const retryExport = async (scanId) => {
    setBusy(true);
    try {
      await window.store.scanRetryExport(scanId);
      window.toast && window.toast.info(`\u041F\u043E\u0432\u0442\u043E\u0440\u0435\u043D \u043E\u043F\u0438\u0442 \u0437\u0430 \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 ${scanId}\u2026`, { duration: 3e3 });
      setTimeout(reload, 2500);
    } catch (err) {
      window.toast && window.toast.error("\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u0438\u044F\u0442 \u043E\u043F\u0438\u0442 \u043D\u0435 \u0443\u0441\u043F\u044F: " + (err && err.message || err), { duration: 5e3 });
    } finally {
      setBusy(false);
    }
  };
  const EXPORT_LABELS = {
    pending: { text: "\u0410\u0440\u0445\u0438\u0432\u0438\u0440\u0430 \u0441\u0435\u2026", color: "#F59E0B" },
    done: { text: "\u0410\u0440\u0445\u0438\u0432\u0438\u0440\u0430\u043D", color: "#22C55E" },
    failed: { text: "\u041D\u0415\u0423\u0421\u041F\u0415\u0428\u0415\u041D", color: "#EF4444" }
  };
  const UNCONFIRMED_LABEL = { text: "\u041D\u0435\u0437\u0430\u0432\u044A\u0440\u0448\u0435\u043D (\u043F\u0440\u0435\u0434\u0438 v5.10)", color: "#6B7280" };
  return /* @__PURE__ */ React.createElement("div", { "data-testid": "section-scans", style: { maxWidth: 780 } }, /* @__PURE__ */ React.createElement(
    SectionHeader,
    {
      title: "\u0421\u043A\u0430\u043D\u0438\u0440\u0430\u043D\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
      subtitle: "\u041E\u043F\u0430\u0448\u043A\u0430 \u043D\u0430 \u043E\u0442\u043B\u043E\u0436\u0435\u043D\u0438\u0442\u0435 \u0441\u043A\u0430\u043D\u043E\u0432\u0435 \u0438 \u0441\u0442\u0430\u0442\u0443\u0441 \u043D\u0430 \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u0430\u043D\u0435\u0442\u043E \u0432 Google Drive/Sheets.",
      right: /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "sm", icon: "refresh", onClick: reload, disabled: busy }, "\u041E\u0431\u043D\u043E\u0432\u0438")
    }
  ), /* @__PURE__ */ React.createElement(Card, { pad: 16, style: { marginBottom: 14 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", marginBottom: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 700, color: T.text0 } }, "\u041E\u043F\u0430\u0448\u043A\u0430 \u0437\u0430 \u043A\u0430\u0447\u0432\u0430\u043D\u0435 ", queue.length > 0 ? `(${queue.length})` : ""), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }), queue.length > 0 && /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "sm", icon: "refresh", onClick: flushNow, disabled: busy }, busy ? "\u041A\u0430\u0447\u0432\u0430\u043D\u0435\u2026" : "\u041A\u0430\u0447\u0438 \u0441\u0435\u0433\u0430")), queue.length === 0 ? /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2 } }, "\u041D\u044F\u043C\u0430 \u0447\u0430\u043A\u0430\u0449\u0438 \u0441\u043A\u0430\u043D\u043E\u0432\u0435 \u2014 \u0432\u0441\u0438\u0447\u043A\u043E \u0435 \u043A\u0430\u0447\u0435\u043D\u043E.") : queue.map((entry) => /* @__PURE__ */ React.createElement("div", { key: entry.scanId, style: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "8px 0",
    borderTop: `1px solid ${T.border}`
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "camera", size: 16, color: "#F59E0B" }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600, color: T.text0, fontFamily: "JetBrains Mono, monospace" } }, entry.scanId), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2 } }, entry.customerName || "\u0431\u0435\u0437 \u0438\u043C\u0435", " \xB7 ", Object.keys(entry.photos || {}).length, " \u0441\u043D\u0438\u043C\u043A\u0438", entry.lastError && /* @__PURE__ */ React.createElement("span", { style: { color: "#EF4444" } }, " \xB7 ", entry.lastError))), /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "xs", onClick: async () => {
    await window.store.scanQueueDelete(entry.scanId);
    reload();
  } }, "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0438")))), /* @__PURE__ */ React.createElement(Card, { pad: 16 }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 700, color: T.text0, marginBottom: 10 } }, "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438 \u0441\u043A\u0430\u043D\u043E\u0432\u0435"), exportsError && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: "#EF4444", fontWeight: 600, marginBottom: 8 } }, "\u0421\u043F\u0438\u0441\u044A\u043A\u044A\u0442 \u043D\u0435 \u043C\u043E\u0436\u0430 \u0434\u0430 \u0441\u0435 \u0437\u0430\u0440\u0435\u0434\u0438: ", exportsError), exports === null ? /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2 } }, "\u0417\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435\u2026") : exports.length === 0 && !exportsError ? /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2 } }, "\u041E\u0449\u0435 \u043D\u044F\u043C\u0430 \u0441\u043A\u0430\u043D\u0438\u0440\u0430\u043D\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438.") : exports.map((s) => {
    const confirmed = s.status === "confirmed";
    const lbl = confirmed ? EXPORT_LABELS[s.exportStatus] || EXPORT_LABELS.pending : UNCONFIRMED_LABEL;
    return /* @__PURE__ */ React.createElement("div", { key: s.scanId, style: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      padding: "8px 0",
      borderTop: `1px solid ${T.border}`
    } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600, color: T.text0, fontFamily: "JetBrains Mono, monospace" } }, s.scanId), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2 } }, s.customerName || "\u2014", s.exportError && /* @__PURE__ */ React.createElement("span", { style: { color: "#EF4444" } }, " \xB7 ", s.exportError))), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11.5, fontWeight: 700, color: lbl.color } }, lbl.text), s.driveFolderUrl && s.exportStatus === "done" && /* @__PURE__ */ React.createElement("a", { href: s.driveFolderUrl, target: "_blank", rel: "noreferrer", style: { fontSize: 11.5, color: T.accent } }, "Drive \u2197"), confirmed && s.exportStatus === "failed" && /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "xs", onClick: () => retryExport(s.scanId), disabled: busy }, "\u041F\u043E\u0432\u0442\u043E\u0440\u0438"));
  })));
}
window.SectionScans = SectionScans;

/* ══════════ components/pdfgen.jsx ══════════ */
var cachedFontRegularBytes = null;
var cachedFontBoldBytes = null;
var cachedFontPromise = null;
async function loadFontBytes() {
  if (cachedFontRegularBytes && cachedFontBoldBytes) {
    return { regular: cachedFontRegularBytes, bold: cachedFontBoldBytes };
  }
  if (cachedFontPromise) return cachedFontPromise;
  cachedFontPromise = (async () => {
    const [regRes, boldRes] = await Promise.all([
      fetch("assets/fonts/NotoSans-Regular.ttf"),
      fetch("assets/fonts/NotoSans-Bold.ttf")
    ]);
    if (!regRes.ok) {
      throw new Error(
        "\u041D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435 \u043D\u0430 \u0448\u0440\u0438\u0444\u0442 NotoSans-Regular.ttf (HTTP " + regRes.status + "). \u0413\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435\u0442\u043E \u043D\u0430 PDF \u0435 \u043F\u0440\u0435\u043A\u0440\u0430\u0442\u0435\u043D\u043E \u2014 \u043E\u0442\u043A\u0430\u0437\u0432\u0430\u043C\u0435 \u0434\u0430 \u0441\u044A\u0437\u0434\u0430\u0434\u0435\u043C \u043F\u0440\u0430\u0432\u0435\u043D \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0431\u0435\u0437 \u043F\u043E\u0434\u0434\u0440\u044A\u0436\u043A\u0430 \u043D\u0430 \u043A\u0438\u0440\u0438\u043B\u0438\u0446\u0430."
      );
    }
    if (!boldRes.ok) {
      throw new Error(
        "\u041D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435 \u043D\u0430 \u0448\u0440\u0438\u0444\u0442 NotoSans-Bold.ttf (HTTP " + boldRes.status + "). \u0413\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435\u0442\u043E \u043D\u0430 PDF \u0435 \u043F\u0440\u0435\u043A\u0440\u0430\u0442\u0435\u043D\u043E \u2014 \u043E\u0442\u043A\u0430\u0437\u0432\u0430\u043C\u0435 \u0434\u0430 \u0441\u044A\u0437\u0434\u0430\u0434\u0435\u043C \u043F\u0440\u0430\u0432\u0435\u043D \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0431\u0435\u0437 \u043F\u043E\u0434\u0434\u0440\u044A\u0436\u043A\u0430 \u043D\u0430 \u043A\u0438\u0440\u0438\u043B\u0438\u0446\u0430."
      );
    }
    const [regBuf, boldBuf] = await Promise.all([
      regRes.arrayBuffer(),
      boldRes.arrayBuffer()
    ]);
    const isTTF = (buf) => {
      const b = new Uint8Array(buf);
      if (b.length < 4) return false;
      const sig = b[0] << 24 | b[1] << 16 | b[2] << 8 | b[3];
      return sig === 65536 || sig === 1330926671;
    };
    if (!isTTF(regBuf) || regBuf.byteLength < 1e5) {
      throw new Error("\u0424\u0430\u0439\u043B\u044A\u0442 NotoSans-Regular.ttf \u0435 \u043F\u043E\u0432\u0440\u0435\u0434\u0435\u043D \u0438\u043B\u0438 \u0441\u044A\u043A\u0440\u0430\u0442\u0435\u043D (" + regBuf.byteLength + " \u0431\u0430\u0439\u0442\u0430). \u0413\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435\u0442\u043E \u043D\u0430 PDF \u0435 \u043F\u0440\u0435\u043A\u0440\u0430\u0442\u0435\u043D\u043E.");
    }
    if (!isTTF(boldBuf) || boldBuf.byteLength < 1e5) {
      throw new Error("\u0424\u0430\u0439\u043B\u044A\u0442 NotoSans-Bold.ttf \u0435 \u043F\u043E\u0432\u0440\u0435\u0434\u0435\u043D \u0438\u043B\u0438 \u0441\u044A\u043A\u0440\u0430\u0442\u0435\u043D (" + boldBuf.byteLength + " \u0431\u0430\u0439\u0442\u0430). \u0413\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435\u0442\u043E \u043D\u0430 PDF \u0435 \u043F\u0440\u0435\u043A\u0440\u0430\u0442\u0435\u043D\u043E.");
    }
    cachedFontRegularBytes = regBuf;
    cachedFontBoldBytes = boldBuf;
    return { regular: regBuf, bold: boldBuf };
  })();
  cachedFontPromise.catch(() => {
    cachedFontPromise = null;
  });
  return cachedFontPromise;
}
function getOperatorProfileForPdf({ requireSignature }) {
  const profile = window.store && window.store.operatorProfile ? window.store.operatorProfile() : null;
  if (!profile) {
    throw new Error("Operator profile store not available. Refresh the page and retry.");
  }
  if (requireSignature && !profile.signatureDataUrl) {
    throw new Error(
      "\u041D\u044F\u043C\u0430 \u0437\u0430\u043F\u0438\u0441\u0430\u043D \u043F\u043E\u0434\u043F\u0438\u0441 \u043D\u0430 \u043D\u0430\u0435\u043C\u043E\u0434\u0430\u0442\u0435\u043B\u044F \u2014 \u0434\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0433\u043E \u0432 Settings \u2192 Operator profile \u0438 \u043E\u043F\u0438\u0442\u0430\u0439\u0442\u0435 \u043E\u0442\u043D\u043E\u0432\u043E. \u0414\u043E\u0433\u043E\u0432\u043E\u0440\u044A\u0442 \u043D\u0435 \u0435 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D."
    );
  }
  return profile;
}
async function embedNotoSans(pdfDoc) {
  const { regular, bold } = await loadFontBytes();
  pdfDoc.registerFontkit(window.pdfLibFontkit);
  const font = await pdfDoc.embedFont(regular, { subset: true });
  const fontBold = await pdfDoc.embedFont(bold, { subset: true });
  const probe = font.widthOfTextAtSize("\u041C\u0430\u0440\u0438\u044F \u0418\u0432\u0430\u043D\u043E\u0432\u0430", 10);
  if (!Number.isFinite(probe) || probe <= 0) {
    throw new Error(
      "\u0428\u0440\u0438\u0444\u0442\u044A\u0442 Noto Sans \u0435 \u0437\u0430\u0440\u0435\u0434\u0435\u043D, \u043D\u043E \u043B\u0438\u043F\u0441\u0432\u0430\u0442 \u043A\u0438\u0440\u0438\u043B\u0441\u043A\u0438 \u0437\u043D\u0430\u0446\u0438 (\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0432\u044A\u0440\u043D\u0430 " + probe + "). \u0413\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435\u0442\u043E \u043D\u0430 PDF \u0435 \u043F\u0440\u0435\u043A\u0440\u0430\u0442\u0435\u043D\u043E."
    );
  }
  return { font, fontBold };
}
async function ensurePdfLib() {
  if (window.PDFLib && window.pdfLibFontkit) return;
  const loadScript = (src) => new Promise((resolve, reject) => {
    if ([...document.scripts].some((s2) => s2.src === src)) {
      resolve();
      return;
    }
    const s = document.createElement("script");
    s.src = src;
    s.onload = resolve;
    s.onerror = () => reject(new Error("Failed to load " + src));
    document.head.appendChild(s);
  });
  await loadScript("assets/vendor/pdf-lib.min.js");
  await loadScript("assets/vendor/fontkit.umd.min.js");
  if (!window.PDFLib) throw new Error("pdf-lib did not attach to window");
  window.pdfLibFontkit = window.fontkit || window.pdfLibFontkit;
  if (!window.pdfLibFontkit) throw new Error("fontkit did not attach to window");
}
var A4 = { w: 595.28, h: 841.89 };
var MARGIN = 50;
var INK = { r: 0.06, g: 0.08, b: 0.13 };
var MUTED = { r: 0.29, g: 0.32, b: 0.38 };
var ACCENT = { r: 0.1, g: 0.36, b: 0.9 };
var HAIRLINE = { r: 0.85, g: 0.84, b: 0.78 };
function fmtEuroPdf(n, { dp = 2 } = {}) {
  if (n == null || Number.isNaN(n)) return "\u2014 \u20AC";
  const abs = Math.abs(n);
  const [intPart, decPart] = abs.toFixed(dp).split(".");
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, "\xA0");
  return (n < 0 ? "\u2212" : "") + grouped + (dp > 0 ? "," + decPart : "") + "\xA0\u20AC";
}
function fmtDatePdf(d, { withYearSuffix = false } = {}) {
  if (!(d instanceof Date)) d = new Date(d);
  const day = String(d.getDate()).padStart(2, "0");
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  const y = d.getFullYear();
  return `${day}.${mo}.${y}` + (withYearSuffix ? " \u0433." : "");
}
function fmtTimePdf(d) {
  if (!(d instanceof Date)) d = new Date(d);
  return String(d.getHours()).padStart(2, "0") + ":" + String(d.getMinutes()).padStart(2, "0");
}
function wrapText(text, font, size, maxWidth) {
  const words = text.split(/(\s+)/);
  const lines = [];
  let cur = "";
  for (const w of words) {
    const trial = cur + w;
    const width = font.widthOfTextAtSize(trial, size);
    if (width > maxWidth && cur.trim().length > 0) {
      lines.push(cur.trimEnd());
      cur = w.trimStart();
    } else {
      cur = trial;
    }
  }
  if (cur.length) lines.push(cur.trimEnd());
  return lines;
}
function makeWriter(page, font, fontBold) {
  const _bold = fontBold || font;
  let cursorY = A4.h - MARGIN;
  const usableW = A4.w - MARGIN * 2;
  const writeLines = (lines, { size = 10, color = INK, lineHeight = 1.35, bold = false, indent = 0 } = {}) => {
    for (const line of lines) {
      if (cursorY - size < MARGIN) return false;
      page.drawText(line, {
        x: MARGIN + indent,
        y: cursorY - size,
        size,
        font: bold ? _bold : font,
        color: window.PDFLib.rgb(color.r, color.g, color.b)
      });
      cursorY -= size * lineHeight;
    }
    return true;
  };
  return {
    getCursor: () => cursorY,
    moveTo: (y) => {
      cursorY = y;
    },
    gap: (n) => {
      cursorY -= n;
    },
    ruler: (color = HAIRLINE) => {
      page.drawLine({
        start: { x: MARGIN, y: cursorY },
        end: { x: A4.w - MARGIN, y: cursorY },
        thickness: 0.5,
        color: window.PDFLib.rgb(color.r, color.g, color.b)
      });
      cursorY -= 8;
    },
    heading: (text, { size = 16, bold = true, color = INK, align = "left" } = {}) => {
      const f = bold ? _bold : font;
      const w = f.widthOfTextAtSize(text, size);
      let x = MARGIN;
      if (align === "center") x = (A4.w - w) / 2;
      else if (align === "right") x = A4.w - MARGIN - w;
      page.drawText(text, { x, y: cursorY - size, size, font: f, color: window.PDFLib.rgb(color.r, color.g, color.b) });
      cursorY -= size * 1.4;
    },
    paragraph: (text, opts = {}) => {
      const size = opts.size || 10;
      const lines = wrapText(text, font, size, usableW - (opts.indent || 0));
      writeLines(lines, opts);
      cursorY -= opts.paraGap != null ? opts.paraGap : 4;
    },
    kv: (label, value, { labelWidth = 170, size = 10, valueBold = false } = {}) => {
      const y = cursorY - size;
      page.drawText(label, {
        x: MARGIN,
        y,
        size,
        font,
        color: window.PDFLib.rgb(MUTED.r, MUTED.g, MUTED.b)
      });
      const valStr = String(value);
      const valLines = wrapText(valStr, font, size, usableW - labelWidth);
      valLines.forEach((line, i) => {
        page.drawText(line, {
          x: MARGIN + labelWidth,
          y: y - i * size * 1.3,
          size,
          font,
          color: window.PDFLib.rgb(INK.r, INK.g, INK.b)
        });
        if (valueBold) {
          page.drawText(line, {
            x: MARGIN + labelWidth + 0.4,
            y: y - i * size * 1.3,
            size,
            font,
            color: window.PDFLib.rgb(INK.r, INK.g, INK.b)
          });
        }
      });
      cursorY -= size * 1.4 * valLines.length;
    },
    smallCaption: (text) => {
      page.drawText(text, {
        x: MARGIN,
        y: cursorY - 8,
        size: 8,
        font,
        color: window.PDFLib.rgb(MUTED.r, MUTED.g, MUTED.b)
      });
      cursorY -= 12;
    }
  };
}
function drawChrome(pdfLib, page, font, { contractNo, footerNote }) {
  page.drawRectangle({
    x: 0,
    y: A4.h - 34,
    width: A4.w,
    height: 34,
    color: pdfLib.rgb(0.06, 0.08, 0.13)
  });
  page.drawRectangle({
    x: MARGIN,
    y: A4.h - 26,
    width: 20,
    height: 20,
    color: pdfLib.rgb(ACCENT.r, ACCENT.g, ACCENT.b)
  });
  page.drawText("b.", {
    x: MARGIN + 3,
    y: A4.h - 24,
    size: 15,
    font,
    color: pdfLib.rgb(1, 1, 1)
  });
  page.drawText(window.COMPANY && window.COMPANY.brand || "banicharka.bg", {
    x: MARGIN + 30,
    y: A4.h - 22,
    size: 12,
    font,
    color: pdfLib.rgb(1, 1, 1)
  });
  page.drawText("\u201E" + (window.COMPANY && window.COMPANY.legal || "\u2014") + '" \xB7 \u0415\u0418\u041A ' + (window.COMPANY && window.COMPANY.eik || ""), {
    x: MARGIN + 30,
    y: A4.h - 33,
    size: 8,
    font,
    color: pdfLib.rgb(0.75, 0.79, 0.85)
  });
  if (contractNo) {
    page.drawText("\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u2116 " + contractNo, {
      x: A4.w - MARGIN - 130,
      y: A4.h - 22,
      size: 11,
      font,
      color: pdfLib.rgb(1, 1, 1)
    });
  }
  page.drawLine({
    start: { x: MARGIN, y: 40 },
    end: { x: A4.w - MARGIN, y: 40 },
    thickness: 0.5,
    color: pdfLib.rgb(HAIRLINE.r, HAIRLINE.g, HAIRLINE.b)
  });
  const footer = footerNote || "\u0422\u043E\u0437\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0435 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u043E\u0442 \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u0442\u0430 \u043D\u0430 banicharka.bg.";
  page.drawText(footer, {
    x: MARGIN,
    y: 26,
    size: 8,
    font,
    color: pdfLib.rgb(MUTED.r, MUTED.g, MUTED.b)
  });
  const dateStamp = fmtDatePdf(/* @__PURE__ */ new Date(), { withYearSuffix: true }) + " \xB7 " + fmtTimePdf(/* @__PURE__ */ new Date());
  const stampWidth = font.widthOfTextAtSize(dateStamp, 8);
  page.drawText(dateStamp, {
    x: A4.w - MARGIN - stampWidth,
    y: 26,
    size: 8,
    font,
    color: pdfLib.rgb(MUTED.r, MUTED.g, MUTED.b)
  });
}
async function drawSignatureBlock(pdfDoc, page, font, {
  labelLeft,
  labelRight,
  nameLeft,
  nameRight,
  signatureLeft,
  signatureRight,
  signedAtLeft,
  signedAtRight,
  yTop
}) {
  const pdfLib = window.PDFLib;
  const colW = (A4.w - MARGIN * 2 - 20) / 2;
  const boxes = [
    { x: MARGIN, label: labelLeft, name: nameLeft, sig: signatureLeft, ts: signedAtLeft },
    { x: MARGIN + colW + 20, label: labelRight, name: nameRight, sig: signatureRight, ts: signedAtRight }
  ];
  for (const box of boxes) {
    if (!box.label) continue;
    page.drawText(box.label, {
      x: box.x,
      y: yTop,
      size: 8,
      font,
      color: pdfLib.rgb(MUTED.r, MUTED.g, MUTED.b)
    });
    const sigBoxTop = yTop - 10;
    const sigBoxH = 70;
    if (box.sig) {
      try {
        const bytes = dataUrlToBytes(box.sig);
        const sigImg = await pdfDoc.embedPng(bytes);
        const sigDims = sigImg.scale(1);
        const maxW = colW - 10;
        const maxH = sigBoxH - 4;
        const ratio = Math.min(maxW / sigDims.width, maxH / sigDims.height);
        const drawW = sigDims.width * ratio;
        const drawH = sigDims.height * ratio;
        page.drawImage(sigImg, {
          x: box.x + (colW - drawW) / 2,
          y: sigBoxTop - sigBoxH + (sigBoxH - drawH) / 2,
          width: drawW,
          height: drawH
        });
      } catch (err) {
        console.warn("sig embed failed", err);
      }
    }
    page.drawLine({
      start: { x: box.x, y: sigBoxTop - sigBoxH - 2 },
      end: { x: box.x + colW, y: sigBoxTop - sigBoxH - 2 },
      thickness: 0.75,
      color: pdfLib.rgb(INK.r, INK.g, INK.b)
    });
    if (box.name) {
      page.drawText(box.name, {
        x: box.x,
        y: sigBoxTop - sigBoxH - 14,
        size: 9,
        font,
        color: pdfLib.rgb(INK.r, INK.g, INK.b)
      });
    }
    if (box.ts) {
      const tsStr = "\u0414\u0430\u0442\u0430: " + fmtDatePdf(box.ts) + " " + fmtTimePdf(box.ts) + " \u0447.";
      const tsW = font.widthOfTextAtSize(tsStr, 8);
      page.drawText(tsStr, {
        x: box.x + colW - tsW,
        y: sigBoxTop - sigBoxH - 14,
        size: 8,
        font,
        color: pdfLib.rgb(MUTED.r, MUTED.g, MUTED.b)
      });
    }
  }
}
function dataUrlToBytes(dataUrl) {
  const base64 = dataUrl.split(",")[1];
  const raw = atob(base64);
  const bytes = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) bytes[i] = raw.charCodeAt(i);
  return bytes;
}
async function generateContractPdf(rentalState) {
  const op = getOperatorProfileForPdf({ requireSignature: true });
  await ensurePdfLib();
  const pdfLib = window.PDFLib;
  const pdfDoc = await pdfLib.PDFDocument.create();
  const { font, fontBold } = await embedNotoSans(pdfDoc);
  pdfDoc.setTitle("\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u0437\u0430 \u043D\u0430\u0435\u043C \u043D\u0430 \u041C\u041F\u0421 " + (rentalState.contractNo || ""));
  pdfDoc.setAuthor("banicharka.bg");
  pdfDoc.setSubject("\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u0437\u0430 \u043D\u0430\u0435\u043C \u043D\u0430 \u041C\u041F\u0421");
  pdfDoc.setCreator("banicharka.bg Rental Ops");
  const page = pdfDoc.addPage([A4.w, A4.h]);
  const contractNo = rentalState.contractNo || "\u041D\u041E\u0412/2026";
  drawChrome(pdfLib, page, font, { contractNo });
  const w = makeWriter(page, font, fontBold);
  w.moveTo(A4.h - 60);
  w.gap(20);
  w.heading("\u0414\u041E\u0413\u041E\u0412\u041E\u0420 \u0417\u0410 \u041D\u0410\u0415\u041C \u041D\u0410 \u041C\u041F\u0421", { size: 15, align: "center" });
  w.smallCaption("\u2116 " + contractNo + " \xB7 " + fmtDatePdf(/* @__PURE__ */ new Date(), { withYearSuffix: true }) + " \xB7 \u0433\u0440. \u0421\u043E\u0444\u0438\u044F");
  w.gap(8);
  w.ruler();
  w.gap(4);
  const c = rentalState.customer || {};
  const v = rentalState.vehicle || {};
  w.paragraph(
    "\u0414\u043D\u0435\u0441, " + fmtDatePdf(/* @__PURE__ */ new Date(), { withYearSuffix: true }) + ", \u0432 \u0433\u0440. \u0421\u043E\u0444\u0438\u044F, \u043C\u0435\u0436\u0434\u0443:",
    { size: 10, paraGap: 6 }
  );
  const co = window.COMPANY || {};
  w.paragraph(
    "\u201E" + (co.legal || "\u2014") + '", \u0415\u0418\u041A ' + (co.eik || "\u2014") + (co.vatId ? ", \u0414\u0414\u0421 \u2116 " + co.vatId : "") + ", \u0441\u0435\u0434\u0430\u043B\u0438\u0449\u0435 " + (co.address || "\u2014") + ", \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u0432\u0430\u043D\u043E \u043E\u0442 " + op.name + " \u2014 " + op.role.toLowerCase() + ', \u043D\u0430\u0440\u0438\u0447\u0430\u043D \u043F\u043E-\u0434\u043E\u043B\u0443 \u0437\u0430 \u043A\u0440\u0430\u0442\u043A\u043E\u0441\u0442 \u201E\u041D\u0410\u0415\u041C\u041E\u0414\u0410\u0422\u0415\u041B",',
    { size: 10, paraGap: 4 }
  );
  w.paragraph("\u0438", { size: 10, paraGap: 4 });
  w.paragraph(
    (c.name || "\u2014") + ", \u0415\u0413\u041D " + (c.egn || "\u2014") + ", \u041B\u041A \u2116 " + (c.idCard && c.idCard.number || "\u2014") + ", \u0432\u0430\u043B\u0438\u0434\u043D\u0430 \u0434\u043E " + (c.idCard && c.idCard.expiry ? fmtDatePdf(c.idCard.expiry) : "\u2014") + ", \u0421\u0423\u041C\u041F\u0421 \u2116 " + (c.driverLicense && c.driverLicense.number || "\u2014") + ", \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F " + (c.driverLicense && c.driverLicense.categories || "\u2014") + ", \u0432\u0430\u043B\u0438\u0434\u043D\u043E \u0434\u043E " + (c.driverLicense && c.driverLicense.expiry ? fmtDatePdf(c.driverLicense.expiry) : "\u2014") + ", \u0430\u0434\u0440\u0435\u0441: " + (c.address || "\u2014") + ', \u043D\u0430\u0440\u0438\u0447\u0430\u043D \u043F\u043E-\u0434\u043E\u043B\u0443 \u0437\u0430 \u043A\u0440\u0430\u0442\u043A\u043E\u0441\u0442 \u201E\u041D\u0410\u0415\u041C\u0410\u0422\u0415\u041B",',
    { size: 10, paraGap: 6 }
  );
  w.paragraph("\u0441\u0435 \u0441\u043A\u043B\u044E\u0447\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u044F\u0442 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0437\u0430 \u0441\u043B\u0435\u0434\u043D\u043E\u0442\u043E:", { size: 10, paraGap: 10 });
  const days = window.daysBetween ? window.daysBetween(rentalState.startAt, rentalState.endAt) : 1;
  const dailyRate = rentalState.dailyRate || v.dailyRate || 0;
  const totalPrice = dailyRate * days;
  w.heading("\u0427\u043B. 1. \u041F\u0440\u0435\u0434\u043C\u0435\u0442 \u043D\u0430 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430", { size: 11, bold: true });
  w.paragraph(
    "\u041D\u0430\u0435\u043C\u043E\u0434\u0430\u0442\u0435\u043B\u044F\u0442 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u044F \u0437\u0430 \u0432\u044A\u0437\u043C\u0435\u0437\u0434\u043D\u043E \u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0435, \u0430 \u041D\u0430\u0435\u043C\u0430\u0442\u0435\u043B\u044F\u0442 \u043F\u0440\u0438\u0435\u043C\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B " + (v.make || "\u2014") + " " + (v.model || "") + ", \u0440\u0435\u0433. \u2116 " + (v.plate || "\u2014") + ", VIN " + (v.vin || "\u2014") + ", \u0446\u0432\u044F\u0442 " + (v.color || "\u2014") + ", " + (v.year || "\u2014") + " \u0433.",
    { size: 10, paraGap: 8 }
  );
  w.heading("\u0427\u043B. 2. \u0421\u0440\u043E\u043A", { size: 11, bold: true });
  w.paragraph(
    "\u041D\u0430\u0435\u043C\u044A\u0442 \u0441\u0435 \u0441\u043A\u043B\u044E\u0447\u0432\u0430 \u0437\u0430 \u0441\u0440\u043E\u043A \u043E\u0442 " + fmtDatePdf(rentalState.startAt) + " " + fmtTimePdf(rentalState.startAt) + " \u0447. \u0434\u043E " + fmtDatePdf(rentalState.endAt) + " " + fmtTimePdf(rentalState.endAt) + " \u0447., \u043E\u0431\u0449\u043E " + days + " \u0434\u0435\u043D\u043E\u043D\u043E\u0449\u0438\u044F.",
    { size: 10, paraGap: 8 }
  );
  w.heading("\u0427\u043B. 3. \u041D\u0430\u0435\u043C\u043D\u0430 \u0446\u0435\u043D\u0430 \u0438 \u0434\u0435\u043F\u043E\u0437\u0438\u0442", { size: 11, bold: true });
  w.kv("\u0414\u043D\u0435\u0432\u043D\u0430 \u043D\u0430\u0435\u043C\u043D\u0430 \u0446\u0435\u043D\u0430:", fmtEuroPdf(dailyRate), { size: 10, valueBold: true });
  w.kv("\u041E\u0431\u0449\u0430 \u043D\u0430\u0435\u043C\u043D\u0430 \u0446\u0435\u043D\u0430:", fmtEuroPdf(totalPrice), { size: 10, valueBold: true });
  w.kv("\u0414\u0435\u043F\u043E\u0437\u0438\u0442:", fmtEuroPdf(rentalState.deposit || 0) + " \xB7 " + (rentalState.depositMethod === "cash" ? "\u0432 \u0431\u0440\u043E\u0439" : "\u043F\u043E \u0431\u0430\u043D\u043A\u043E\u0432 \u043F\u044A\u0442"), { size: 10 });
  w.gap(4);
  w.heading("\u0427\u043B. 4. \u0414\u043D\u0435\u0432\u0435\u043D \u043F\u0440\u043E\u0431\u0435\u0433", { size: 11, bold: true });
  if (rentalState.unlimited) {
    w.paragraph("\u041F\u0440\u043E\u0431\u0435\u0433\u044A\u0442 \u0435 \u043D\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D \u0437\u0430 \u0446\u0435\u043B\u0438\u044F \u0441\u0440\u043E\u043A \u043D\u0430 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u044F \u0434\u043E\u0433\u043E\u0432\u043E\u0440.", { size: 10, paraGap: 8 });
  } else {
    w.paragraph(
      "\u0421\u0440\u0435\u0434\u043D\u0438\u044F\u0442 \u0434\u043D\u0435\u0432\u0435\u043D \u043F\u0440\u043E\u0431\u0435\u0433 \u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D \u0434\u043E " + (rentalState.kmPerDay || 200) + " \u043A\u043C/\u0434\u0435\u043D. \u0412\u0441\u0435\u043A\u0438 \u0434\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u0435\u043D \u043A\u0438\u043B\u043E\u043C\u0435\u0442\u044A\u0440 \u0441\u0435 \u0437\u0430\u043F\u043B\u0430\u0449\u0430 \u043F\u043E " + fmtEuroPdf(rentalState.extraKmPrice || 0) + " \u043D\u0430 \u043A\u0438\u043B\u043E\u043C\u0435\u0442\u044A\u0440.",
      { size: 10, paraGap: 8 }
    );
  }
  w.heading("\u0427\u043B. 5. \u0417\u0430\u0434\u044A\u043B\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u041D\u0430\u0435\u043C\u0430\u0442\u0435\u043B\u044F", { size: 11, bold: true });
  w.paragraph(
    "\u041D\u0430\u0435\u043C\u0430\u0442\u0435\u043B\u044F\u0442 \u0441\u0435 \u0437\u0430\u0434\u044A\u043B\u0436\u0430\u0432\u0430 \u0434\u0430 \u043F\u043E\u043B\u0437\u0432\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0430 \u0441\u044A\u043E\u0431\u0440\u0430\u0437\u043D\u043E \u043F\u0440\u0435\u0434\u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0442\u043E \u043C\u0443, \u0434\u0430 \u0433\u043E \u043F\u043E\u0434\u0434\u044A\u0440\u0436\u0430 \u0432 \u0438\u0437\u043F\u0440\u0430\u0432\u043D\u043E \u0441\u044A\u0441\u0442\u043E\u044F\u043D\u0438\u0435, \u0434\u0430 \u043D\u0435 \u0433\u043E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u044F \u043D\u0430 \u0442\u0440\u0435\u0442\u0438 \u043B\u0438\u0446\u0430 \u0431\u0435\u0437 \u043F\u0438\u0441\u043C\u0435\u043D\u043E \u0441\u044A\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u041D\u0430\u0435\u043C\u043E\u0434\u0430\u0442\u0435\u043B\u044F, \u0434\u0430 \u0437\u0430\u043F\u043B\u0430\u0449\u0430 \u0433\u043B\u043E\u0431\u0438 \u0438 \u0442\u0430\u043A\u0441\u0438, \u043D\u0430\u043B\u043E\u0436\u0435\u043D\u0438 \u043F\u043E \u0432\u0440\u0435\u043C\u0435 \u043D\u0430 \u043D\u0430\u0435\u043C\u0430, \u0438 \u0434\u0430 \u0432\u044A\u0440\u043D\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0430 \u0432 \u043C\u044F\u0441\u0442\u043E\u0442\u043E \u0438 \u0447\u0430\u0441\u0430, \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438 \u0432 \u0447\u043B. 2.",
    { size: 10, paraGap: 8 }
  );
  w.heading("\u0427\u043B. 6. \u041F\u0440\u0438\u0435\u043C\u043E-\u043F\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u0435\u043B\u0435\u043D \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B", { size: 11, bold: true });
  w.paragraph(
    "\u0421\u044A\u0441\u0442\u043E\u044F\u043D\u0438\u0435\u0442\u043E \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0430 \u043F\u0440\u0438 \u043F\u0440\u0435\u0434\u0430\u0432\u0430\u043D\u0435 \u0435 \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u0435\u043D\u043E \u0441 \u043F\u0440\u0438\u0435\u043C\u043E-\u043F\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u0435\u043B\u0435\u043D \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B \u0438 \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0441\u043A\u0438 \u0441\u043D\u0438\u043C\u043A\u0438, \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438 \u043A\u044A\u043C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u044F \u0434\u043E\u0433\u043E\u0432\u043E\u0440.",
    { size: 10, paraGap: 20 }
  );
  await drawSignatureBlock(pdfDoc, page, font, {
    labelLeft: "\u041D\u0410\u0415\u041C\u041E\u0414\u0410\u0422\u0415\u041B",
    nameLeft: op.name + " \u2014 " + op.role,
    signatureLeft: op.signatureDataUrl,
    signedAtLeft: op.signatureCapturedAt ? new Date(op.signatureCapturedAt) : null,
    labelRight: "\u041D\u0410\u0415\u041C\u0410\u0422\u0415\u041B",
    nameRight: c.name || "",
    signatureRight: rentalState.contractSignature,
    signedAtRight: rentalState.contractSignedAt,
    yTop: 160
  });
  const bytes = await pdfDoc.save();
  return { bytes, name: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440_" + (contractNo || "\u041D\u041E\u0412").replace("/", "-") + ".pdf" };
}
async function generateProtocolPdf(rentalState) {
  const op = getOperatorProfileForPdf({ requireSignature: true });
  await ensurePdfLib();
  const pdfLib = window.PDFLib;
  const pdfDoc = await pdfLib.PDFDocument.create();
  const { font, fontBold } = await embedNotoSans(pdfDoc);
  pdfDoc.setTitle("\u041F\u0440\u0438\u0435\u043C\u043E-\u043F\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u0435\u043B\u0435\u043D \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B " + (rentalState.contractNo || ""));
  pdfDoc.setAuthor("banicharka.bg");
  const page = pdfDoc.addPage([A4.w, A4.h]);
  const contractNo = rentalState.contractNo || "\u041D\u041E\u0412/2026";
  drawChrome(pdfLib, page, font, { contractNo });
  const w = makeWriter(page, font, fontBold);
  w.moveTo(A4.h - 60);
  w.gap(20);
  w.heading("\u041F\u0420\u0418\u0415\u041C\u041E-\u041F\u0420\u0415\u0414\u0410\u0412\u0410\u0422\u0415\u041B\u0415\u041D \u041F\u0420\u041E\u0422\u041E\u041A\u041E\u041B", { size: 14, align: "center" });
  w.smallCaption("\u041F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043A\u044A\u043C \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u2116 " + contractNo);
  w.gap(8);
  w.ruler();
  w.gap(6);
  const v = rentalState.vehicle || {};
  const c = rentalState.customer || {};
  w.heading("\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B", { size: 11, bold: true });
  w.kv("\u041C\u0430\u0440\u043A\u0430 \u0438 \u043C\u043E\u0434\u0435\u043B:", (v.make || "\u2014") + " " + (v.model || ""), { size: 10 });
  w.kv("\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u0435\u043D \u2116:", v.plate || "\u2014", { size: 10 });
  w.kv("VIN \u043D\u043E\u043C\u0435\u0440:", v.vin || "\u2014", { size: 10 });
  w.kv("\u0426\u0432\u044F\u0442:", v.color || "\u2014", { size: 10 });
  w.gap(6);
  w.heading("\u041D\u0430\u0435\u043C\u0430\u0442\u0435\u043B", { size: 11, bold: true });
  w.kv("\u0418\u043C\u0435:", c.name || "\u2014", { size: 10 });
  w.kv("\u0415\u0413\u041D:", c.egn || "\u2014", { size: 10 });
  w.kv("\u0422\u0435\u043B\u0435\u0444\u043E\u043D:", c.phone || "\u2014", { size: 10 });
  w.gap(6);
  w.heading("\u0421\u044A\u0441\u0442\u043E\u044F\u043D\u0438\u0435 \u043F\u0440\u0438 \u043F\u0440\u0435\u0434\u0430\u0432\u0430\u043D\u0435", { size: 11, bold: true });
  w.kv("\u0414\u0430\u0442\u0430 \u0438 \u0447\u0430\u0441:", fmtDatePdf(rentalState.startAt || /* @__PURE__ */ new Date()) + " " + fmtTimePdf(rentalState.startAt || /* @__PURE__ */ new Date()) + " \u0447.", { size: 10 });
  w.kv("\u041A\u0438\u043B\u043E\u043C\u0435\u0442\u0440\u0430\u0436:", (rentalState.handoverOdo != null ? rentalState.handoverOdo.toLocaleString("bg-BG").replace(/,/g, "\xA0") : "\u2014") + "\xA0\u043A\u043C", { size: 10 });
  const fuelLabel = v.drivetrain === "electric" ? "\u0417\u0430\u0440\u044F\u0434 \u043D\u0430 \u0431\u0430\u0442\u0435\u0440\u0438\u044F:" : "\u041D\u0438\u0432\u043E \u043D\u0430 \u0433\u043E\u0440\u0438\u0432\u043E:";
  w.kv(fuelLabel, (rentalState.handoverFuel != null ? rentalState.handoverFuel : "\u2014") + "\xA0%", { size: 10 });
  if (rentalState.handoverNotes) {
    w.kv("\u0417\u0430\u0431\u0435\u043B\u0435\u0436\u043A\u0438:", rentalState.handoverNotes, { size: 10 });
  }
  w.gap(8);
  w.heading("\u041F\u0440\u0438\u043B\u043E\u0436\u0435\u043D \u0441\u043D\u0438\u043C\u043A\u043E\u0432 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B", { size: 11, bold: true });
  const slotLabels = {
    front: "\u041E\u0442\u043F\u0440\u0435\u0434",
    rear: "\u041E\u0442\u0437\u0430\u0434",
    left: "\u041B\u044F\u0432\u0430 \u0441\u0442\u0440\u0430\u043D\u0430",
    right: "\u0414\u044F\u0441\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0430",
    odometer: "\u041A\u0438\u043B\u043E\u043C\u0435\u0442\u0440\u0430\u0436",
    cargo: "\u0422\u043E\u0432\u0430\u0440\u0435\u043D \u043E\u0442\u0441\u0435\u043A"
  };
  const shots = Object.entries(rentalState.handoverPhotos || {}).filter(([, r]) => r && r.dataUrl);
  const extraCount = (rentalState.extraPhotos || []).length;
  w.paragraph(
    "\u041F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438 \u0441\u0430 " + shots.length + " \u043E\u0442 6 \u0437\u0430\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u043D\u0438 \u0441\u043D\u0438\u043C\u043A\u0438" + (extraCount > 0 ? " \u0438 " + extraCount + (extraCount === 1 ? " \u0434\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u043D\u0430 \u0441\u043D\u0438\u043C\u043A\u0430 \u043D\u0430 \u0449\u0435\u0442\u0430" : " \u0434\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u043D\u0438 \u0441\u043D\u0438\u043C\u043A\u0438 \u043D\u0430 \u0449\u0435\u0442\u0438") : "") + ". \u0412\u0441\u044F\u043A\u0430 \u0441\u043D\u0438\u043C\u043A\u0430 \u0435 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u0449\u0430\u043C\u043F\u043E\u0432\u0430\u043D\u0430 \u0441 \u0434\u0430\u0442\u0430\u0442\u0430, \u0447\u0430\u0441\u0430 \u0438 \u043D\u043E\u043C\u0435\u0440\u0430 \u043D\u0430 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430.",
    { size: 10, paraGap: 6 }
  );
  if (shots.length > 0) {
    const cellW = (A4.w - MARGIN * 2 - 20) / 3;
    const cellH = cellW * 0.75;
    const startY = w.getCursor();
    for (let i = 0; i < Math.min(6, shots.length); i++) {
      const [key, rec] = shots[i];
      const col = i % 3;
      const row = Math.floor(i / 3);
      const x = MARGIN + col * (cellW + 10);
      const y = startY - (row + 1) * (cellH + 22);
      try {
        const bytes2 = dataUrlToBytes(rec.dataUrl);
        const img = await pdfDoc.embedJpg(bytes2);
        const ratio = Math.min(cellW / img.width, cellH / img.height);
        const dw = img.width * ratio, dh = img.height * ratio;
        page.drawImage(img, {
          x: x + (cellW - dw) / 2,
          y: y + (cellH - dh) / 2,
          width: dw,
          height: dh
        });
        page.drawRectangle({
          x,
          y,
          width: cellW,
          height: cellH,
          borderColor: pdfLib.rgb(HAIRLINE.r, HAIRLINE.g, HAIRLINE.b),
          borderWidth: 0.5
        });
        page.drawText(slotLabels[key] || key, {
          x,
          y: y - 12,
          size: 8,
          font,
          color: pdfLib.rgb(MUTED.r, MUTED.g, MUTED.b)
        });
      } catch (err) {
        console.warn("photo embed failed for", key, err);
      }
    }
    w.moveTo(startY - 2 * (cellH + 22) - 10);
  }
  await drawSignatureBlock(pdfDoc, page, font, {
    labelLeft: "\u041F\u0420\u0415\u0414\u0410\u041B / \u041D\u0410\u0415\u041C\u041E\u0414\u0410\u0422\u0415\u041B",
    nameLeft: op.name + " \u2014 " + op.role,
    signatureLeft: op.signatureDataUrl,
    signedAtLeft: op.signatureCapturedAt ? new Date(op.signatureCapturedAt) : null,
    labelRight: "\u041F\u0420\u0418\u0415\u041B / \u041D\u0410\u0415\u041C\u0410\u0422\u0415\u041B",
    nameRight: c.name || "",
    signatureRight: rentalState.contractSignature,
    signedAtRight: rentalState.contractSignedAt,
    yTop: 160
  });
  const bytes = await pdfDoc.save();
  return { bytes, name: "\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B_" + (contractNo || "\u041D\u041E\u0412").replace("/", "-") + ".pdf" };
}
async function generateGdprPdf(rentalState) {
  await ensurePdfLib();
  const pdfLib = window.PDFLib;
  const pdfDoc = await pdfLib.PDFDocument.create();
  const { font, fontBold } = await embedNotoSans(pdfDoc);
  pdfDoc.setTitle("\u0421\u044A\u0433\u043B\u0430\u0441\u0438\u0435 GDPR " + (rentalState.contractNo || ""));
  const page = pdfDoc.addPage([A4.w, A4.h]);
  drawChrome(pdfLib, page, font, { contractNo: rentalState.contractNo });
  const w = makeWriter(page, font, fontBold);
  w.moveTo(A4.h - 60);
  w.gap(20);
  w.heading("\u0421\u042A\u0413\u041B\u0410\u0421\u0418\u0415 \u0417\u0410 \u041E\u0411\u0420\u0410\u0411\u041E\u0422\u041A\u0410 \u041D\u0410 \u041B\u0418\u0427\u041D\u0418 \u0414\u0410\u041D\u041D\u0418", { size: 13, align: "center" });
  w.smallCaption("\u0420\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442 (\u0415\u0421) 2016/679 (GDPR) \xB7 \u0417\u0430\u043A\u043E\u043D \u0437\u0430 \u0437\u0430\u0449\u0438\u0442\u0430 \u043D\u0430 \u043B\u0438\u0447\u043D\u0438\u0442\u0435 \u0434\u0430\u043D\u043D\u0438");
  w.gap(8);
  w.ruler();
  w.gap(4);
  const c = rentalState.customer || {};
  const paras = [
    "\u201E" + (window.COMPANY && window.COMPANY.legal || "\u2014") + '", \u0415\u0418\u041A ' + (window.COMPANY && window.COMPANY.eik || "\u2014") + ", \u0441\u044A\u0441 \u0441\u0435\u0434\u0430\u043B\u0438\u0449\u0435 " + (window.COMPANY && window.COMPANY.address || "\u2014") + ', \u0432 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u043E\u0442\u043E \u0441\u0438 \u043D\u0430 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u043D\u0430 \u043B\u0438\u0447\u043D\u0438 \u0434\u0430\u043D\u043D\u0438 \u043F\u043E \u0441\u043C\u0438\u0441\u044A\u043B\u0430 \u043D\u0430 \u0420\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442 (\u0415\u0421) 2016/679, \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0432\u0430 \u0412\u0430\u0448\u0438\u0442\u0435 \u043B\u0438\u0447\u043D\u0438 \u0434\u0430\u043D\u043D\u0438 \u043F\u0440\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u044F\u043D\u0435 \u043D\u0430 \u0443\u0441\u043B\u0443\u0433\u0430\u0442\u0430 \u201E\u043D\u0430\u0435\u043C \u043D\u0430 \u043C\u043E\u0442\u043E\u0440\u043D\u043E \u043F\u0440\u0435\u0432\u043E\u0437\u043D\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E".',
    "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438 \u0434\u0430\u043D\u043D\u0438, \u043A\u043E\u0438\u0442\u043E \u0441\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0432\u0430\u0442: \u0442\u0440\u0438 \u0438\u043C\u0435\u043D\u0430, \u0415\u0413\u041D, \u0430\u0434\u0440\u0435\u0441, \u0442\u0435\u043B\u0435\u0444\u043E\u043D, \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0449\u0430, \u0434\u0430\u043D\u043D\u0438 \u043E\u0442 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0437\u0430 \u0441\u0430\u043C\u043E\u043B\u0438\u0447\u043D\u043E\u0441\u0442 (\u043B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430), \u0434\u0430\u043D\u043D\u0438 \u043E\u0442 \u0441\u0432\u0438\u0434\u0435\u0442\u0435\u043B\u0441\u0442\u0432\u043E \u0437\u0430 \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0430 \u041C\u041F\u0421, \u043A\u043E\u043F\u0438\u044F \u043D\u0430 \u043F\u043E\u0441\u043E\u0447\u0435\u043D\u0438\u0442\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438, \u043F\u043E\u0434\u043F\u0438\u0441.",
    "\u0426\u0435\u043B\u0438 \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u0442\u0430: \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u043D\u0430 \u043D\u0430\u0435\u043C\u0430\u0442\u0435\u043B\u044F, \u0441\u043A\u043B\u044E\u0447\u0432\u0430\u043D\u0435 \u0438 \u0438\u0437\u043F\u044A\u043B\u043D\u0435\u043D\u0438\u0435 \u043D\u0430 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0437\u0430 \u043D\u0430\u0435\u043C, \u0441\u043F\u0430\u0437\u0432\u0430\u043D\u0435 \u043D\u0430 \u043D\u043E\u0440\u043C\u0430\u0442\u0438\u0432\u043D\u0438 \u0437\u0430\u0434\u044A\u043B\u0436\u0435\u043D\u0438\u044F, \u0437\u0430\u0449\u0438\u0442\u0430 \u043D\u0430 \u0437\u0430\u043A\u043E\u043D\u043D\u0438\u044F \u0438\u043D\u0442\u0435\u0440\u0435\u0441 \u043D\u0430 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u043F\u0440\u0438 \u0449\u0435\u0442\u0438, \u0437\u043B\u043E\u0443\u043F\u043E\u0442\u0440\u0435\u0431\u0430 \u0438\u043B\u0438 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F.",
    "\u0421\u0440\u043E\u043A \u043D\u0430 \u0441\u044A\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435: 5 (\u043F\u0435\u0442) \u0433\u043E\u0434\u0438\u043D\u0438 \u0441\u043B\u0435\u0434 \u043F\u0440\u0435\u043A\u0440\u0430\u0442\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043D\u0438\u0442\u0435 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u044F.",
    "\u041F\u0440\u0430\u0432\u0430 \u043D\u0430 \u0441\u0443\u0431\u0435\u043A\u0442\u0430 \u043D\u0430 \u0434\u0430\u043D\u043D\u0438\u0442\u0435: \u043F\u0440\u0430\u0432\u043E \u043D\u0430 \u0434\u043E\u0441\u0442\u044A\u043F, \u043A\u043E\u0440\u0438\u0433\u0438\u0440\u0430\u043D\u0435, \u0438\u0437\u0442\u0440\u0438\u0432\u0430\u043D\u0435, \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0430\u0432\u0430\u043D\u0435 \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u0442\u0430, \u043F\u0440\u0435\u043D\u043E\u0441\u0438\u043C\u043E\u0441\u0442, \u0432\u044A\u0437\u0440\u0430\u0436\u0435\u043D\u0438\u0435, \u043E\u0442\u0442\u0435\u0433\u043B\u044F\u043D\u0435 \u043D\u0430 \u0441\u044A\u0433\u043B\u0430\u0441\u0438\u0435\u0442\u043E, \u0436\u0430\u043B\u0431\u0430 \u0434\u043E \u041A\u0417\u041B\u0414.",
    "\u0421 \u043F\u043E\u043B\u0430\u0433\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u043F\u043E\u0434\u043F\u0438\u0441 \u043F\u043E-\u0434\u043E\u043B\u0443 \u0434\u0435\u043A\u043B\u0430\u0440\u0438\u0440\u0430\u043C, \u0447\u0435 \u0441\u044A\u043C \u0441\u0435 \u0437\u0430\u043F\u043E\u0437\u043D\u0430\u043B/\u0430 \u0441 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0430\u0442\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u044F\u043C \u0438\u0437\u0440\u0438\u0447\u043D\u043E\u0442\u043E \u0441\u0438 \u0441\u044A\u0433\u043B\u0430\u0441\u0438\u0435 \u0437\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043D\u0430 \u043C\u043E\u0438\u0442\u0435 \u043B\u0438\u0447\u043D\u0438 \u0434\u0430\u043D\u043D\u0438 \u0441\u044A\u0433\u043B\u0430\u0441\u043D\u043E \u043F\u043E\u0441\u043E\u0447\u0435\u043D\u0438\u0442\u0435 \u0446\u0435\u043B\u0438."
  ];
  for (const p of paras) {
    w.paragraph(p, { size: 10, paraGap: 6 });
  }
  w.gap(8);
  w.kv("\u0418\u043C\u0435 \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442:", c.name || "\u2014", { size: 10, valueBold: true });
  w.kv("\u0415\u0413\u041D:", c.egn || "\u2014", { size: 10 });
  await drawSignatureBlock(pdfDoc, page, font, {
    labelLeft: "\u0414\u0410\u0422\u0410",
    nameLeft: fmtDatePdf(rentalState.gdprSignedAt || /* @__PURE__ */ new Date(), { withYearSuffix: true }),
    labelRight: "\u041F\u041E\u0414\u041F\u0418\u0421 \u041D\u0410 \u041A\u041B\u0418\u0415\u041D\u0422\u0410",
    nameRight: c.name || "",
    signatureRight: rentalState.gdprSignature,
    signedAtRight: rentalState.gdprSignedAt,
    yTop: 160
  });
  const bytes = await pdfDoc.save();
  return { bytes, name: "\u0414\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0438\u044F_GDPR_" + (rentalState.contractNo || "\u041D\u041E\u0412").replace("/", "-") + ".pdf" };
}
async function generateDeclarationPdf(rentalState) {
  await ensurePdfLib();
  const pdfLib = window.PDFLib;
  const pdfDoc = await pdfLib.PDFDocument.create();
  const { font, fontBold } = await embedNotoSans(pdfDoc);
  pdfDoc.setTitle("\u0414\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0438\u044F \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u043D\u0430\u0435\u043C\u0430\u043D\u0435 " + (rentalState.contractNo || ""));
  const page = pdfDoc.addPage([A4.w, A4.h]);
  drawChrome(pdfLib, page, font, { contractNo: rentalState.contractNo });
  const w = makeWriter(page, font, fontBold);
  w.moveTo(A4.h - 60);
  w.gap(20);
  w.heading("\u0414\u0415\u041A\u041B\u0410\u0420\u0410\u0426\u0418\u042F", { size: 15, align: "center" });
  w.smallCaption("\u041E\u0442\u043D\u043E\u0441\u043D\u043E \u0432\u0430\u043B\u0438\u0434\u043D\u043E\u0441\u0442 \u043D\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438\u0442\u0435 \u0437\u0430 \u0441\u0430\u043C\u043E\u043B\u0438\u0447\u043D\u043E\u0441\u0442");
  w.gap(10);
  const c = rentalState.customer || {};
  w.paragraph(
    "\u0414\u043E\u043B\u0443\u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u044F\u0442/\u0430\u0442\u0430 " + (c.name || "\u2014") + ", \u0415\u0413\u041D " + (c.egn || "\u2014") + ", \u0432 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u043E\u0442\u043E \u0441\u0438 \u043D\u0430 \u043D\u0430\u0435\u043C\u0430\u0442\u0435\u043B \u043F\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u2116 " + (rentalState.contractNo || "\u041D\u041E\u0412") + " \u0441 \u201E" + (window.COMPANY && window.COMPANY.legal || "\u2014") + '" (' + (window.COMPANY && window.COMPANY.brand || "banicharka.bg") + "),",
    { size: 10, paraGap: 12 }
  );
  w.paragraph("\u0414\u0415\u041A\u041B\u0410\u0420\u0418\u0420\u0410\u041C, \u0447\u0435:", { size: 11, bold: true, paraGap: 10 });
  const items = [
    "\u041B\u0438\u0447\u043D\u0430\u0442\u0430 \u043C\u0438 \u043A\u0430\u0440\u0442\u0430 \u0435 \u0443 \u043C\u0435\u043D, \u0432\u0430\u043B\u0438\u0434\u043D\u0430 \u0435 \u0438 \u043D\u0435 \u0435 \u043E\u0431\u044F\u0432\u0435\u043D\u0430 \u0437\u0430 \u043D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u0430, \u0438\u0437\u0433\u0443\u0431\u0435\u043D\u0430 \u0438\u043B\u0438 \u043E\u0442\u043A\u0440\u0430\u0434\u043D\u0430\u0442\u0430.",
    "\u0421\u0432\u0438\u0434\u0435\u0442\u0435\u043B\u0441\u0442\u0432\u043E\u0442\u043E \u043C\u0438 \u0437\u0430 \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0430 \u041C\u041F\u0421 \u0435 \u0443 \u043C\u0435\u043D, \u0432\u0430\u043B\u0438\u0434\u043D\u043E \u0435 \u0438 \u043D\u0435 \u043C\u0438 \u0435 \u043E\u0442\u043D\u0435\u0442\u043E \u043F\u043E \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u0435\u043D \u0438\u043B\u0438 \u0441\u044A\u0434\u0435\u0431\u0435\u043D \u0440\u0435\u0434.",
    "\u041D\u0435 \u0441\u0430 \u043C\u0438 \u043D\u0430\u043B\u0430\u0433\u0430\u043D\u0438 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u0438 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F \u0432\u044A\u0440\u0445\u0443 \u043F\u0440\u0430\u0432\u043E\u0442\u043E \u043C\u0438 \u0434\u0430 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0432\u0430\u043C \u041C\u041F\u0421.",
    "\u0414\u0430\u043D\u043D\u0438\u0442\u0435 \u043C\u0438 \u0437\u0430 \u0441\u0430\u043C\u043E\u043B\u0438\u0447\u043D\u043E\u0441\u0442 \u0438 \u043F\u0440\u0430\u0432\u043E\u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u0441\u0442, \u0441\u044A\u0445\u0440\u0430\u043D\u044F\u0432\u0430\u043D\u0438 \u043E\u0442 \u043D\u0430\u0435\u043C\u043E\u0434\u0430\u0442\u0435\u043B\u044F \u043E\u0442 \u043F\u0440\u0435\u0434\u0445\u043E\u0434\u043D\u0438 \u043D\u0430\u0435\u043C\u0438, \u0441\u0430 \u0430\u043A\u0442\u0443\u0430\u043B\u043D\u0438 \u0438 \u0432\u0435\u0440\u043D\u0438 \u043A\u044A\u043C \u0434\u043D\u0435\u0448\u043D\u0430 \u0434\u0430\u0442\u0430."
  ];
  for (let i = 0; i < items.length; i++) {
    w.paragraph(i + 1 + ". " + items[i], { size: 10, paraGap: 6, indent: 10 });
  }
  w.gap(8);
  w.paragraph("\u0418\u0437\u0432\u0435\u0441\u0442\u043D\u043E \u043C\u0438 \u0435, \u0447\u0435 \u0437\u0430 \u0434\u0435\u043A\u043B\u0430\u0440\u0438\u0440\u0430\u043D\u0438 \u043D\u0435\u0432\u0435\u0440\u043D\u0438 \u0434\u0430\u043D\u043D\u0438 \u043D\u043E\u0441\u044F \u043D\u0430\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u043D\u0430 \u043E\u0442\u0433\u043E\u0432\u043E\u0440\u043D\u043E\u0441\u0442 \u043F\u043E \u0447\u043B. 313 \u043E\u0442 \u041D\u041A.", { size: 10, paraGap: 12 });
  w.smallCaption("\u0414\u0430\u0442\u0430: " + fmtDatePdf(rentalState.declarationSignedAt || /* @__PURE__ */ new Date(), { withYearSuffix: true }) + " \xB7 \u041C\u044F\u0441\u0442\u043E: \u0433\u0440. \u0421\u043E\u0444\u0438\u044F");
  await drawSignatureBlock(pdfDoc, page, font, {
    labelRight: "\u041F\u041E\u0414\u041F\u0418\u0421 \u041D\u0410 \u0414\u0415\u041A\u041B\u0410\u0420\u0410\u0422\u041E\u0420\u0410",
    nameRight: c.name || "",
    signatureRight: rentalState.declarationSignature,
    signedAtRight: rentalState.declarationSignedAt,
    yTop: 160
  });
  const bytes = await pdfDoc.save();
  return { bytes, name: "\u0414\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0438\u044F_\u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E_\u043D\u0430\u0435\u043C\u0430\u043D\u0435_" + (rentalState.contractNo || "\u041D\u041E\u0412").replace("/", "-") + ".pdf" };
}
async function generateExtensionAddendumPdf(state) {
  const op = getOperatorProfileForPdf({ requireSignature: true });
  await ensurePdfLib();
  const pdfLib = window.PDFLib;
  const pdfDoc = await pdfLib.PDFDocument.create();
  const { font, fontBold } = await embedNotoSans(pdfDoc);
  const {
    contractNo,
    customer: c,
    vehicle: v,
    originalEnd,
    newEnd,
    extraDays,
    extraCost,
    // Sequence number for the filename ("Анекс удължаване 1.pdf",
    // "Анекс удължаване 2.pdf" …) — caller counts previous addendums
    // attached to the rental and passes N+1.
    sequenceNumber,
    // Timestamp of when the operator recorded the extension request.
    // Used in the "заявено по телефон на …" note drawn under the empty
    // НАЕМАТЕЛ signature line.
    requestedAt
  } = state;
  pdfDoc.setTitle("\u0410\u043D\u0435\u043A\u0441 \u0437\u0430 \u0443\u0434\u044A\u043B\u0436\u0430\u0432\u0430\u043D\u0435 " + (contractNo || ""));
  pdfDoc.setAuthor(window.COMPANY && window.COMPANY.legal || "banicharka.bg");
  pdfDoc.setSubject("\u0410\u043D\u0435\u043A\u0441 \u0437\u0430 \u0443\u0434\u044A\u043B\u0436\u0430\u0432\u0430\u043D\u0435 \u043D\u0430 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0437\u0430 \u043D\u0430\u0435\u043C");
  pdfDoc.setCreator("banicharka.bg Rental Ops");
  const page = pdfDoc.addPage([A4.w, A4.h]);
  drawChrome(pdfLib, page, font, { contractNo });
  const w = makeWriter(page, font, fontBold);
  w.moveTo(A4.h - 90);
  w.heading("\u0410\u041D\u0415\u041A\u0421 \u041A\u042A\u041C \u0414\u041E\u0413\u041E\u0412\u041E\u0420 \u0417\u0410 \u041D\u0410\u0415\u041C \u2116 " + (contractNo || "\u041D\u041E\u0412"), { size: 14, align: "center" });
  w.gap(6);
  w.paragraph(
    "\u0414\u043D\u0435\u0441, " + fmtDatePdf(/* @__PURE__ */ new Date(), { withYearSuffix: true }) + ", \u0441\u0442\u0440\u0430\u043D\u0438\u0442\u0435 \u043F\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u2116 " + (contractNo || "\u041D\u041E\u0412") + " \u0441\u0435 \u0441\u044A\u0433\u043B\u0430\u0441\u0438\u0445\u0430 \u0434\u0430 \u0443\u0434\u044A\u043B\u0436\u0430\u0442 \u0441\u0440\u043E\u043A\u0430 \u043D\u0430 \u043D\u0430\u0435\u043C\u0430 \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B " + (v && v.make || "") + " " + (v && v.model || "") + " (\u0440\u0435\u0433. " + (v && v.plate || "\u2014") + ") \u0437\u0430 \u043D\u0430\u0435\u043C\u0430\u0442\u0435\u043B\u044F " + (c && c.name || "\u2014") + ".",
    { size: 10, paraGap: 10 }
  );
  w.gap(8);
  w.kv("\u041E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u0435\u043D \u043A\u0440\u0430\u0439:", fmtDatePdf(originalEnd) + " " + fmtTimePdf(originalEnd) + " \u0447.");
  w.kv("\u041D\u043E\u0432 \u043A\u0440\u0430\u0439:", fmtDatePdf(newEnd) + " " + fmtTimePdf(newEnd) + " \u0447.");
  w.kv("\u0414\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u043D\u0438 \u0434\u043D\u0438:", String(extraDays) + " " + (extraDays === 1 ? "\u0434\u0435\u043D" : "\u0434\u043D\u0438"));
  w.kv("\u0414\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u043D\u0430 \u0441\u0443\u043C\u0430:", fmtEuroPdf(extraCost));
  w.gap(14);
  w.paragraph(
    "\u0412\u0441\u0438\u0447\u043A\u0438 \u043E\u0441\u0442\u0430\u043D\u0430\u043B\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043D\u0430 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u043E\u0441\u0442\u0430\u0432\u0430\u0442 \u043D\u0435\u043F\u0440\u043E\u043C\u0435\u043D\u0435\u043D\u0438. \u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u044F\u0442 \u0430\u043D\u0435\u043A\u0441 \u0441\u0435 \u043F\u043E\u0434\u043F\u0438\u0441\u0432\u0430 \u043E\u0442 \u0434\u0432\u0435\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438 \u0438 \u0441\u0435 \u043F\u0440\u0438\u043B\u0430\u0433\u0430 \u043A\u044A\u043C \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0437\u0430 \u043D\u0430\u0435\u043C.",
    { size: 10, paraGap: 8 }
  );
  await drawSignatureBlock(pdfDoc, page, font, {
    labelLeft: "\u041D\u0410\u0415\u041C\u041E\u0414\u0410\u0422\u0415\u041B",
    nameLeft: op.name + " \u2014 " + op.role,
    signatureLeft: op.signatureDataUrl,
    signedAtLeft: op.signatureCapturedAt ? new Date(op.signatureCapturedAt) : null,
    labelRight: "\u041D\u0410\u0415\u041C\u0410\u0422\u0415\u041B",
    nameRight: c && c.name || "",
    // Extension is typically initiated by phone/email — customer
    // countersign is captured on next contact. No signature to embed
    // right now, but the line and name are drawn so the operator can
    // countersign in ink if needed.
    yTop: 200
  });
  const noteTs = requestedAt || /* @__PURE__ */ new Date();
  const noteText = "\u0423\u0434\u044A\u043B\u0436\u0430\u0432\u0430\u043D\u0435\u0442\u043E \u0435 \u0437\u0430\u044F\u0432\u0435\u043D\u043E \u043E\u0442 \u043D\u0430\u0435\u043C\u0430\u0442\u0435\u043B\u044F \u043F\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u043D\u0430 " + fmtDatePdf(noteTs, { withYearSuffix: true }) + ", " + fmtTimePdf(noteTs) + " \u0447.";
  const colW = (A4.w - MARGIN * 2 - 20) / 2;
  const rightX = MARGIN + colW + 20;
  page.drawText(noteText, {
    x: rightX,
    y: 200 - 80 - 30,
    // = yTop - sigBoxH - 30
    size: 8,
    font,
    color: pdfLib.rgb(MUTED.r, MUTED.g, MUTED.b)
  });
  const bytes = await pdfDoc.save();
  const seq = Number.isFinite(sequenceNumber) && sequenceNumber > 0 ? sequenceNumber : null;
  const contractPart = (contractNo || "\u041D\u041E\u0412").replace("/", "-");
  const name = seq ? "\u0410\u043D\u0435\u043A\u0441 \u0443\u0434\u044A\u043B\u0436\u0430\u0432\u0430\u043D\u0435 " + seq + " \xB7 " + contractPart + ".pdf" : "\u0410\u043D\u0435\u043A\u0441_\u0443\u0434\u044A\u043B\u0436\u0430\u0432\u0430\u043D\u0435_" + contractPart + ".pdf";
  return { bytes, name };
}
async function generateRentalDocuments(rentalState) {
  const results = [];
  results.push(await generateContractPdf(rentalState));
  results.push(await generateProtocolPdf(rentalState));
  if (rentalState.gdprSigned) {
    results.push(await generateGdprPdf(rentalState));
  }
  if (rentalState.declarationSigned) {
    results.push(await generateDeclarationPdf(rentalState));
  }
  return results;
}
function pdfsToFiles(pdfs) {
  return pdfs.map(({ bytes, name }) => new File([bytes], name, { type: "application/pdf" }));
}
function downloadPdfs(pdfs) {
  for (const { bytes, name } of pdfs) {
    const blob = new Blob([bytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 5e3);
  }
}
async function shareRentalPdfs(pdfs, { title, text }) {
  const files = pdfsToFiles(pdfs);
  if (typeof navigator !== "undefined" && navigator.canShare && navigator.canShare({ files })) {
    try {
      await navigator.share({ files, title, text });
      return { ok: true, method: "share" };
    } catch (err) {
      if (err && err.name === "AbortError") return { ok: false, cancelled: true };
      try {
        if (window.store && window.store.logClientError) {
          window.store.logClientError({
            message: "navigator.share() failed \u2014 fell back to download",
            serverText: JSON.stringify({ errName: err && err.name, errMessage: err && err.message }),
            context: "shareRentalPdfs (pdfgen.jsx)",
            severity: "warn"
          });
        }
      } catch (e) {
      }
      console.warn("navigator.share failed, falling back to download:", err);
    }
  }
  try {
    downloadPdfs(pdfs);
    return { ok: true, method: "download" };
  } catch (err) {
    return { ok: false, error: err };
  }
}
Object.assign(window, {
  generateContractPdf,
  generateProtocolPdf,
  generateGdprPdf,
  generateDeclarationPdf,
  generateExtensionAddendumPdf,
  generateRentalDocuments,
  shareRentalPdfs,
  pdfsToFiles,
  downloadPdfs
});

/* ══════════ components/template.jsx ══════════ */
(() => {
  let jszipPromise = null;
  const loadJSZip = () => {
    if (window.JSZip) return Promise.resolve(window.JSZip);
    if (jszipPromise) return jszipPromise;
    jszipPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = "https://unpkg.com/jszip@3.10.1/dist/jszip.min.js";
      s.onload = () => window.JSZip ? resolve(window.JSZip) : reject(new Error("JSZip failed to attach"));
      s.onerror = () => reject(new Error("Failed to load JSZip"));
      document.head.appendChild(s);
    });
    return jszipPromise;
  };
  async function parseDocx(arrayBuffer) {
    const JSZip = await loadJSZip();
    const zip = await JSZip.loadAsync(arrayBuffer);
    const docXml = zip.file("word/document.xml");
    if (!docXml) throw new Error("This does not look like a Word document (word/document.xml missing).");
    const xml = await docXml.async("string");
    const paragraphs = [];
    const paraRe = /<w:p[^>]*>([\s\S]*?)<\/w:p>/g;
    const runTextRe = /<w:t[^>]*>([\s\S]*?)<\/w:t>/g;
    let pm;
    while ((pm = paraRe.exec(xml)) !== null) {
      const inner = pm[1];
      let rm;
      let paraText = "";
      runTextRe.lastIndex = 0;
      while ((rm = runTextRe.exec(inner)) !== null) {
        paraText += decodeXml(rm[1]);
      }
      paragraphs.push(paraText);
    }
    if (paragraphs.length === 0) {
      let rm;
      const bag = [];
      runTextRe.lastIndex = 0;
      while ((rm = runTextRe.exec(xml)) !== null) {
        bag.push(decodeXml(rm[1]));
      }
      paragraphs.push(bag.join(" "));
    }
    const text = paragraphs.join("\n");
    const tokens = extractPlaceholders(text);
    return { text, tokens, paragraphs };
  }
  function decodeXml(s) {
    return s.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&apos;/g, "'");
  }
  function extractPlaceholders(text) {
    const re = /\{\{\s*([A-Za-z][A-Za-z0-9_]*)\s*\}\}/g;
    const seen = /* @__PURE__ */ new Set();
    const out = [];
    let m;
    while ((m = re.exec(text)) !== null) {
      const raw = m[1];
      if (seen.has(raw)) continue;
      seen.add(raw);
      out.push(raw);
    }
    return out;
  }
  function categorize(tokens) {
    const supported = new Set((window.PLACEHOLDERS || []).map((p) => p.key));
    const supportedList = (window.PLACEHOLDERS || []).map((p) => p.key);
    const recognized = [];
    const unrecognized = [];
    const supportedLower = /* @__PURE__ */ new Map();
    for (const k of supportedList) supportedLower.set(k.toLowerCase(), k);
    for (const t of tokens) {
      const canonical = supportedLower.get(t.toLowerCase());
      if (canonical) recognized.push({ raw: t, canonical });
      else unrecognized.push({ raw: t });
    }
    const usedCanonicals = new Set(recognized.map((r) => r.canonical));
    const unused = supportedList.filter((k) => !usedCanonicals.has(k));
    return { recognized, unrecognized, unused };
  }
  function buildSampleRental() {
    const c = window.CUSTOMERS && window.CUSTOMERS[0] || {};
    const v = window.VEHICLES && window.VEHICLES[0] || {};
    const now = /* @__PURE__ */ new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 10, 0);
    const end = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 3, 18, 0);
    return { c, v, start, end, contractNo: "999/" + start.getFullYear() };
  }
  function buildSampleValues(sample) {
    const { c, v, start, end, contractNo } = sample;
    const days = window.daysBetween ? window.daysBetween(start, end) : 3;
    const daily = v.dailyRate || 45;
    return {
      CUSTOMER_NAME: c.name || "\u2014",
      EGN: c.egn || "\u2014",
      ID_NUMBER: c.idCard && c.idCard.number || "\u2014",
      ID_VALID_UNTIL: window.fmtDateBG ? window.fmtDateBG(c.idCard && c.idCard.expiry) : "\u2014",
      DL_NUMBER: c.driverLicense && c.driverLicense.number || "\u2014",
      DL_VALID_UNTIL: window.fmtDateBG ? window.fmtDateBG(c.driverLicense && c.driverLicense.expiry) : "\u2014",
      CUSTOMER_ADDRESS: c.address || "\u2014",
      CUSTOMER_PHONE: c.phone || "\u2014",
      VEHICLE_MAKE_MODEL: (v.make || "") + " " + (v.model || ""),
      PLATE: v.plate || "\u2014",
      VIN: v.vin || "\u2014",
      DATE_FROM: window.fmtDateTimeBG ? window.fmtDateTimeBG(start) : "\u2014",
      DATE_TO: window.fmtDateTimeBG ? window.fmtDateTimeBG(end) : "\u2014",
      DAILY_RATE: window.fmtEuro ? window.fmtEuro(daily) : daily + " \u20AC",
      TOTAL_PRICE: window.fmtEuro ? window.fmtEuro(daily * days) : daily * days + " \u20AC",
      DEPOSIT: window.fmtEuro ? window.fmtEuro(200) : "200 \u20AC",
      KM_LIMIT_PER_DAY: (v.kmPerDay || 200) + " \u043A\u043C",
      EXTRA_KM_PRICE: window.fmtEuro ? window.fmtEuro(v.extraKmPrice || 0.18) : (v.extraKmPrice || 0.18) + " \u20AC",
      FUEL_LEVEL: "100 %",
      ODOMETER: (v.odo || 0) + " \u043A\u043C",
      CONTRACT_NUMBER: contractNo,
      DATE_TODAY: window.fmtDateBG ? window.fmtDateBG(/* @__PURE__ */ new Date(), { withYearSuffix: true }) : (/* @__PURE__ */ new Date()).toLocaleDateString(),
      OPERATOR_NAME: window.store && window.store.operatorProfile && window.store.operatorProfile().name || "\u041D\u0438\u043A\u043E\u043B\u0430\u0439 \u041C\u0443\u0442\u0430\u0444\u0447\u0438\u0435\u0432"
    };
  }
  function substitutePlaceholders(paragraph, values) {
    return paragraph.replace(/\{\{\s*([A-Za-z][A-Za-z0-9_]*)\s*\}\}/g, (_, key) => {
      const upper = key.toUpperCase();
      if (Object.prototype.hasOwnProperty.call(values, upper)) return String(values[upper]);
      if (Object.prototype.hasOwnProperty.call(values, key)) return String(values[key]);
      return "";
    });
  }
  function arrayBufferToBase64(buffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const chunkSize = 32768;
    for (let i = 0; i < bytes.length; i += chunkSize) {
      binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunkSize));
    }
    return btoa(binary);
  }
  function base64ToArrayBuffer(base64) {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return bytes.buffer;
  }
  window.templateModule = {
    loadJSZip,
    parseDocx,
    extractPlaceholders,
    categorize,
    buildSampleRental,
    buildSampleValues,
    substitutePlaceholders,
    arrayBufferToBase64,
    base64ToArrayBuffer
  };
})();

/* ══════════ components/wizard.jsx ══════════ */
var WIZARD_STEPS = [
  { id: "customer", label: "Customer" },
  { id: "vehicle", label: "Vehicle & Period" },
  { id: "price", label: "Price & Terms" },
  { id: "gdpr", label: "GDPR Consent", kiosk: true },
  { id: "declaration", label: "Declaration", kiosk: true, conditional: true },
  { id: "contract", label: "Contract Review", kiosk: true },
  { id: "photos", label: "Handover Photos" },
  { id: "handover", label: "Handover Data" },
  { id: "confirm", label: "Confirmation" }
];
function nowRoundedTo15() {
  const d = /* @__PURE__ */ new Date();
  const rounded = Math.round(d.getMinutes() / 15) * 15;
  d.setSeconds(0, 0);
  d.setMinutes(rounded);
  return d;
}
function Wizard({ isPhone, initial = {}, onClose, onOpenKiosk, onFinish }) {
  const [state, setState] = useState(() => ({
    stepIndex: 0,
    // Reserve a contract number the moment the wizard opens so that the
    // photo stamps and kiosk contract review page display the actual
    // number that will be assigned to this rental. If the operator
    // abandons the wizard (see WIZARD_STEPS[9] handling in app.jsx),
    // the number is simply skipped in the sequence.
    // If launched from a reservation → keep the reservation's contract
    // number instead of reserving a new one (that would leave a gap in
    // the sequence for every handover).
    contractNo: initial.contractNo || (window.store ? window.store.nextContractNumber() : null),
    reservationId: initial.reservationId || null,
    // Reservation notes carried through so the price step / confirm
    // screen can surface them ("иска багажник", agreed price, …).
    reservationName: initial.reservationName || null,
    reservationPhone: initial.reservationPhone || null,
    reservationNote: initial.reservationNote || null,
    customer: initial.customer || null,
    isNewCustomer: false,
    isReturningWithoutRescan: false,
    vehicle: initial.vehicle || null,
    // Default START to the actual current time, rounded to the nearest
    // 15 min (e.g. 14:38 -> 14:45), on both the "New rental" full-wizard
    // path (initial = {}) and the today-tap calendar path (initial.date
    // is set but only ever *today* at midnight -- isToday routing in
    // app.jsx guarantees that, so the date portion is redundant with
    // "now" and only the stale midnight time needs replacing). The
    // reservation-launch path (Start handover / onStartHandoverNow) is
    // untouched -- it always supplies initial.startAt explicitly (r.start),
    // which still wins here. Quick Reservation (future dates) never
    // reaches this component at all, so it is unaffected by definition.
    startAt: initial.startAt || nowRoundedTo15(),
    endAt: initial.endAt || (() => {
      const nd = new Date(initial.startAt || nowRoundedTo15());
      nd.setDate(nd.getDate() + 3);
      nd.setHours(18);
      return nd;
    })(),
    // Default km limit comes from Operations settings (defaultKmLimit).
    // As soon as the operator picks a vehicle, StepPrice replaces this
    // with the vehicle's own kmPerDay (see the effect below).
    // Reservation may have carried an agreed price — use it as the
    // starting daily rate if provided (agreedPrice is the total, we
    // convert back to daily to fit the price step's model).
    dailyRate: initial.dailyRate || initial.vehicle && initial.vehicle.dailyRate || 45,
    kmPerDay: initial.kmPerDay || window.store && window.store.operations && window.store.operations().defaultKmLimit || 200,
    extraKmPrice: initial.extraKmPrice || 0.18,
    unlimited: false,
    // Carry agreed price so the price step can show it as reference.
    agreedPrice: initial.agreedPrice || null,
    deposit: 200,
    depositMethod: "cash",
    gdprSigned: false,
    declarationSigned: false,
    contractSigned: false,
    handoverPhotos: {},
    // { front: {dataUrl, width, height, bytes, capturedAt}, ... }
    extraPhotos: [],
    // [ { id, dataUrl, width, height, bytes, capturedAt } ]
    handoverOdo: null,
    handoverFuel: 100,
    handoverNotes: "",
    // v28 contract checkboxes — cleanliness (да default) + 15-key
    // equipment checklist. CHARGING_CABLE/CHARGING_CARD default off here
    // and are flipped ON (and shown) only for electric vehicles — the
    // isElectric effect in StepHandover handles the flip.
    handoverClean: true,
    handoverEquipment: {
      KEYS: true,
      REGISTRATION: true,
      TPL: true,
      VIGNETTE: true,
      FIRST_AID: true,
      TRIANGLE: true,
      VEST: true,
      EXTINGUISHER: true,
      JACK: true,
      SPARE: true,
      MATS: true,
      CHARGING_CABLE: false,
      CHARGING_CARD: false,
      STRAPS: true,
      OTHER: false
    },
    handoverEquipmentOther: "",
    voucherCode: ""
  }));
  useEffect(() => {
    const c = state.customer;
    if (!c) return;
    const idExpired = c.idCard && new Date(c.idCard.expiry) < TODAY;
    const dlExpired = c.driverLicense && new Date(c.driverLicense.expiry) < TODAY;
    setState((s) => ({
      ...s,
      isReturningWithoutRescan: !idExpired && !dlExpired,
      _docsExpired: !!(idExpired || dlExpired)
    }));
  }, []);
  const step = WIZARD_STEPS[state.stepIndex];
  const shouldSkip = (stepId) => {
    if (stepId === "declaration") return !state.isReturningWithoutRescan;
    return false;
  };
  const goNext = () => {
    let n = state.stepIndex + 1;
    while (n < WIZARD_STEPS.length && shouldSkip(WIZARD_STEPS[n].id)) n++;
    if (n >= WIZARD_STEPS.length) {
      if (onFinish) onFinish(state);
      return;
    }
    setState((s) => ({ ...s, stepIndex: n }));
  };
  const goBack = () => {
    let n = state.stepIndex - 1;
    while (n > 0 && shouldSkip(WIZARD_STEPS[n].id)) n--;
    if (n < 0) {
      onClose && onClose();
      return;
    }
    setState((s) => ({ ...s, stepIndex: n }));
  };
  const patch = (obj) => setState((s) => ({ ...s, ...obj }));
  const canProceed = () => {
    switch (step.id) {
      case "customer":
        if (!state.customer) return false;
        if (state._docsExpired) return false;
        if (state.customer.blacklisted && !state._blacklistAccepted) return false;
        return true;
      case "vehicle":
        if (!state.vehicle || !state.startAt || !state.endAt) return false;
        if (state.endAt <= state.startAt) return false;
        if (state._periodError) return false;
        if (state._vehicleConflict) return false;
        return true;
      case "price":
        if (!(state.dailyRate > 0)) return false;
        if (!state.unlimited && !(state.kmPerDay > 0)) return false;
        return true;
      case "gdpr":
        return state.gdprSigned;
      case "declaration":
        return state.declarationSigned;
      case "contract":
        return state.contractSigned;
      case "photos":
        return ["front", "rear", "left", "right", "odometer", "cargo"].every((k) => state.handoverPhotos[k] && state.handoverPhotos[k].dataUrl);
      case "handover":
        return state.handoverOdo != null && state.handoverFuel != null;
      default:
        return true;
    }
  };
  const days = daysBetween(state.startAt, state.endAt);
  const subtotal = state.dailyRate * days;
  return /* @__PURE__ */ React.createElement("div", { "data-wizard": "1", "data-wizard-step": step.id, "data-screen-label": "Rental wizard", style: {
    position: "absolute",
    inset: 0,
    background: T.bg0,
    zIndex: 100,
    display: "flex",
    flexDirection: "column"
  } }, /* @__PURE__ */ React.createElement(
    WizardHeader,
    {
      step,
      stepIndex: state.stepIndex,
      totalSteps: WIZARD_STEPS.length,
      onClose,
      isPhone
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "scroll-y", style: { flex: 1, position: "relative" } }, step.id === "customer" && /* @__PURE__ */ React.createElement(StepCustomer, { state, patch, isPhone }), step.id === "vehicle" && /* @__PURE__ */ React.createElement(StepVehicle, { state, patch, isPhone }), step.id === "price" && /* @__PURE__ */ React.createElement(StepPrice, { state, patch, isPhone, days, subtotal }), step.id === "gdpr" && /* @__PURE__ */ React.createElement(StepKioskHandoff, { step: "gdpr", state, patch, onOpenKiosk, isPhone }), step.id === "declaration" && /* @__PURE__ */ React.createElement(StepKioskHandoff, { step: "declaration", state, patch, onOpenKiosk, isPhone }), step.id === "contract" && /* @__PURE__ */ React.createElement(StepKioskHandoff, { step: "contract", state, patch, onOpenKiosk, isPhone }), step.id === "photos" && /* @__PURE__ */ React.createElement(StepPhotos, { state, patch, isPhone }), step.id === "handover" && /* @__PURE__ */ React.createElement(StepHandover, { state, patch, isPhone }), step.id === "confirm" && /* @__PURE__ */ React.createElement(StepConfirm, { state, isPhone, days, subtotal })), /* @__PURE__ */ React.createElement("div", { style: {
    borderTop: `1px solid ${T.border}`,
    background: T.bg1,
    padding: isPhone ? "12px 14px" : "16px 24px",
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexShrink: 0
  } }, /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: isPhone ? "md" : "lg", icon: "arrowLeft", onClick: goBack }, "Back"), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }), step.id !== "confirm" && /* @__PURE__ */ React.createElement(React.Fragment, null, !isPhone && /* @__PURE__ */ React.createElement("div", { style: { color: T.text2, fontSize: 13 } }, "Step ", state.stepIndex + 1, " of ", WIZARD_STEPS.length), /* @__PURE__ */ React.createElement(
    Button,
    {
      kind: "primary",
      size: isPhone ? "md" : "lg",
      iconRight: "arrowRight",
      disabled: !canProceed(),
      onClick: goNext,
      style: { minWidth: isPhone ? 130 : 180 }
    },
    "Continue"
  )), step.id === "confirm" && /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: isPhone ? "md" : "lg", icon: "check", onClick: goNext, style: { minWidth: isPhone ? 160 : 220 } }, "Finalize rental")));
}
function WizardHeader({ step, stepIndex, totalSteps, onClose, isPhone }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    background: T.bg1,
    borderBottom: `1px solid ${T.border}`,
    padding: isPhone ? "12px 14px 14px" : "14px 24px 16px",
    flexShrink: 0
  } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 12 } }, /* @__PURE__ */ React.createElement(IconBtn, { icon: "x", onClick: onClose, title: "Cancel rental" }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.6, fontWeight: 600 } }, "New rental \xB7 Step ", stepIndex + 1, "/", totalSteps), /* @__PURE__ */ React.createElement("div", { style: { fontSize: isPhone ? 18 : 20, fontWeight: 700, letterSpacing: -0.2, marginTop: 2 } }, step.label, step.kiosk && /* @__PURE__ */ React.createElement(Chip, { tone: "accent", size: "sm", style: { marginLeft: 10, verticalAlign: "middle" }, icon: "eye" }, "Customer-facing")))), /* @__PURE__ */ React.createElement("div", { className: "stepdots" }, WIZARD_STEPS.map((s, i) => /* @__PURE__ */ React.createElement("div", { key: s.id, className: `d ${i === stepIndex ? "active" : ""} ${i < stepIndex ? "done" : ""}` }))));
}
function StepCustomer({ state, patch, isPhone }) {
  const [tab, setTab] = useState("existing");
  const [q, setQ] = useState(state.reservationName || "");
  const [editingDocs, setEditingDocs] = useState(false);
  const filtered = CUSTOMERS.map((c) => {
    const res = window.searchCustomer(c, q.length >= 2 ? q : null);
    if (!res.hit) return null;
    return { customer: c, matched: res.matched, matchedValue: res.value };
  }).filter(Boolean);
  const selectCustomer = (c) => {
    const idExpired = new Date(c.idCard.expiry) < TODAY;
    const dlExpired = new Date(c.driverLicense.expiry) < TODAY;
    patch({
      customer: c,
      isNewCustomer: false,
      isReturningWithoutRescan: !idExpired && !dlExpired,
      // valid returning customers need declaration
      // Flags used by the gate: any expired doc blocks proceed until the
      // operator updates the data (or the customer is deselected).
      _docsExpired: idExpired || dlExpired,
      _blacklistAccepted: false
    });
    setEditingDocs(false);
  };
  const sel = state.customer;
  const idExp = sel ? new Date(sel.idCard.expiry) < TODAY : false;
  const dlExp = sel ? new Date(sel.driverLicense.expiry) < TODAY : false;
  const idSoon = sel && !idExp ? new Date(sel.idCard.expiry) - TODAY < 30 * 24 * 60 * 60 * 1e3 : false;
  const dlSoon = sel && !dlExp ? new Date(sel.driverLicense.expiry) - TODAY < 30 * 24 * 60 * 60 * 1e3 : false;
  return /* @__PURE__ */ React.createElement("div", { style: { padding: isPhone ? 16 : 24 } }, /* @__PURE__ */ React.createElement(
    Segmented,
    {
      block: true,
      size: "lg",
      value: tab,
      onChange: setTab,
      options: [
        { value: "existing", label: "Existing customer" },
        { value: "new", label: "New customer" }
      ],
      style: { marginBottom: 20 }
    }
  ), tab === "existing" && /* @__PURE__ */ React.createElement(React.Fragment, null, sel && sel.blacklisted && /* @__PURE__ */ React.createElement(Card, { pad: 16, style: { marginBottom: 12, background: T.redTint, borderColor: "rgba(239,68,68,0.45)" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 12, alignItems: "flex-start" } }, /* @__PURE__ */ React.createElement(Icon, { name: "block", size: 22, color: T.red }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 700, color: "#FCA5A5" } }, "Blacklisted customer"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: T.text1, marginTop: 4 } }, sel.blacklistReason || "\u2014"), !state._blacklistAccepted && /* @__PURE__ */ React.createElement("div", { style: { marginTop: 10, display: "flex", gap: 8, alignItems: "center" } }, /* @__PURE__ */ React.createElement(Button, { kind: "danger", size: "sm", onClick: () => patch({ _blacklistAccepted: true }) }, "\u041F\u0440\u043E\u0434\u044A\u043B\u0436\u0438 \u0432\u044A\u043F\u0440\u0435\u043A\u0438 \u0442\u043E\u0432\u0430"), /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "sm", onClick: () => patch({ customer: null, _docsExpired: false, _blacklistAccepted: false }) }, "\u041E\u0442\u043C\u0435\u043D\u0438 \u0438\u0437\u0431\u043E\u0440\u0430")), state._blacklistAccepted && /* @__PURE__ */ React.createElement("div", { style: { marginTop: 8, fontSize: 12, color: "#FCA5A5" } }, "\u26A0 \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u044A\u0442 \u0435 \u0438\u0437\u0431\u0440\u0430\u043B \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438 \u0432\u044A\u043F\u0440\u0435\u043A\u0438 \u0437\u0430\u043F\u0438\u0441\u0430 \u0432 blacklist. \u0422\u043E\u0432\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u0441\u0435 \u043B\u043E\u0433\u0432\u0430.")))), sel && (idExp || dlExp) && !editingDocs && /* @__PURE__ */ React.createElement(Card, { pad: 16, style: { marginBottom: 12, background: T.redTint, borderColor: "rgba(239,68,68,0.45)" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 12, alignItems: "flex-start" } }, /* @__PURE__ */ React.createElement(Icon, { name: "warn", size: 22, color: T.red }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 700, color: "#FCA5A5" } }, idExp && dlExp ? "\u041B\u041A \u0438 \u0421\u0423\u041C\u041F\u0421 \u0441\u0430 \u0438\u0437\u0442\u0435\u043A\u043B\u0438" : idExp ? "\u041B\u0438\u0447\u043D\u0430\u0442\u0430 \u043A\u0430\u0440\u0442\u0430 \u0435 \u0438\u0437\u0442\u0435\u043A\u043B\u0430" : "\u0421\u0423\u041C\u041F\u0421 \u0435 \u0438\u0437\u0442\u0435\u043A\u043B\u043E"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text1, marginTop: 4, lineHeight: 1.5 } }, "\u041D\u0435 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0441\u0435 \u0441\u043A\u043B\u044E\u0447\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0441 \u0438\u0437\u0442\u0435\u043A\u043B\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438. \u0410\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u0439\u0442\u0435 \u0434\u0430\u043D\u043D\u0438\u0442\u0435 \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435."), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 10, display: "flex", gap: 8 } }, /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "sm", icon: "edit", onClick: () => setEditingDocs(true) }, "\u0410\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u0439 \u0434\u0430\u043D\u043D\u0438\u0442\u0435"))))), sel && editingDocs && /* @__PURE__ */ React.createElement(
    DocUpdatePanel,
    {
      customer: sel,
      onSave: (updates) => {
        window.store.updateCustomer(sel.id, updates);
        const fresh = window.store.findCustomer(sel.id);
        const newIdExp = new Date(fresh.idCard.expiry) < TODAY;
        const newDlExp = new Date(fresh.driverLicense.expiry) < TODAY;
        patch({
          customer: fresh,
          _docsExpired: newIdExp || newDlExp,
          // Since we just re-scanned documents, no declaration needed.
          isReturningWithoutRescan: false
        });
        setEditingDocs(false);
        window.toast && window.toast.success("\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438\u0442\u0435 \u0441\u0430 \u0430\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u0438.", { duration: 3e3 });
      },
      onCancel: () => setEditingDocs(false)
    }
  ), sel && (idSoon || dlSoon) && !idExp && !dlExp && /* @__PURE__ */ React.createElement(Card, { pad: 14, style: { marginBottom: 12, background: T.yellowTint, borderColor: "rgba(245,165,36,0.35)" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10, alignItems: "center" } }, /* @__PURE__ */ React.createElement(Icon, { name: "warn", size: 18, color: T.yellow }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, fontSize: 12.5, color: T.text1 } }, /* @__PURE__ */ React.createElement("strong", { style: { color: "#FBBF24" } }, idSoon && dlSoon ? "\u041B\u041A \u0438 \u0421\u0423\u041C\u041F\u0421 \u0438\u0437\u0442\u0438\u0447\u0430\u0442 \u0434\u043E 30 \u0434\u043D\u0438" : idSoon ? "\u041B\u041A \u0438\u0437\u0442\u0438\u0447\u0430 \u0434\u043E 30 \u0434\u043D\u0438" : "\u0421\u0423\u041C\u041F\u0421 \u0438\u0437\u0442\u0438\u0447\u0430 \u0434\u043E 30 \u0434\u043D\u0438"), " \u2014 \u043C\u043E\u0436\u0435 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435, \u043D\u043E \u043E\u0431\u043C\u0438\u0441\u043B\u0435\u0442\u0435 \u0430\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F."))), /* @__PURE__ */ React.createElement(
    Input,
    {
      size: "lg",
      value: q,
      onChange: (e) => setQ(e.target.value),
      placeholder: "Search by name, EGN or phone\u2026",
      prefix: /* @__PURE__ */ React.createElement(Icon, { name: "search", size: 18 }),
      style: { marginBottom: 16 }
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 10 } }, filtered.map((item) => /* @__PURE__ */ React.createElement(
    CustomerRow,
    {
      key: item.customer.id,
      c: item.customer,
      matched: item.matched,
      matchedValue: item.matchedValue,
      selected: state.customer && state.customer.id === item.customer.id,
      onSelect: () => selectCustomer(item.customer)
    }
  )), filtered.length === 0 && /* @__PURE__ */ React.createElement("div", { style: {
    padding: 40,
    textAlign: "center",
    color: T.text2,
    fontSize: 13
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 44,
    height: 44,
    borderRadius: 12,
    background: T.bg1,
    border: `1px solid ${T.border}`,
    margin: "0 auto 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "search", size: 20, color: T.text3 })), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 600, color: T.text1 } }, "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u043A\u043B\u0438\u0435\u043D\u0442\u0438"), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 6, lineHeight: 1.5, maxWidth: 320, marginLeft: "auto", marginRight: "auto" } }, q ? `\u0417\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 "${q}" \u043D\u044F\u043C\u0430 \u0441\u044A\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u044F. \u041F\u0440\u043E\u0431\u0432\u0430\u0439\u0442\u0435 \u0447\u0430\u0441\u0442\u0438\u0447\u043D\u043E \u0438\u043C\u0435, \u0415\u0413\u041D, \u0442\u0435\u043B\u0435\u0444\u043E\u043D, email, \u041B\u041A \u0438\u043B\u0438 \u0421\u0423\u041C\u041F\u0421 \u2014 \u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u0430\u043D\u0435\u0442\u043E \u043D\u0435 \u0435 \u0432\u0430\u0436\u043D\u043E.` : "\u041D\u044F\u043C\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0438 \u043D\u0430 \u0444\u0430\u0439\u043B."), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 14 } }, /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "sm", icon: "plus", onClick: () => setTab("new") }, "\u0421\u044A\u0437\u0434\u0430\u0439 \u043D\u043E\u0432 \u043A\u043B\u0438\u0435\u043D\u0442"))))), tab === "new" && /* @__PURE__ */ React.createElement(NewCustomerForm, { state, patch, isPhone }));
}
function DocUpdatePanel({ customer, onSave, onCancel }) {
  const [idNumber, setIdNumber] = useState(customer.idCard.number || "");
  const [idIssue, setIdIssue] = useState(customer.idCard.issue || "");
  const [idExpiry, setIdExpiry] = useState("");
  const [idAuth, setIdAuth] = useState(customer.idCard.authority || "");
  const [dlNumber, setDlNumber] = useState(customer.driverLicense.number || "");
  const [dlCategories, setDlCategories] = useState(customer.driverLicense.categories || "B");
  const [dlExpiry, setDlExpiry] = useState("");
  const [scanOpen, setScanOpen] = useState(false);
  const [scanSources, setScanSources] = useState({});
  const [scanId, setScanId] = useState(null);
  const applyScan = (result) => {
    const f = result.fields || {};
    const map = {
      idNumber: ["idCardNumber", setIdNumber],
      idIssue: ["idCardIssue", setIdIssue],
      idExpiry: ["idCardExpiry", setIdExpiry],
      idAuth: ["idCardAuthority", setIdAuth],
      dlNumber: ["dlNumber", setDlNumber],
      dlCategories: ["dlCategories", setDlCategories],
      dlExpiry: ["dlExpiry", setDlExpiry]
    };
    const src = {};
    for (const k in map) {
      const fld = f[map[k][0]];
      if (fld && fld.value) {
        if (window.BNC_DATE_KEYS[k] && !window.bncParseDocDate(fld.value)) {
          map[k][1]("");
          src[k] = { ...fld, source: "uncertain", note: window.BNC_SCAN_DATE_NOTE };
        } else {
          map[k][1](fld.value);
          src[k] = fld;
        }
      }
    }
    setScanSources(src);
    if (result.scanId) setScanId(result.scanId);
    (result.warnings || []).forEach((w) => window.toast && window.toast.warn(w, { duration: 6e3 }));
  };
  const parseDate = (s) => {
    return window.bncParseDocDate(s);
  };
  const submit = () => {
    const idExp = parseDate(idExpiry);
    const dlExp = parseDate(dlExpiry);
    if (!idExp || !dlExp) {
      window.toast && window.toast.warn("\u041C\u043E\u043B\u044F \u0432\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0432\u0430\u043B\u0438\u0434\u043D\u0438 \u0434\u0430\u0442\u0438 \u0437\u0430 \u041B\u041A \u0438 \u0421\u0423\u041C\u041F\u0421.", { duration: 3e3 });
      return;
    }
    onSave({
      idCard: {
        ...customer.idCard,
        number: idNumber,
        issue: idIssue,
        expiry: idExp.toISOString().slice(0, 10),
        authority: idAuth
      },
      driverLicense: {
        ...customer.driverLicense,
        number: dlNumber,
        categories: dlCategories,
        expiry: dlExp.toISOString().slice(0, 10)
      },
      warnings: []
      // clear any expired warnings
    });
    if (scanId) {
      window.store.scanConfirm(scanId, { customerId: customer.id, customerName: customer.name }).catch(
        () => window.toast && window.toast.warn("\u0410\u0440\u0445\u0438\u0432\u0438\u0440\u0430\u043D\u0435\u0442\u043E \u0432 Google Drive \u043D\u0435 \u0443\u0441\u043F\u044F \u2014 \u043F\u043E\u0432\u0442\u043E\u0440\u0435\u0442\u0435 \u043E\u0442 \u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438.", { duration: 6e3 })
      );
    }
  };
  return /* @__PURE__ */ React.createElement(Card, { pad: 16, style: { marginBottom: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, marginBottom: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, flex: 1 } }, "\u0410\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \xB7 ", customer.name), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "sm", icon: "camera", onClick: () => setScanOpen(true) }, "\u{1F4F7} Scan document")), scanOpen && /* @__PURE__ */ React.createElement(ScanDocumentsOverlay, { customerName: customer.name, onClose: () => setScanOpen(false), onExtracted: (r) => {
    applyScan(r);
    setScanOpen(false);
  } }), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 14 } }, /* @__PURE__ */ React.createElement(Field, { label: "\u041B\u041A \u043D\u043E\u043C\u0435\u0440" }, /* @__PURE__ */ React.createElement(ScanFieldHighlight, { source: scanSources.idNumber && scanSources.idNumber.source, note: scanSources.idNumber && scanSources.idNumber.note }, /* @__PURE__ */ React.createElement(Input, { mono: true, size: "md", value: idNumber, onChange: (e) => {
    setIdNumber(e.target.value);
    setScanSources((s) => ({ ...s, idNumber: null }));
  } }))), /* @__PURE__ */ React.createElement(Field, { label: "\u0414\u0430\u0442\u0430 \u043D\u0430 \u0438\u0437\u0434\u0430\u0432\u0430\u043D\u0435" }, /* @__PURE__ */ React.createElement(ScanFieldHighlight, { source: scanSources.idIssue && scanSources.idIssue.source, note: scanSources.idIssue && scanSources.idIssue.note }, /* @__PURE__ */ React.createElement(Input, { mono: true, size: "md", value: idIssue, onChange: (e) => {
    setIdIssue(e.target.value);
    setScanSources((s) => ({ ...s, idIssue: null }));
  }, placeholder: "\u0434\u0434.\u043C\u043C.\u0433\u0433\u0433\u0433" }))), /* @__PURE__ */ React.createElement(Field, { label: "\u0412\u0430\u043B\u0438\u0434\u043D\u0430 \u0434\u043E" }, /* @__PURE__ */ React.createElement(ScanFieldHighlight, { source: scanSources.idExpiry && scanSources.idExpiry.source, note: scanSources.idExpiry && scanSources.idExpiry.note }, /* @__PURE__ */ React.createElement(Input, { mono: true, size: "md", value: idExpiry, onChange: (e) => {
    setIdExpiry(e.target.value);
    setScanSources((s) => ({ ...s, idExpiry: null }));
  }, placeholder: "\u0434\u0434.\u043C\u043C.\u0433\u0433\u0433\u0433" }))), /* @__PURE__ */ React.createElement(Field, { label: "\u0418\u0437\u0434\u0430\u0432\u0430\u0449\u0430 \u0438\u043D\u0441\u0442\u0438\u0442\u0443\u0446\u0438\u044F", style: { gridColumn: "1 / -1" } }, /* @__PURE__ */ React.createElement(ScanFieldHighlight, { source: scanSources.idAuth && scanSources.idAuth.source, note: scanSources.idAuth && scanSources.idAuth.note }, /* @__PURE__ */ React.createElement(Input, { size: "md", value: idAuth, onChange: (e) => {
    setIdAuth(e.target.value);
    setScanSources((s) => ({ ...s, idAuth: null }));
  } })))), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 14 } }, /* @__PURE__ */ React.createElement(Field, { label: "\u0421\u0423\u041C\u041F\u0421 \u043D\u043E\u043C\u0435\u0440" }, /* @__PURE__ */ React.createElement(ScanFieldHighlight, { source: scanSources.dlNumber && scanSources.dlNumber.source, note: scanSources.dlNumber && scanSources.dlNumber.note }, /* @__PURE__ */ React.createElement(Input, { mono: true, size: "md", value: dlNumber, onChange: (e) => {
    setDlNumber(e.target.value);
    setScanSources((s) => ({ ...s, dlNumber: null }));
  } }))), /* @__PURE__ */ React.createElement(Field, { label: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438" }, /* @__PURE__ */ React.createElement(ScanFieldHighlight, { source: scanSources.dlCategories && scanSources.dlCategories.source, note: scanSources.dlCategories && scanSources.dlCategories.note }, /* @__PURE__ */ React.createElement(Input, { size: "md", value: dlCategories, onChange: (e) => {
    setDlCategories(e.target.value);
    setScanSources((s) => ({ ...s, dlCategories: null }));
  } }))), /* @__PURE__ */ React.createElement(Field, { label: "\u0412\u0430\u043B\u0438\u0434\u043D\u043E \u0434\u043E" }, /* @__PURE__ */ React.createElement(ScanFieldHighlight, { source: scanSources.dlExpiry && scanSources.dlExpiry.source, note: scanSources.dlExpiry && scanSources.dlExpiry.note }, /* @__PURE__ */ React.createElement(Input, { mono: true, size: "md", value: dlExpiry, onChange: (e) => {
    setDlExpiry(e.target.value);
    setScanSources((s) => ({ ...s, dlExpiry: null }));
  }, placeholder: "\u0434\u0434.\u043C\u043C.\u0433\u0433\u0433\u0433" })))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8 } }, /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "sm", onClick: onCancel }, "\u041E\u0442\u043A\u0430\u0437"), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "sm", icon: "check", onClick: submit }, "\u0417\u0430\u043F\u0430\u0437\u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435")));
}
function CustomerRow({ c, matched, matchedValue, selected, onSelect }) {
  const idExpired = new Date(c.idCard.expiry) < TODAY;
  const dlExpired = new Date(c.driverLicense.expiry) < TODAY;
  const dlSoon = !dlExpired && new Date(c.driverLicense.expiry) - TODAY < 30 * 24 * 60 * 60 * 1e3;
  const idSoon = !idExpired && new Date(c.idCard.expiry) - TODAY < 30 * 24 * 60 * 60 * 1e3;
  const hasWarn = idSoon || dlSoon;
  const hasBlock = idExpired || dlExpired;
  const matchLabel = matched && matched !== "name" ? window.CUSTOMER_FIELD_LABELS[matched] || matched : null;
  return /* @__PURE__ */ React.createElement("button", { onClick: onSelect, style: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    padding: "14px 16px",
    background: selected ? T.accentTint : T.bg1,
    border: `1px solid ${selected ? T.accent : T.border}`,
    borderRadius: 12,
    textAlign: "left"
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 40,
    height: 40,
    borderRadius: 10,
    background: c.blacklisted ? T.redTint : T.bg3,
    color: c.blacklisted ? T.red : T.text1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: 13
  } }, c.blacklisted ? /* @__PURE__ */ React.createElement(Icon, { name: "block", size: 18 }) : c.name.split(" ").map((w) => w[0]).slice(0, 2).join("")), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700 } }, c.name), c.blacklisted && /* @__PURE__ */ React.createElement(Chip, { tone: "red", size: "sm", icon: "block" }, "Blacklisted"), hasBlock && !c.blacklisted && /* @__PURE__ */ React.createElement(Chip, { tone: "red", size: "sm", icon: "warn" }, "Docs expired"), hasWarn && !c.blacklisted && !hasBlock && /* @__PURE__ */ React.createElement(Chip, { tone: "yellow", size: "sm", icon: "warn" }, "Docs expiring")), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 11.5, color: T.text2, marginTop: 3 } }, "\u0415\u0413\u041D ", c.egn, " \xB7 ", c.phone, " \xB7 ", c.rentalsCount, " rentals"), matchLabel && /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 11, color: T.accent, marginTop: 3 } }, /* @__PURE__ */ React.createElement("span", { style: { color: T.text2 } }, "\u041C\u0430\u0447 \u043F\u043E "), matchLabel, ": ", /* @__PURE__ */ React.createElement("span", { style: { color: T.text1 } }, matchedValue))), /* @__PURE__ */ React.createElement(Icon, { name: "chevronR", size: 18, color: T.text3 }));
}
function NewCustomerForm({ state, patch, isPhone }) {
  const [form, setForm] = useState({
    name: state.reservationName || "",
    egn: "",
    phone: state.reservationPhone || "",
    email: "",
    address: "",
    idNumber: "",
    idIssue: "",
    idExpiry: "",
    idAuth: "",
    dlNumber: "",
    dlCategories: "B",
    dlExpiry: ""
  });
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const [scanOpen, setScanOpen] = useState(false);
  const [scanSources, setScanSources] = useState({});
  const [scanId, setScanId] = useState(null);
  const applyScan = (result) => {
    const f = result.fields || {};
    const map = {
      name: "nameCyrillic",
      egn: "egn",
      address: "address",
      idNumber: "idCardNumber",
      idIssue: "idCardIssue",
      idExpiry: "idCardExpiry",
      idAuth: "idCardAuthority",
      dlNumber: "dlNumber",
      dlCategories: "dlCategories",
      dlExpiry: "dlExpiry"
    };
    const src = {};
    setForm((prev) => {
      const next = { ...prev };
      for (const k in map) {
        const fld = f[map[k]];
        if (fld && fld.value) {
          if (window.BNC_DATE_KEYS[k] && !window.bncParseDocDate(fld.value)) {
            next[k] = "";
            src[k] = { ...fld, source: "uncertain", note: window.BNC_SCAN_DATE_NOTE };
          } else {
            next[k] = fld.value;
            src[k] = fld;
          }
        }
      }
      return next;
    });
    setScanSources(src);
    if (result.scanId) setScanId(result.scanId);
    (result.warnings || []).forEach((w) => window.toast && window.toast.warn(w, { duration: 6e3 }));
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Card, { pad: 16, style: { marginBottom: 12, background: T.accentTint, borderColor: "rgba(26,92,230,0.35)" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "flex-start", gap: 12 } }, /* @__PURE__ */ React.createElement(Icon, { name: "info", size: 20, color: T.accent }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600, color: T.text0 } }, "\u0421\u043A\u0430\u043D\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text1, marginTop: 3 } }, "\u0421\u043D\u0438\u043C\u0430\u0439\u0442\u0435 \u043B\u0438\u0447\u043D\u0430\u0442\u0430 \u043A\u0430\u0440\u0442\u0430 \u0438 \u0421\u0423\u041C\u041F\u0421 \u2014 \u043F\u043E\u043B\u0435\u0442\u0430\u0442\u0430 \u0441\u0435 \u043F\u043E\u043F\u044A\u043B\u0432\u0430\u0442 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E. \u0420\u044A\u0447\u043D\u043E\u0442\u043E \u0432\u044A\u0432\u0435\u0436\u0434\u0430\u043D\u0435 \u0432\u0438\u043D\u0430\u0433\u0438 \u043E\u0441\u0442\u0430\u0432\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u043E.")), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "sm", icon: "camera", onClick: () => setScanOpen(true) }, "\u{1F4F7} Scan document"))), scanOpen && /* @__PURE__ */ React.createElement(ScanDocumentsOverlay, { customerName: form.name, onClose: () => setScanOpen(false), onExtracted: (r) => {
    applyScan(r);
    setScanOpen(false);
  } }), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20 }, /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: isPhone ? "1fr" : "1fr 1fr", gap: 14 } }, /* @__PURE__ */ React.createElement(Field, { label: "Full name (three names)", style: { gridColumn: isPhone ? "auto" : "1 / -1" } }, /* @__PURE__ */ React.createElement(ScanFieldHighlight, { source: scanSources.name && scanSources.name.source, note: scanSources.name && scanSources.name.note }, /* @__PURE__ */ React.createElement(Input, { size: "lg", value: form.name, onChange: (e) => {
    set("name", e.target.value);
    setScanSources((s) => ({ ...s, name: null }));
  }, placeholder: "\u0418\u043C\u0435 \u041F\u0440\u0435\u0437\u0438\u043C\u0435 \u0424\u0430\u043C\u0438\u043B\u0438\u044F" }))), /* @__PURE__ */ React.createElement(Field, { label: "\u0415\u0413\u041D" }, /* @__PURE__ */ React.createElement(ScanFieldHighlight, { source: scanSources.egn && scanSources.egn.source, note: scanSources.egn && scanSources.egn.note }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: form.egn, onChange: (e) => {
    set("egn", e.target.value);
    setScanSources((s) => ({ ...s, egn: null }));
  }, placeholder: "0000000000" }))), /* @__PURE__ */ React.createElement(Field, { label: "Phone" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: form.phone, onChange: (e) => set("phone", e.target.value), placeholder: "+359 \u2026" })), /* @__PURE__ */ React.createElement(Field, { label: "Email" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", value: form.email, onChange: (e) => set("email", e.target.value), placeholder: "name@example.com" })), /* @__PURE__ */ React.createElement(Field, { label: "Address", style: { gridColumn: isPhone ? "auto" : "1 / -1" } }, /* @__PURE__ */ React.createElement(ScanFieldHighlight, { source: scanSources.address && scanSources.address.source, note: scanSources.address && scanSources.address.note }, /* @__PURE__ */ React.createElement(Input, { size: "lg", value: form.address, onChange: (e) => {
    set("address", e.target.value);
    setScanSources((s) => ({ ...s, address: null }));
  }, placeholder: "\u0433\u0440. \u0421\u043E\u0444\u0438\u044F, \u2026" })))), /* @__PURE__ */ React.createElement("div", { style: { height: 1, background: T.border, margin: "20px 0" } }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 12 } }, "\u041B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430 / ID card"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: isPhone ? "1fr" : "1fr 1fr 1fr", gap: 14 } }, /* @__PURE__ */ React.createElement(Field, { label: "Number" }, /* @__PURE__ */ React.createElement(ScanFieldHighlight, { source: scanSources.idNumber && scanSources.idNumber.source, note: scanSources.idNumber && scanSources.idNumber.note }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: form.idNumber, onChange: (e) => {
    set("idNumber", e.target.value);
    setScanSources((s) => ({ ...s, idNumber: null }));
  } }))), /* @__PURE__ */ React.createElement(Field, { label: "Issue date" }, /* @__PURE__ */ React.createElement(ScanFieldHighlight, { source: scanSources.idIssue && scanSources.idIssue.source, note: scanSources.idIssue && scanSources.idIssue.note }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: form.idIssue, onChange: (e) => {
    set("idIssue", e.target.value);
    setScanSources((s) => ({ ...s, idIssue: null }));
  }, placeholder: "\u0434\u0434.\u043C\u043C.\u0433\u0433\u0433\u0433" }))), /* @__PURE__ */ React.createElement(Field, { label: "Expiry" }, /* @__PURE__ */ React.createElement(ScanFieldHighlight, { source: scanSources.idExpiry && scanSources.idExpiry.source, note: scanSources.idExpiry && scanSources.idExpiry.note }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: form.idExpiry, onChange: (e) => {
    set("idExpiry", e.target.value);
    setScanSources((s) => ({ ...s, idExpiry: null }));
  }, placeholder: "\u0434\u0434.\u043C\u043C.\u0433\u0433\u0433\u0433" }))), /* @__PURE__ */ React.createElement(Field, { label: "Issuing authority", style: { gridColumn: isPhone ? "auto" : "1 / -1" } }, /* @__PURE__ */ React.createElement(ScanFieldHighlight, { source: scanSources.idAuth && scanSources.idAuth.source, note: scanSources.idAuth && scanSources.idAuth.note }, /* @__PURE__ */ React.createElement(Input, { size: "lg", value: form.idAuth, onChange: (e) => {
    set("idAuth", e.target.value);
    setScanSources((s) => ({ ...s, idAuth: null }));
  }, placeholder: "\u041C\u0412\u0420 ..." })))), /* @__PURE__ */ React.createElement("div", { style: { height: 1, background: T.border, margin: "20px 0" } }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 12 } }, "\u0421\u0423\u041C\u041F\u0421 / Driver's license"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: isPhone ? "1fr" : "1fr 1fr 1fr", gap: 14 } }, /* @__PURE__ */ React.createElement(Field, { label: "Number" }, /* @__PURE__ */ React.createElement(ScanFieldHighlight, { source: scanSources.dlNumber && scanSources.dlNumber.source, note: scanSources.dlNumber && scanSources.dlNumber.note }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: form.dlNumber, onChange: (e) => {
    set("dlNumber", e.target.value);
    setScanSources((s) => ({ ...s, dlNumber: null }));
  } }))), /* @__PURE__ */ React.createElement(Field, { label: "Categories" }, /* @__PURE__ */ React.createElement(ScanFieldHighlight, { source: scanSources.dlCategories && scanSources.dlCategories.source, note: scanSources.dlCategories && scanSources.dlCategories.note }, /* @__PURE__ */ React.createElement(Input, { size: "lg", value: form.dlCategories, onChange: (e) => {
    set("dlCategories", e.target.value);
    setScanSources((s) => ({ ...s, dlCategories: null }));
  } }))), /* @__PURE__ */ React.createElement(Field, { label: "Expiry" }, /* @__PURE__ */ React.createElement(ScanFieldHighlight, { source: scanSources.dlExpiry && scanSources.dlExpiry.source, note: scanSources.dlExpiry && scanSources.dlExpiry.note }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: form.dlExpiry, onChange: (e) => {
    set("dlExpiry", e.target.value);
    setScanSources((s) => ({ ...s, dlExpiry: null }));
  }, placeholder: "\u0434\u0434.\u043C\u043C.\u0433\u0433\u0433\u0433" })))), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 20 } }, /* @__PURE__ */ React.createElement(
    Button,
    {
      kind: "primary",
      size: "lg",
      icon: "check",
      block: true,
      onClick: () => {
        if (!form.name) return;
        const dates = window.bncValidateDocDates(form);
        if (!dates) return;
        const newC = {
          id: "new1",
          name: form.name || "\u041D\u043E\u0432 \u043A\u043B\u0438\u0435\u043D\u0442",
          egn: form.egn || "\u2014",
          phone: form.phone || "\u2014",
          email: form.email || "\u2014",
          address: form.address || "\u2014",
          idCard: { number: form.idNumber || "\u2014", issue: dates.idIssue, expiry: dates.idExpiry, authority: form.idAuth || "\u2014" },
          driverLicense: { number: form.dlNumber || "\u2014", categories: form.dlCategories, expiry: dates.dlExpiry },
          blacklisted: false,
          rentalsCount: 0,
          docsOnFile: 0
        };
        patch({ customer: newC, isNewCustomer: true, isReturningWithoutRescan: false });
        if (scanId) {
          window.store.scanConfirm(scanId, { customerName: newC.name }).catch(
            () => window.toast && window.toast.warn("\u0410\u0440\u0445\u0438\u0432\u0438\u0440\u0430\u043D\u0435\u0442\u043E \u0432 Google Drive \u043D\u0435 \u0443\u0441\u043F\u044F \u2014 \u043F\u043E\u0432\u0442\u043E\u0440\u0435\u0442\u0435 \u043E\u0442 \u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438.", { duration: 6e3 })
          );
        }
      }
    },
    "Save & continue"
  ))));
}
var getBufferMs = () => {
  const hrs = window.store && window.store.operations && window.store.operations().bufferHours;
  return (Number.isFinite(hrs) ? hrs : 2) * 60 * 60 * 1e3;
};
function checkVehicleConflict(vehicleId, start, end, excludeRentalId) {
  if (!(start instanceof Date) || !(end instanceof Date)) return null;
  const startMs = start.getTime();
  const endMs = end.getTime();
  const bufferMs = getBufferMs();
  const startWithBuffer = startMs - bufferMs;
  const endWithBuffer = endMs + bufferMs;
  const relevant = RENTALS.filter(
    (r) => r.vehicleId === vehicleId && r.status !== "cancelled" && r.status !== "completed" && r.status !== "no-show" && r.id !== excludeRentalId
  );
  for (const r of relevant) {
    const rStart = r.start.getTime();
    const rEnd = r.end.getTime();
    if (rStart < endMs && rEnd > startMs) {
      return { rental: r, kind: "overlap" };
    }
    if (rEnd <= startMs && rEnd > startWithBuffer) {
      return { rental: r, kind: "buffer", direction: "before" };
    }
    if (rStart >= endMs && rStart < endWithBuffer) {
      return { rental: r, kind: "buffer", direction: "after" };
    }
  }
  return null;
}
function StepVehicle({ state, patch, isPhone }) {
  const isServiceBlocked = (v) => v.status === "in_service" || v.status === "cleaning" || v.status === "inactive";
  const dateError = (() => {
    if (!state.startAt || !state.endAt) return "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043D\u0430\u0447\u0430\u043B\u043D\u0430 \u0438 \u043A\u0440\u0430\u0439\u043D\u0430 \u0434\u0430\u0442\u0430.";
    if (state.endAt <= state.startAt) return "\u041A\u0440\u0430\u0439\u043D\u0430\u0442\u0430 \u0434\u0430\u0442\u0430 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0435 \u0441\u043B\u0435\u0434 \u043D\u0430\u0447\u0430\u043B\u043D\u0430\u0442\u0430.";
    if (state.endAt - state.startAt < 60 * 60 * 1e3) return "\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u043D\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u043D\u043E\u0441\u0442: 1 \u0447\u0430\u0441.";
    return null;
  })();
  const vehicleConflicts = useMemo(() => {
    if (dateError) return {};
    const out = {};
    for (const v of VEHICLES) {
      if (isServiceBlocked(v)) continue;
      const c = checkVehicleConflict(v.id, state.startAt, state.endAt, state.reservationId);
      if (c) out[v.id] = c;
    }
    return out;
  }, [state.startAt, state.endAt, dateError]);
  const selectedConflict = state.vehicle ? vehicleConflicts[state.vehicle.id] : null;
  const days = daysBetween(state.startAt, state.endAt);
  useEffect(() => {
    patch({ _periodError: dateError, _vehicleConflict: selectedConflict });
  }, [dateError, selectedConflict && selectedConflict.rental && selectedConflict.rental.id, selectedConflict && selectedConflict.kind]);
  return /* @__PURE__ */ React.createElement("div", { style: { padding: isPhone ? 16 : 24 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: isPhone ? "1fr" : "1fr 1fr", gap: 14, marginBottom: 14 } }, /* @__PURE__ */ React.createElement(
    PeriodPicker,
    {
      label: "Start",
      value: state.startAt,
      onChange: (v) => {
        const patchObj = { startAt: v };
        if (state.endAt && v && state.endAt <= v) {
          const nd = new Date(v);
          nd.setDate(nd.getDate() + 1);
          nd.setHours(18, 0, 0, 0);
          patchObj.endAt = nd;
        }
        patch(patchObj);
      }
    }
  ), /* @__PURE__ */ React.createElement(
    PeriodPicker,
    {
      label: "End",
      value: state.endAt,
      onChange: (v) => patch({ endAt: v }),
      minDate: state.startAt
    }
  )), dateError ? /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 14px",
    background: T.redTint,
    border: "1px solid rgba(239,68,68,0.35)",
    borderRadius: 10,
    marginBottom: 20
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "warn", size: 16, color: T.red }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: "#FCA5A5", fontWeight: 600 } }, dateError)) : /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", background: T.bg1, border: `1px solid ${T.border}`, borderRadius: 10, marginBottom: 20 } }, /* @__PURE__ */ React.createElement(Icon, { name: "clock", size: 16, color: T.text2 }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text1, flex: 1 } }, /* @__PURE__ */ React.createElement("span", { className: "mono" }, days), " ", days === 1 ? "day" : "days", " \xB7 2-hour buffer enforced between rentals"), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 13, color: T.text2 } }, "\u2248 ", fmtEuro(days * (state.dailyRate || (state.vehicle ? state.vehicle.dailyRate : 45)), { dp: 0 }))), selectedConflict && !dateError && /* @__PURE__ */ React.createElement(ConflictBanner, { conflict: selectedConflict, vehicle: state.vehicle }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 700, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 12 } }, "Choose vehicle"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: isPhone ? "1fr" : "repeat(2, 1fr)", gap: 12 } }, VEHICLES.map((v) => {
    const serviceBlocked = isServiceBlocked(v);
    const conflict = vehicleConflicts[v.id];
    const unbookable = serviceBlocked || !!conflict;
    const selected = state.vehicle && state.vehicle.id === v.id;
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: v.id,
        disabled: unbookable && !selected,
        onClick: () => {
          if (unbookable && !selected) return;
          patch({ vehicle: v, dailyRate: v.dailyRate, kmPerDay: v.kmPerDay, extraKmPrice: v.extraKmPrice });
        },
        style: {
          padding: 16,
          background: selected ? conflict ? T.redTint : T.accentTint : T.bg1,
          border: `1px solid ${selected ? conflict ? T.red : T.accent : T.border}`,
          borderRadius: 12,
          textAlign: "left",
          opacity: serviceBlocked ? 0.4 : conflict && !selected ? 0.55 : 1,
          cursor: unbookable && !selected ? "not-allowed" : "pointer",
          display: "flex",
          alignItems: "center",
          gap: 14,
          position: "relative"
        }
      },
      /* @__PURE__ */ React.createElement("div", { style: { background: T.bg2, padding: 8, borderRadius: 10 } }, /* @__PURE__ */ React.createElement(VanGlyph, { size: 50, drivetrain: v.drivetrain })),
      /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700 } }, v.make, " ", v.model), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 11.5, color: T.text2, marginTop: 3 } }, v.plate, " \xB7 ", v.year, " \xB7 ", v.drivetrain === "electric" ? "electric" : "diesel"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, marginTop: 8, flexWrap: "wrap" } }, serviceBlocked ? /* @__PURE__ */ React.createElement(Chip, { tone: "gray", size: "sm" }, v.status === "in_service" ? "In service" : v.status === "cleaning" ? "Cleaning" : "Inactive") : conflict ? /* @__PURE__ */ React.createElement(Chip, { tone: "red", size: "sm", icon: "warn" }, conflict.kind === "buffer" ? "Buffer conflict" : "Booked in period") : /* @__PURE__ */ React.createElement(Chip, { tone: "green", size: "sm" }, "Available"), /* @__PURE__ */ React.createElement(Chip, { tone: "outline", size: "sm" }, fmtEuro(v.dailyRate, { dp: 0 }), "/day"))),
      selected && !conflict && /* @__PURE__ */ React.createElement(Icon, { name: "check", size: 20, color: T.accent }),
      selected && conflict && /* @__PURE__ */ React.createElement(Icon, { name: "warn", size: 20, color: T.red })
    );
  })));
}
function ConflictBanner({ conflict, vehicle }) {
  const r = conflict.rental;
  const otherCustomer = CUSTOMERS.find((c) => c.id === r.customerId);
  const message = conflict.kind === "overlap" ? `\u0422\u043E\u0437\u0438 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B \u0435 \u0437\u0430\u0435\u0442 \u043E\u0442 ${fmtDateTimeBG(r.start)} \u0434\u043E ${fmtDateTimeBG(r.end)} (\u0434\u043E\u0433\u043E\u0432\u043E\u0440 ${r.contractNo}${otherCustomer ? " \xB7 " + otherCustomer.name : ""}).` : conflict.direction === "before" ? `\u0418\u0437\u0438\u0441\u043A\u0432\u0430 \u0441\u0435 2-\u0447\u0430\u0441\u043E\u0432 \u0431\u0443\u0444\u0435\u0440 \u043F\u0440\u0435\u0434\u0438 \u043D\u0430\u0447\u0430\u043B\u043E\u0442\u043E \u043D\u0430 \u043D\u0430\u0435\u043C\u0430. \u041F\u0440\u0435\u0434\u0438\u0448\u0435\u043D \u043D\u0430\u0435\u043C: ${fmtDateTimeBG(r.start)} \u2014 ${fmtDateTimeBG(r.end)} (${r.contractNo}).` : `\u0418\u0437\u0438\u0441\u043A\u0432\u0430 \u0441\u0435 2-\u0447\u0430\u0441\u043E\u0432 \u0431\u0443\u0444\u0435\u0440 \u0441\u043B\u0435\u0434 \u043A\u0440\u0430\u044F \u043D\u0430 \u043D\u0430\u0435\u043C\u0430. \u0421\u043B\u0435\u0434\u0432\u0430\u0449 \u043D\u0430\u0435\u043C: ${fmtDateTimeBG(r.start)} \u2014 ${fmtDateTimeBG(r.end)} (${r.contractNo}).`;
  return /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
    padding: "12px 14px",
    background: T.redTint,
    border: "1px solid rgba(239,68,68,0.35)",
    borderRadius: 10,
    marginBottom: 20
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "warn", size: 18, color: T.red, style: { marginTop: 1 } }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 700, color: "#FCA5A5" } }, "\u041A\u043E\u043D\u0444\u043B\u0438\u043A\u0442: ", vehicle.make, " ", vehicle.model, " \xB7 ", vehicle.plate), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text1, marginTop: 3, lineHeight: 1.45 } }, message)));
}
function PeriodPicker({ label, value, onChange, minDate }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);
  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const t = setTimeout(() => document.addEventListener("mousedown", onDoc), 0);
    return () => {
      clearTimeout(t);
      document.removeEventListener("mousedown", onDoc);
    };
  }, [open]);
  const commit = (nextDate) => onChange(nextDate);
  return /* @__PURE__ */ React.createElement("div", { ref: containerRef, style: { position: "relative" } }, /* @__PURE__ */ React.createElement(Field, { label }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: () => setOpen((o) => !o),
      style: {
        width: "100%",
        background: T.bg2,
        border: `1px solid ${open ? T.accent : T.border}`,
        borderRadius: 12,
        padding: 14,
        display: "flex",
        alignItems: "center",
        gap: 12,
        textAlign: "left",
        color: "inherit",
        cursor: "pointer",
        transition: "border 0.12s"
      }
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "calendar", size: 22, color: open ? T.accent : T.text2 }),
    /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 16, fontWeight: 700 }, className: "mono" }, fmtDateBG(value)), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginTop: 2 }, className: "mono" }, fmtTime(value), " \u0447.")),
    /* @__PURE__ */ React.createElement(Icon, { name: "edit", size: 16, color: open ? T.accent : T.text3 })
  )), open && /* @__PURE__ */ React.createElement(
    DateTimePopover,
    {
      value,
      minDate,
      onCommit: (d) => {
        commit(d);
        setOpen(false);
      },
      onCancel: () => setOpen(false)
    }
  ));
}
function DateTimePopover({ value, minDate, onCommit, onCancel }) {
  const initial = value instanceof Date ? value : /* @__PURE__ */ new Date();
  const [draft, setDraft] = useState(new Date(initial));
  const [pageMonth, setPageMonth] = useState(() => {
    const d = new Date(draft);
    d.setDate(1);
    d.setHours(0, 0, 0, 0);
    return d;
  });
  const shiftMonth = (n) => {
    const d = new Date(pageMonth);
    d.setMonth(d.getMonth() + n);
    setPageMonth(d);
  };
  const patchDate = (yyyy, mm, dd) => {
    const d = new Date(draft);
    d.setFullYear(yyyy, mm, dd);
    setDraft(d);
  };
  const patchTime = (hh, mm) => {
    const d = new Date(draft);
    d.setHours(hh, mm, 0, 0);
    setDraft(d);
  };
  const monthGrid = useMemo(() => {
    const firstOfMonth = new Date(pageMonth.getFullYear(), pageMonth.getMonth(), 1);
    const jsDow = firstOfMonth.getDay();
    const mondayOffset = (jsDow + 6) % 7;
    const gridStart = new Date(firstOfMonth);
    gridStart.setDate(1 - mondayOffset);
    const cells = [];
    for (let i = 0; i < 42; i++) {
      const d = new Date(gridStart);
      d.setDate(gridStart.getDate() + i);
      cells.push(d);
    }
    return cells;
  }, [pageMonth]);
  const today = /* @__PURE__ */ new Date();
  const isSameDay = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  const isSelected = (d) => isSameDay(d, draft);
  const isBelowMin = (d) => {
    if (!minDate) return false;
    const md = new Date(minDate);
    md.setHours(0, 0, 0, 0);
    const cd = new Date(d);
    cd.setHours(0, 0, 0, 0);
    return cd < md;
  };
  const monthLabels = [
    "\u042F\u043D\u0443\u0430\u0440\u0438",
    "\u0424\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
    "\u041C\u0430\u0440\u0442",
    "\u0410\u043F\u0440\u0438\u043B",
    "\u041C\u0430\u0439",
    "\u042E\u043D\u0438",
    "\u042E\u043B\u0438",
    "\u0410\u0432\u0433\u0443\u0441\u0442",
    "\u0421\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
    "\u041E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
    "\u041D\u043E\u0435\u043C\u0432\u0440\u0438",
    "\u0414\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
  ];
  const dowLabels = ["\u043F\u043D", "\u0432\u0442", "\u0441\u0440", "\u0447\u0442", "\u043F\u0442", "\u0441\u0431", "\u043D\u0434"];
  return /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    top: "calc(100% + 6px)",
    left: 0,
    right: 0,
    background: T.bg1,
    border: `1px solid ${T.border}`,
    borderRadius: 14,
    padding: 14,
    boxShadow: "0 12px 40px rgba(0,0,0,0.5)",
    zIndex: 50,
    minWidth: 320
  } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 6, marginBottom: 10 } }, /* @__PURE__ */ React.createElement(IconBtn, { icon: "chevronL", size: 30, onClick: () => shiftMonth(-1), title: "Prev month" }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, textAlign: "center", fontSize: 13.5, fontWeight: 700 } }, monthLabels[pageMonth.getMonth()], " ", pageMonth.getFullYear()), /* @__PURE__ */ React.createElement(IconBtn, { icon: "chevronR", size: 30, onClick: () => shiftMonth(1), title: "Next month" })), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 2, marginBottom: 4 } }, dowLabels.map((l) => /* @__PURE__ */ React.createElement("div", { key: l, style: { textAlign: "center", fontSize: 10, color: T.text3, textTransform: "uppercase", letterSpacing: 0.4, fontWeight: 600, padding: "4px 0" } }, l))), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 2 } }, monthGrid.map((d, i) => {
    const inMonth = d.getMonth() === pageMonth.getMonth();
    const isToday = isSameDay(d, today);
    const selected = isSelected(d);
    const belowMin = isBelowMin(d);
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: i,
        type: "button",
        disabled: belowMin,
        onClick: () => {
          if (belowMin) return;
          patchDate(d.getFullYear(), d.getMonth(), d.getDate());
        },
        style: {
          aspectRatio: "1 / 1",
          minHeight: 34,
          border: "none",
          background: selected ? T.accent : isToday ? T.bg3 : "transparent",
          color: selected ? "#fff" : belowMin ? T.text3 : inMonth ? T.text0 : T.text3,
          borderRadius: 8,
          fontSize: 12.5,
          fontWeight: selected ? 700 : isToday ? 700 : 500,
          cursor: belowMin ? "not-allowed" : "pointer",
          fontFamily: "var(--font-mono)",
          opacity: belowMin ? 0.35 : 1
        }
      },
      d.getDate()
    );
  })), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 14, paddingTop: 12, borderTop: `1px solid ${T.border}` } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 10 } }, /* @__PURE__ */ React.createElement(Icon, { name: "clock", size: 16, color: T.text2 }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, flex: 1 } }, "\u0427\u0430\u0441"), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 18, fontWeight: 700, color: T.accent } }, String(draft.getHours()).padStart(2, "0"), ":", String(draft.getMinutes()).padStart(2, "0"))), /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10.5, color: T.text3, width: 22, textTransform: "uppercase", fontWeight: 600 } }, "\u0447"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "range",
      min: 0,
      max: 23,
      value: draft.getHours(),
      onChange: (e) => patchTime(parseInt(e.target.value, 10), draft.getMinutes()),
      style: { flex: 1, accentColor: T.accent, height: 28 }
    }
  ))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10.5, color: T.text3, width: 22, textTransform: "uppercase", fontWeight: 600 } }, "\u043C"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "range",
      min: 0,
      max: 45,
      step: 15,
      value: Math.floor(draft.getMinutes() / 15) * 15,
      onChange: (e) => patchTime(draft.getHours(), parseInt(e.target.value, 10)),
      style: { flex: 1, accentColor: T.accent, height: 28 }
    }
  ))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, marginTop: 10, flexWrap: "wrap" } }, [["08:00", 8, 0], ["10:00", 10, 0], ["12:00", 12, 0], ["14:00", 14, 0], ["17:00", 17, 0], ["18:00", 18, 0], ["20:00", 20, 0]].map(([label, h, m]) => {
    const active = draft.getHours() === h && Math.floor(draft.getMinutes() / 15) * 15 === m;
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: label,
        type: "button",
        onClick: () => patchTime(h, m),
        className: "mono",
        style: {
          padding: "4px 10px",
          fontSize: 11.5,
          fontWeight: 600,
          background: active ? T.accentTint : T.bg2,
          color: active ? T.accent : T.text1,
          border: `1px solid ${active ? T.accent : T.border}`,
          borderRadius: 6,
          cursor: "pointer"
        }
      },
      label
    );
  }))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, marginTop: 14 } }, /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "sm", onClick: onCancel, style: { flex: 1 } }, "\u041E\u0442\u043A\u0430\u0437"), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "sm", onClick: () => onCommit(draft), style: { flex: 2 }, icon: "check" }, "\u0413\u043E\u0442\u043E\u0432\u043E")));
}
function StepPrice({ state, patch, isPhone, days, subtotal }) {
  const zeroRate = !state.dailyRate || state.dailyRate === 0;
  const zeroDeposit = !state.deposit || state.deposit === 0;
  return /* @__PURE__ */ React.createElement("div", { style: { padding: isPhone ? 16 : 24 } }, zeroRate && /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 14px",
    background: T.redTint,
    border: "1px solid rgba(239,68,68,0.35)",
    borderRadius: 10,
    marginBottom: 16
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "warn", size: 16, color: T.red }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: "#FCA5A5" } }, /* @__PURE__ */ React.createElement("strong", null, "\u0414\u043D\u0435\u0432\u043D\u0430\u0442\u0430 \u0446\u0435\u043D\u0430 \u0435 0,00 \u20AC."), " \u041D\u0435 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0441\u0435 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438 \u0431\u0435\u0437 \u0446\u0435\u043D\u0430. \u0410\u043A\u043E \u0436\u0435\u043B\u0430\u0435\u0442\u0435 \u0431\u0435\u0437\u043F\u043B\u0430\u0442\u0435\u043D \u043D\u0430\u0435\u043C, \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 voucher \u0437\u0430 100% \u043E\u0442\u0441\u0442\u044A\u043F\u043A\u0430.")), !zeroRate && zeroDeposit && /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 14px",
    background: T.yellowTint,
    border: "1px solid rgba(245,165,36,0.35)",
    borderRadius: 10,
    marginBottom: 16
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "warn", size: 16, color: T.yellow }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: "#FBBF24" } }, /* @__PURE__ */ React.createElement("strong", null, "\u0414\u0435\u043F\u043E\u0437\u0438\u0442 0,00 \u20AC."), " \u041F\u0440\u043E\u0432\u0435\u0440\u0435\u0442\u0435 \u0434\u0430\u043B\u0438 \u0442\u043E\u0432\u0430 \u0435 \u043F\u043E\u043B\u0438\u0442\u0438\u043A\u0430\u0442\u0430 \u0437\u0430 \u0442\u043E\u0437\u0438 \u043A\u043B\u0438\u0435\u043D\u0442. \u041C\u043E\u0436\u0435 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435, \u043D\u043E \u0431\u0435\u0437 \u0434\u0435\u043F\u043E\u0437\u0438\u0442 \u043D\u044F\u043C\u0430 \u043F\u043E\u043A\u0440\u0438\u0442\u0438\u0435 \u043F\u0440\u0438 \u0449\u0435\u0442\u0438.")), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 14 } }, "Rental terms"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: isPhone ? "1fr" : "1fr 1fr", gap: 14 } }, /* @__PURE__ */ React.createElement(Field, { label: "Daily rate (\u20AC)" }, /* @__PURE__ */ React.createElement(
    NumberInput,
    {
      size: "lg",
      decimals: 2,
      min: 0,
      money: true,
      value: state.dailyRate,
      onChange: (n) => patch({ dailyRate: n || 0 }),
      suffix: "\u20AC / day"
    }
  )), /* @__PURE__ */ React.createElement(Field, { label: "Rental days (auto)" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: days, readOnly: true, suffix: "days" })), /* @__PURE__ */ React.createElement(Field, { label: "Daily km limit", hint: "Average daily km \u2014 uneven days OK." }, /* @__PURE__ */ React.createElement(
    NumberInput,
    {
      size: "lg",
      decimals: 0,
      min: 0,
      disabled: state.unlimited,
      value: state.kmPerDay,
      onChange: (n) => patch({ kmPerDay: n || 0 }),
      suffix: "\u043A\u043C / day"
    }
  )), /* @__PURE__ */ React.createElement(Field, { label: "Extra km price", hint: "Typically fractions of a euro, e.g. 0,18 \u20AC/\u043A\u043C." }, /* @__PURE__ */ React.createElement(
    NumberInput,
    {
      size: "lg",
      decimals: 2,
      min: 0,
      money: true,
      disabled: state.unlimited,
      value: state.extraKmPrice,
      onChange: (n) => patch({ extraKmPrice: n || 0 }),
      suffix: "\u20AC / \u043A\u043C"
    }
  ))), /* @__PURE__ */ React.createElement("label", { style: { display: "flex", alignItems: "center", gap: 12, marginTop: 16, padding: 12, background: T.bg2, borderRadius: 10, border: `1px solid ${T.border}`, cursor: "pointer" } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: state.unlimited,
      onChange: (e) => patch({ unlimited: e.target.checked }),
      style: { width: 20, height: 20, accentColor: T.accent }
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 600 } }, "Unlimited mileage"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginTop: 2 } }, "Waive the km limit for this rental.")))), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 14 } }, "Deposit"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: isPhone ? "1fr" : "1fr 1fr", gap: 14 } }, /* @__PURE__ */ React.createElement(Field, { label: "Amount" }, /* @__PURE__ */ React.createElement(
    NumberInput,
    {
      size: "lg",
      decimals: 2,
      min: 0,
      money: true,
      value: state.deposit,
      onChange: (n) => patch({ deposit: n || 0 }),
      suffix: "\u20AC"
    }
  )), /* @__PURE__ */ React.createElement(Field, { label: "Method" }, /* @__PURE__ */ React.createElement(
    Segmented,
    {
      block: true,
      size: "lg",
      value: state.depositMethod,
      onChange: (m) => patch({ depositMethod: m }),
      options: [{ value: "cash", label: "Cash" }, { value: "bank", label: "Bank transfer" }]
    }
  )))), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12 } }, /* @__PURE__ */ React.createElement(Icon, { name: "voucher", size: 20, color: T.text2 }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 600 } }, "Voucher code (optional)"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginTop: 2 } }, "Apply a promo voucher to this rental.")), /* @__PURE__ */ React.createElement(Input, { mono: true, value: state.voucherCode, onChange: (e) => patch({ voucherCode: e.target.value }), placeholder: "BAN-XXXX", style: { width: 160 } }))), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20, tone: "raised", style: { borderColor: T.accent } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { color: T.text1 } }, fmtEuro(state.dailyRate, { dp: 0 }), " \xD7 ", days, " days"), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 15, fontWeight: 600 } }, fmtEuro(subtotal))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { color: T.text1 } }, "Deposit (", state.depositMethod === "cash" ? "cash" : "bank", ")"), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 15, fontWeight: 600, color: T.text2 } }, "+ ", fmtEuro(state.deposit, { dp: 0 }))), /* @__PURE__ */ React.createElement("div", { style: { height: 1, background: T.border, margin: "12px 0" } }), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "baseline" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 16, fontWeight: 700 } }, "Total collected today"), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 22, fontWeight: 800, color: T.text0 } }, fmtEuro(subtotal + state.deposit)))));
}
function StepKioskHandoff({ step, state, patch, onOpenKiosk, isPhone }) {
  const signed = step === "gdpr" ? state.gdprSigned : step === "declaration" ? state.declarationSigned : state.contractSigned;
  const setSigned = (payload = {}) => {
    const { signatureDataUrl, signedAt } = payload;
    if (step === "gdpr") {
      patch({ gdprSigned: true, gdprSignature: signatureDataUrl, gdprSignedAt: signedAt });
    } else if (step === "declaration") {
      patch({ declarationSigned: true, declarationSignature: signatureDataUrl, declarationSignedAt: signedAt });
    } else {
      patch({ contractSigned: true, contractSignature: signatureDataUrl, contractSignedAt: signedAt });
    }
  };
  const config = {
    gdpr: {
      title: "GDPR consent",
      bg: "\u0421\u044A\u0433\u043B\u0430\u0441\u0438\u0435 \u0437\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043D\u0430 \u043B\u0438\u0447\u043D\u0438 \u0434\u0430\u043D\u043D\u0438",
      body: "The customer must review and sign the GDPR consent. Hand the tablet to them \u2014 the app will lock into full-screen customer view. When they finish, tap the tablet to return here.",
      cta: "Hand tablet to customer"
    },
    declaration: {
      title: "Returning-customer declaration",
      bg: "\u0414\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0438\u044F \u043E\u0442 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u043D\u0430\u0435\u043C\u0430\u0449 \u043A\u043B\u0438\u0435\u043D\u0442",
      body: "Since we are not re-scanning the documents, the customer must declare that their ID card and driver's license are valid and in their possession.",
      cta: "Hand tablet to customer"
    },
    contract: {
      title: "Contract review & signature",
      bg: "\u041F\u0440\u0435\u0433\u043B\u0435\u0434 \u043D\u0430 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0437\u0430 \u043D\u0430\u0435\u043C",
      body: "The customer will see the full generated contract, handover protocol, and all handover photos before signing. The signature is embedded into the final PDF.",
      cta: "Hand tablet for signing"
    }
  }[step];
  return /* @__PURE__ */ React.createElement("div", { style: { padding: isPhone ? 16 : 24, display: "flex", flexDirection: "column", alignItems: "stretch", justifyContent: "center", minHeight: "100%" } }, /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 20 : 32, style: { maxWidth: 640, width: "100%", margin: "0 auto" } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 64,
    height: 64,
    borderRadius: 16,
    background: signed ? T.greenTint : T.accentTint,
    color: signed ? T.green : T.accent,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 20px"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: signed ? "check" : "signature", size: 32, color: signed ? T.green : T.accent })), /* @__PURE__ */ React.createElement("div", { style: { textAlign: "center", fontSize: 22, fontWeight: 700, letterSpacing: -0.3 } }, config.title), /* @__PURE__ */ React.createElement("div", { style: { textAlign: "center", fontFamily: "var(--font-serif)", fontSize: 15, color: T.text1, marginTop: 6, fontStyle: "italic" } }, config.bg), /* @__PURE__ */ React.createElement("div", { style: { textAlign: "center", color: T.text2, marginTop: 16, lineHeight: 1.55, maxWidth: 480, marginLeft: "auto", marginRight: "auto" } }, config.body), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 24 } }, !signed ? /* @__PURE__ */ React.createElement(Button, { block: true, kind: "primary", size: "xl", icon: "signature", onClick: () => onOpenKiosk(step, (payload) => setSigned(payload), state) }, config.cta) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: T.greenTint, border: `1px solid rgba(34,197,94,0.35)`, borderRadius: 10, marginBottom: 12 } }, /* @__PURE__ */ React.createElement(Icon, { name: "check", size: 20, color: T.green }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 600, color: "#86EFAC" } }, "Signed & saved"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text1, marginTop: 2 } }, fmtDateTimeBG(TODAY), " \xB7 attached to rental")), /* @__PURE__ */ React.createElement(Icon, { name: "filePdf", size: 20, color: T.text2 })), /* @__PURE__ */ React.createElement(Button, { block: true, kind: "outline", size: "md", icon: "refresh", onClick: () => onOpenKiosk(step, (payload) => setSigned(payload), state) }, "Re-open on tablet")))));
}
var PHOTO_SLOTS = [
  { key: "front", label: "Front", icon: "\u2191" },
  { key: "rear", label: "Rear", icon: "\u2193" },
  { key: "left", label: "Left side", icon: "\u2190" },
  { key: "right", label: "Right side", icon: "\u2192" },
  { key: "odometer", label: "Odometer", icon: "\u25CE" },
  { key: "cargo", label: "Cargo area", icon: "\u25AD" }
];
function StepPhotos({ state, patch, isPhone }) {
  const totalDone = PHOTO_SLOTS.filter((s) => state.handoverPhotos[s.key] && state.handoverPhotos[s.key].dataUrl).length;
  const extraPhotos = state.extraPhotos || [];
  const setPhoto = (k, record) => patch({ handoverPhotos: { ...state.handoverPhotos, [k]: record } });
  const clearPhoto = (k) => {
    const next = { ...state.handoverPhotos };
    delete next[k];
    patch({ handoverPhotos: next });
  };
  const addExtra = (record) => patch({ extraPhotos: [...extraPhotos, { id: "x" + Date.now() + Math.random().toString(36).slice(2, 5), ...record }] });
  const removeExtra = (id) => patch({ extraPhotos: extraPhotos.filter((p) => p.id !== id) });
  const contractNo = state.contractNo || "\u041D\u041E\u0412";
  useEffect(() => {
    let alive = true;
    const vehicleId = state.vehicle && state.vehicle.id;
    if (!vehicleId || !window.store) {
      patch({ existingDamages: [], existingDamagesLoadFailed: true });
      return;
    }
    window.store.fetchVehicleDamages(vehicleId, { activeOnly: true }).then((list) => Promise.all((list || []).map(async (d) => ({
      ...d,
      photoUrl: d.hasPhoto ? await window.store.getVehicleDamagePhotoUrl(d.id).catch(() => null) : null
    })))).then((entries) => {
      if (alive) patch({ existingDamages: entries, existingDamagesLoadFailed: false });
    }).catch(() => {
      if (alive) patch({ existingDamages: [], existingDamagesLoadFailed: true });
    });
    return () => {
      alive = false;
    };
  }, []);
  return /* @__PURE__ */ React.createElement("div", { style: { padding: isPhone ? 16 : 24 } }, /* @__PURE__ */ React.createElement(Card, { pad: 16, style: { marginBottom: 16, background: totalDone === 6 ? T.greenTint : T.yellowTint, borderColor: totalDone === 6 ? "rgba(34,197,94,0.35)" : "rgba(245,165,36,0.35)" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12 } }, /* @__PURE__ */ React.createElement(Icon, { name: totalDone === 6 ? "check" : "warn", size: 20, color: totalDone === 6 ? T.green : T.yellow }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 700, color: totalDone === 6 ? "#86EFAC" : "#FBBF24" } }, totalDone === 6 ? "All mandatory photos captured" : `${totalDone}/6 mandatory photos`), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text1, marginTop: 2 } }, "Tap a slot to open the rear camera. Photos are auto-resized to 1920px and stamped with date/time + contract number.")))), /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: isPhone ? "1fr 1fr" : "repeat(3, 1fr)",
    gap: 12,
    marginBottom: 20
  } }, PHOTO_SLOTS.map((slot) => /* @__PURE__ */ React.createElement(
    PhotoSlot,
    {
      key: slot.key,
      slot,
      record: state.handoverPhotos[slot.key],
      contractNo,
      onCapture: (rec) => setPhoto(slot.key, rec),
      onClear: () => clearPhoto(slot.key)
    }
  ))), state.existingDamagesLoadFailed && /* @__PURE__ */ React.createElement(Card, { pad: 14, style: { marginBottom: 20, background: T.redTint, borderColor: "rgba(239,68,68,0.35)" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10 } }, /* @__PURE__ */ React.createElement(Icon, { name: "warn", size: 18, color: T.red }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 700, color: "#FCA5A5" } }, "\u0420\u0435\u0433\u0438\u0441\u0442\u044A\u0440\u044A\u0442 \u043D\u0430 \u0449\u0435\u0442\u0438\u0442\u0435 \u043D\u0435 \u0441\u0435 \u0437\u0430\u0440\u0435\u0434\u0438 \u2014 \u0437\u0430\u0432\u0430\u0440\u0435\u043D\u0438\u0442\u0435 \u0449\u0435\u0442\u0438 \u043D\u044F\u043C\u0430 \u0434\u0430 \u0431\u044A\u0434\u0430\u0442 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0438 \u0432 \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u0430"))), !state.existingDamagesLoadFailed && (state.existingDamages || []).length > 0 && /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 20 } }, /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 12, display: "flex", alignItems: "baseline", justifyContent: "space-between" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 } }, "\u0417\u0430\u0432\u0430\u0440\u0435\u043D\u0438 \u0449\u0435\u0442\u0438 (\u043E\u0442 \u0440\u0435\u0433\u0438\u0441\u0442\u044A\u0440\u0430)"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2 } }, state.existingDamages.length, " \u0430\u043A\u0442\u0438\u0432\u043D\u0438")), /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: isPhone ? "1fr 1fr" : "repeat(4, 1fr)",
    gap: 10
  } }, state.existingDamages.map((d) => /* @__PURE__ */ React.createElement("div", { key: d.id, style: {
    aspectRatio: "4 / 3",
    borderRadius: 10,
    border: `1px solid ${T.border}`,
    background: T.bg2,
    position: "relative",
    overflow: "hidden"
  } }, d.photoUrl ? /* @__PURE__ */ React.createElement(
    "img",
    {
      src: d.photoUrl,
      alt: "\u0437\u0430\u0432\u0430\u0440\u0435\u043D\u0430 \u0449\u0435\u0442\u0430",
      style: { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }
    }
  ) : /* @__PURE__ */ React.createElement("div", { style: { position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" } }, /* @__PURE__ */ React.createElement(Icon, { name: "camera", size: 22, color: T.text2 })), /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(0deg, rgba(0,0,0,0.6), transparent 55%)",
    pointerEvents: "none"
  } }), /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    top: 6,
    left: 6,
    padding: "2px 6px",
    borderRadius: 4,
    background: "rgba(245,165,36,0.85)",
    fontSize: 10,
    fontWeight: 700,
    color: "#1A1A1A",
    letterSpacing: 0.3
  } }, "\u0437\u0430\u0432\u0430\u0440\u0435\u043D\u0430 \u0449\u0435\u0442\u0430"), /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    bottom: 6,
    left: 6,
    right: 6,
    fontSize: 11,
    color: "#fff",
    textShadow: "0 1px 2px rgba(0,0,0,0.7)",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  } }, d.description || "\u0411\u0435\u0437 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"))))), /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 12, display: "flex", alignItems: "baseline", justifyContent: "space-between" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 } }, "Additional damage close-ups"), extraPhotos.length > 0 && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2 } }, extraPhotos.length, " extra ", extraPhotos.length === 1 ? "photo" : "photos")), extraPhotos.length > 0 && /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: isPhone ? "1fr 1fr" : "repeat(4, 1fr)",
    gap: 10,
    marginBottom: 12
  } }, extraPhotos.map((p) => /* @__PURE__ */ React.createElement(ExtraPhotoTile, { key: p.id, record: p, onRemove: () => removeExtra(p.id) }))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement(
    CaptureTrigger,
    {
      contractNo,
      slotLabel: "\u0429\u0435\u0442\u0430",
      onCapture: addExtra,
      block: true
    },
    ({ busy }) => /* @__PURE__ */ React.createElement("div", { style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 10,
      height: 52,
      border: `1.5px dashed ${T.border}`,
      borderRadius: 12,
      color: T.text1,
      fontWeight: 600,
      background: "transparent"
    } }, /* @__PURE__ */ React.createElement(Icon, { name: busy ? "refresh" : "add_photo", size: 20, color: T.accent }), busy ? "Processing\u2026" : "+ Additional damage close-up")
  )), /* @__PURE__ */ React.createElement(
    GalleryTrigger,
    {
      contractNo,
      slotLabel: "\u0429\u0435\u0442\u0430",
      onCapture: addExtra,
      onError: (err) => window.toast && window.toast.error(err.message)
    },
    ({ busy }) => /* @__PURE__ */ React.createElement("div", { style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      height: 52,
      padding: "0 16px",
      border: `1.5px dashed ${T.border}`,
      borderRadius: 12,
      color: T.text1,
      fontWeight: 600,
      background: "transparent"
    } }, /* @__PURE__ */ React.createElement(Icon, { name: busy ? "refresh" : "image", size: 18, color: T.accent }), "\u0413\u0430\u043B\u0435\u0440\u0438\u044F")
  )));
}
function PhotoSlot({ slot, record, contractNo, onCapture, onClear }) {
  const filled = !!(record && record.dataUrl);
  const emptyState = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 30, color: T.text2, fontWeight: 300 } }, slot.icon), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600, color: T.text0 } }, slot.label), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 6, color: T.text2, fontSize: 11 } }, /* @__PURE__ */ React.createElement(Icon, { name: "camera", size: 14 }), " Tap to capture"));
  return /* @__PURE__ */ React.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React.createElement(
    CaptureTrigger,
    {
      contractNo,
      slotLabel: slot.label,
      onCapture,
      block: true
    },
    ({ busy }) => /* @__PURE__ */ React.createElement("div", { style: {
      aspectRatio: "4 / 3",
      width: "100%",
      borderRadius: 12,
      border: `2px solid ${filled ? T.green : T.border}`,
      background: filled ? "rgba(34,197,94,0.08)" : T.bg2,
      padding: filled ? 0 : 12,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      color: T.text1,
      position: "relative",
      overflow: "hidden"
    } }, busy ? /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", gap: 6, color: T.text2 } }, /* @__PURE__ */ React.createElement(Icon, { name: "refresh", size: 22 }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5 } }, "Processing\u2026")) : filled ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      "img",
      {
        src: record.dataUrl,
        alt: slot.label,
        style: { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }
      }
    ), /* @__PURE__ */ React.createElement("div", { style: {
      position: "absolute",
      inset: 0,
      background: "linear-gradient(180deg, rgba(0,0,0,0.35) 0%, transparent 30%, transparent 70%, rgba(0,0,0,0.5) 100%)",
      pointerEvents: "none"
    } }), /* @__PURE__ */ React.createElement("div", { style: {
      position: "absolute",
      top: 8,
      left: 8,
      padding: "3px 8px",
      borderRadius: 6,
      background: "rgba(0,0,0,0.55)",
      fontSize: 11,
      fontWeight: 700,
      color: "#fff",
      letterSpacing: 0.3
    } }, slot.label), /* @__PURE__ */ React.createElement("div", { style: {
      position: "absolute",
      top: 8,
      right: 8,
      width: 26,
      height: 26,
      borderRadius: 999,
      background: T.green,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 2px 6px rgba(0,0,0,0.4)"
    } }, /* @__PURE__ */ React.createElement(Icon, { name: "check", size: 16, color: "#052E13", strokeWidth: 2.5 })), /* @__PURE__ */ React.createElement("div", { style: {
      position: "absolute",
      bottom: 8,
      left: 8,
      right: 8,
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "space-between",
      fontSize: 10,
      color: "#fff",
      pointerEvents: "none"
    } }, /* @__PURE__ */ React.createElement("span", { className: "mono", style: { textShadow: "0 1px 2px rgba(0,0,0,0.6)" } }, fmtTime(new Date(record.capturedAt)), " \xB7 ", (record.bytes / 1024).toFixed(0), " KB"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 10, opacity: 0.8, textShadow: "0 1px 2px rgba(0,0,0,0.6)" } }, "Tap to re-take"))) : emptyState)
  ), filled && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: (e) => {
        e.stopPropagation();
        onClear();
      },
      title: "Delete photo",
      style: {
        position: "absolute",
        bottom: 8,
        right: 8,
        width: 32,
        height: 32,
        borderRadius: 8,
        background: "rgba(0,0,0,0.6)",
        color: "#fff",
        border: "1px solid rgba(255,255,255,0.2)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
      }
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "trash", size: 15, color: "#fff" })
  ), /* @__PURE__ */ React.createElement(
    GalleryTrigger,
    {
      contractNo,
      slotLabel: slot.label,
      onCapture,
      onError: (err) => window.toast && window.toast.error(err.message),
      style: { position: "absolute", bottom: 8, left: 8 }
    },
    ({ busy }) => /* @__PURE__ */ React.createElement("span", { title: "\u0418\u0437\u0431\u0435\u0440\u0438 \u043E\u0442 \u0433\u0430\u043B\u0435\u0440\u0438\u044F\u0442\u0430", style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 5,
      height: 26,
      padding: "0 9px",
      borderRadius: 8,
      background: "rgba(0,0,0,0.55)",
      color: "#fff",
      border: "1px solid rgba(255,255,255,0.2)",
      fontSize: 11,
      fontWeight: 700
    } }, /* @__PURE__ */ React.createElement(Icon, { name: busy ? "refresh" : "image", size: 13, color: "#fff" }), "\u0413\u0430\u043B\u0435\u0440\u0438\u044F")
  ));
}
function ExtraPhotoTile({ record, onRemove }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    aspectRatio: "4 / 3",
    borderRadius: 10,
    border: `1px solid ${T.border}`,
    background: T.bg2,
    position: "relative",
    overflow: "hidden"
  } }, /* @__PURE__ */ React.createElement(
    "img",
    {
      src: record.dataUrl,
      alt: "damage close-up",
      style: { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }
    }
  ), /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(0deg, rgba(0,0,0,0.55), transparent 60%)",
    pointerEvents: "none"
  } }), /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    top: 6,
    left: 6,
    padding: "2px 6px",
    borderRadius: 4,
    background: "rgba(0,0,0,0.55)",
    fontSize: 10,
    fontWeight: 700,
    color: "#fff",
    letterSpacing: 0.3
  } }, "\u0429\u0435\u0442\u0430"), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: onRemove,
      title: "Remove",
      style: {
        position: "absolute",
        top: 6,
        right: 6,
        width: 26,
        height: 26,
        borderRadius: 6,
        background: "rgba(0,0,0,0.6)",
        color: "#fff",
        border: "1px solid rgba(255,255,255,0.2)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
      }
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "x", size: 14, color: "#fff" })
  ), /* @__PURE__ */ React.createElement("div", { className: "mono", style: {
    position: "absolute",
    bottom: 6,
    left: 6,
    fontSize: 10,
    color: "#fff",
    textShadow: "0 1px 2px rgba(0,0,0,0.6)"
  } }, fmtTime(new Date(record.capturedAt))));
}
function StepHandover({ state, patch, isPhone }) {
  const v = state.vehicle;
  const isElectric = v && v.drivetrain === "electric";
  const level = state.handoverFuel;
  const setLevel = (n) => patch({ handoverFuel: n });
  React.useEffect(() => {
    if (state.handoverOdo == null && v) {
      patch({ handoverOdo: v.odo });
    }
  }, []);
  const odo = state.handoverOdo != null ? state.handoverOdo : v ? v.odo : 0;
  return /* @__PURE__ */ React.createElement("div", { style: { padding: isPhone ? 16 : 24 } }, /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 14 } }, "Odometer at handover"), /* @__PURE__ */ React.createElement(
    NumberInput,
    {
      size: "lg",
      decimals: 0,
      min: 0,
      value: odo,
      onChange: (n) => patch({ handoverOdo: n || 0 }),
      suffix: "\u043A\u043C",
      style: { height: 60 }
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginTop: 8 } }, "Last recorded odometer: ", /* @__PURE__ */ React.createElement("span", { className: "mono" }, fmtKm(v ? v.odo : 0)))), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, marginBottom: 14 } }, /* @__PURE__ */ React.createElement(Icon, { name: isElectric ? "battery" : "fuel", size: 20, color: T.accent }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 } }, isElectric ? "Battery charge" : "Fuel level")), /* @__PURE__ */ React.createElement(FuelBar, { level, isElectric }), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 8, marginTop: 16 } }, [0, 25, 50, 75, 100].map((n) => /* @__PURE__ */ React.createElement(Button, { key: n, kind: level === n ? "primary" : "outline", size: "md", onClick: () => setLevel(n) }, n, "%")))), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 14 } }, "\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044A\u0442 \u0441\u0435 \u043F\u0440\u0435\u0434\u0430\u0432\u0430 \u043F\u043E\u0447\u0438\u0441\u0442\u0435\u043D"), /* @__PURE__ */ React.createElement(
    Segmented,
    {
      block: true,
      value: state.handoverClean === false ? "no" : "yes",
      onChange: (v2) => patch({ handoverClean: v2 === "yes" }),
      options: [
        { value: "yes", label: "\u0414\u0430" },
        { value: "no", label: "\u041D\u0435" }
      ]
    }
  )), /* @__PURE__ */ React.createElement(HandoverEquipmentCard, { state, patch, isElectric, isPhone }), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20 }, /* @__PURE__ */ React.createElement(Field, { label: "Handover notes (optional)" }, /* @__PURE__ */ React.createElement(
    Textarea,
    {
      rows: 3,
      value: state.handoverNotes,
      onChange: (e) => patch({ handoverNotes: e.target.value }),
      placeholder: "\u0421\u044A\u0449\u0435\u0441\u0442\u0432\u0443\u0432\u0430\u0449\u0438 \u0437\u0430\u0431\u0435\u043B\u0435\u0436\u043A\u0438: \u0434\u0440\u0430\u0441\u043A\u043E\u0442\u0438\u043D\u0430 \u043D\u0430 \u043F\u0440\u0435\u0434\u043D\u0430 \u0434\u044F\u0441\u043D\u0430 \u0432\u0440\u0430\u0442\u0430, \u043B\u0438\u043F\u0441\u0432\u0430 \u0437\u0430\u0434\u043D\u0430 \u0442\u0430\u043F\u0430\u2026"
    }
  ))));
}
var EQUIPMENT_LABELS = [
  ["KEYS", "\u041A\u043B\u044E\u0447\u043E\u0432\u0435"],
  ["REGISTRATION", "\u0422\u0430\u043B\u043E\u043D (\u0441\u0432\u0438\u0434\u0435\u0442\u0435\u043B\u0441\u0442\u0432\u043E \u0437\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F)"],
  ["TPL", "\u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u0430 \u043E\u0442\u0433\u043E\u0432\u043E\u0440\u043D\u043E\u0441\u0442"],
  ["VIGNETTE", "\u0412\u0438\u043D\u0435\u0442\u043A\u0430"],
  ["FIRST_AID", "\u0410\u043F\u0442\u0435\u0447\u043A\u0430"],
  ["TRIANGLE", "\u0422\u0440\u0438\u044A\u0433\u044A\u043B\u043D\u0438\u043A"],
  ["VEST", "\u0421\u0432\u0435\u0442\u043B\u043E\u043E\u0442\u0440\u0430\u0437\u0438\u0442\u0435\u043B\u043D\u0430 \u0436\u0438\u043B\u0435\u0442\u043A\u0430"],
  ["EXTINGUISHER", "\u041F\u043E\u0436\u0430\u0440\u043E\u0433\u0430\u0441\u0438\u0442\u0435\u043B"],
  ["JACK", "\u041A\u0440\u0438\u043A"],
  ["SPARE", "\u0420\u0435\u0437\u0435\u0440\u0432\u043D\u0430 \u0433\u0443\u043C\u0430"],
  ["MATS", "\u0421\u0442\u0435\u043B\u043A\u0438"],
  ["CHARGING_CABLE", "\u041A\u0430\u0431\u0435\u043B \u0437\u0430 \u0437\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435"],
  ["CHARGING_CARD", "\u041A\u0430\u0440\u0442\u0430 \u0437\u0430 \u0437\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435"],
  ["STRAPS", "\u0423\u043A\u0440\u0435\u043F\u0432\u0430\u0449\u0438 \u043A\u043E\u043B\u0430\u043D\u0438"],
  ["OTHER", "\u0414\u0440\u0443\u0433\u043E"]
];
function HandoverEquipmentCard({ state, patch, isElectric, isPhone }) {
  const eq = state.handoverEquipment || {};
  React.useEffect(() => {
    if (isElectric && !eq.CHARGING_CABLE && !eq.CHARGING_CARD && !state._evEquipmentSeeded) {
      patch({
        handoverEquipment: { ...eq, CHARGING_CABLE: true, CHARGING_CARD: true },
        _evEquipmentSeeded: true
      });
    }
  }, [isElectric]);
  const toggle = (key) => {
    const next = { ...eq, [key]: !eq[key] };
    patch({ handoverEquipment: next });
  };
  const rows = EQUIPMENT_LABELS.filter(
    ([key]) => key === "CHARGING_CABLE" || key === "CHARGING_CARD" ? isElectric : true
  );
  return /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 14 } }, "\u041E\u0431\u043E\u0440\u0443\u0434\u0432\u0430\u043D\u0435 \u043F\u0440\u0438 \u043F\u0440\u0435\u0434\u0430\u0432\u0430\u043D\u0435"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: isPhone ? "1fr" : "1fr 1fr", gap: 8 } }, rows.map(([key, label]) => /* @__PURE__ */ React.createElement(
    "div",
    {
      key,
      onClick: () => toggle(key),
      style: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "10px 12px",
        borderRadius: 10,
        cursor: "pointer",
        border: `1px solid ${eq[key] ? T.accent : T.border}`,
        background: eq[key] ? `${T.accent}14` : T.bg2,
        userSelect: "none"
      }
    },
    /* @__PURE__ */ React.createElement("div", { style: {
      width: 22,
      height: 22,
      borderRadius: 6,
      flexShrink: 0,
      border: `2px solid ${eq[key] ? T.accent : T.text2}`,
      background: eq[key] ? T.accent : "transparent",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    } }, eq[key] ? /* @__PURE__ */ React.createElement(Icon, { name: "check", size: 14, color: "#fff" }) : null),
    /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, color: T.text1 } }, label)
  ))), eq.OTHER ? /* @__PURE__ */ React.createElement("div", { style: { marginTop: 12 } }, /* @__PURE__ */ React.createElement(
    Input,
    {
      size: "lg",
      value: state.handoverEquipmentOther || "",
      onChange: (e) => patch({ handoverEquipmentOther: e.target.value }),
      onBlur: () => {
        if (eq.OTHER && !(state.handoverEquipmentOther || "").trim()) {
          window.toast && window.toast.error(
            '\u041E\u0442\u0431\u0435\u043B\u044F\u0437\u0430\u043D\u043E \u0435 \u201E\u0414\u0440\u0443\u0433\u043E", \u043D\u043E \u043D\u0435 \u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u043E \u043A\u0430\u043A\u0432\u043E. \u041C\u043E\u043B\u044F, \u043F\u043E\u043F\u044A\u043B\u043D\u0435\u0442\u0435 \u043F\u043E\u043B\u0435\u0442\u043E \u0438\u043B\u0438 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0435\u0442\u0435 \u043E\u0442\u043C\u0435\u0442\u043A\u0430\u0442\u0430.',
            { title: "\u041D\u0435\u043F\u044A\u043B\u043D\u043E \u043E\u0431\u043E\u0440\u0443\u0434\u0432\u0430\u043D\u0435", duration: 4500 }
          );
        }
      },
      placeholder: "\u041E\u043F\u0438\u0448\u0435\u0442\u0435 \u0434\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u043D\u043E\u0442\u043E \u043E\u0431\u043E\u0440\u0443\u0434\u0432\u0430\u043D\u0435\u2026"
    }
  )) : null);
}
function FuelBar({ level, isElectric }) {
  const color = isElectric ? level < 25 ? T.red : level < 50 ? T.yellow : T.green : level < 25 ? T.red : level < 50 ? T.yellow : T.green;
  return /* @__PURE__ */ React.createElement("div", { style: {
    position: "relative",
    height: 44,
    background: T.bg2,
    borderRadius: 10,
    border: `1px solid ${T.border}`,
    overflow: "hidden"
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: `${level}%`,
    background: `linear-gradient(90deg, ${color}, ${color}CC)`,
    transition: "width 0.2s"
  } }), /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: 20,
    color: "#fff",
    textShadow: "0 1px 3px rgba(0,0,0,0.5)"
  }, className: "mono tabular" }, level, "%"), [25, 50, 75].map((t) => /* @__PURE__ */ React.createElement("div", { key: t, style: {
    position: "absolute",
    left: `${t}%`,
    top: 8,
    bottom: 8,
    width: 1,
    background: "rgba(255,255,255,0.15)"
  } })));
}
function StepConfirm({ state, isPhone, days, subtotal }) {
  const [share, setShare] = useState({ status: "idle", message: "" });
  const [pdfCache, setPdfCache] = useState(null);
  const [emailInfo, setEmailInfo] = useState(false);
  const canShareFiles = (() => {
    if (typeof navigator === "undefined" || !navigator.canShare) return false;
    try {
      const probe = new File([new Uint8Array([0])], "probe.pdf", { type: "application/pdf" });
      return navigator.canShare({ files: [probe] });
    } catch {
      return false;
    }
  })();
  const buildContractNo = () => state.contractNo || (window.store ? window.store.nextContractNumber() : "150/2026");
  const rentalForPdf = {
    ...state,
    contractNo: buildContractNo()
  };
  const pdfPromiseRef = useRef(null);
  const generateOnce = () => {
    if (!pdfPromiseRef.current) {
      pdfPromiseRef.current = window.generateRentalDocuments(rentalForPdf).then((pdfs) => {
        setPdfCache(pdfs);
        return pdfs;
      }).catch((err) => {
        pdfPromiseRef.current = null;
        throw err;
      });
    }
    return pdfPromiseRef.current;
  };
  useEffect(() => {
    generateOnce().catch(() => {
    });
  }, []);
  const handleShare = async () => {
    if (!pdfCache) {
      setShare({ status: "preparing", message: "\u0413\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 PDF \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438\u2026" });
      try {
        await generateOnce();
        setShare({ status: "ready", message: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438\u0442\u0435 \u0441\u0430 \u0433\u043E\u0442\u043E\u0432\u0438 \u2014 \u043D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u201EShare PDFs\u201C \u043E\u0442\u043D\u043E\u0432\u043E \u0437\u0430 \u0441\u043F\u043E\u0434\u0435\u043B\u044F\u043D\u0435." });
      } catch (err) {
        console.error(err);
        setShare({ status: "error", message: "\u0413\u0440\u0435\u0448\u043A\u0430 \u043F\u0440\u0438 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435: " + (err && err.message || err) });
      }
      return;
    }
    setShare({ status: "preparing", message: "\u041F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0430 \u0437\u0430 \u0441\u043F\u043E\u0434\u0435\u043B\u044F\u043D\u0435\u2026" });
    try {
      const pdfs = pdfCache;
      const result = await window.shareRentalPdfs(pdfs, {
        title: "banicharka.bg \xB7 \u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u2116 " + rentalForPdf.contractNo,
        text: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u0437\u0430 \u043D\u0430\u0435\u043C \u0438 \u043F\u0440\u0438\u0435\u043C\u043E-\u043F\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u0435\u043B\u0435\u043D \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B \u2014 " + (state.customer ? state.customer.name : "") + ", " + (state.vehicle ? state.vehicle.make + " " + state.vehicle.model : "") + ", " + fmtDateBG(state.startAt) + " \u2014 " + fmtDateBG(state.endAt) + "."
      });
      if (result.ok && result.method === "share") {
        setShare({ status: "shared", message: "\u041E\u0442\u0432\u043E\u0440\u0435\u043D \u0435 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u0438\u044F\u0442 share sheet \u2014 \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043A\u044A\u0434\u0435 \u0434\u0430 \u0438\u0437\u043F\u0440\u0430\u0442\u0438\u0442\u0435." });
      } else if (result.ok && result.method === "download") {
        setShare({ status: "downloaded", message: "\u0418\u0437\u0442\u0435\u0433\u043B\u0435\u043D\u0438 \u0441\u0430 " + pdfs.length + " PDF \u0444\u0430\u0439\u043B\u0430. \u0421\u0438\u0441\u0442\u0435\u043C\u043D\u0438\u044F\u0442 share sheet \u043D\u0435 \u0435 \u043D\u0430\u043B\u0438\u0447\u0435\u043D \u043D\u0430 \u0442\u043E\u0437\u0438 \u0431\u0440\u0430\u0443\u0437\u044A\u0440 \u2014 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0433\u0438 \u0438\u0437\u043F\u0440\u0430\u0442\u0438\u0442\u0435 \u0440\u044A\u0447\u043D\u043E." });
      } else if (result.cancelled) {
        setShare({ status: "cancelled", message: "\u041E\u0442\u043C\u0435\u043D\u0435\u043D\u043E \u043E\u0442 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u044F." });
      } else {
        throw result.error || new Error("Unknown share error");
      }
    } catch (err) {
      console.error(err);
      setShare({ status: "error", message: "\u0413\u0440\u0435\u0448\u043A\u0430 \u043F\u0440\u0438 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435: " + (err && err.message || err) });
    }
  };
  const handlePreviewOne = async (nameLike) => {
    setShare({ status: "preparing", message: "\u0413\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 PDF \u0437\u0430 \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u2026" });
    try {
      const pdfs = await generateOnce();
      const doc = pdfs.find((p) => p.name.includes(nameLike)) || pdfs[0];
      const blob = new Blob([doc.bytes], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
      setShare({ status: "idle", message: "" });
      setTimeout(() => URL.revokeObjectURL(url), 6e4);
    } catch (err) {
      setShare({ status: "error", message: "\u0413\u0440\u0435\u0448\u043A\u0430 \u043F\u0440\u0438 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435: " + (err && err.message || err) });
    }
  };
  return /* @__PURE__ */ React.createElement("div", { style: { padding: isPhone ? 16 : 24 } }, /* @__PURE__ */ React.createElement("div", { style: { textAlign: "center", marginBottom: 24 } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 72,
    height: 72,
    borderRadius: 20,
    background: T.greenTint,
    margin: "0 auto 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "check", size: 40, color: T.green, strokeWidth: 2.5 })), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 24, fontWeight: 700, letterSpacing: -0.3 } }, "Ready to finalize"), /* @__PURE__ */ React.createElement("div", { style: { color: T.text2, marginTop: 4 } }, "Review the summary and confirm to activate the rental.")), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20, style: { marginBottom: 12 } }, /* @__PURE__ */ React.createElement(RowKV, { label: "Customer", value: state.customer ? state.customer.name : "\u2014" }), /* @__PURE__ */ React.createElement(RowKV, { label: "Phone", value: state.customer ? state.customer.phone : "\u2014", mono: true }), /* @__PURE__ */ React.createElement(RowKV, { label: "Vehicle", value: state.vehicle ? `${state.vehicle.make} ${state.vehicle.model}` : "\u2014" }), /* @__PURE__ */ React.createElement(RowKV, { label: "Plate", value: state.vehicle ? state.vehicle.plate : "\u2014", mono: true }), /* @__PURE__ */ React.createElement(RowKV, { label: "Period", value: `${fmtDateBG(state.startAt)} \u2014 ${fmtDateBG(state.endAt)}`, mono: true }), /* @__PURE__ */ React.createElement(RowKV, { label: "Days", value: days, mono: true })), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20, style: { marginBottom: 12 } }, /* @__PURE__ */ React.createElement(RowKV, { label: "Daily rate", value: fmtEuro(state.dailyRate), mono: true }), /* @__PURE__ */ React.createElement(RowKV, { label: "Km limit / day", value: state.unlimited ? "unlimited" : `${state.kmPerDay} \u043A\u043C`, mono: true }), /* @__PURE__ */ React.createElement(RowKV, { label: "Extra km price", value: state.unlimited ? "\u2014" : fmtEuro(state.extraKmPrice, { dp: 2 }), mono: true }), /* @__PURE__ */ React.createElement(RowKV, { label: "Deposit", value: `${fmtEuro(state.deposit)} \xB7 ${state.depositMethod}`, mono: true }), /* @__PURE__ */ React.createElement(RowKV, { label: "Handover fuel", value: state.handoverFuel + "%", mono: true }), /* @__PURE__ */ React.createElement(RowKV, { label: "Handover odo", value: fmtKm(state.handoverOdo || 0), mono: true }), /* @__PURE__ */ React.createElement("div", { style: { height: 1, background: T.border, margin: "10px 0" } }), /* @__PURE__ */ React.createElement(RowKV, { label: "Rent subtotal", value: fmtEuro(subtotal), bold: true, mono: true }), /* @__PURE__ */ React.createElement(RowKV, { label: "+ Deposit", value: fmtEuro(state.deposit), mono: true }), /* @__PURE__ */ React.createElement(RowKV, { label: "Total collected today", value: fmtEuro(subtotal + state.deposit), bold: true, big: true, mono: true })), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20 }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 12 } }, "Documents generated"), /* @__PURE__ */ React.createElement(
    DocRow,
    {
      icon: "filePdf",
      name: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u0437\u0430 \u043D\u0430\u0435\u043C.pdf",
      size: "signed",
      onPreview: () => handlePreviewOne("\u0414\u043E\u0433\u043E\u0432\u043E\u0440")
    }
  ), /* @__PURE__ */ React.createElement(
    DocRow,
    {
      icon: "filePdf",
      name: "\u041F\u0440\u0438\u0435\u043C\u043E-\u043F\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u0435\u043B\u0435\u043D \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B.pdf",
      size: "signed",
      onPreview: () => handlePreviewOne("\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B")
    }
  ), state.gdprSigned && /* @__PURE__ */ React.createElement(
    DocRow,
    {
      icon: "filePdf",
      name: "\u0414\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0438\u044F GDPR.pdf",
      size: "signed",
      onPreview: () => handlePreviewOne("GDPR")
    }
  ), state.declarationSigned && /* @__PURE__ */ React.createElement(
    DocRow,
    {
      icon: "filePdf",
      name: "\u0414\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0438\u044F \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u043D\u0430\u0435\u043C\u0430\u043D\u0435.pdf",
      size: "signed",
      onPreview: () => handlePreviewOne("\u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E")
    }
  ), /* @__PURE__ */ React.createElement("div", { style: {
    marginTop: 10,
    padding: "10px 12px",
    background: T.bg2,
    border: `1px solid ${T.border}`,
    borderRadius: 8,
    display: "flex",
    gap: 10,
    alignItems: "flex-start"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "info", size: 16, color: T.text2, style: { marginTop: 2 } }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2, lineHeight: 1.5 } }, "Prototype PDFs are generated client-side with the customer's signature and Cyrillic embedded font. Production will render from the operator's DOCX template (see Settings \u2192 Contract template) with the same placeholders \u2014 no app change required."))), share.status !== "idle" && /* @__PURE__ */ React.createElement("div", { style: {
    marginTop: 12,
    padding: "10px 14px",
    background: share.status === "error" ? T.redTint : share.status === "preparing" ? T.blueTint : T.greenTint,
    border: `1px solid ${share.status === "error" ? "rgba(239,68,68,0.35)" : share.status === "preparing" ? "rgba(59,118,240,0.35)" : "rgba(34,197,94,0.35)"}`,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    gap: 10
  } }, /* @__PURE__ */ React.createElement(
    Icon,
    {
      name: share.status === "error" ? "warn" : share.status === "preparing" ? "refresh" : "check",
      size: 18,
      color: share.status === "error" ? T.red : share.status === "preparing" ? T.blue : T.green
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, fontSize: 12.5, color: T.text0 } }, share.message), share.status !== "preparing" && /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: () => setShare({ status: "idle", message: "" }),
      style: { background: "transparent", border: "none", color: T.text2, cursor: "pointer" }
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "x", size: 14, color: T.text2 })
  )), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10, marginTop: 16 } }, /* @__PURE__ */ React.createElement(
    Button,
    {
      kind: "primary",
      size: "lg",
      icon: share.status === "preparing" ? "refresh" : "share",
      style: { flex: 1 },
      disabled: share.status === "preparing",
      onClick: handleShare
    },
    share.status === "preparing" ? "Generating\u2026" : canShareFiles ? "Share PDFs" : "Download PDFs"
  ), /* @__PURE__ */ React.createElement(
    Button,
    {
      kind: "outline",
      size: "lg",
      icon: "mail",
      style: { flex: 1, opacity: 0.65 },
      onClick: () => setEmailInfo(true)
    },
    /* @__PURE__ */ React.createElement("span", { style: { display: "flex", flexDirection: "column", alignItems: "flex-start", lineHeight: 1.1 } }, /* @__PURE__ */ React.createElement("span", null, "Email to customer"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 10, fontWeight: 500, color: T.text2, letterSpacing: 0.4, marginTop: 2 } }, "PHASE 2 \xB7 SMTP"))
  )), emailInfo && /* @__PURE__ */ React.createElement(
    "div",
    {
      onClick: () => setEmailInfo(false),
      style: {
        position: "absolute",
        inset: 0,
        background: "rgba(5, 7, 11, 0.7)",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
        zIndex: 300
      }
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        onClick: (e) => e.stopPropagation(),
        style: {
          background: T.bg1,
          border: `1px solid ${T.border}`,
          borderRadius: "16px 16px 0 0",
          padding: 24,
          maxWidth: 520,
          width: "100%",
          boxShadow: "0 -8px 40px rgba(0,0,0,0.5)"
        }
      },
      /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 12 } }, /* @__PURE__ */ React.createElement("div", { style: {
        width: 44,
        height: 44,
        borderRadius: 12,
        background: T.blueTint,
        color: T.blue,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      } }, /* @__PURE__ */ React.createElement(Icon, { name: "mail", size: 22, color: T.blue })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 16, fontWeight: 700 } }, "Email delivery \xB7 Phase 2"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginTop: 2 } }, "Requires SMTP setup in Settings")), /* @__PURE__ */ React.createElement(IconBtn, { icon: "x", size: 32, onClick: () => setEmailInfo(false) })),
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text1, lineHeight: 1.55, marginBottom: 14 } }, "Once you configure your mailbox (Settings \u2192 Email & SMTP), this button will send the signed contract, protocol, and declarations from ", /* @__PURE__ */ React.createElement("span", { className: "mono", style: { color: T.text0 } }, "office@banicharka.bg"), " ", "to the customer in Bulgarian, with BCC to the operator (brief \xA76.2)."),
      /* @__PURE__ */ React.createElement("div", { style: {
        background: T.bg2,
        borderRadius: 8,
        padding: 12,
        marginBottom: 14,
        fontSize: 12,
        color: T.text2
      } }, "For now, use ", /* @__PURE__ */ React.createElement("strong", { style: { color: T.text0 } }, "Share PDFs"), " \u2014 it opens Android's native share sheet so you can send via Viber, WhatsApp, Gmail or any installed app in one tap."),
      /* @__PURE__ */ React.createElement(Button, { kind: "secondary", block: true, size: "md", onClick: () => setEmailInfo(false) }, "Got it")
    )
  ));
}
function RowKV({ label, value, mono, bold, big }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    padding: "7px 0"
  } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2 } }, label), /* @__PURE__ */ React.createElement("div", { className: mono ? "mono tabular" : "", style: {
    fontSize: big ? 20 : 14,
    fontWeight: bold ? 700 : 500,
    color: T.text0,
    textAlign: "right"
  } }, value));
}
function DocRow({ icon, name, size, onPreview }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "10px 12px",
    background: T.bg2,
    border: `1px solid ${T.border}`,
    borderRadius: 10,
    marginBottom: 8
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 36,
    height: 36,
    borderRadius: 8,
    background: T.redTint,
    color: T.red,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: icon, size: 18, color: T.red })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } }, name), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, marginTop: 2 } }, size)), /* @__PURE__ */ React.createElement(IconBtn, { icon: "eye", size: 34, title: "Preview PDF", onClick: onPreview }));
}
Object.assign(window, { Wizard, checkVehicleConflict, PeriodPicker });

/* ══════════ components/quick-reservation.jsx ══════════ */
function QuickReservationPanel({
  mode = "create",
  // 'create' | 'edit'
  rental = null,
  // required for edit
  initial = {},
  // { vehicleId, date } for create
  onClose,
  onStartHandoverNow
  // optional — if provided, exposes a "Start handover сега" button
}) {
  store.useStore();
  const isEdit = mode === "edit" && rental;
  const [vehicleId, setVehicleId] = useState(() => {
    if (isEdit) return rental.vehicleId;
    if (initial.vehicleId) return initial.vehicleId;
    return VEHICLES[0]?.id ?? null;
  });
  const [startAt, setStartAt] = useState(() => {
    if (isEdit) return rental.start;
    const base = initial.date instanceof Date ? new Date(initial.date) : new Date(TODAY.getFullYear(), TODAY.getMonth(), TODAY.getDate());
    base.setHours(10, 0, 0, 0);
    return base;
  });
  const [endAt, setEndAt] = useState(() => {
    if (isEdit) return rental.end;
    const base = initial.date instanceof Date ? new Date(initial.date) : new Date(TODAY.getFullYear(), TODAY.getMonth(), TODAY.getDate());
    base.setDate(base.getDate() + 3);
    base.setHours(18, 0, 0, 0);
    return base;
  });
  const [name, setName] = useState(isEdit ? rental.reservationName || "" : "");
  const [phone, setPhone] = useState(isEdit ? rental.reservationPhone || "" : "");
  const [note, setNote] = useState(isEdit ? rental.reservationNote || "" : "");
  const [linkedCustomerId, setLinkedCustomerId] = useState(isEdit ? rental.customerId || null : null);
  const linkedCustomer = linkedCustomerId ? window.store.findCustomer(linkedCustomerId) : null;
  const [confirmingCancel, setConfirmingCancel] = useState(false);
  const vehicle = window.store.findVehicle(vehicleId);
  const dailyRate = vehicle ? vehicle.dailyRate : 0;
  const days = Math.max(1, window.daysBetween(startAt, endAt));
  const suggestedPrice = dailyRate * days;
  const [agreedPrice, setAgreedPrice] = useState(
    () => isEdit && rental.agreedPrice != null ? rental.agreedPrice : suggestedPrice
  );
  const [agreedTouched, setAgreedTouched] = useState(false);
  useEffect(() => {
    if (!isEdit && !agreedTouched) setAgreedPrice(suggestedPrice);
  }, [suggestedPrice, isEdit, agreedTouched]);
  const conflict = window.checkVehicleConflict ? window.checkVehicleConflict(vehicleId, startAt, endAt, isEdit ? rental.id : null) : null;
  const periodValid = endAt > startAt;
  const query = (name + " " + phone).trim();
  const suggestions = query.length >= 2 ? CUSTOMERS.map((c) => ({ c, res: window.searchCustomer(c, query) })).filter((x) => x.res.hit).slice(0, 4) : [];
  const pastNoShows = phone.length >= 6 ? window.store.findNoShowsByPhone(phone) : [];
  const canSave = !!vehicleId && name.trim().length >= 2 && phone.trim().length >= 4 && periodValid && !conflict;
  const save = () => {
    if (!canSave) return;
    const payload = {
      vehicleId,
      start: startAt,
      end: endAt,
      reservationName: name.trim(),
      reservationPhone: phone.trim(),
      reservationNote: note.trim() || null,
      customerId: linkedCustomerId || null,
      dailyRate: vehicle ? vehicle.dailyRate : 0,
      kmPerDay: vehicle ? vehicle.kmPerDay : 200,
      extraKmPrice: vehicle ? vehicle.extraKmPrice : 0.18,
      unlimited: false,
      agreedPrice: agreedPrice || null,
      total: agreedPrice || dailyRate * days,
      deposit: null,
      // decided at handover time
      status: "reserved",
      reservedAt: /* @__PURE__ */ new Date()
    };
    if (isEdit) {
      window.store.updateRental(rental.id, payload);
      window.toast && window.toast.success(
        "\u0420\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F " + (rental.contractNo || "") + " \u0435 \u043E\u0431\u043D\u043E\u0432\u0435\u043D\u0430.",
        { title: "\u0420\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F\u0442\u0430 \u0435 \u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0430", duration: 3500 }
      );
    } else {
      const added = window.store.addRental(payload);
      window.toast && window.toast.success(
        "\u0420\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F " + (added.contractNo || "") + " \u0441\u044A\u0437\u0434\u0430\u0434\u0435\u043D\u0430 \u0437\u0430 " + payload.reservationName + ".",
        { title: "\u0420\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F\u0442\u0430 \u0435 \u0437\u0430\u043F\u0438\u0441\u0430\u043D\u0430", duration: 4e3 }
      );
    }
    onClose && onClose();
  };
  const cancelReservation = () => {
    window.store.cancelRental(rental.id, { reason: "operator-cancelled" });
    window.toast && window.toast.info(
      "\u0420\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F " + (rental.contractNo || "") + " \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u0430. \u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044A\u0442 \u0435 \u043E\u0441\u0432\u043E\u0431\u043E\u0434\u0435\u043D.",
      { title: "\u041E\u0442\u043C\u0435\u043D\u0435\u043D\u0430", duration: 3500 }
    );
    onClose && onClose();
  };
  const showStartHandoverNow = isEdit && typeof onStartHandoverNow === "function" && rental.status === "reserved";
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      onClick: onClose,
      style: {
        position: "absolute",
        inset: 0,
        background: "rgba(5,7,11,0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 200
      }
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        onClick: (e) => e.stopPropagation(),
        "data-screen-label": isEdit ? "Edit reservation" : "Quick reservation",
        style: {
          width: "min(680px, calc(100% - 40px))",
          maxHeight: "92%",
          background: T.bg1,
          border: `1px solid ${T.border}`,
          borderRadius: 14,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden"
        }
      },
      /* @__PURE__ */ React.createElement("div", { style: {
        padding: "14px 20px",
        borderBottom: `1px solid ${T.border}`,
        display: "flex",
        alignItems: "center",
        gap: 12,
        background: T.bg0
      } }, /* @__PURE__ */ React.createElement("div", { style: {
        width: 38,
        height: 38,
        borderRadius: 10,
        background: T.accentTint,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      } }, /* @__PURE__ */ React.createElement(Icon, { name: isEdit ? "edit" : "plus", size: 18, color: T.accent })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700 } }, isEdit ? "\u0420\u0435\u0434\u0430\u043A\u0446\u0438\u044F \u043D\u0430 \u0440\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F" : "\u0411\u044A\u0440\u0437\u0430 \u0440\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2, marginTop: 2 } }, isEdit ? `${rental.contractNo || "\u0431\u0435\u0437 \u043D\u043E\u043C\u0435\u0440"} \xB7 ${(rental.status || "").toUpperCase()}` : "\u041E\u0431\u0430\u0436\u0434\u0430 \u0441\u0435 \u043A\u043B\u0438\u0435\u043D\u0442 \u043F\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \xB7 \u043F\u043E\u043F\u044A\u043B\u043D\u0435\u0442\u0435 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0442\u043E, \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u044A\u0442 \u0441\u0435 \u0441\u043A\u043B\u044E\u0447\u0432\u0430 \u043F\u0440\u0438 \u043F\u0440\u0438\u0441\u0442\u0438\u0433\u0430\u043D\u0435")), /* @__PURE__ */ React.createElement(IconBtn, { icon: "x", onClick: onClose })),
      /* @__PURE__ */ React.createElement("div", { className: "scroll-y", style: { flex: 1, padding: 20 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 8 } }, "\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B \u0438 \u043F\u0435\u0440\u0438\u043E\u0434"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr", gap: 10, marginBottom: 8 } }, /* @__PURE__ */ React.createElement(Field, { label: "\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B" }, /* @__PURE__ */ React.createElement(
        VehiclePicker,
        {
          value: vehicleId,
          onChange: setVehicleId,
          startAt,
          endAt,
          excludeRentalId: isEdit ? rental.id : null
        }
      ))), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 8 } }, /* @__PURE__ */ React.createElement(Field, { label: "\u041E\u0442" }, /* @__PURE__ */ React.createElement(PeriodPicker, { value: startAt, onChange: setStartAt })), /* @__PURE__ */ React.createElement(Field, { label: "\u0414\u043E" }, /* @__PURE__ */ React.createElement(PeriodPicker, { value: endAt, onChange: setEndAt, minDate: startAt }))), !periodValid && /* @__PURE__ */ React.createElement("div", { style: {
        padding: "8px 12px",
        marginBottom: 12,
        background: T.redTint,
        border: "1px solid rgba(239,68,68,0.3)",
        borderRadius: 8,
        fontSize: 12,
        color: "#FCA5A5"
      } }, "\u041A\u0440\u0430\u044F\u0442 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0435 \u0441\u043B\u0435\u0434 \u043D\u0430\u0447\u0430\u043B\u043E\u0442\u043E."), conflict && /* @__PURE__ */ React.createElement(ConflictBanner, { conflict }), !conflict && periodValid && /* @__PURE__ */ React.createElement("div", { style: {
        padding: "8px 12px",
        marginBottom: 12,
        background: T.greenTint,
        border: "1px solid rgba(34,197,94,0.28)",
        borderRadius: 8,
        display: "flex",
        alignItems: "center",
        gap: 10,
        fontSize: 12,
        color: T.text1
      } }, /* @__PURE__ */ React.createElement(Icon, { name: "check", size: 14, color: T.green }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("strong", { style: { color: "#86EFAC" } }, days, " ", days === 1 ? "\u0434\u0435\u043D" : "\u0434\u043D\u0438"), " \xB7 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0430 \u0441\u0443\u043C\u0430 \u2248 ", /* @__PURE__ */ React.createElement("span", { className: "mono" }, fmtEuro(suggestedPrice)))), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginTop: 16, marginBottom: 8 } }, "\u041A\u043B\u0438\u0435\u043D\u0442 (\u043F\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430)"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 } }, /* @__PURE__ */ React.createElement(Field, { label: "\u0418\u043C\u0435 (\u043A\u0430\u043A\u0442\u043E \u0441\u0435 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u044F)" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", value: name, onChange: (e) => setName(e.target.value), placeholder: "\u041F\u0435\u0442\u044A\u0440 \u0414\u0440\u0430\u0433\u0430\u043D\u043E\u0432" })), /* @__PURE__ */ React.createElement(Field, { label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: phone, onChange: (e) => setPhone(e.target.value), placeholder: "+359 \u2026" }))), pastNoShows.length > 0 && /* @__PURE__ */ React.createElement("div", { style: {
        marginTop: 8,
        padding: "10px 12px",
        background: T.yellowTint,
        border: "1px solid rgba(245,165,36,0.35)",
        borderRadius: 8,
        display: "flex",
        gap: 10,
        alignItems: "flex-start"
      } }, /* @__PURE__ */ React.createElement(Icon, { name: "warn", size: 16, color: T.yellow, style: { marginTop: 2, flexShrink: 0 } }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text1, lineHeight: 1.5 } }, /* @__PURE__ */ React.createElement("strong", { style: { color: "#FBBF24" } }, "\u26A0 ", pastNoShows.length, " \u043F\u0440\u0435\u0434\u0438\u0448\u043D", pastNoShows.length === 1 ? "\u043E \u043D\u0435\u044F\u0432\u044F\u0432\u0430\u043D\u0435" : "\u0438 \u043D\u0435\u044F\u0432\u044F\u0432\u0430\u043D\u0438\u044F", " \u0441 \u0442\u043E\u0437\u0438 \u043D\u043E\u043C\u0435\u0440."), " ", "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u043E: ", fmtDateBG(pastNoShows[pastNoShows.length - 1].reservedFor), ".", " ", "\u041F\u0440\u0435\u0446\u0435\u043D\u0438 \u0440\u0438\u0441\u043A\u0430, \u043F\u0440\u0435\u0434\u0438 \u0434\u0430 \u0431\u043B\u043E\u043A\u0438\u0440\u0430\u0448 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0430.")), suggestions.length > 0 && !linkedCustomerId && /* @__PURE__ */ React.createElement("div", { style: { marginTop: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, marginBottom: 6 } }, "\u0421\u044A\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u044F \u0432 \u0431\u0430\u0437\u0430\u0442\u0430 \u2014 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0441\u0432\u044A\u0440\u0436\u0435\u0442\u0435 (\u043D\u0435 \u0435 \u0437\u0430\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u043D\u043E):"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 6 } }, suggestions.map(({ c, res }) => /* @__PURE__ */ React.createElement(
        "button",
        {
          key: c.id,
          onClick: () => {
            setLinkedCustomerId(c.id);
            setName(c.name);
            if (!phone) setPhone(c.phone);
          },
          style: {
            display: "flex",
            alignItems: "center",
            gap: 10,
            padding: "8px 12px",
            background: T.bg2,
            border: `1px solid ${T.border}`,
            borderRadius: 8,
            textAlign: "left",
            cursor: "pointer"
          }
        },
        /* @__PURE__ */ React.createElement("div", { style: {
          width: 28,
          height: 28,
          borderRadius: 8,
          background: T.bg3,
          color: T.text1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 700,
          fontSize: 10
        } }, c.name.split(" ").map((w) => w[0]).slice(0, 2).join("")),
        /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, fontWeight: 600 } }, c.name), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 10.5, color: T.text2 } }, c.phone, " \xB7 ", c.rentalsCount, " rental", c.rentalsCount === 1 ? "" : "s", res.matched && res.matched !== "name" && res.matched !== "phone" ? " \xB7 match: " + (window.CUSTOMER_FIELD_LABELS[res.matched] || res.matched) : "")),
        /* @__PURE__ */ React.createElement(Icon, { name: "chevronR", size: 14, color: T.text3 })
      )))), linkedCustomerId && linkedCustomer && /* @__PURE__ */ React.createElement("div", { style: {
        marginTop: 12,
        padding: "10px 12px",
        background: T.accentTint,
        border: "1px solid rgba(26,92,230,0.35)",
        borderRadius: 8,
        display: "flex",
        gap: 10,
        alignItems: "center"
      } }, /* @__PURE__ */ React.createElement(Icon, { name: "check", size: 14, color: T.accent }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, fontSize: 12, color: T.text1 } }, "\u0421\u0432\u044A\u0440\u0437\u0430\u043D \u0441 \u043A\u043B\u0438\u0435\u043D\u0442: ", /* @__PURE__ */ React.createElement("strong", null, linkedCustomer.name), " \xB7 ", /* @__PURE__ */ React.createElement("span", { className: "mono", style: { color: T.text2 } }, linkedCustomer.rentalsCount, " rentals \u0432 \u0431\u0430\u0437\u0430\u0442\u0430")), /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          onClick: () => setLinkedCustomerId(null),
          style: {
            background: "transparent",
            border: "none",
            color: T.text2,
            fontSize: 11,
            cursor: "pointer",
            padding: "4px 8px",
            borderRadius: 6
          }
        },
        "\u041E\u0442\u043A\u0430\u0447\u0438"
      )), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginTop: 16, marginBottom: 8 } }, "\u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0435\u043D\u0430 \u0441\u0443\u043C\u0430 \u0438 \u0431\u0435\u043B\u0435\u0436\u043A\u0430"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 } }, /* @__PURE__ */ React.createElement(Field, { label: "\u0423\u0433\u043E\u0432\u043E\u0440\u0435\u043D\u0430 \u0441\u0443\u043C\u0430" }, /* @__PURE__ */ React.createElement(
        NumberInput,
        {
          size: "lg",
          decimals: 2,
          min: 0,
          money: true,
          value: agreedPrice,
          onChange: (n) => {
            setAgreedTouched(true);
            setAgreedPrice(n || 0);
          },
          suffix: "\u20AC"
        }
      )), /* @__PURE__ */ React.createElement(Field, { label: `\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0430 (${dailyRate} \u20AC/\u0434\u0435\u043D \xD7 ${days})` }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: fmtEuro(suggestedPrice), readOnly: true }))), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 10 } }, /* @__PURE__ */ React.createElement(Field, { label: "\u0417\u0430\u0431\u0435\u043B\u0435\u0436\u043A\u0430 (\u043F\u043E \u0438\u0437\u0431\u043E\u0440)" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", value: note, onChange: (e) => setNote(e.target.value), placeholder: "\u043D\u0430\u043F\u0440. \u0438\u0441\u043A\u0430 \u0431\u0430\u0433\u0430\u0436\u043D\u0438\u043A, \u0432\u0437\u0435\u043C\u0430\u043D\u0435 \u043E\u0442 \u043F\u0430\u0440\u043A\u0438\u043D\u0433\u0430\u2026" }))), /* @__PURE__ */ React.createElement("div", { style: {
        marginTop: 14,
        padding: "8px 12px",
        background: T.bg2,
        border: `1px solid ${T.border}`,
        borderRadius: 8,
        fontSize: 11.5,
        color: T.text2,
        lineHeight: 1.5
      } }, /* @__PURE__ */ React.createElement(Icon, { name: "info", size: 12, color: T.text2, style: { verticalAlign: "middle", marginRight: 6 } }), "\u041D\u0435 \u0441\u0435 \u0441\u044A\u0431\u0438\u0440\u0430\u0442 \u0434\u0435\u043F\u043E\u0437\u0438\u0442 \u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u0432 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u2014 \u0442\u043E\u0432\u0430 \u0441\u0442\u0430\u0432\u0430 \u043D\u0430 \u043C\u044F\u0441\u0442\u043E \u043F\u0440\u0438 \u043F\u0440\u0438\u0441\u0442\u0438\u0433\u0430\u043D\u0435 \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430, \u0447\u0440\u0435\u0437 ", /* @__PURE__ */ React.createElement("strong", { style: { color: T.text1 } }, "Start handover"), ".")),
      /* @__PURE__ */ React.createElement("div", { style: {
        padding: "12px 20px",
        borderTop: `1px solid ${T.border}`,
        display: "flex",
        gap: 10,
        alignItems: "center",
        flexWrap: "wrap"
      } }, !vehicleId && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2, flexBasis: "100%" } }, "Add a vehicle to the fleet before creating a reservation."), isEdit && /* @__PURE__ */ React.createElement(
        Button,
        {
          kind: "outline",
          size: "md",
          icon: "trash",
          danger: true,
          onClick: () => setConfirmingCancel(true)
        },
        "\u041E\u0442\u043C\u0435\u043D\u0438 \u0440\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F\u0442\u0430"
      ), showStartHandoverNow && /* @__PURE__ */ React.createElement(
        Button,
        {
          kind: "outline",
          size: "md",
          icon: "key",
          onClick: () => onStartHandoverNow(rental)
        },
        "Start handover \u0441\u0435\u0433\u0430"
      ), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }), /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "md", onClick: onClose }, "\u041E\u0442\u043A\u0430\u0437"), /* @__PURE__ */ React.createElement(
        Button,
        {
          kind: "primary",
          size: "md",
          icon: "check",
          disabled: !canSave,
          onClick: save
        },
        isEdit ? "\u0417\u0430\u043F\u0430\u0437\u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435" : "\u0421\u044A\u0437\u0434\u0430\u0439 \u0440\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F"
      )),
      confirmingCancel && /* @__PURE__ */ React.createElement(
        ConfirmSheet,
        {
          title: "\u041E\u0442\u043C\u0435\u043D\u0438 \u0440\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F\u0442\u0430?",
          body: `\u0420\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F ${rental.contractNo || ""} \u043D\u0430 ${rental.reservationName || "\u043A\u043B\u0438\u0435\u043D\u0442"} \u0449\u0435 \u0431\u044A\u0434\u0435 \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u0430 \u0438 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044A\u0442 \u0449\u0435 \u0431\u044A\u0434\u0435 \u043E\u0441\u0432\u043E\u0431\u043E\u0434\u0435\u043D.`,
          confirmLabel: "\u041E\u0442\u043C\u0435\u043D\u0438",
          confirmTone: "danger",
          onConfirm: () => {
            setConfirmingCancel(false);
            cancelReservation();
          },
          onCancel: () => setConfirmingCancel(false)
        }
      )
    )
  );
}
function VehiclePicker({ value, onChange, startAt, endAt, excludeRentalId }) {
  const items = VEHICLES;
  if (items.length === 0) {
    return /* @__PURE__ */ React.createElement("div", { style: {
      padding: "10px 12px",
      background: T.bg2,
      border: `1px solid ${T.border}`,
      borderRadius: 10,
      fontSize: 12,
      color: T.text2
    } }, "No vehicles in the fleet yet. Add a vehicle from the Fleet screen first.");
  }
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 6 } }, items.map((v) => {
    const conflict = window.checkVehicleConflict ? window.checkVehicleConflict(v.id, startAt, endAt, excludeRentalId) : null;
    const svcBlocked = v.status === "in_service" || v.status === "cleaning" || v.status === "inactive";
    const disabled = svcBlocked;
    const selected = v.id === value;
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: v.id,
        onClick: () => !disabled && onChange(v.id),
        disabled,
        style: {
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 12px",
          background: selected ? T.accentTint : T.bg2,
          border: `1px solid ${selected ? T.accent : T.border}`,
          borderRadius: 10,
          opacity: disabled ? 0.4 : 1,
          cursor: disabled ? "not-allowed" : "pointer",
          textAlign: "left"
        }
      },
      /* @__PURE__ */ React.createElement(VanGlyph, { size: 32, drivetrain: v.drivetrain }),
      /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 700 } }, v.make, " ", v.model), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 11, color: T.text2 } }, v.plate, " \xB7 ", v.dailyRate, " \u20AC/\u0434\u0435\u043D")),
      svcBlocked ? /* @__PURE__ */ React.createElement(Chip, { tone: "gray", size: "sm" }, STATUS_COLORS[v.status].label) : conflict ? /* @__PURE__ */ React.createElement(Chip, { tone: "red", size: "sm", icon: "warn" }, conflict.kind === "buffer" ? "Buffer" : "Booked") : /* @__PURE__ */ React.createElement(Chip, { tone: "green", size: "sm" }, "Available")
    );
  }));
}
function ConflictBanner({ conflict }) {
  const rental = conflict.rental;
  const otherName = rental.reservationName || (window.store.findCustomer(rental.customerId) || {}).name || "\u0434\u0440\u0443\u0433 \u043D\u0430\u0435\u043C";
  return /* @__PURE__ */ React.createElement("div", { style: {
    padding: "10px 12px",
    marginBottom: 12,
    background: T.redTint,
    border: "1px solid rgba(239,68,68,0.35)",
    borderRadius: 8,
    display: "flex",
    gap: 10,
    alignItems: "flex-start"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "warn", size: 16, color: T.red, style: { marginTop: 2, flexShrink: 0 } }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text1, lineHeight: 1.5 } }, /* @__PURE__ */ React.createElement("strong", { style: { color: "#FCA5A5" } }, conflict.kind === "buffer" ? "Buffer \u043A\u043E\u043D\u0444\u043B\u0438\u043A\u0442" : "\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044A\u0442 \u0435 \u0437\u0430\u0435\u0442", " \u0441 ", rental.contractNo || "\u043D\u0430\u0435\u043C"), " ", "(", otherName, ") \u2014 ", fmtDateBG(rental.start), " \u0434\u043E ", fmtDateBG(rental.end), ". \u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0434\u0440\u0443\u0433\u0430 \u0434\u0430\u0442\u0430 \u0438\u043B\u0438 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B."));
}
Object.assign(window, { QuickReservationPanel });

/* ══════════ components/kiosk.jsx ══════════ */
function KioskMode({ step, state, onComplete, onCancel }) {
  const [scrolledToBottom, setScrolledToBottom] = useState(false);
  const [confirmChecked, setConfirmChecked] = useState(false);
  const [signature, setSignature] = useState(null);
  const config = {
    gdpr: {
      title: "\u0421\u044A\u0433\u043B\u0430\u0441\u0438\u0435 \u0437\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043D\u0430 \u043B\u0438\u0447\u043D\u0438 \u0434\u0430\u043D\u043D\u0438",
      subtitle: "\u0420\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442 (\u0415\u0421) 2016/679 (GDPR) \xB7 \u0417\u0430\u043A\u043E\u043D \u0437\u0430 \u0437\u0430\u0449\u0438\u0442\u0430 \u043D\u0430 \u043B\u0438\u0447\u043D\u0438\u0442\u0435 \u0434\u0430\u043D\u043D\u0438",
      body: /* @__PURE__ */ React.createElement(GDPRText, null),
      confirmLabel: "\u041F\u0440\u043E\u0447\u0435\u0442\u043E\u0445 \u0438 \u0441\u0435 \u0441\u044A\u0433\u043B\u0430\u0441\u044F\u0432\u0430\u043C \u0441 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u0442\u0430 \u043D\u0430 \u043C\u043E\u0438\u0442\u0435 \u043B\u0438\u0447\u043D\u0438 \u0434\u0430\u043D\u043D\u0438 \u0441\u044A\u0433\u043B\u0430\u0441\u043D\u043E \u043F\u043E\u0441\u043E\u0447\u0435\u043D\u0438\u0442\u0435 \u0446\u0435\u043B\u0438.",
      signLabel: "\u041F\u043E\u0434\u043F\u0438\u0441 \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430"
    },
    declaration: {
      title: "\u0414\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0438\u044F \u2014 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u043D\u0430\u0435\u043C\u0430\u043D\u0435",
      subtitle: "\u0414\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0438\u044F \u043E\u0442\u043D\u043E\u0441\u043D\u043E \u0432\u0430\u043B\u0438\u0434\u043D\u043E\u0441\u0442 \u043D\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438\u0442\u0435 \u0437\u0430 \u0441\u0430\u043C\u043E\u043B\u0438\u0447\u043D\u043E\u0441\u0442",
      body: /* @__PURE__ */ React.createElement(DeclarationText, null),
      confirmLabel: "\u0414\u0435\u043A\u043B\u0430\u0440\u0438\u0440\u0430\u043C \u0432\u0435\u0440\u043D\u043E\u0441\u0442\u0442\u0430 \u043D\u0430 \u043F\u043E\u0441\u043E\u0447\u0435\u043D\u0438\u0442\u0435 \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u0441\u0442\u0432\u0430.",
      signLabel: "\u041F\u043E\u0434\u043F\u0438\u0441 \u043D\u0430 \u0434\u0435\u043A\u043B\u0430\u0440\u0430\u0442\u043E\u0440\u0430"
    },
    contract: {
      title: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u0437\u0430 \u043D\u0430\u0435\u043C \u043D\u0430 \u041C\u041F\u0421",
      subtitle: `\u2116 ${state && state.contractNo || "148/2026"} \xB7 ${fmtDateBG(TODAY, { withYearSuffix: true })}`,
      body: /* @__PURE__ */ React.createElement(ContractText, { state }),
      confirmLabel: "\u0417\u0430\u043F\u043E\u0437\u043D\u0430\u0442 \u0441\u044A\u043C \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0442\u0430, \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u0445 \u043F\u0440\u0438\u0435\u043C\u043E-\u043F\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u0435\u043B\u043D\u0438\u044F \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B \u0438 \u0441\u043D\u0438\u043C\u043A\u0438\u0442\u0435.",
      signLabel: "\u041D\u0430\u0435\u043C\u0430\u0442\u0435\u043B"
    },
    // v28 — bilateral return protocol: customer kiosk ink at return
    // finalization (same mechanism as handover). state carries the
    // return summary assembled by settlement.jsx.
    return_protocol: {
      title: "\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u043D\u0430 \u041C\u041F\u0421",
      subtitle: `\u041A\u044A\u043C \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u2116 ${state && state.contractNo || ""} \xB7 ${fmtDateBG(TODAY, { withYearSuffix: true })}`,
      body: /* @__PURE__ */ React.createElement(ReturnProtocolText, { state }),
      confirmLabel: "\u0417\u0430\u043F\u043E\u0437\u043D\u0430\u0442 \u0441\u044A\u043C \u0441 \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u0430 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u0438 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0430\u0432\u0430\u043C \u043F\u043E\u0441\u043E\u0447\u0435\u043D\u0438\u0442\u0435 \u0434\u0430\u043D\u043D\u0438.",
      signLabel: "\u041D\u0430\u0435\u043C\u0430\u0442\u0435\u043B"
    }
  }[step];
  const canSubmit = confirmChecked && signature && scrolledToBottom;
  const handleScroll = (e) => {
    const el = e.target;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 40) {
      setScrolledToBottom(true);
    }
  };
  return /* @__PURE__ */ React.createElement("div", { "data-kiosk": "1", "data-kiosk-step": step, "data-screen-label": "Customer kiosk", className: "kiosk", style: {
    position: "absolute",
    inset: 0,
    background: "#F7F6F2",
    color: T.kioskInk,
    display: "flex",
    flexDirection: "column",
    zIndex: 200
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    background: "#0F1420",
    color: "#F7F6F2",
    padding: "14px 24px",
    display: "flex",
    alignItems: "center",
    gap: 14,
    flexShrink: 0
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 34,
    height: 34,
    borderRadius: 6,
    background: T.accent,
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 800,
    fontSize: 16
  } }, "b."), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 700, fontSize: 14 } }, window.store && window.store.companySettings && window.store.companySettings().brand || COMPANY.brand), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, opacity: 0.7 } }, "\u201E", window.store && window.store.companySettings && window.store.companySettings().legal || COMPANY.legal, '" \xB7 \u0415\u0418\u041A ', window.store && window.store.companySettings && window.store.companySettings().eik || COMPANY.eik)), /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "6px 12px",
    background: "rgba(255,255,255,0.08)",
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: 0.4,
    textTransform: "uppercase"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "eye", size: 13 }), " \u041A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u0438 \u043F\u0440\u0435\u0433\u043B\u0435\u0434")), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, display: "flex", flexDirection: "column", minHeight: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { padding: "28px 40px 12px", textAlign: "center", flexShrink: 0 } }, /* @__PURE__ */ React.createElement("div", { className: "serif", style: { fontSize: 28, fontWeight: 700, letterSpacing: -0.5, color: T.kioskInk, fontFamily: "var(--font-serif)" } }, config.title), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.kioskInkSoft, marginTop: 6, fontFamily: "var(--font-serif)", fontStyle: "italic" } }, config.subtitle)), /* @__PURE__ */ React.createElement(
    "div",
    {
      onScroll: handleScroll,
      style: {
        flex: 1,
        padding: "20px 40px 20px",
        overflowY: "auto",
        fontFamily: "var(--font-serif)",
        fontSize: 14.5,
        lineHeight: 1.6,
        color: "#1F2733"
      }
    },
    config.body
  ), /* @__PURE__ */ React.createElement("div", { style: {
    borderTop: `1px solid ${T.kioskBorder}`,
    padding: "18px 32px",
    background: "#F0EEE7",
    flexShrink: 0
  } }, !scrolledToBottom && /* @__PURE__ */ React.createElement("div", { style: {
    padding: "10px 14px",
    background: "#FEF3C7",
    border: "1px solid #F5A524",
    borderRadius: 8,
    color: "#78350F",
    fontSize: 13,
    marginBottom: 14,
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontFamily: "var(--font-ui)",
    fontWeight: 600
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "chevronD", size: 16, color: "#78350F" }), " \u041C\u043E\u043B\u044F, \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u0439\u0442\u0435 \u0446\u0435\u043B\u0438\u044F \u0442\u0435\u043A\u0441\u0442, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435."), /* @__PURE__ */ React.createElement("label", { style: {
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
    padding: "10px 0",
    cursor: "pointer",
    fontFamily: "var(--font-ui)"
  } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: confirmChecked,
      onChange: (e) => setConfirmChecked(e.target.checked),
      disabled: !scrolledToBottom,
      style: { width: 24, height: 24, accentColor: T.accent, marginTop: 1, flexShrink: 0 }
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, color: T.kioskInk, fontWeight: 500 } }, config.confirmLabel)), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, fontWeight: 700, color: T.kioskInkSoft, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8, fontFamily: "var(--font-ui)" } }, config.signLabel), /* @__PURE__ */ React.createElement(SignaturePad, { value: signature, onChange: setSignature })), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 12, marginTop: 16 } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: onCancel,
      style: {
        padding: "14px 24px",
        background: "transparent",
        border: `1px solid ${T.kioskBorder}`,
        borderRadius: 10,
        fontSize: 14,
        fontWeight: 600,
        color: T.kioskInkSoft,
        fontFamily: "var(--font-ui)"
      }
    },
    "\u041E\u0442\u043A\u0430\u0437"
  ), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }), /* @__PURE__ */ React.createElement(
    "button",
    {
      disabled: !canSubmit,
      onClick: () => onComplete && onComplete({ signatureDataUrl: signature, signedAt: (/* @__PURE__ */ new Date()).toISOString() }),
      style: {
        padding: "14px 32px",
        background: canSubmit ? T.accent : "#CFD3DA",
        color: "#fff",
        border: "none",
        borderRadius: 10,
        fontSize: 15,
        fontWeight: 700,
        cursor: canSubmit ? "pointer" : "not-allowed",
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
        fontFamily: "var(--font-ui)"
      }
    },
    "\u041F\u043E\u0434\u043F\u0438\u0448\u0438 \u0438 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438",
    /* @__PURE__ */ React.createElement(Icon, { name: "arrowRight", size: 18, color: "#fff", strokeWidth: 2 })
  )))));
}
function SignaturePad({ value, onChange }) {
  const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [hasSignature, setHasSignature] = useState(false);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const dpr = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
    const ctx = canvas.getContext("2d");
    ctx.scale(dpr, dpr);
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#0F1420";
  }, []);
  const getPos = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    if (e.touches) {
      return { x: e.touches[0].clientX - rect.left, y: e.touches[0].clientY - rect.top };
    }
    return { x: e.clientX - rect.left, y: e.clientY - rect.top };
  };
  const start = (e) => {
    e.preventDefault();
    setDrawing(true);
    const { x, y } = getPos(e);
    const ctx = canvasRef.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(x, y);
  };
  const emitDataUrl = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    try {
      const url = canvas.toDataURL("image/png");
      onChange && onChange(url);
    } catch (err) {
      onChange && onChange(true);
    }
  };
  const move = (e) => {
    if (!drawing) return;
    e.preventDefault();
    const { x, y } = getPos(e);
    const ctx = canvasRef.current.getContext("2d");
    ctx.lineTo(x, y);
    ctx.stroke();
    if (!hasSignature) setHasSignature(true);
  };
  const end = () => {
    if (drawing) emitDataUrl();
    setDrawing(false);
  };
  const clear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    setHasSignature(false);
    onChange && onChange(null);
  };
  return /* @__PURE__ */ React.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React.createElement(
    "canvas",
    {
      ref: canvasRef,
      className: "sigpad",
      style: {
        width: "100%",
        height: 130,
        background: "#fff",
        border: `1.5px dashed ${T.kioskBorder}`,
        borderRadius: 10,
        touchAction: "none"
      },
      onMouseDown: start,
      onMouseMove: move,
      onMouseUp: end,
      onMouseLeave: end,
      onTouchStart: start,
      onTouchMove: move,
      onTouchEnd: end
    }
  ), !hasSignature && /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    color: T.kioskInkSoft,
    fontSize: 15,
    fontFamily: "var(--font-serif)",
    fontStyle: "italic"
  } }, "\u270D \u041F\u043E\u0434\u043F\u0438\u0448\u0435\u0442\u0435 \u0442\u0443\u043A"), /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    bottom: 8,
    right: 12,
    display: "flex",
    gap: 8,
    alignItems: "center"
  } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.kioskInkSoft, fontFamily: "var(--font-ui)" } }, fmtDateTimeBG(TODAY)), /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: clear,
      style: {
        padding: "4px 10px",
        fontSize: 11,
        fontWeight: 600,
        border: `1px solid ${T.kioskBorder}`,
        borderRadius: 6,
        background: "#fff",
        color: T.kioskInkSoft,
        fontFamily: "var(--font-ui)"
      }
    },
    "\u0418\u0437\u0447\u0438\u0441\u0442\u0438"
  )));
}
function LegalBody({ text }) {
  if (!text) return null;
  const paras = text.split(/\n{2,}/);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, paras.map((p, i) => /* @__PURE__ */ React.createElement("p", { key: i, style: { marginBottom: 12 } }, p)));
}
function ReturnProtocolText({ state }) {
  const s = state || {};
  const row = (label, value) => /* @__PURE__ */ React.createElement("p", { style: { display: "flex", justifyContent: "space-between", gap: 16, margin: "8px 0", fontSize: 14 } }, /* @__PURE__ */ React.createElement("span", null, label), /* @__PURE__ */ React.createElement("strong", null, value));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", { style: { textAlign: "center", fontSize: 16, marginBottom: 20 } }, /* @__PURE__ */ React.createElement("strong", null, "\u041F\u0420\u041E\u0422\u041E\u041A\u041E\u041B \u0417\u0410 \u0412\u0420\u042A\u0429\u0410\u041D\u0415 \u041D\u0410 \u041C\u041F\u0421")), row("\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B", s.vehicleLabel || "\u2014"), row("\u041A\u0438\u043B\u043E\u043C\u0435\u0442\u0440\u0430\u0436 \u043F\u0440\u0438 \u0432\u0440\u044A\u0449\u0430\u043D\u0435", s.returnOdo != null ? fmtKm(s.returnOdo) : "\u2014"), row(s.isElectric ? "\u0411\u0430\u0442\u0435\u0440\u0438\u044F \u043F\u0440\u0438 \u0432\u0440\u044A\u0449\u0430\u043D\u0435" : "\u0413\u043E\u0440\u0438\u0432\u043E \u043F\u0440\u0438 \u0432\u0440\u044A\u0449\u0430\u043D\u0435", s.returnFuel != null ? s.returnFuel + "%" : "\u2014"), row("\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044A\u0442 \u0435 \u0432\u044A\u0440\u043D\u0430\u0442 \u043F\u043E\u0447\u0438\u0441\u0442\u0435\u043D", s.returnClean === false ? "\u043D\u0435" : "\u0434\u0430"), row("\u0414\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u043D\u0438 \u0442\u0430\u043A\u0441\u0438", s.extraTotalLabel || "\u2014"), row("\u0414\u0435\u043F\u043E\u0437\u0438\u0442", s.depositLabel || "\u2014"), /* @__PURE__ */ React.createElement("p", { style: { marginTop: 24, color: T.kioskInkSoft, fontStyle: "italic", fontSize: 13 } }, "\u0421 \u043F\u043E\u0434\u043F\u0438\u0441\u0430 \u0441\u0438 \u043D\u0430\u0435\u043C\u0430\u0442\u0435\u043B\u044F\u0442 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0430\u0432\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0430 \u0432 \u043E\u043F\u0438\u0441\u0430\u043D\u043E\u0442\u043E \u0441\u044A\u0441\u0442\u043E\u044F\u043D\u0438\u0435. \u0414\u0430\u0442\u0430: ", fmtDateBG(TODAY, { withYearSuffix: true })));
}
function GDPRText() {
  window.store && window.store.useStore();
  const text = window.store && window.store.legalTexts && window.store.legalTexts().gdpr || "";
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(LegalBody, { text }), /* @__PURE__ */ React.createElement("p", { style: { marginTop: 24, color: T.kioskInkSoft, fontSize: 12, fontStyle: "italic" } }, "\u0414\u0430\u0442\u0430: ", fmtDateBG(TODAY, { withYearSuffix: true }), " \xB7 \u041C\u044F\u0441\u0442\u043E: \u0433\u0440. \u0421\u043E\u0444\u0438\u044F"));
}
function DeclarationText() {
  window.store && window.store.useStore();
  const text = window.store && window.store.legalTexts && window.store.legalTexts().declaration || "";
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", { style: { textAlign: "center", fontSize: 16, marginBottom: 20 } }, /* @__PURE__ */ React.createElement("strong", null, "\u0414\u0415\u041A\u041B\u0410\u0420\u0410\u0426\u0418\u042F")), /* @__PURE__ */ React.createElement(LegalBody, { text }), /* @__PURE__ */ React.createElement("p", { style: { marginTop: 24, color: T.kioskInkSoft, fontStyle: "italic", fontSize: 13 } }, "\u0414\u0430\u0442\u0430: ", fmtDateBG(TODAY, { withYearSuffix: true }), " \xB7 \u041C\u044F\u0441\u0442\u043E: \u0433\u0440. \u0421\u043E\u0444\u0438\u044F"));
}
function ContractText({ state }) {
  const c = state && state.customer || CUSTOMERS[0];
  const v = state && state.vehicle || VEHICLES[0];
  const startAt = state && state.startAt || d(0, 10, 0);
  const endAt = state && state.endAt || d(3, 18, 0);
  const days = daysBetween(startAt, endAt);
  const total = (state && state.dailyRate || v.dailyRate) * days;
  const dep = state && state.deposit || 200;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", { style: { textAlign: "center", fontWeight: 700, fontSize: 15, marginBottom: 20 } }, "\u0414\u043D\u0435\u0441, ", fmtDateBG(TODAY, { withYearSuffix: true }), " \u0432 \u0433\u0440. \u0421\u043E\u0444\u0438\u044F, \u043C\u0435\u0436\u0434\u0443:"), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("strong", null, "\u041D\u0430\u0435\u043C\u043E\u0434\u0430\u0442\u0435\u043B:"), " \u201E", window.store && window.store.companySettings().legal || COMPANY.legal, '", \u0415\u0418\u041A ', window.store && window.store.companySettings().eik || COMPANY.eik, window.store && window.store.companySettings().vatId ? ", \u0414\u0414\u0421 \u2116 " + window.store.companySettings().vatId : "", ", \u0441\u0435\u0434\u0430\u043B\u0438\u0449\u0435 ", window.store && window.store.companySettings().address || COMPANY.address, ", \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u0432\u0430\u043D\u043E \u043E\u0442 ", window.store && window.store.operatorProfile().name || "\u0423\u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B", " \u2014 ", (window.store && window.store.operatorProfile().role || "\u0443\u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B").toLowerCase(), ', \u043D\u0430\u0440\u0438\u0447\u0430\u043D \u043F\u043E-\u0434\u043E\u043B\u0443 \u0437\u0430 \u043A\u0440\u0430\u0442\u043A\u043E\u0441\u0442 \u201E\u041D\u0410\u0415\u041C\u041E\u0414\u0410\u0422\u0415\u041B",'), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("strong", null, "\u0438")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("strong", null, "\u041D\u0430\u0435\u043C\u0430\u0442\u0435\u043B:"), " ", c.name, ", \u0415\u0413\u041D ", c.egn, ", \u041B\u041A \u2116 ", c.idCard.number, ", \u0432\u0430\u043B\u0438\u0434\u043D\u0430 \u0434\u043E ", fmtDateBG(c.idCard.expiry), ", \u0421\u0423\u041C\u041F\u0421 \u2116 ", c.driverLicense.number, ", \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F ", c.driverLicense.categories, ", \u0432\u0430\u043B\u0438\u0434\u043D\u043E \u0434\u043E ", fmtDateBG(c.driverLicense.expiry), ", \u0430\u0434\u0440\u0435\u0441: ", c.address, ', \u043D\u0430\u0440\u0438\u0447\u0430\u043D \u043F\u043E-\u0434\u043E\u043B\u0443 \u0437\u0430 \u043A\u0440\u0430\u0442\u043A\u043E\u0441\u0442 \u201E\u041D\u0410\u0415\u041C\u0410\u0422\u0415\u041B",'), /* @__PURE__ */ React.createElement("p", { style: { marginTop: 16 } }, "\u0441\u0435 \u0441\u043A\u043B\u044E\u0447\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u044F\u0442 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0437\u0430 \u0441\u043B\u0435\u0434\u043D\u043E\u0442\u043E:"), /* @__PURE__ */ React.createElement("p", { style: { marginTop: 20, fontWeight: 700 } }, "\u0427\u043B. 1. \u041F\u0440\u0435\u0434\u043C\u0435\u0442 \u043D\u0430 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430"), /* @__PURE__ */ React.createElement("p", null, "\u041D\u0430\u0435\u043C\u043E\u0434\u0430\u0442\u0435\u043B\u044F\u0442 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u044F \u0437\u0430 \u0432\u044A\u0437\u043C\u0435\u0437\u0434\u043D\u043E \u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0435, \u0430 \u041D\u0430\u0435\u043C\u0430\u0442\u0435\u043B\u044F\u0442 \u043F\u0440\u0438\u0435\u043C\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B ", /* @__PURE__ */ React.createElement("strong", null, v.make, " ", v.model), ", \u0440\u0435\u0433. \u2116 ", /* @__PURE__ */ React.createElement("strong", null, v.plate), ", VIN ", v.vin, ", \u0446\u0432\u044F\u0442 ", v.color, ", ", v.year, " \u0433."), /* @__PURE__ */ React.createElement("p", { style: { marginTop: 16, fontWeight: 700 } }, "\u0427\u043B. 2. \u0421\u0440\u043E\u043A"), /* @__PURE__ */ React.createElement("p", null, "\u041D\u0430\u0435\u043C\u044A\u0442 \u0441\u0435 \u0441\u043A\u043B\u044E\u0447\u0432\u0430 \u0437\u0430 \u0441\u0440\u043E\u043A \u043E\u0442 ", fmtDateTimeBG(startAt), " \u0447. \u0434\u043E ", fmtDateTimeBG(endAt), " \u0447., \u043E\u0431\u0449\u043E ", /* @__PURE__ */ React.createElement("strong", null, days, " \u0434\u0435\u043D\u043E\u043D\u043E\u0449\u0438\u044F"), "."), /* @__PURE__ */ React.createElement("p", { style: { marginTop: 16, fontWeight: 700 } }, "\u0427\u043B. 3. \u041D\u0430\u0435\u043C\u043D\u0430 \u0446\u0435\u043D\u0430 \u0438 \u0434\u0435\u043F\u043E\u0437\u0438\u0442"), /* @__PURE__ */ React.createElement("p", null, "\u0414\u043D\u0435\u0432\u043D\u0430 \u043D\u0430\u0435\u043C\u043D\u0430 \u0446\u0435\u043D\u0430: ", /* @__PURE__ */ React.createElement("strong", null, fmtEuro(state && state.dailyRate || v.dailyRate)), ". \u041E\u0431\u0449\u0430 \u043D\u0430\u0435\u043C\u043D\u0430 \u0446\u0435\u043D\u0430 \u0437\u0430 \u0441\u0440\u043E\u043A\u0430 \u043D\u0430 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430: ", /* @__PURE__ */ React.createElement("strong", null, fmtEuro(total)), ". \u0414\u0435\u043F\u043E\u0437\u0438\u0442: ", /* @__PURE__ */ React.createElement("strong", null, fmtEuro(dep)), ", \u043F\u043B\u0430\u0442\u0438\u043C \u0432 \u0431\u0440\u043E\u0439 \u043F\u0440\u0438 \u043F\u0440\u0435\u0434\u0430\u0432\u0430\u043D\u0435 \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0430."), /* @__PURE__ */ React.createElement("p", { style: { marginTop: 16, fontWeight: 700 } }, "\u0427\u043B. 4. \u0414\u043D\u0435\u0432\u0435\u043D \u043F\u0440\u043E\u0431\u0435\u0433"), /* @__PURE__ */ React.createElement("p", null, "\u0421\u0440\u0435\u0434\u043D\u0438\u044F\u0442 \u0434\u043D\u0435\u0432\u0435\u043D \u043F\u0440\u043E\u0431\u0435\u0433 \u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D \u0434\u043E ", /* @__PURE__ */ React.createElement("strong", null, state && state.kmPerDay || v.kmPerDay, " \u043A\u043C/\u0434\u0435\u043D"), ". \u0412\u0441\u0435\u043A\u0438 \u0434\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u0435\u043D \u043A\u0438\u043B\u043E\u043C\u0435\u0442\u044A\u0440 \u0441\u0435 \u0437\u0430\u043F\u043B\u0430\u0449\u0430 \u043F\u043E ", /* @__PURE__ */ React.createElement("strong", null, fmtEuro(state && state.extraKmPrice || v.extraKmPrice), "/\u043A\u043C"), "."), /* @__PURE__ */ React.createElement("p", { style: { marginTop: 16, fontWeight: 700 } }, "\u0427\u043B. 5. \u0417\u0430\u0434\u044A\u043B\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u041D\u0430\u0435\u043C\u0430\u0442\u0435\u043B\u044F"), /* @__PURE__ */ React.createElement("p", null, "\u041D\u0430\u0435\u043C\u0430\u0442\u0435\u043B\u044F\u0442 \u0441\u0435 \u0437\u0430\u0434\u044A\u043B\u0436\u0430\u0432\u0430 \u0434\u0430 \u043F\u043E\u043B\u0437\u0432\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0430 \u0441\u044A\u043E\u0431\u0440\u0430\u0437\u043D\u043E \u043F\u0440\u0435\u0434\u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0442\u043E \u043C\u0443, \u0434\u0430 \u0433\u043E \u043F\u043E\u0434\u0434\u044A\u0440\u0436\u0430 \u0432 \u0438\u0437\u043F\u0440\u0430\u0432\u043D\u043E \u0441\u044A\u0441\u0442\u043E\u044F\u043D\u0438\u0435, \u0434\u0430 \u043D\u0435 \u0433\u043E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u044F \u043D\u0430 \u0442\u0440\u0435\u0442\u0438 \u043B\u0438\u0446\u0430 \u0431\u0435\u0437 \u043F\u0438\u0441\u043C\u0435\u043D\u043E \u0441\u044A\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u041D\u0430\u0435\u043C\u043E\u0434\u0430\u0442\u0435\u043B\u044F, \u0434\u0430 \u0437\u0430\u043F\u043B\u0430\u0449\u0430 \u0433\u043B\u043E\u0431\u0438 \u0438 \u0442\u0430\u043A\u0441\u0438, \u043D\u0430\u043B\u043E\u0436\u0435\u043D\u0438 \u043F\u043E \u0432\u0440\u0435\u043C\u0435 \u043D\u0430 \u043D\u0430\u0435\u043C\u0430, \u0438 \u0434\u0430 \u0432\u044A\u0440\u043D\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0430 \u0432 \u043C\u044F\u0441\u0442\u043E\u0442\u043E \u0438 \u0447\u0430\u0441\u0430, \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438 \u0432 \u0447\u043B. 2."), /* @__PURE__ */ React.createElement("p", { style: { marginTop: 16, fontWeight: 700 } }, "\u0427\u043B. 6. \u041F\u0440\u0438\u0435\u043C\u043E-\u043F\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u0435\u043B\u0435\u043D \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B"), /* @__PURE__ */ React.createElement("p", null, "\u0421\u044A\u0441\u0442\u043E\u044F\u043D\u0438\u0435\u0442\u043E \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0430 \u043F\u0440\u0438 \u043F\u0440\u0435\u0434\u0430\u0432\u0430\u043D\u0435 \u0435 \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u0435\u043D\u043E \u0441 \u043F\u0440\u0438\u0435\u043C\u043E-\u043F\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u0435\u043B\u0435\u043D \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B \u0438 \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0441\u043A\u0438 \u0441\u043D\u0438\u043C\u043A\u0438, \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438 \u043A\u044A\u043C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u044F \u0434\u043E\u0433\u043E\u0432\u043E\u0440."), /* @__PURE__ */ React.createElement("p", { style: { marginTop: 24, padding: 14, background: "rgba(26,92,230,0.08)", border: "1px solid rgba(26,92,230,0.3)", borderRadius: 8, fontFamily: "var(--font-ui)", fontSize: 13 } }, /* @__PURE__ */ React.createElement("strong", null, "\u{1F4CE} \u041F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F (\u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u0439\u0442\u0435 \u043F\u0440\u0435\u0434\u0438 \u043F\u043E\u0434\u043F\u0438\u0441\u0432\u0430\u043D\u0435):"), /* @__PURE__ */ React.createElement("br", null), "\xB7 \u041F\u0440\u0438\u0435\u043C\u043E-\u043F\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u0435\u043B\u0435\u043D \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B (1 \u0441\u0442\u0440.)", /* @__PURE__ */ React.createElement("br", null), "\xB7 \u0421\u043D\u0438\u043C\u043A\u043E\u0432 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B \u2014 6 \u0437\u0430\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u043D\u0438 \u0441\u043D\u0438\u043C\u043A\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0430"), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 20, display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 } }, ["\u041E\u0442\u043F\u0440\u0435\u0434", "\u041E\u0442\u0437\u0430\u0434", "\u041B\u044F\u0432a \u0441\u0442\u0440\u0430\u043D\u0430", "\u0414\u044F\u0441\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0430", "\u041A\u0438\u043B\u043E\u043C\u0435\u0442\u0440\u0430\u0436", "\u0422\u043E\u0432\u0430\u0440\u0435\u043D \u043E\u0442\u0441\u0435\u043A"].map((label, i) => /* @__PURE__ */ React.createElement("div", { key: i, style: {
    aspectRatio: "4/3",
    border: `1px solid ${T.kioskBorder}`,
    borderRadius: 6,
    background: "#EEEBE1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 11,
    color: T.kioskInkSoft,
    fontFamily: "var(--font-ui)"
  } }, label))), /* @__PURE__ */ React.createElement("p", { style: { marginTop: 32, fontSize: 12, color: T.kioskInkSoft, fontStyle: "italic" } }, "\u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u044F\u0442 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0441\u0435 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u043E\u0442 \u0448\u0430\u0431\u043B\u043E\u043D, \u0437\u0430\u0440\u0435\u0434\u0435\u043D \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u0442\u0430 \u043D\u0430 \u043D\u0430\u0435\u043C\u043E\u0434\u0430\u0442\u0435\u043B\u044F. \u041F\u044A\u043B\u043D\u0438\u0442\u0435 ", 21, " placeholders \u0441\u0435 \u0437\u0430\u043C\u0435\u0441\u0442\u0432\u0430\u0442 \u043F\u0440\u0438 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435: ", "{{CUSTOMER_NAME}}, {{EGN}}, {{ID_NUMBER}}, {{VEHICLE_MAKE_MODEL}}, {{PLATE}}, {{DAILY_RATE}}, {{TOTAL_PRICE}}\u2026"));
}
Object.assign(window, { KioskMode, SignaturePad });

/* ══════════ components/settlement.jsx ══════════ */
var RETURN_PHOTO_SLOTS = [
  { key: "front", label: "Front" },
  { key: "rear", label: "Rear" },
  { key: "left", label: "Left side" },
  { key: "right", label: "Right side" },
  { key: "odometer", label: "Odometer" },
  { key: "cargo", label: "Cargo area" }
];
var SETTLEMENT_EQ_LABELS = {
  KEYS: "\u041A\u043B\u044E\u0447\u043E\u0432\u0435",
  REGISTRATION: "\u0422\u0430\u043B\u043E\u043D",
  TPL: "\u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u0430",
  VIGNETTE: "\u0412\u0438\u043D\u0435\u0442\u043A\u0430",
  FIRST_AID: "\u0410\u043F\u0442\u0435\u0447\u043A\u0430",
  TRIANGLE: "\u0422\u0440\u0438\u044A\u0433\u044A\u043B\u043D\u0438\u043A",
  VEST: "\u0416\u0438\u043B\u0435\u0442\u043A\u0430",
  EXTINGUISHER: "\u041F\u043E\u0436\u0430\u0440\u043E\u0433\u0430\u0441\u0438\u0442\u0435\u043B",
  JACK: "\u041A\u0440\u0438\u043A",
  SPARE: "\u0420\u0435\u0437\u0435\u0440\u0432\u043D\u0430 \u0433\u0443\u043C\u0430",
  MATS: "\u0421\u0442\u0435\u043B\u043A\u0438",
  CHARGING_CABLE: "\u041A\u0430\u0431\u0435\u043B \u0437\u0430 \u0437\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435",
  CHARGING_CARD: "\u041A\u0430\u0440\u0442\u0430 \u0437\u0430 \u0437\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435",
  STRAPS: "\u041A\u043E\u043B\u0430\u043D\u0438",
  OTHER: "\u0414\u0440\u0443\u0433\u043E"
};
function SettlementScreen({ isPhone, rental, onClose, onFinalize, onOpenKiosk }) {
  store.useStore();
  const r = rental || RENTALS.find((x) => x.id === "r2");
  const v = VEHICLES.find((x) => x.id === r.vehicleId);
  const c = CUSTOMERS.find((x) => x.id === r.customerId) || { name: r.reservationName || "\u2014", phone: r.reservationPhone || "" };
  const isElectric = v.drivetrain === "electric";
  const days = daysBetween(r.start, r.end);
  const allowedKm = r.kmPerDay * days;
  const [returnOdo, setReturnOdo] = useState(r.handoverOdo + 640);
  const [returnFuel, setReturnFuel] = useState(70);
  const [waivedKm, setWaivedKm] = useState(false);
  const [waivedFuel, setWaivedFuel] = useState(false);
  const [notes, setNotes] = useState("");
  const [depositAction, setDepositAction] = useState("return");
  const [returnPhotos, setReturnPhotos] = useState({});
  const [showCompare, setShowCompare] = useState(false);
  const [hasNewDamages, setHasNewDamages] = useState(false);
  const [damagePhotos, setDamagePhotos] = useState([]);
  const [returnClean, setReturnClean] = useState(true);
  const suggestedCleaningFee = window.store && window.store.operations && window.store.operations().cleaningFee != null ? window.store.operations().cleaningFee : 25;
  const [cleaningFee, setCleaningFee] = useState(suggestedCleaningFee);
  const [cleaningFeeWaived, setCleaningFeeWaived] = useState(false);
  const [returnSignature, setReturnSignature] = useState(null);
  const [returnSignedAt, setReturnSignedAt] = useState(null);
  const effectiveCleaningFee = returnClean === false && !cleaningFeeWaived ? cleaningFee || 0 : 0;
  const drivenKm = Math.max(0, returnOdo - r.handoverOdo);
  const overKm = Math.max(0, drivenKm - allowedKm);
  const extraKmCharge = waivedKm ? 0 : overKm * r.extraKmPrice;
  const fuelDiff = Math.max(0, r.handoverFuel - returnFuel);
  const fuelCharge = waivedFuel ? 0 : fuelDiff * v.fuelPerPercent;
  const returnPhotoCount = Object.values(returnPhotos).filter((p) => p && p.dataUrl).length;
  const extraTotal = extraKmCharge + fuelCharge + effectiveCleaningFee;
  const [withheldAmount, setWithheldAmount] = useState(Math.min(extraTotal, r.deposit));
  const depositReturn = depositAction === "return" ? r.deposit : depositAction === "withhold-partial" ? r.deposit - withheldAmount : 0;
  return /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    inset: 0,
    background: T.bg0,
    zIndex: 100,
    display: "flex",
    flexDirection: "column"
  } }, /* @__PURE__ */ React.createElement(
    TopBar,
    {
      title: "Return & Settlement",
      subtitle: `Contract ${r.contractNo} \xB7 ${c.name}`,
      right: /* @__PURE__ */ React.createElement(IconBtn, { icon: "x", onClick: onClose })
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "scroll-y", style: { flex: 1, padding: isPhone ? 16 : 24 } }, /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 14 : 18, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 14 } }, /* @__PURE__ */ React.createElement("div", { style: { background: T.bg2, padding: 8, borderRadius: 10 } }, /* @__PURE__ */ React.createElement(VanGlyph, { size: 60, drivetrain: v.drivetrain })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 16, fontWeight: 700 } }, v.make, " ", v.model), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 12, color: T.text2, marginTop: 3 } }, v.plate, " \xB7 VIN ", v.vin.slice(0, 12), "\u2026"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, marginTop: 8 } }, /* @__PURE__ */ React.createElement(Chip, { tone: "blue", size: "sm", icon: "clock" }, "Active \xB7 ", days, " days"), /* @__PURE__ */ React.createElement(Chip, { tone: "outline", size: "sm" }, "Rate ", fmtEuro(r.dailyRate, { dp: 0 }), "/day"))))), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: isPhone ? "1fr" : "1fr 1fr", gap: 16, marginBottom: 16 } }, /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 18 }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, marginBottom: 14 } }, /* @__PURE__ */ React.createElement(Icon, { name: "gauge", size: 20, color: T.accent }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 } }, "Odometer")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "flex-end", gap: 20, marginBottom: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, marginBottom: 4, textTransform: "uppercase", letterSpacing: 0.4, fontWeight: 600 } }, "Handover"), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 18, fontWeight: 600, color: T.text1 } }, fmtKm(r.handoverOdo))), /* @__PURE__ */ React.createElement(Icon, { name: "arrowRight", size: 18, color: T.text3, style: { marginBottom: 6 } }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, marginBottom: 4, textTransform: "uppercase", letterSpacing: 0.4, fontWeight: 600 } }, "Return"), /* @__PURE__ */ React.createElement(NumberInput, { size: "lg", decimals: 0, min: 0, value: returnOdo, onChange: (n) => setReturnOdo(n || 0), suffix: "\u043A\u043C" }))), /* @__PURE__ */ React.createElement("div", { style: { padding: "10px 12px", background: T.bg2, borderRadius: 8, marginTop: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", fontSize: 12.5 } }, /* @__PURE__ */ React.createElement("span", { style: { color: T.text2 } }, "Driven"), /* @__PURE__ */ React.createElement("span", { className: "mono tabular", style: { fontWeight: 700 } }, fmtKm(drivenKm))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", fontSize: 12.5, marginTop: 6 } }, /* @__PURE__ */ React.createElement("span", { style: { color: T.text2 } }, "Allowed (", r.kmPerDay, " \xD7 ", days, ")"), /* @__PURE__ */ React.createElement("span", { className: "mono tabular" }, fmtKm(allowedKm))), /* @__PURE__ */ React.createElement("div", { style: { height: 1, background: T.border, margin: "8px 0" } }), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", fontSize: 13 } }, /* @__PURE__ */ React.createElement("span", { style: { color: overKm > 0 ? T.yellow : T.green, fontWeight: 600 } }, overKm > 0 ? "Over limit" : "Within limit"), /* @__PURE__ */ React.createElement("span", { className: "mono tabular", style: { fontWeight: 700, color: overKm > 0 ? "#FBBF24" : "#86EFAC" } }, overKm > 0 ? "+" + fmtKm(overKm) : "\u2014")))), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 18 }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, marginBottom: 14 } }, /* @__PURE__ */ React.createElement(Icon, { name: isElectric ? "battery" : "fuel", size: 20, color: T.accent }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 } }, isElectric ? "Battery" : "Fuel level")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "flex-end", gap: 20, marginBottom: 14 } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, marginBottom: 4, textTransform: "uppercase", letterSpacing: 0.4, fontWeight: 600 } }, "Handover"), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 22, fontWeight: 700, color: T.text1 } }, r.handoverFuel, "%")), /* @__PURE__ */ React.createElement(Icon, { name: "arrowRight", size: 18, color: T.text3, style: { marginBottom: 6 } }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, marginBottom: 4, textTransform: "uppercase", letterSpacing: 0.4, fontWeight: 600 } }, "Return"), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 22, fontWeight: 700 } }, returnFuel, "%"))), /* @__PURE__ */ React.createElement(FuelBar, { level: returnFuel, isElectric }), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 6, marginTop: 12 } }, [0, 25, 50, 75, 100].map((n) => /* @__PURE__ */ React.createElement(Button, { key: n, kind: returnFuel === n ? "primary" : "outline", size: "sm", onClick: () => setReturnFuel(n) }, n, "%"))), fuelDiff > 0 && /* @__PURE__ */ React.createElement("div", { style: { padding: "8px 12px", background: T.yellowTint, borderRadius: 8, marginTop: 12, fontSize: 12.5, color: "#FBBF24" } }, "Missing ", fuelDiff, "% \xD7 ", fmtEuro(v.fuelPerPercent, { dp: 2 }), "/% = ", /* @__PURE__ */ React.createElement("strong", null, fmtEuro(fuelCharge))))), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 14 } }, "Settlement breakdown"), /* @__PURE__ */ React.createElement(
    BreakdownRow,
    {
      label: `Rent \xB7 ${fmtEuro(r.dailyRate, { dp: 0 })} \xD7 ${days} days`,
      amount: r.total,
      paid: true
    }
  ), /* @__PURE__ */ React.createElement(
    BreakdownRow,
    {
      label: `Extra km \xB7 ${overKm} \u043A\u043C \xD7 ${fmtEuro(r.extraKmPrice, { dp: 2 })}`,
      amount: extraKmCharge,
      editable: true,
      waived: waivedKm,
      onWaive: () => setWaivedKm(!waivedKm),
      hidden: overKm === 0
    }
  ), /* @__PURE__ */ React.createElement(
    BreakdownRow,
    {
      label: `Missing ${isElectric ? "charge" : "fuel"} \xB7 ${fuelDiff}% \xD7 ${fmtEuro(v.fuelPerPercent, { dp: 2 })}/%`,
      amount: fuelCharge,
      editable: true,
      waived: waivedFuel,
      onWaive: () => setWaivedFuel(!waivedFuel),
      hidden: fuelDiff === 0
    }
  ), /* @__PURE__ */ React.createElement(
    BreakdownRow,
    {
      label: "\u0422\u0430\u043A\u0441\u0430 \u043F\u043E\u0447\u0438\u0441\u0442\u0432\u0430\u043D\u0435 (\u0432\u044A\u0440\u043D\u0430\u0442 \u043D\u0435\u043F\u043E\u0447\u0438\u0441\u0442\u0435\u043D)",
      amount: cleaningFee || 0,
      editable: true,
      waived: cleaningFeeWaived,
      onWaive: () => setCleaningFeeWaived(!cleaningFeeWaived),
      hidden: returnClean !== false
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { height: 1, background: T.border, margin: "12px 0" } }), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "baseline" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700 } }, "Additional charges"), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 20, fontWeight: 800, color: extraTotal > 0 ? "#FBBF24" : T.text1 } }, extraTotal > 0 ? fmtEuro(extraTotal) : "\u2014 \u20AC"))), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 14 } }, "Deposit (", fmtEuro(r.deposit), " held)"), hasNewDamages && /* @__PURE__ */ React.createElement("div", { style: { padding: "10px 12px", borderRadius: 8, background: T.yellowTint, border: `1px solid ${T.yellow}`, color: T.yellow, fontSize: 13, fontWeight: 600, marginBottom: 12 } }, "\u0418\u043C\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0430\u043D\u0438 \u0449\u0435\u0442\u0438 \u2014 \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u0439 \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u0430"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: isPhone ? "1fr" : "repeat(3, 1fr)", gap: 10, marginBottom: 12 } }, [
    { v: "return", label: "Return in full", tone: "green" },
    { v: "withhold-partial", label: "Withhold partial", tone: "yellow" },
    { v: "withhold-full", label: "Withhold full", tone: "red" }
  ].map((o) => /* @__PURE__ */ React.createElement("button", { key: o.v, onClick: () => setDepositAction(o.v), style: {
    padding: "14px",
    borderRadius: 10,
    background: depositAction === o.v ? T[o.tone + "Tint"] : T.bg2,
    border: `1px solid ${depositAction === o.v ? T[o.tone] : T.border}`,
    color: depositAction === o.v ? T[o.tone] : T.text1,
    fontWeight: 600,
    fontSize: 13
  } }, o.label))), depositAction === "withhold-partial" && /* @__PURE__ */ React.createElement(Field, { label: "Amount to withhold" }, /* @__PURE__ */ React.createElement(NumberInput, { decimals: 2, min: 0, money: true, value: withheldAmount, onChange: (n) => setWithheldAmount(n || 0), suffix: "\u20AC" })), (depositAction === "withhold-partial" || depositAction === "withhold-full") && /* @__PURE__ */ React.createElement(Field, { label: "Reason for withholding", style: { marginTop: 12 } }, /* @__PURE__ */ React.createElement(Textarea, { rows: 2, value: notes, onChange: (e) => setNotes(e.target.value), placeholder: "\u041E\u0431\u043E\u0441\u043D\u043E\u0432\u043A\u0430 \u0437\u0430 \u0437\u0430\u0434\u044A\u0440\u0436\u0430\u043D\u0435 \u043D\u0430 \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u0430\u2026" }))), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 18 : 24, tone: "raised", style: { borderColor: T.accent } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { color: T.text1, fontSize: 14 } }, "Deposit to return"), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 16, fontWeight: 600 } }, fmtEuro(depositReturn))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { color: T.text1, fontSize: 14 } }, "Extra charges due"), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 16, fontWeight: 600, color: "#FBBF24" } }, fmtEuro(extraTotal))), /* @__PURE__ */ React.createElement("div", { style: { height: 1, background: T.border, margin: "14px 0" } }), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "baseline" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700 } }, extraTotal - depositReturn >= 0 ? "Customer pays" : "Refund to customer"), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 26, fontWeight: 800 } }, fmtEuro(Math.abs(extraTotal - depositReturn))))), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, marginBottom: 12 } }, /* @__PURE__ */ React.createElement(Icon, { name: "camera", size: 20, color: T.accent }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, flex: 1 } }, "Return photos"), /* @__PURE__ */ React.createElement(Chip, { tone: returnPhotoCount === 6 ? "green" : "yellow", size: "sm" }, returnPhotoCount, "/6"), returnPhotoCount > 0 && /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "sm", icon: "eye", onClick: () => setShowCompare(true) }, "Compare")), /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: isPhone ? "1fr 1fr" : "repeat(3, 1fr)",
    gap: 10
  } }, RETURN_PHOTO_SLOTS.map((slot) => {
    const rec = returnPhotos[slot.key];
    const filled = !!(rec && rec.dataUrl);
    return /* @__PURE__ */ React.createElement("div", { key: slot.key, style: { position: "relative" } }, /* @__PURE__ */ React.createElement(
      CaptureTrigger,
      {
        contractNo: r.contractNo,
        slotLabel: slot.label + " (\u0432\u0440\u044A\u0449\u0430\u043D\u0435)",
        onCapture: (record) => setReturnPhotos((p) => ({ ...p, [slot.key]: record })),
        block: true
      },
      ({ busy }) => /* @__PURE__ */ React.createElement("div", { style: {
        aspectRatio: "4 / 3",
        borderRadius: 10,
        border: `2px solid ${filled ? T.green : T.border}`,
        background: filled ? "rgba(34,197,94,0.08)" : T.bg2,
        padding: filled ? 0 : 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: T.text1,
        position: "relative",
        overflow: "hidden"
      } }, busy ? /* @__PURE__ */ React.createElement(Icon, { name: "refresh", size: 18, color: T.text2 }) : filled ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("img", { src: rec.dataUrl, alt: slot.label, style: { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" } }), /* @__PURE__ */ React.createElement("div", { style: {
        position: "absolute",
        top: 6,
        left: 6,
        padding: "2px 6px",
        borderRadius: 4,
        background: "rgba(0,0,0,0.55)",
        fontSize: 10,
        fontWeight: 700,
        color: "#fff"
      } }, slot.label), /* @__PURE__ */ React.createElement("div", { style: {
        position: "absolute",
        top: 6,
        right: 6,
        width: 22,
        height: 22,
        borderRadius: 999,
        background: T.green,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      } }, /* @__PURE__ */ React.createElement(Icon, { name: "check", size: 13, color: "#052E13", strokeWidth: 2.5 }))) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, fontWeight: 600, color: T.text0 } }, slot.label), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, color: T.text2, marginTop: 3 } }, "Tap")))
    ), /* @__PURE__ */ React.createElement(
      GalleryTrigger,
      {
        contractNo: r.contractNo,
        slotLabel: slot.label + " (\u0432\u0440\u044A\u0449\u0430\u043D\u0435)",
        onCapture: (record) => setReturnPhotos((p) => ({ ...p, [slot.key]: record })),
        onError: (err) => window.toast && window.toast.error(err.message),
        style: { position: "absolute", bottom: 6, left: 6 }
      },
      ({ busy }) => /* @__PURE__ */ React.createElement("span", { title: "\u0418\u0437\u0431\u0435\u0440\u0438 \u043E\u0442 \u0433\u0430\u043B\u0435\u0440\u0438\u044F\u0442\u0430", style: {
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        height: 22,
        padding: "0 7px",
        borderRadius: 6,
        background: "rgba(0,0,0,0.55)",
        color: "#fff",
        border: "1px solid rgba(255,255,255,0.2)",
        fontSize: 10,
        fontWeight: 700
      } }, /* @__PURE__ */ React.createElement(Icon, { name: busy ? "refresh" : "image", size: 11, color: "#fff" }), "\u0413\u0430\u043B\u0435\u0440\u0438\u044F")
    ));
  }))), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 12 } }, "\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044A\u0442 \u0435 \u0432\u044A\u0440\u043D\u0430\u0442 \u043F\u043E\u0447\u0438\u0441\u0442\u0435\u043D"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 } }, [
    { v: true, label: "\u0414\u0430", tone: "green" },
    { v: false, label: "\u041D\u0435", tone: "red" }
  ].map((o) => /* @__PURE__ */ React.createElement("button", { key: String(o.v), onClick: () => setReturnClean(o.v), style: {
    padding: "14px",
    borderRadius: 10,
    background: returnClean === o.v ? T[o.tone + "Tint"] : T.bg2,
    border: `1px solid ${returnClean === o.v ? T[o.tone] : T.border}`,
    color: returnClean === o.v ? T[o.tone] : T.text1,
    fontWeight: 600,
    fontSize: 13
  } }, o.label))), returnClean === false && /* @__PURE__ */ React.createElement("div", { style: { marginTop: 14 } }, /* @__PURE__ */ React.createElement("div", { style: { padding: "10px 12px", borderRadius: 8, background: T.yellowTint, border: `1px solid ${T.yellow}`, color: T.yellow, fontSize: 13, fontWeight: 600, marginBottom: 12 } }, "\u0412\u044A\u0440\u043D\u0430\u0442\u0430 \u043D\u0435\u043F\u043E\u0447\u0438\u0441\u0442\u0435\u043D\u0430 \u2014 \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u0439 \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u0430/\u0442\u0430\u043A\u0441\u0430\u0442\u0430"), /* @__PURE__ */ React.createElement(Field, { label: "\u0422\u0430\u043A\u0441\u0430 \u043F\u043E\u0447\u0438\u0441\u0442\u0432\u0430\u043D\u0435 (\u043F\u043E\u0442\u0432\u044A\u0440\u0434\u0438 \u0438\u043B\u0438 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0430\u0439)" }, /* @__PURE__ */ React.createElement(NumberInput, { decimals: 2, min: 0, money: true, value: cleaningFee, onChange: (n) => setCleaningFee(n || 0), suffix: "\u20AC" }))), (() => {
    const eq = r.handoverEquipment || null;
    if (!eq) return null;
    const keys = Object.keys(SETTLEMENT_EQ_LABELS).filter((k) => eq[k] === true);
    if (!keys.length) return null;
    return /* @__PURE__ */ React.createElement("div", { style: { marginTop: 14 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.4, fontWeight: 600, marginBottom: 8 } }, "\u041E\u0431\u043E\u0440\u0443\u0434\u0432\u0430\u043D\u0435 \u043F\u0440\u0438 \u043F\u0440\u0435\u0434\u0430\u0432\u0430\u043D\u0435 (\u0441\u043F\u0440\u0430\u0432\u043A\u0430)"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 6 } }, keys.map((k) => /* @__PURE__ */ React.createElement(Chip, { key: k, tone: "outline", size: "sm" }, k === "OTHER" && r.handoverEquipmentOther ? "\u0414\u0440\u0443\u0433\u043E: " + r.handoverEquipmentOther : SETTLEMENT_EQ_LABELS[k]))));
  })()), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, marginBottom: 12 } }, /* @__PURE__ */ React.createElement(Icon, { name: "edit", size: 20, color: returnSignature ? T.green : T.accent }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, flex: 1 } }, "\u041F\u043E\u0434\u043F\u0438\u0441 \u043D\u0430 \u043D\u0430\u0435\u043C\u0430\u0442\u0435\u043B\u044F \u2014 \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435"), returnSignature ? /* @__PURE__ */ React.createElement(Chip, { tone: "green", size: "sm", icon: "check" }, "\u041F\u043E\u0434\u043F\u0438\u0441\u0430\u043D") : /* @__PURE__ */ React.createElement(Chip, { tone: "yellow", size: "sm" }, "\u0427\u0430\u043A\u0430 \u043F\u043E\u0434\u043F\u0438\u0441")), /* @__PURE__ */ React.createElement(
    Button,
    {
      kind: returnSignature ? "outline" : "primary",
      size: "lg",
      block: true,
      onClick: () => onOpenKiosk && onOpenKiosk("return_protocol", (payload) => {
        if (payload && payload.signatureDataUrl) {
          setReturnSignature(payload.signatureDataUrl);
          setReturnSignedAt(payload.signedAt || (/* @__PURE__ */ new Date()).toISOString());
        }
      }, {
        contractNo: r.contractNo,
        vehicleLabel: v.make + " " + v.model + " \xB7 " + v.plate,
        isElectric,
        returnOdo,
        returnFuel,
        returnClean,
        extraTotalLabel: extraTotal > 0 ? fmtEuro(extraTotal) : "\u043D\u044F\u043C\u0430",
        depositLabel: depositAction === "return" ? "\u0432\u0440\u044A\u0449\u0430 \u0441\u0435 \u0438\u0437\u0446\u044F\u043B\u043E (" + fmtEuro(r.deposit) + ")" : depositAction === "withhold-partial" ? "\u0447\u0430\u0441\u0442\u0438\u0447\u043D\u043E \u0437\u0430\u0434\u044A\u0440\u0436\u0430\u043D\u0435 (" + fmtEuro(withheldAmount) + ")" : "\u0437\u0430\u0434\u044A\u0440\u0436\u0430 \u0441\u0435 \u0438\u0437\u0446\u044F\u043B\u043E"
      })
    },
    returnSignature ? "\u041F\u043E\u0434\u043F\u0438\u0448\u0438 \u043E\u0442\u043D\u043E\u0432\u043E" : "\u041F\u043E\u0434\u0430\u0439 \u0437\u0430 \u043F\u043E\u0434\u043F\u0438\u0441 (\u043A\u0438\u043E\u0441\u043A)"
  )), /* @__PURE__ */ React.createElement(Card, { pad: isPhone ? 16 : 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, marginBottom: 12 } }, /* @__PURE__ */ React.createElement(Icon, { name: "camera", size: 20, color: hasNewDamages ? T.red : T.accent }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, flex: 1 } }, "\u0429\u0435\u0442\u0438 \u043F\u0440\u0438 \u0432\u0440\u044A\u0449\u0430\u043D\u0435"), hasNewDamages && damagePhotos.length > 0 && /* @__PURE__ */ React.createElement(Chip, { tone: "red", size: "sm" }, damagePhotos.length)), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text1, marginBottom: 10 } }, "\u0418\u043C\u0430 \u043D\u043E\u0432\u0438 \u0449\u0435\u0442\u0438:"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: hasNewDamages ? 14 : 0 } }, [
    { v: false, label: "\u041D\u0435", tone: "green" },
    { v: true, label: "\u0414\u0430", tone: "red" }
  ].map((o) => /* @__PURE__ */ React.createElement("button", { key: String(o.v), onClick: () => setHasNewDamages(o.v), style: {
    padding: "14px",
    borderRadius: 10,
    background: hasNewDamages === o.v ? T[o.tone + "Tint"] : T.bg2,
    border: `1px solid ${hasNewDamages === o.v ? T[o.tone] : T.border}`,
    color: hasNewDamages === o.v ? T[o.tone] : T.text1,
    fontWeight: 600,
    fontSize: 13
  } }, o.label))), hasNewDamages && /* @__PURE__ */ React.createElement(React.Fragment, null, damagePhotos.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { padding: "10px 12px", borderRadius: 8, background: T.redTint, border: `1px solid ${T.red}`, color: T.red, fontSize: 13, fontWeight: 600, marginBottom: 12 } }, "\u0414\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u043F\u043E\u043D\u0435 \u0435\u0434\u043D\u0430 \u0441\u043D\u0438\u043C\u043A\u0430 \u043D\u0430 \u0449\u0435\u0442\u0430"), damagePhotos.map((p, i) => /* @__PURE__ */ React.createElement("div", { key: p.id, style: { display: "flex", gap: 10, marginBottom: 12, alignItems: "flex-start" } }, /* @__PURE__ */ React.createElement("div", { style: { position: "relative", width: 96, flexShrink: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { aspectRatio: "4 / 3", borderRadius: 10, border: `2px solid ${T.red}`, overflow: "hidden", position: "relative", background: T.bg2 } }, /* @__PURE__ */ React.createElement("img", { src: p.dataUrl, alt: "\u0429\u0435\u0442\u0430 " + (i + 1), style: { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" } }), /* @__PURE__ */ React.createElement("div", { style: { position: "absolute", top: 4, left: 4, padding: "2px 6px", borderRadius: 4, background: "rgba(0,0,0,0.55)", fontSize: 10, fontWeight: 700, color: "#fff" } }, "\u0429\u0435\u0442\u0430 ", i + 1))), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement(
    Textarea,
    {
      rows: 2,
      value: p.description || "",
      placeholder: "\u041A\u0440\u0430\u0442\u043A\u043E \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043D\u0430 \u0449\u0435\u0442\u0430\u0442\u0430\u2026",
      onChange: (e) => {
        const val = e.target.value;
        setDamagePhotos((list) => list.map((x) => x.id === p.id ? { ...x, description: val } : x));
      }
    }
  )), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "sm", icon: "x", onClick: () => setDamagePhotos((list) => list.filter((x) => x.id !== p.id)) }))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement(
    CaptureTrigger,
    {
      contractNo: r.contractNo,
      slotLabel: "\u0429\u0435\u0442\u0430 (\u0432\u0440\u044A\u0449\u0430\u043D\u0435)",
      onCapture: (record) => setDamagePhotos((list) => [...list, { id: "rd" + Date.now() + Math.random().toString(36).slice(2, 5), ...record, description: "" }]),
      block: true
    },
    ({ busy }) => /* @__PURE__ */ React.createElement("div", { style: {
      padding: "12px",
      borderRadius: 10,
      border: `1px dashed ${T.red}`,
      background: T.bg2,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      color: T.red,
      fontWeight: 600,
      fontSize: 13
    } }, busy ? /* @__PURE__ */ React.createElement(Icon, { name: "refresh", size: 16, color: T.text2 }) : /* @__PURE__ */ React.createElement(React.Fragment, null, "+ \u0421\u043D\u0438\u043C\u043A\u0430 \u043D\u0430 \u0449\u0435\u0442\u0430"))
  )), /* @__PURE__ */ React.createElement(
    GalleryTrigger,
    {
      contractNo: r.contractNo,
      slotLabel: "\u0429\u0435\u0442\u0430 (\u0432\u0440\u044A\u0449\u0430\u043D\u0435)",
      onCapture: (record) => setDamagePhotos((list) => [...list, { id: "rd" + Date.now() + Math.random().toString(36).slice(2, 5), ...record, description: "" }]),
      onError: (err) => window.toast && window.toast.error(err.message)
    },
    ({ busy }) => /* @__PURE__ */ React.createElement("div", { style: {
      padding: "12px 14px",
      borderRadius: 10,
      border: `1px dashed ${T.red}`,
      background: T.bg2,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 6,
      color: T.red,
      fontWeight: 600,
      fontSize: 13
    } }, /* @__PURE__ */ React.createElement(Icon, { name: busy ? "refresh" : "image", size: 14, color: T.red }), "\u0413\u0430\u043B\u0435\u0440\u0438\u044F")
  )))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 12, marginTop: 16 } }, /* @__PURE__ */ React.createElement(
    Button,
    {
      kind: "primary",
      size: "lg",
      icon: "check",
      style: { flex: 2 },
      disabled: returnPhotoCount < 6,
      title: returnPhotoCount < 6 ? "\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0438 \u0441\u0430 \u0432\u0441\u0438\u0447\u043A\u0438 6 \u0437\u0430\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u043D\u0438 \u0441\u043D\u0438\u043C\u043A\u0438 \u043E\u0442 \u0432\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E" : "",
      onClick: () => {
        if (hasNewDamages && damagePhotos.length === 0) {
          window.toast && window.toast.error(
            '\u041E\u0442\u0431\u0435\u043B\u044F\u0437\u0430\u043D\u0438 \u0441\u0430 \u043D\u043E\u0432\u0438 \u0449\u0435\u0442\u0438, \u043D\u043E \u043D\u044F\u043C\u0430 \u043D\u0438\u0442\u043E \u0435\u0434\u043D\u0430 \u0441\u043D\u0438\u043C\u043A\u0430. \u0414\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0441\u043D\u0438\u043C\u043A\u0430 \u043D\u0430 \u0449\u0435\u0442\u0430\u0442\u0430 \u0438\u043B\u0438 \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u201E\u041D\u0435".',
            { title: "\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u044A\u0442 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0431\u044A\u0434\u0435 \u0444\u0438\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D" }
          );
          return;
        }
        if (!returnSignature) {
          window.toast && window.toast.error(
            "\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u044A\u0442 \u0437\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u043D\u0435 \u0435 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D \u043E\u0442 \u043A\u043B\u0438\u0435\u043D\u0442\u0430. \u0412\u0440\u044A\u0449\u0430\u043D\u0435\u0442\u043E \u043D\u0435 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0431\u044A\u0434\u0435 \u0444\u0438\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u043E \u0431\u0435\u0437 \u043F\u043E\u0434\u043F\u0438\u0441.",
            { title: "\u041B\u0438\u043F\u0441\u0432\u0430 \u043F\u043E\u0434\u043F\u0438\u0441", duration: 7e3 }
          );
          return;
        }
        try {
          window.store.finalizeReturn({
            rentalId: r.id,
            returnOdo,
            returnFuel,
            extraKmCharge: waivedKm ? 0 : extraKmCharge,
            fuelCharge: waivedFuel ? 0 : fuelCharge,
            depositAction,
            withheldAmount,
            withholdReason: notes,
            notes,
            returnPhotos,
            hasNewDamages,
            damagePhotos: hasNewDamages ? damagePhotos : [],
            returnSignature,
            returnClean,
            cleaningFee: returnClean === false ? cleaningFee || 0 : null,
            cleaningFeeWaived: returnClean === false ? cleaningFeeWaived : false
          });
          window.toast && window.toast.success(
            "\u041D\u0430\u0435\u043C " + r.contractNo + " \u0435 \u043F\u0440\u0438\u043A\u043B\u044E\u0447\u0435\u043D. \u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044A\u0442 \u0435 \u043E\u0441\u0432\u043E\u0431\u043E\u0434\u0435\u043D \u0432 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u0430, \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u044A\u0442 \u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0435\u043D, \u0434\u043E\u0431\u0430\u0432\u0435\u043D\u0438 \u0441\u0430 " + [extraKmCharge > 0 && !waivedKm ? "extra km" : null, fuelCharge > 0 && !waivedFuel ? "fuel" : null].filter(Boolean).join(" + ") + " \u043F\u043B\u0430\u0449\u0430\u043D\u0438\u044F.",
            { title: "\u041D\u0430\u0435\u043C\u044A\u0442 \u0435 \u0432\u044A\u0440\u043D\u0430\u0442", duration: 5200 }
          );
        } catch (err) {
          window.toast && window.toast.error("\u0413\u0440\u0435\u0448\u043A\u0430: " + (err && err.message || err));
        }
        onFinalize && onFinalize();
      }
    },
    returnPhotoCount < 6 ? `Finalize (${returnPhotoCount}/6 photos)` : "Finalize return"
  )), /* @__PURE__ */ React.createElement("div", { style: { height: 20 } })), showCompare && /* @__PURE__ */ React.createElement(
    PhotoCompareOverlay,
    {
      handover: r.handoverPhotos || {},
      returnPhotos,
      slots: RETURN_PHOTO_SLOTS,
      onClose: () => setShowCompare(false)
    }
  ));
}
function PhotoCompareOverlay({ handover, returnPhotos, slots, onClose }) {
  const [angle, setAngle] = useState(slots[0].key);
  const cur = slots.find((s) => s.key === angle);
  const h = handover[angle];
  const rp = returnPhotos[angle];
  return /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    inset: 0,
    background: "rgba(5,7,11,0.94)",
    zIndex: 300,
    display: "flex",
    flexDirection: "column"
  } }, /* @__PURE__ */ React.createElement("div", { style: { padding: "14px 24px", display: "flex", alignItems: "center", gap: 12, borderBottom: `1px solid ${T.border}` } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 } }, "Damage inspection"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 16, fontWeight: 700, marginTop: 2 } }, cur.label, " \xB7 handover vs. return")), /* @__PURE__ */ React.createElement(IconBtn, { icon: "x", onClick: onClose, title: "Close" })), /* @__PURE__ */ React.createElement("div", { style: { padding: "10px 24px", display: "flex", gap: 6, overflowX: "auto", borderBottom: `1px solid ${T.border}` } }, slots.map((s) => {
    const has = handover[s.key] && handover[s.key].dataUrl && returnPhotos[s.key] && returnPhotos[s.key].dataUrl;
    return /* @__PURE__ */ React.createElement("button", { key: s.key, onClick: () => setAngle(s.key), style: {
      padding: "6px 12px",
      borderRadius: 8,
      border: `1px solid ${angle === s.key ? T.accent : T.border}`,
      background: angle === s.key ? T.accentTint : T.bg2,
      color: angle === s.key ? T.text0 : T.text1,
      fontSize: 12,
      fontWeight: 600,
      whiteSpace: "nowrap",
      cursor: "pointer",
      opacity: has ? 1 : 0.5
    } }, s.label, " ", has ? "\u2713" : "");
  })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, padding: 20, minHeight: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 } }, "Handover"), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, background: T.bg2, borderRadius: 10, border: `1px solid ${T.border}`, overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", minHeight: 0 } }, h && h.dataUrl ? /* @__PURE__ */ React.createElement("img", { src: h.dataUrl, alt: "handover", style: { maxWidth: "100%", maxHeight: "100%", objectFit: "contain" } }) : /* @__PURE__ */ React.createElement("div", { style: { color: T.text3, fontSize: 13 } }, "\u041D\u044F\u043C\u0430 \u0441\u043D\u0438\u043C\u043A\u0430"))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 } }, "Return"), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, background: T.bg2, borderRadius: 10, border: `1px solid ${T.border}`, overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", minHeight: 0 } }, rp && rp.dataUrl ? /* @__PURE__ */ React.createElement("img", { src: rp.dataUrl, alt: "return", style: { maxWidth: "100%", maxHeight: "100%", objectFit: "contain" } }) : /* @__PURE__ */ React.createElement("div", { style: { color: T.text3, fontSize: 13 } }, "\u041D\u044F\u043C\u0430 \u0441\u043D\u0438\u043C\u043A\u0430")))), /* @__PURE__ */ React.createElement("div", { style: { padding: "10px 24px", borderTop: `1px solid ${T.border}`, display: "flex", alignItems: "center", gap: 10, fontSize: 12, color: T.text2 } }, /* @__PURE__ */ React.createElement(Icon, { name: "info", size: 14 }), /* @__PURE__ */ React.createElement("div", null, "\u041F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u0439\u0442\u0435 \u0432\u0441\u044F\u043A\u0430 \u0441\u043D\u0438\u043C\u043A\u0430 \u043E\u0442 \u0434\u0432\u0435\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438. \u0410\u043A\u043E \u0437\u0430\u0431\u0435\u043B\u0435\u0436\u0438\u0442\u0435 \u043D\u043E\u0432\u0438 \u043F\u043E\u0432\u0440\u0435\u0434\u0438, \u0434\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0433\u0438 \u0432 Damage register \u0441\u043B\u0435\u0434 \u0444\u0438\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u0435.")));
}
function BreakdownRow({ label, amount, paid, editable, waived, onWaive, hidden }) {
  if (hidden) return null;
  return /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "10px 0"
  } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13.5, color: waived ? T.text3 : T.text0, textDecoration: waived ? "line-through" : "none" } }, label), paid && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.green, marginTop: 2 } }, "\u2713 paid at handover")), editable && /* @__PURE__ */ React.createElement("button", { onClick: onWaive, style: {
    fontSize: 11,
    fontWeight: 600,
    color: waived ? T.accent : T.text2,
    padding: "4px 10px",
    border: `1px solid ${waived ? T.accent : T.border}`,
    borderRadius: 6,
    background: waived ? T.accentTint : "transparent"
  } }, waived ? "restored" : "waive"), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 14, fontWeight: 600, color: waived ? T.text3 : T.text0, width: 90, textAlign: "right", textDecoration: waived ? "line-through" : "none" } }, fmtEuro(amount)));
}
Object.assign(window, { SettlementScreen });

/* ══════════ components/customers.jsx ══════════ */
function CustomersScreen({ isPhone, onOpenCustomer }) {
  store.useStore();
  const [q, setQ] = useState("");
  const [filter, setFilter] = useState("all");
  const [selected, setSelected] = useState(null);
  const filtered = CUSTOMERS.map((c2) => {
    if (filter === "blacklisted" && !c2.blacklisted) return null;
    if (filter === "active") {
      const hasActive = RENTALS.some((r) => r.customerId === c2.id && (r.status === "active" || r.status === "reserved"));
      if (!hasActive) return null;
    }
    if (filter === "warnings" && !(c2.warnings && c2.warnings.length)) return null;
    const res = window.searchCustomer(c2, q.length >= 2 ? q : null);
    if (!res.hit) return null;
    return { customer: c2, matched: res.matched, matchedValue: res.value };
  }).filter(Boolean);
  const c = selected ? CUSTOMERS.find((x) => x.id === selected) : null;
  return /* @__PURE__ */ React.createElement("div", { style: { flex: 1, display: "flex", overflow: "hidden", background: T.bg0 } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: isPhone ? "100%" : c ? 380 : "100%",
    borderRight: c && !isPhone ? `1px solid ${T.border}` : "none",
    display: "flex",
    flexDirection: "column",
    flexShrink: 0
  } }, /* @__PURE__ */ React.createElement("div", { style: { padding: isPhone ? "14px 16px" : "18px 24px", borderBottom: `1px solid ${T.border}` } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 14 } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: isPhone ? 18 : 22, fontWeight: 700, letterSpacing: -0.2 } }, "Customers"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginTop: 2 } }, CUSTOMERS.length, " on file")), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "sm", icon: "plus", onClick: () => window.toast && window.toast.info(
    "\u0412 production \u0444\u043E\u0440\u043C\u0430\u0442\u0430 \u0437\u0430 \u043D\u043E\u0432 \u043A\u043B\u0438\u0435\u043D\u0442 \u0449\u0435 \u043F\u043E\u0437\u0432\u043E\u043B\u0438 \u0440\u044A\u0447\u043D\u043E \u0432\u044A\u0432\u0435\u0436\u0434\u0430\u043D\u0435 \u0438\u043B\u0438 \u0437\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435 \u043E\u0442 OCR \u0441\u043A\u0435\u043D\u0435\u0440\u0430 (Phase 2 \u2014 Google Sheets).",
    { title: "Add customer", duration: 4200 }
  ) }, "Add")), /* @__PURE__ */ React.createElement(
    Input,
    {
      value: q,
      onChange: (e) => setQ(e.target.value),
      placeholder: "Search name, EGN, phone\u2026",
      prefix: /* @__PURE__ */ React.createElement(Icon, { name: "search", size: 16 }),
      style: { marginBottom: 10 }
    }
  ), /* @__PURE__ */ React.createElement(
    Segmented,
    {
      value: filter,
      onChange: setFilter,
      size: "sm",
      options: [
        { value: "all", label: `All (${CUSTOMERS.length})` },
        { value: "active", label: "Active" },
        { value: "warnings", label: "Warnings" },
        { value: "blacklisted", label: "Blacklist" }
      ]
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "scroll-y", style: { flex: 1, padding: "8px 12px" } }, filtered.length === 0 && /* @__PURE__ */ React.createElement("div", { style: {
    padding: 32,
    textAlign: "center",
    color: T.text2,
    fontSize: 13
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 44,
    height: 44,
    borderRadius: 12,
    background: T.bg1,
    border: `1px solid ${T.border}`,
    margin: "0 auto 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "search", size: 20, color: T.text3 })), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 600, color: T.text1 } }, "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u043A\u043B\u0438\u0435\u043D\u0442\u0438"), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 6, lineHeight: 1.5, maxWidth: 280, marginLeft: "auto", marginRight: "auto" } }, q ? `\u0417\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 "${q}" \u043D\u044F\u043C\u0430 \u0441\u044A\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u044F \u043F\u043E \u0438\u043C\u0435, \u0415\u0413\u041D, \u0442\u0435\u043B\u0435\u0444\u043E\u043D, email, \u041B\u041A, \u0421\u0423\u041C\u041F\u0421 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441.` : "\u041D\u0438\u043A\u043E\u0439 \u043A\u043B\u0438\u0435\u043D\u0442 \u043D\u0435 \u043E\u0442\u0433\u043E\u0432\u0430\u0440\u044F \u043D\u0430 \u0442\u0435\u043A\u0443\u0449\u0438\u0442\u0435 \u0444\u0438\u043B\u0442\u0440\u0438.")), filtered.map((item) => /* @__PURE__ */ React.createElement(
    CustomerListItem,
    {
      key: item.customer.id,
      c: item.customer,
      matched: item.matched,
      matchedValue: item.matchedValue,
      active: selected === item.customer.id,
      onClick: () => setSelected(item.customer.id)
    }
  )))), !isPhone && /* @__PURE__ */ React.createElement("div", { className: "scroll-y", style: { flex: 1 } }, !c && /* @__PURE__ */ React.createElement("div", { style: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
    color: T.text2
  } }, /* @__PURE__ */ React.createElement("div", { style: { width: 60, height: 60, borderRadius: 14, background: T.bg1, display: "flex", alignItems: "center", justifyContent: "center" } }, /* @__PURE__ */ React.createElement(Icon, { name: "users", size: 28, color: T.text3 })), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14 } }, "Select a customer to view profile")), c && /* @__PURE__ */ React.createElement(CustomerProfile, { c, onAfterAnonymize: () => setSelected(null) })));
}
function CustomerListItem({ c, matched, matchedValue, active, onClick }) {
  const idExpired = new Date(c.idCard.expiry) < TODAY;
  const dlExpired = new Date(c.driverLicense.expiry) < TODAY;
  const warning = c.warnings && c.warnings.length > 0;
  const label = matched && matched !== "name" ? window.CUSTOMER_FIELD_LABELS[matched] || matched : null;
  return /* @__PURE__ */ React.createElement("button", { onClick, style: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "10px 12px",
    background: active ? T.accentTint : "transparent",
    border: `1px solid ${active ? T.accent : "transparent"}`,
    borderRadius: 10,
    width: "100%",
    textAlign: "left",
    marginBottom: 3
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 36,
    height: 36,
    borderRadius: 10,
    background: c.blacklisted ? T.redTint : T.bg2,
    color: c.blacklisted ? T.red : T.text1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: 12
  } }, c.blacklisted ? /* @__PURE__ */ React.createElement(Icon, { name: "block", size: 16 }) : c.name.split(" ").map((w) => w[0]).slice(0, 2).join("")), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 6 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13.5, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } }, c.name), (warning || idExpired || dlExpired) && !c.blacklisted && /* @__PURE__ */ React.createElement(StatusDot, { status: "warn", size: 6 })), label ? /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.accent, marginTop: 2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } }, /* @__PURE__ */ React.createElement("span", { className: "mono", style: { color: T.text2, marginRight: 4 } }, label, ":"), /* @__PURE__ */ React.createElement("span", { className: "mono", style: { color: T.text1 } }, matchedValue)) : /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 11, color: T.text2, marginTop: 2 } }, c.phone)), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text3, whiteSpace: "nowrap" } }, c.rentalsCount, "\xD7"));
}
function CustomerProfile({ c, onAfterAnonymize }) {
  const [confirmingDelete, setConfirmingDelete] = useState(false);
  const idExpired = new Date(c.idCard.expiry) < TODAY;
  const dlExpired = new Date(c.driverLicense.expiry) < TODAY;
  const dlSoon = !dlExpired && new Date(c.driverLicense.expiry) - TODAY < 90 * 24 * 60 * 60 * 1e3;
  const rentals = RENTALS.filter((r) => r.customerId === c.id);
  return /* @__PURE__ */ React.createElement("div", { style: { padding: 24 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 16, marginBottom: 20 } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 60,
    height: 60,
    borderRadius: 16,
    background: c.blacklisted ? T.redTint : T.bg2,
    color: c.blacklisted ? T.red : T.text1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: 18
  } }, c.blacklisted ? /* @__PURE__ */ React.createElement(Icon, { name: "block", size: 26 }) : c.name.split(" ").map((w) => w[0]).slice(0, 2).join("")), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 22, fontWeight: 700, letterSpacing: -0.3 } }, c.name), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 12, color: T.text2, marginTop: 3 } }, "\u0415\u0413\u041D ", c.egn, " \xB7 ", c.phone)), /* @__PURE__ */ React.createElement(IconBtn, { icon: "edit", title: "Edit customer", onClick: () => {
    window.toast && window.toast.info(
      "Edit \u0449\u0435 \u043E\u0442\u0432\u043E\u0440\u0438 \u0444\u043E\u0440\u043C\u0430 \u0437\u0430 \u043A\u043E\u0440\u0435\u043A\u0446\u0438\u044F \u043D\u0430 \u043B\u0438\u0447\u043D\u0438\u0442\u0435 \u0434\u0430\u043D\u043D\u0438 \u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438\u0442\u0435. \u041F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435 \u0441\u0435 \u043B\u043E\u0433\u0432\u0430\u0442 \u0432 historia \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u0438 \u0441\u0435 \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0438\u0440\u0430\u0442 \u0441 Google Drive \u0430\u0440\u0445\u0438\u0432\u0430.",
      { title: "Edit " + c.name, duration: 4500 }
    );
  } })), c.blacklisted && /* @__PURE__ */ React.createElement(Card, { pad: 16, style: { marginBottom: 16, background: T.redTint, borderColor: "rgba(239,68,68,0.35)" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 12, alignItems: "flex-start" } }, /* @__PURE__ */ React.createElement(Icon, { name: "block", size: 22, color: T.red }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 700, color: "#FCA5A5" } }, "Blacklisted customer"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: T.text1, marginTop: 4 } }, c.blacklistReason)))), /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 14 } }, "Documents"), /* @__PURE__ */ React.createElement(
    DocRow2,
    {
      title: "\u041B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430",
      number: c.idCard.number,
      expiry: c.idCard.expiry,
      authority: c.idCard.authority,
      status: idExpired ? "danger" : new Date(c.idCard.expiry) - TODAY < 30 * 24 * 60 * 60 * 1e3 ? "warn" : "ok"
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { height: 12 } }), /* @__PURE__ */ React.createElement(
    DocRow2,
    {
      title: "\u0421\u0423\u041C\u041F\u0421",
      number: c.driverLicense.number,
      expiry: c.driverLicense.expiry,
      authority: `\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438 ${c.driverLicense.categories}`,
      status: dlExpired ? "danger" : dlSoon ? "warn" : "ok"
    }
  )), /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 } }, "Rental history"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2 } }, c.rentalsCount, " total")), rentals.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { color: T.text2, fontSize: 13, padding: "20px 0", textAlign: "center" } }, "No rentals yet."), rentals.map((r) => {
    const v = VEHICLES.find((vv) => vv.id === r.vehicleId);
    return /* @__PURE__ */ React.createElement("div", { key: r.id, style: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      padding: "10px 12px",
      background: T.bg2,
      borderRadius: 10,
      border: `1px solid ${T.border}`,
      marginBottom: 8
    } }, /* @__PURE__ */ React.createElement(StatusDot, { status: r.status }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13.5, fontWeight: 600 } }, v.make, " ", v.model), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 11.5, color: T.text2, marginTop: 2 } }, r.contractNo, " \xB7 ", fmtDateShort(r.start), " \u2014 ", fmtDateShort(r.end))), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 13, fontWeight: 700 } }, fmtEuro(r.total)));
  })), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10 } }, /* @__PURE__ */ React.createElement(
    Button,
    {
      kind: "outline",
      size: "md",
      style: { flex: 1 },
      icon: "plus",
      onClick: () => window.toast && window.toast.info(
        "\u0421\u0442\u0430\u0440\u0442\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u043D\u043E\u0432 \u043D\u0430\u0435\u043C \u0441 " + c.name.split(" ")[0] + " " + c.name.split(" ").slice(-1)[0] + ". Wizard-\u044A\u0442 \u0449\u0435 \u0441\u0435 \u043E\u0442\u0432\u043E\u0440\u0438 \u0441\u044A\u0441 \u0441\u0442\u044A\u043F\u043A\u0430 Customer \u0432\u0435\u0447\u0435 \u043F\u043E\u043F\u044A\u043B\u043D\u0435\u043D\u0430.",
        { title: "\u041D\u043E\u0432 \u043D\u0430\u0435\u043C", duration: 3500 }
      )
    },
    "New rental"
  ), !c.blacklisted && /* @__PURE__ */ React.createElement(
    Button,
    {
      kind: "outline",
      size: "md",
      style: { flex: 1 },
      icon: "block",
      danger: true,
      onClick: () => window.toast && window.toast.warn(
        "\u0414\u043E\u0431\u0430\u0432\u044F\u043D\u0435\u0442\u043E \u0432 blacklist \u0438\u0437\u0438\u0441\u043A\u0432\u0430 \u0432\u044A\u0432\u0435\u0436\u0434\u0430\u043D\u0435 \u043D\u0430 \u043F\u0440\u0438\u0447\u0438\u043D\u0430. \u0422\u0430\u0437\u0438 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u0441\u0435 \u043B\u043E\u0433\u0432\u0430 \u0432 audit trail-\u0430 \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430.",
        { title: "Add to blacklist", duration: 4e3 }
      )
    },
    "Add to blacklist"
  ), /* @__PURE__ */ React.createElement(
    Button,
    {
      kind: "outline",
      size: "md",
      icon: "trash",
      title: "Delete customer (GDPR)",
      disabled: c.anonymized,
      onClick: () => setConfirmingDelete(true)
    }
  )), confirmingDelete && /* @__PURE__ */ React.createElement(
    ConfirmSheet,
    {
      title: "GDPR anonymize?",
      body: `\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435\u0442\u043E \u0449\u0435 \u0430\u043D\u043E\u043D\u0438\u043C\u0438\u0437\u0438\u0440\u0430 \u043B\u0438\u0447\u043D\u0438\u0442\u0435 \u0434\u0430\u043D\u043D\u0438 \u043D\u0430 ${c.name} (\u0438\u043C\u0435, \u0415\u0413\u041D, \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438, \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0438). \u0424\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u0438\u0442\u0435 \u0437\u0430\u043F\u0438\u0441\u0438 (\u043F\u043B\u0430\u0449\u0430\u043D\u0438\u044F, \u043D\u0430\u0435\u043C\u0438, \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u0438) \u043E\u0441\u0442\u0430\u0432\u0430\u0442 \u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0438 \u0432 \u0430\u043D\u043E\u043D\u0438\u043C\u0438\u0437\u0438\u0440\u0430\u043D \u0432\u0438\u0434. \u0422\u0430\u0437\u0438 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u0435 \u043D\u0435\u043E\u0431\u0440\u0430\u0442\u0438\u043C\u0430.`,
      confirmLabel: "Anonymize (GDPR)",
      confirmTone: "danger",
      onConfirm: () => {
        window.store.anonymizeCustomer(c.id);
        setConfirmingDelete(false);
        window.toast && window.toast.warn(
          "\u041A\u043B\u0438\u0435\u043D\u0442 \u201E" + c.name + '" \u0435 \u0430\u043D\u043E\u043D\u0438\u043C\u0438\u0437\u0438\u0440\u0430\u043D. \u0424\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u0438\u0442\u0435 \u0437\u0430\u043F\u0438\u0441\u0438 \u0441\u0430 \u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0438.',
          { title: "\u0410\u043D\u043E\u043D\u0438\u043C\u0438\u0437\u0438\u0440\u0430\u043D", duration: 4500 }
        );
        onAfterAnonymize && onAfterAnonymize();
      },
      onCancel: () => setConfirmingDelete(false)
    }
  ));
}
function DocRow2({ title, number, expiry, authority, status }) {
  const c = { ok: T.green, warn: T.yellow, danger: T.red }[status];
  const label = { ok: "Valid", warn: "Expires soon", danger: "EXPIRED" }[status];
  return /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    padding: "10px 12px",
    background: T.bg2,
    border: `1px solid ${T.border}`,
    borderRadius: 10
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 40,
    height: 40,
    borderRadius: 10,
    background: `${c}22`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "file", size: 20, color: c })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600 } }, title), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 11.5, color: T.text2, marginTop: 2 } }, number, " \xB7 ", authority)), /* @__PURE__ */ React.createElement("div", { style: { textAlign: "right" } }, /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 12, color: T.text1 } }, fmtDateBG(expiry)), /* @__PURE__ */ React.createElement(Chip, { tone: status === "ok" ? "green" : status === "warn" ? "yellow" : "red", size: "sm", style: { marginTop: 4 } }, label)));
}
Object.assign(window, { CustomersScreen });

/* ══════════ components/fleet.jsx ══════════ */
function FleetScreen({ isPhone }) {
  store.useStore();
  const [selected, setSelected] = useState(VEHICLES[0]?.id ?? null);
  const [adding, setAdding] = useState(false);
  const [editing, setEditing] = useState(false);
  const v = selected ? VEHICLES.find((x) => x.id === selected) : null;
  return /* @__PURE__ */ React.createElement("div", { style: { flex: 1, display: "flex", overflow: "hidden", background: T.bg0, position: "relative" } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: isPhone ? "100%" : 380,
    borderRight: !isPhone ? `1px solid ${T.border}` : "none",
    display: "flex",
    flexDirection: "column",
    flexShrink: 0
  } }, /* @__PURE__ */ React.createElement("div", { style: { padding: isPhone ? "14px 16px" : "18px 24px", borderBottom: `1px solid ${T.border}` } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: isPhone ? 18 : 22, fontWeight: 700, letterSpacing: -0.2 } }, "Fleet"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginTop: 2 } }, VEHICLES.filter((v2) => v2.status === "available").length, " available \xB7 ", VEHICLES.length, " total")), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "sm", icon: "plus", onClick: () => setAdding(true) }, "Add"))), /* @__PURE__ */ React.createElement("div", { className: "scroll-y", style: { flex: 1, padding: "10px 14px" } }, VEHICLES.length === 0 && /* @__PURE__ */ React.createElement("div", { style: {
    padding: 32,
    textAlign: "center",
    color: T.text2,
    fontSize: 13
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 44,
    height: 44,
    borderRadius: 12,
    background: T.bg1,
    border: `1px solid ${T.border}`,
    margin: "0 auto 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "van", size: 20, color: T.text3 })), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 600, color: T.text1 } }, "No vehicles yet"), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 6, lineHeight: 1.5, maxWidth: 280, marginLeft: "auto", marginRight: "auto" } }, "Add your first vehicle to start building your fleet."), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 14 } }, /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "sm", icon: "plus", onClick: () => setAdding(true) }, "Add vehicle"))), VEHICLES.map((vv) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: vv.id,
      onClick: () => setSelected(vv.id),
      style: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: 12,
        background: selected === vv.id ? T.accentTint : T.bg1,
        border: `1px solid ${selected === vv.id ? T.accent : T.border}`,
        borderRadius: 12,
        width: "100%",
        textAlign: "left",
        marginBottom: 8
      }
    },
    /* @__PURE__ */ React.createElement("div", { style: { background: T.bg2, padding: 6, borderRadius: 8 } }, /* @__PURE__ */ React.createElement(VanGlyph, { size: 44, drivetrain: vv.drivetrain })),
    /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13.5, fontWeight: 700 } }, vv.make, " ", vv.model), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 11, color: T.text2, marginTop: 2 } }, vv.plate)),
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 6 } }, /* @__PURE__ */ React.createElement(StatusDot, { status: vv.status, size: 8 }), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 10.5, color: T.text2 } }, fmtKm(vv.odo)))
  )))), !isPhone && v && /* @__PURE__ */ React.createElement(VehicleProfile, { v, onEdit: () => setEditing(true) }), !isPhone && !v && /* @__PURE__ */ React.createElement("div", { style: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
    color: T.text2
  } }, /* @__PURE__ */ React.createElement("div", { style: { width: 60, height: 60, borderRadius: 14, background: T.bg1, display: "flex", alignItems: "center", justifyContent: "center" } }, /* @__PURE__ */ React.createElement(Icon, { name: "van", size: 28, color: T.text3 })), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, textAlign: "center", maxWidth: 260 } }, VEHICLES.length === 0 ? "No vehicles yet \u2014 add your first vehicle to get started" : "Select a vehicle to view profile")), adding && /* @__PURE__ */ React.createElement(
    AddVehiclePanel,
    {
      onSave: (nv) => {
        const added = window.store.addVehicle(nv);
        setSelected(added.id);
        setAdding(false);
        window.toast && window.toast.success(
          "\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B " + added.make + " " + added.model + " (" + added.plate + ") \u0435 \u0434\u043E\u0431\u0430\u0432\u0435\u043D \u0432\u044A\u0432 \u0444\u043B\u043E\u0442\u0430.",
          { title: "\u0414\u043E\u0431\u0430\u0432\u0435\u043D \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B", duration: 3800 }
        );
      },
      onCancel: () => setAdding(false)
    }
  ), editing && v && /* @__PURE__ */ React.createElement(
    VehicleFormPanel,
    {
      mode: "edit",
      initial: v,
      onSave: (payload) => {
        window.store.updateVehicle(v.id, payload);
        setEditing(false);
        window.toast && window.toast.success(
          "\u041F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435 \u043D\u0430 " + payload.make + " " + payload.model + " (" + payload.plate + ") \u0441\u0430 \u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0438.",
          { title: "\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044A\u0442 \u0435 \u043E\u0431\u043D\u043E\u0432\u0435\u043D", duration: 3500 }
        );
      },
      onCancel: () => setEditing(false)
    }
  ));
}
function isoToDisplay(iso) {
  if (!iso) return "";
  const s = String(iso).slice(0, 10);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : s;
}
function displayToIso(disp) {
  if (!disp) return null;
  const s = String(disp).trim();
  const m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(s);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;
  const m2 = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  return m2 ? s : null;
}
function AddVehiclePanel({ onSave, onCancel }) {
  return /* @__PURE__ */ React.createElement(VehicleFormPanel, { mode: "add", onSave, onCancel });
}
function VehicleFormPanel({ mode = "add", initial = null, onSave, onCancel }) {
  const isEdit = mode === "edit";
  const v0 = initial || {};
  const [form, setForm] = useState({
    make: v0.make || "",
    model: v0.model || "",
    plate: v0.plate || "",
    vin: v0.vin || "",
    year: v0.year || (/* @__PURE__ */ new Date()).getFullYear(),
    type: v0.type || "cargo",
    seats: v0.seats || 2,
    drivetrain: v0.drivetrain || "diesel",
    odo: v0.odo || 0,
    status: v0.status || "available",
    dailyRate: v0.dailyRate || 45,
    weeklyRate: v0.weeklyRate || 280,
    monthlyRate: v0.monthlyRate || 950,
    kmPerDay: v0.kmPerDay || 200,
    extraKmPrice: v0.extraKmPrice || 0.18,
    fuelPerPercent: v0.fuelPerPercent || 0.65,
    color: v0.color || "\u0431\u044F\u043B",
    notes: v0.notes || "",
    insuranceExpiry: isoToDisplay(v0.docs && v0.docs.insurance),
    cascoExpiry: isoToDisplay(v0.docs && v0.docs.casco),
    gtpExpiry: isoToDisplay(v0.docs && v0.docs.gtp),
    vignetteExpiry: isoToDisplay(v0.docs && v0.docs.vignette),
    taxExpiry: isoToDisplay(v0.docs && v0.docs.tax)
  });
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const [confirmDrop, setConfirmDrop] = useState(null);
  const canSave = form.make && form.model && form.plate && form.vin && form.dailyRate > 0;
  const buildPayload = () => ({
    make: form.make.trim(),
    model: form.model.trim(),
    plate: form.plate.trim().toUpperCase(),
    vin: form.vin.trim().toUpperCase(),
    year: form.year,
    type: form.type,
    seats: form.seats,
    drivetrain: form.drivetrain,
    odo: form.odo,
    status: form.status,
    dailyRate: form.dailyRate,
    weeklyRate: form.weeklyRate,
    monthlyRate: form.monthlyRate,
    kmPerDay: form.kmPerDay,
    extraKmPrice: form.extraKmPrice,
    fuelPerPercent: form.drivetrain === "electric" ? form.fuelPerPercent || 0.4 : form.fuelPerPercent,
    color: form.color,
    notes: form.notes,
    docs: {
      insurance: displayToIso(form.insuranceExpiry),
      casco: displayToIso(form.cascoExpiry),
      gtp: displayToIso(form.gtpExpiry),
      vignette: displayToIso(form.vignetteExpiry),
      tax: displayToIso(form.taxExpiry)
    },
    // Keep existing oil schedule on edit; on add, derive from initial km.
    oil: isEdit ? v0.oil || { dueDate: null, dueKm: null } : form.drivetrain === "electric" ? { dueDate: null, dueKm: null } : { dueDate: null, dueKm: form.odo + 15e3 }
  });
  const submit = () => {
    if (!canSave) return;
    if (isEdit && form.odo < (v0.odo || 0)) {
      setConfirmDrop({
        oldOdo: v0.odo,
        newOdo: form.odo
      });
      return;
    }
    onSave(buildPayload());
  };
  const commitAfterConfirm = () => {
    setConfirmDrop(null);
    onSave(buildPayload());
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      onClick: onCancel,
      style: {
        position: "absolute",
        inset: 0,
        background: "rgba(5,7,11,0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 300
      }
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        onClick: (e) => e.stopPropagation(),
        style: {
          background: T.bg1,
          border: `1px solid ${T.border}`,
          borderRadius: 14,
          maxWidth: 720,
          width: "calc(100% - 40px)",
          maxHeight: "90%",
          overflowY: "auto",
          padding: 24
        }
      },
      /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: {
        width: 40,
        height: 40,
        borderRadius: 10,
        background: T.accentTint,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      } }, /* @__PURE__ */ React.createElement(Icon, { name: isEdit ? "edit" : "van", size: 20, color: T.accent })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 17, fontWeight: 700 } }, isEdit ? "Edit vehicle" : "Add vehicle"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginTop: 2 } }, isEdit ? `${v0.make} ${v0.model} \xB7 ${v0.plate}` : "\u041D\u043E\u0432 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B \u0432\u044A\u0432 \u0444\u043B\u043E\u0442\u0430")), /* @__PURE__ */ React.createElement(IconBtn, { icon: "x", onClick: onCancel })),
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 10 } }, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F"),
      /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 16 } }, /* @__PURE__ */ React.createElement(Field, { label: "\u041C\u0430\u0440\u043A\u0430" }, /* @__PURE__ */ React.createElement(Input, { size: "md", value: form.make, onChange: (e) => set("make", e.target.value), placeholder: "Renault" })), /* @__PURE__ */ React.createElement(Field, { label: "\u041C\u043E\u0434\u0435\u043B" }, /* @__PURE__ */ React.createElement(Input, { size: "md", value: form.model, onChange: (e) => set("model", e.target.value), placeholder: "Express Cargo" })), /* @__PURE__ */ React.createElement(Field, { label: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440" }, /* @__PURE__ */ React.createElement(Input, { size: "md", mono: true, value: form.plate, onChange: (e) => set("plate", e.target.value), placeholder: "CB 0000 XX" })), /* @__PURE__ */ React.createElement(Field, { label: "VIN" }, /* @__PURE__ */ React.createElement(Input, { size: "md", mono: true, value: form.vin, onChange: (e) => set("vin", e.target.value), placeholder: "17 chars" })), /* @__PURE__ */ React.createElement(Field, { label: "\u0413\u043E\u0434\u0438\u043D\u0430" }, /* @__PURE__ */ React.createElement(NumberInput, { size: "md", decimals: 0, min: 1990, max: 2100, value: form.year, onChange: (n) => set("year", n || 2026) })), /* @__PURE__ */ React.createElement(Field, { label: "\u0426\u0432\u044F\u0442" }, /* @__PURE__ */ React.createElement(Input, { size: "md", value: form.color, onChange: (e) => set("color", e.target.value) }))),
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 10 } }, "\u0422\u0438\u043F \u0438 \u0437\u0430\u0434\u0432\u0438\u0436\u0432\u0430\u043D\u0435"),
      /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 16 } }, /* @__PURE__ */ React.createElement(Field, { label: "\u0422\u0438\u043F" }, /* @__PURE__ */ React.createElement(Segmented, { block: true, value: form.type, onChange: (v) => set("type", v), options: [
        { value: "cargo", label: "Cargo" },
        { value: "minibus", label: "Minibus" }
      ] })), /* @__PURE__ */ React.createElement(Field, { label: "\u041C\u0435\u0441\u0442\u0430" }, /* @__PURE__ */ React.createElement(NumberInput, { size: "md", decimals: 0, min: 1, max: 16, value: form.seats, onChange: (n) => set("seats", n || 2) })), /* @__PURE__ */ React.createElement(Field, { label: "\u0417\u0430\u0434\u0432\u0438\u0436\u0432\u0430\u043D\u0435" }, /* @__PURE__ */ React.createElement(Segmented, { block: true, value: form.drivetrain, onChange: (v) => set("drivetrain", v), options: [
        { value: "diesel", label: "Diesel" },
        { value: "petrol", label: "Petrol" },
        { value: "lpg", label: "LPG" },
        { value: "electric", label: "Electric" }
      ] }))),
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 10 } }, "\u0421\u0442\u0430\u0442\u0443\u0441"),
      /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement(Segmented, { block: true, value: form.status, onChange: (v) => set("status", v), options: [
        { value: "available", label: "Available" },
        { value: "in_service", label: "In service" },
        { value: "cleaning", label: "Cleaning" },
        { value: "inactive", label: "Inactive" }
      ] }), form.status !== "available" && form.status !== "rented" && /* @__PURE__ */ React.createElement("div", { style: { marginTop: 8, fontSize: 11.5, color: T.text2 } }, '\u24D8 \u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044A\u0442 \u0449\u0435 \u0431\u044A\u0434\u0435 \u0431\u043B\u043E\u043A\u0438\u0440\u0430\u043D \u0432 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u0430, \u0434\u043E\u043A\u0430\u0442\u043E \u0441\u0442\u0430\u0442\u0443\u0441\u044A\u0442 \u043D\u0435 \u0441\u0435 \u0432\u044A\u0440\u043D\u0435 \u043D\u0430 \u201EAvailable".')),
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 10 } }, "\u0426\u0435\u043D\u0438"),
      /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 16 } }, /* @__PURE__ */ React.createElement(Field, { label: "\u0414\u043D\u0435\u0432\u043D\u0430 \u0446\u0435\u043D\u0430 (\u20AC)" }, /* @__PURE__ */ React.createElement(NumberInput, { size: "md", decimals: 2, min: 0, money: true, value: form.dailyRate, onChange: (n) => set("dailyRate", n || 0), suffix: "\u20AC" })), /* @__PURE__ */ React.createElement(Field, { label: "\u0421\u0435\u0434\u043C\u0438\u0447\u043D\u0430 (\u20AC)" }, /* @__PURE__ */ React.createElement(NumberInput, { size: "md", decimals: 2, min: 0, money: true, value: form.weeklyRate, onChange: (n) => set("weeklyRate", n || 0), suffix: "\u20AC" })), /* @__PURE__ */ React.createElement(Field, { label: "\u041C\u0435\u0441\u0435\u0447\u043D\u0430 (\u20AC)" }, /* @__PURE__ */ React.createElement(NumberInput, { size: "md", decimals: 2, min: 0, money: true, value: form.monthlyRate, onChange: (n) => set("monthlyRate", n || 0), suffix: "\u20AC" })), /* @__PURE__ */ React.createElement(Field, { label: "Km / \u0434\u0435\u043D" }, /* @__PURE__ */ React.createElement(NumberInput, { size: "md", decimals: 0, min: 0, value: form.kmPerDay, onChange: (n) => set("kmPerDay", n || 0), suffix: "\u043A\u043C" })), /* @__PURE__ */ React.createElement(Field, { label: "Extra km" }, /* @__PURE__ */ React.createElement(NumberInput, { size: "md", decimals: 2, min: 0, money: true, value: form.extraKmPrice, onChange: (n) => set("extraKmPrice", n || 0), suffix: "\u20AC / \u043A\u043C" })), /* @__PURE__ */ React.createElement(Field, { label: form.drivetrain === "electric" ? "\u0426\u0435\u043D\u0430 \u0437\u0430 1% \u0437\u0430\u0440\u044F\u0434" : "\u0426\u0435\u043D\u0430 \u0437\u0430 1% \u0433\u043E\u0440\u0438\u0432\u043E" }, /* @__PURE__ */ React.createElement(NumberInput, { size: "md", decimals: 2, min: 0, money: true, value: form.fuelPerPercent, onChange: (n) => set("fuelPerPercent", n || 0), suffix: "\u20AC / %" }))),
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 10 } }, isEdit ? "\u041A\u0438\u043B\u043E\u043C\u0435\u0442\u0440\u0430\u0436 \u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438" : "\u041D\u0430\u0447\u0430\u043B\u0435\u043D \u043A\u0438\u043B\u043E\u043C\u0435\u0442\u0440\u0430\u0436 \u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438"),
      /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 20 } }, /* @__PURE__ */ React.createElement(Field, { label: isEdit ? "\u0422\u0435\u043A\u0443\u0449 km" : "\u041D\u0430\u0447\u0430\u043B\u0435\u043D \u043A\u043C" }, /* @__PURE__ */ React.createElement(NumberInput, { size: "md", decimals: 0, min: 0, value: form.odo, onChange: (n) => set("odo", n || 0), suffix: "\u043A\u043C" })), /* @__PURE__ */ React.createElement(Field, { label: "\u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u0430 \u0434\u043E" }, /* @__PURE__ */ React.createElement(Input, { size: "md", mono: true, value: form.insuranceExpiry, onChange: (e) => set("insuranceExpiry", e.target.value), placeholder: "\u0434\u0434.\u043C\u043C.\u0433\u0433\u0433\u0433" })), /* @__PURE__ */ React.createElement(Field, { label: "\u0410\u0432\u0442\u043E\u043A\u0430\u0441\u043A\u043E \u0434\u043E" }, /* @__PURE__ */ React.createElement(Input, { size: "md", mono: true, value: form.cascoExpiry, onChange: (e) => set("cascoExpiry", e.target.value), placeholder: "\u0434\u0434.\u043C\u043C.\u0433\u0433\u0433\u0433" })), /* @__PURE__ */ React.createElement(Field, { label: "\u0413\u0422\u041F \u0434\u043E" }, /* @__PURE__ */ React.createElement(Input, { size: "md", mono: true, value: form.gtpExpiry, onChange: (e) => set("gtpExpiry", e.target.value), placeholder: "\u0434\u0434.\u043C\u043C.\u0433\u0433\u0433\u0433" })), /* @__PURE__ */ React.createElement(Field, { label: "\u0412\u0438\u043D\u0435\u0442\u043A\u0430 \u0434\u043E" }, /* @__PURE__ */ React.createElement(Input, { size: "md", mono: true, value: form.vignetteExpiry, onChange: (e) => set("vignetteExpiry", e.target.value), placeholder: "\u0434\u0434.\u043C\u043C.\u0433\u0433\u0433\u0433" })), /* @__PURE__ */ React.createElement(Field, { label: "\u0414\u0430\u043D\u044A\u043A \u0434\u043E" }, /* @__PURE__ */ React.createElement(Input, { size: "md", mono: true, value: form.taxExpiry, onChange: (e) => set("taxExpiry", e.target.value), placeholder: "\u0434\u0434.\u043C\u043C.\u0433\u0433\u0433\u0433" }))),
      /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 20 } }, /* @__PURE__ */ React.createElement(Field, { label: "\u0417\u0430\u0431\u0435\u043B\u0435\u0436\u043A\u0438" }, /* @__PURE__ */ React.createElement(Textarea, { rows: 2, value: form.notes, onChange: (e) => set("notes", e.target.value), placeholder: "\u0412\u0441\u044F\u043A\u0430\u043A\u0432\u0438 \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u0438\u044F \u0437\u0430 \u0442\u043E\u0437\u0438 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u2026" }))),
      /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10 } }, /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "md", style: { flex: 1 }, onClick: onCancel }, "\u041E\u0442\u043A\u0430\u0437"), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "md", icon: "check", style: { flex: 2 }, disabled: !canSave, onClick: submit }, isEdit ? "\u0417\u0430\u043F\u0430\u0437\u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435" : "\u0414\u043E\u0431\u0430\u0432\u0438 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B")),
      confirmDrop && /* @__PURE__ */ React.createElement(
        "div",
        {
          onClick: () => setConfirmDrop(null),
          style: {
            position: "absolute",
            inset: 0,
            background: "rgba(5,7,11,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 320
          }
        },
        /* @__PURE__ */ React.createElement(
          "div",
          {
            onClick: (e) => e.stopPropagation(),
            style: {
              background: T.bg1,
              border: `1px solid ${T.border}`,
              borderRadius: 14,
              padding: 24,
              maxWidth: 480,
              width: "calc(100% - 40px)"
            }
          },
          /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 12 } }, /* @__PURE__ */ React.createElement("div", { style: {
            width: 40,
            height: 40,
            borderRadius: 10,
            background: T.yellowTint,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          } }, /* @__PURE__ */ React.createElement(Icon, { name: "warn", size: 20, color: T.yellow })), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 16, fontWeight: 700 } }, "Odometer lower than current")),
          /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text1, lineHeight: 1.5, marginBottom: 16 } }, "\u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0430 \u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442: ", /* @__PURE__ */ React.createElement("span", { className: "mono", style: { color: T.text0, fontWeight: 700 } }, fmtKm(confirmDrop.oldOdo)), /* @__PURE__ */ React.createElement("br", null), "\u041D\u043E\u0432\u0430 \u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442: ", /* @__PURE__ */ React.createElement("span", { className: "mono", style: { color: T.text0, fontWeight: 700 } }, fmtKm(confirmDrop.newOdo)), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("span", { style: { color: T.text2, fontSize: 12 } }, "\u041E\u0431\u0438\u043A\u043D\u043E\u0432\u0435\u043D\u043E km \u043D\u0438\u043A\u043E\u0433\u0430 \u043D\u0435 \u043D\u0430\u043C\u0430\u043B\u044F\u0432\u0430. \u0410\u043A\u043E \u0442\u043E\u0432\u0430 \u0435 \u0433\u0440\u0435\u0448\u043A\u0430 \u043E\u0442 \u0431\u044A\u0440\u0437\u0430\u043D\u0435, \u0432\u044A\u0440\u043D\u0435\u0442\u0435 \u0441\u0435 \u0438 \u043A\u043E\u0440\u0438\u0433\u0438\u0440\u0430\u0439\u0442\u0435. \u0410\u043A\u043E \u0435 \u0432\u0430\u043B\u0438\u0434\u0435\u043D \u0441\u043B\u0443\u0447\u0430\u0439 (\u043D\u0430\u043F\u0440. \u0441\u043C\u044F\u043D\u0430 \u043D\u0430 \u043A\u0438\u043B\u043E\u043C\u0435\u0442\u0440\u0430\u0436\u043D\u0430 \u0442\u0430\u0431\u043B\u043E), \u043F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u0442\u0435.")),
          /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10 } }, /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "md", style: { flex: 1 }, onClick: () => setConfirmDrop(null) }, "\u041D\u0430\u0437\u0430\u0434"), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "md", style: { flex: 1 }, icon: "check", onClick: commitAfterConfirm }, "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0438"))
        )
      )
    )
  );
}
function VehicleProfile({ v, onEdit }) {
  const status = STATUS_COLORS[v.status];
  const rentals = RENTALS.filter((r) => r.vehicleId === v.id);
  const completedCount = rentals.filter((r) => r.status === "completed").length;
  return /* @__PURE__ */ React.createElement("div", { className: "scroll-y", style: { flex: 1, padding: 24 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "flex-start", gap: 16, marginBottom: 20 } }, /* @__PURE__ */ React.createElement("div", { style: { background: T.bg1, padding: 12, borderRadius: 14, border: `1px solid ${T.border}` } }, /* @__PURE__ */ React.createElement(VanGlyph, { size: 80, drivetrain: v.drivetrain })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 24, fontWeight: 700, letterSpacing: -0.3 } }, v.make, " ", v.model), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 13, color: T.text2, marginTop: 4 } }, v.plate, " \xB7 VIN ", v.vin), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, marginTop: 10, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement(Chip, { tone: v.status === "available" ? "green" : v.status === "rented" ? "blue" : "gray" }, status.label), /* @__PURE__ */ React.createElement(Chip, { tone: "outline" }, v.year), /* @__PURE__ */ React.createElement(Chip, { tone: "outline", icon: v.drivetrain === "electric" ? "bolt" : "fuel" }, v.drivetrain), /* @__PURE__ */ React.createElement(Chip, { tone: "outline" }, v.type === "cargo" ? "Cargo van" : "Minibus", " \xB7 ", v.seats, " \u043C\u0435\u0441\u0442\u0430"))), /* @__PURE__ */ React.createElement(IconBtn, { icon: "edit", size: 40, title: "Edit vehicle", onClick: onEdit })), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12, marginBottom: 16 } }, /* @__PURE__ */ React.createElement(MiniStat, { label: "Odometer", value: fmtKm(v.odo) }), /* @__PURE__ */ React.createElement(MiniStat, { label: "Daily rate", value: fmtEuro(v.dailyRate, { dp: 0 }) }), /* @__PURE__ */ React.createElement(MiniStat, { label: "Rentals total", value: rentals.length }), /* @__PURE__ */ React.createElement(MiniStat, { label: "Utilization \xB7 30d", value: "72%" })), /* @__PURE__ */ React.createElement(Card, { pad: 16, style: { marginBottom: 20 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 4 } }, "Quick status"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2 } }, v.status === "rented" ? "\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044A\u0442 \u0435 \u043D\u0430\u0435\u0442 \u2014 \u0441\u0442\u0430\u0442\u0443\u0441\u044A\u0442 \u0441\u0435 \u0441\u043C\u0435\u043D\u044F \u043F\u0440\u0438 \u0432\u0440\u044A\u0449\u0430\u043D\u0435." : "\u041F\u0440\u043E\u043C\u044F\u043D\u0430 \u043D\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u043E\u0441\u0442\u0442\u0430 \u0432 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u0430.")), v.status === "rented" ? /* @__PURE__ */ React.createElement(Chip, { tone: "blue", size: "lg", icon: "key" }, "Rented") : /* @__PURE__ */ React.createElement(
    Segmented,
    {
      value: v.status,
      onChange: (next) => {
        if (next === v.status) return;
        window.store.setVehicleStatus(v.id, next);
        window.toast && window.toast.success(
          "\u0421\u0442\u0430\u0442\u0443\u0441 \u043D\u0430 " + v.plate + " \u2192 " + STATUS_COLORS[next].label + ".",
          { title: "\u0421\u0442\u0430\u0442\u0443\u0441\u044A\u0442 \u0435 \u043E\u0431\u043D\u043E\u0432\u0435\u043D", duration: 3e3 }
        );
      },
      options: [
        { value: "available", label: "Available" },
        { value: "in_service", label: "In service" },
        { value: "cleaning", label: "Cleaning" },
        { value: "inactive", label: "Inactive" }
      ]
    }
  ))), /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 14 } }, "Vehicle documents"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 } }, /* @__PURE__ */ React.createElement(DocExpiry, { label: "\u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u0430 \u043E\u0442\u0433\u043E\u0432\u043E\u0440\u043D\u043E\u0441\u0442", expiry: v.docs.insurance }), /* @__PURE__ */ React.createElement(DocExpiry, { label: "\u0410\u0432\u0442\u043E\u043A\u0430\u0441\u043A\u043E", expiry: v.docs.casco }), /* @__PURE__ */ React.createElement(DocExpiry, { label: "\u0413\u0422\u041F", expiry: v.docs.gtp }), /* @__PURE__ */ React.createElement(DocExpiry, { label: "\u0412\u0438\u043D\u0435\u0442\u043A\u0430", expiry: v.docs.vignette }), /* @__PURE__ */ React.createElement(DocExpiry, { label: "\u0414\u0430\u043D\u044A\u043A \u041C\u041F\u0421", expiry: v.docs.tax }), v.oil.dueKm && /* @__PURE__ */ React.createElement(DocExpiry, { label: "\u0421\u043C\u044F\u043D\u0430 \u043D\u0430 \u043C\u0430\u0441\u043B\u043E", expiry: v.oil.dueDate, extra: `\u043F\u0440\u0438 ${fmtKm(v.oil.dueKm)}` }))), /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 14 } }, "Price list"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10 } }, /* @__PURE__ */ React.createElement(MiniStat, { label: "Daily", value: fmtEuro(v.dailyRate, { dp: 0 }) }), /* @__PURE__ */ React.createElement(MiniStat, { label: "Weekly", value: fmtEuro(v.weeklyRate, { dp: 0 }) }), /* @__PURE__ */ React.createElement(MiniStat, { label: "Monthly", value: fmtEuro(v.monthlyRate, { dp: 0 }) })), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10, marginTop: 10 } }, /* @__PURE__ */ React.createElement(MiniStat, { label: "Km/day default", value: `${v.kmPerDay} \u043A\u043C` }), /* @__PURE__ */ React.createElement(MiniStat, { label: "Extra km", value: fmtEuro(v.extraKmPrice, { dp: 2 }) }), /* @__PURE__ */ React.createElement(MiniStat, { label: v.drivetrain === "electric" ? "Per 1% charge" : "Per 1% fuel", value: fmtEuro(v.fuelPerPercent, { dp: 2 }) }))), /* @__PURE__ */ React.createElement(VehicleDamagesPanel, { v }));
}
function MiniStat({ label, value }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    padding: "10px 12px",
    background: T.bg1,
    border: `1px solid ${T.border}`,
    borderRadius: 10
  } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10.5, color: T.text2, letterSpacing: 0.4, textTransform: "uppercase", fontWeight: 600 } }, label), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 17, fontWeight: 700, marginTop: 4 } }, value));
}
function DocExpiry({ label, expiry, extra }) {
  const days = expiry ? Math.floor((new Date(expiry) - TODAY) / (1e3 * 60 * 60 * 24)) : null;
  const status = days == null ? "gray" : days < 0 ? "red" : days < 30 ? "yellow" : "green";
  return /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 12px",
    background: T.bg2,
    border: `1px solid ${T.border}`,
    borderRadius: 10
  } }, /* @__PURE__ */ React.createElement(StatusDot, { status: status === "red" ? "danger" : status === "yellow" ? "warn" : "ok" }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text1, fontWeight: 500 } }, label), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 12, color: T.text2, marginTop: 2 } }, expiry ? fmtDateBG(expiry) : "\u2014", extra ? " \xB7 " + extra : "")));
}
var DAMAGE_ORIGIN_LABELS = { handover: "\u043F\u0440\u0435\u0434\u0430\u0432\u0430\u043D\u0435", return: "\u0432\u0440\u044A\u0449\u0430\u043D\u0435", manual: "\u0440\u044A\u0447\u043D\u043E" };
function VehicleDamagesPanel({ v }) {
  const [damages, setDamages] = useState(null);
  const [loadError, setLoadError] = useState(false);
  const [adding, setAdding] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const reload = () => {
    setLoadError(false);
    window.store.fetchVehicleDamages(v.id).then((list) => setDamages(list || [])).catch(() => {
      setDamages([]);
      setLoadError(true);
    });
  };
  useEffect(() => {
    setDamages(null);
    reload();
  }, [v.id]);
  const active = (damages || []).filter((d) => d.status === "active");
  const repaired = (damages || []).filter((d) => d.status === "repaired");
  return /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", marginBottom: 14 } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1, fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 } }, "\u0429\u0435\u0442\u0438", damages ? ` \xB7 ${active.length} \u0430\u043A\u0442\u0438\u0432\u043D\u0438` : ""), /* @__PURE__ */ React.createElement(Button, { size: "sm", icon: "plus", onClick: () => setAdding(true) }, "\u0414\u043E\u0431\u0430\u0432\u0438 \u0449\u0435\u0442\u0430")), loadError && /* @__PURE__ */ React.createElement("div", { style: {
    padding: "12px 14px",
    borderRadius: 10,
    marginBottom: 10,
    background: T.redTint,
    border: "1px solid rgba(239,68,68,0.35)",
    fontSize: 13,
    fontWeight: 600,
    color: "#FCA5A5",
    display: "flex",
    alignItems: "center",
    gap: 10
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "warn", size: 16, color: T.red }), "\u0420\u0435\u0433\u0438\u0441\u0442\u044A\u0440\u044A\u0442 \u043D\u0430 \u0449\u0435\u0442\u0438\u0442\u0435 \u043D\u0435 \u0441\u0435 \u0437\u0430\u0440\u0435\u0434\u0438 \u2014 \u043E\u043F\u0438\u0442\u0430\u0439\u0442\u0435 \u043E\u0442\u043D\u043E\u0432\u043E.", /* @__PURE__ */ React.createElement(Button, { size: "sm", onClick: reload }, "\u041E\u043F\u0438\u0442\u0430\u0439 \u043F\u0430\u043A")), damages === null && !loadError && /* @__PURE__ */ React.createElement("div", { style: { padding: 20, textAlign: "center", color: T.text2, fontSize: 13 } }, "\u0417\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435\u2026"), damages !== null && !loadError && damages.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { padding: 20, textAlign: "center", color: T.text2, fontSize: 13 } }, "\u041D\u044F\u043C\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0430\u043D\u0438 \u0449\u0435\u0442\u0438 \u0437\u0430 \u0442\u043E\u0437\u0438 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B."), active.map((d) => /* @__PURE__ */ React.createElement(DamageRow, { key: d.id, damage: d, onChanged: reload, onDelete: () => setConfirmDelete(d) })), repaired.length > 0 && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, margin: "14px 0 8px" } }, "\u041E\u0442\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438 (", repaired.length, ")"), repaired.map((d) => /* @__PURE__ */ React.createElement(DamageRow, { key: d.id, damage: d, onChanged: reload, onDelete: () => setConfirmDelete(d) })), adding && /* @__PURE__ */ React.createElement(
    ManualDamagePanel,
    {
      v,
      onSaved: () => {
        setAdding(false);
        reload();
      },
      onCancel: () => setAdding(false)
    }
  ), confirmDelete && /* @__PURE__ */ React.createElement(
    "div",
    {
      onClick: () => setConfirmDelete(null),
      style: {
        position: "fixed",
        inset: 0,
        background: "rgba(5,7,11,0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 300
      }
    },
    /* @__PURE__ */ React.createElement("div", { onClick: (e) => e.stopPropagation(), style: {
      background: T.bg1,
      border: `1px solid ${T.border}`,
      borderRadius: 14,
      maxWidth: 440,
      width: "calc(100% - 40px)",
      padding: 20
    } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 16, fontWeight: 700, marginBottom: 10 } }, "\u0418\u0437\u0442\u0440\u0438\u0432\u0430\u043D\u0435 \u043D\u0430 \u0449\u0435\u0442\u0430"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text1, lineHeight: 1.5, marginBottom: 6 } }, '\u0418\u0437\u0442\u0440\u0438\u0432\u0430\u043D\u0435\u0442\u043E \u0435 \u0441\u0430\u043C\u043E \u0437\u0430 \u0433\u0440\u0435\u0448\u043D\u043E \u0432\u044A\u0432\u0435\u0434\u0435\u043D\u0438 \u0449\u0435\u0442\u0438. \u0417\u0430 \u043E\u0442\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438 \u0449\u0435\u0442\u0438 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u201E\u041E\u0442\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0430".'), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginBottom: 16 } }, confirmDelete.description || "\u0411\u0435\u0437 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435", " \xB7 ", DAMAGE_ORIGIN_LABELS[confirmDelete.origin] || confirmDelete.origin), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10, justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(Button, { onClick: () => setConfirmDelete(null) }, "\u041E\u0442\u043A\u0430\u0437"), /* @__PURE__ */ React.createElement(Button, { kind: "primary", danger: true, onClick: () => {
      const d = confirmDelete;
      setConfirmDelete(null);
      window.store.deleteVehicleDamage(d.id).then(() => {
        reload();
        window.toast && window.toast.success("\u0429\u0435\u0442\u0430\u0442\u0430 \u0435 \u0438\u0437\u0442\u0440\u0438\u0442\u0430 \u043E\u0442 \u0440\u0435\u0433\u0438\u0441\u0442\u044A\u0440\u0430.", { title: "\u0418\u0437\u0442\u0440\u0438\u0442\u0430 \u0449\u0435\u0442\u0430", duration: 3e3 });
      }).catch((err) => {
        window.toast && window.toast.error("\u0418\u0437\u0442\u0440\u0438\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0449\u0435\u0442\u0430\u0442\u0430 \u043D\u0435 \u0431\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E: " + (err && err.message ? err.message : "\u0433\u0440\u0435\u0448\u043A\u0430"), { title: "\u0413\u0440\u0435\u0448\u043A\u0430", duration: 6e3 });
      });
    } }, "\u0418\u0437\u0442\u0440\u0438\u0439")))
  ));
}
function DamageRow({ damage: d, onChanged, onDelete }) {
  const [photoUrl, setPhotoUrl] = useState(null);
  const [editing, setEditing] = useState(false);
  const [desc, setDesc] = useState(d.description || "");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let alive = true;
    if (d.hasPhoto) {
      window.store.getVehicleDamagePhotoUrl(d.id).then((url) => {
        if (alive) setPhotoUrl(url);
      }).catch(() => {
      });
    }
    return () => {
      alive = false;
    };
  }, [d.id, d.hasPhoto]);
  const saveDesc = () => {
    setBusy(true);
    window.store.updateVehicleDamage(d.id, { description: desc }).then(() => {
      setEditing(false);
      setBusy(false);
      onChanged();
    }).catch((err) => {
      setBusy(false);
      window.toast && window.toast.error("\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u0442\u043E \u043D\u0435 \u0431\u0435 \u0437\u0430\u043F\u0430\u0437\u0435\u043D\u043E: " + (err && err.message ? err.message : "\u0433\u0440\u0435\u0448\u043A\u0430"), { title: "\u0413\u0440\u0435\u0448\u043A\u0430", duration: 6e3 });
    });
  };
  const markRepaired = () => {
    setBusy(true);
    window.store.markVehicleDamageRepaired(d.id).then(() => {
      setBusy(false);
      onChanged();
      window.toast && window.toast.success("\u0429\u0435\u0442\u0430\u0442\u0430 \u0435 \u043E\u0442\u0431\u0435\u043B\u044F\u0437\u0430\u043D\u0430 \u043A\u0430\u0442\u043E \u043E\u0442\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0430.", { title: "\u041E\u0442\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0430 \u0449\u0435\u0442\u0430", duration: 3e3 });
    }).catch((err) => {
      setBusy(false);
      window.toast && window.toast.error("\u0429\u0435\u0442\u0430\u0442\u0430 \u043D\u0435 \u0431\u0435 \u043E\u0442\u0431\u0435\u043B\u044F\u0437\u0430\u043D\u0430 \u043A\u0430\u0442\u043E \u043E\u0442\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0430: " + (err && err.message ? err.message : "\u0433\u0440\u0435\u0448\u043A\u0430"), { title: "\u0413\u0440\u0435\u0448\u043A\u0430", duration: 6e3 });
    });
  };
  const repaired = d.status === "repaired";
  return /* @__PURE__ */ React.createElement("div", { style: {
    display: "flex",
    gap: 12,
    padding: 12,
    marginBottom: 8,
    background: T.bg2,
    border: `1px solid ${T.border}`,
    borderRadius: 12,
    opacity: repaired ? 0.65 : 1
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 86,
    height: 64,
    borderRadius: 8,
    overflow: "hidden",
    flexShrink: 0,
    background: T.bg1,
    border: `1px solid ${T.border}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  } }, photoUrl ? /* @__PURE__ */ React.createElement("img", { src: photoUrl, alt: "\u0449\u0435\u0442\u0430", style: { width: "100%", height: "100%", objectFit: "cover" } }) : /* @__PURE__ */ React.createElement(Icon, { name: "camera", size: 18, color: T.text3 })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, editing ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Textarea, { value: desc, onChange: (e) => setDesc(e.target.value), rows: 2, placeholder: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043D\u0430 \u0449\u0435\u0442\u0430\u0442\u0430 (\u043D\u0430\u043F\u0440. \u201E\u0434\u0440\u0430\u0441\u043A\u043E\u0442\u0438\u043D\u0430 \u0437\u0430\u0434\u043D\u0430 \u043B\u044F\u0432\u0430 \u0432\u0440\u0430\u0442\u0430\u201C)" }), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, marginTop: 6 } }, /* @__PURE__ */ React.createElement(Button, { size: "sm", kind: "primary", disabled: busy, onClick: saveDesc }, "\u0417\u0430\u043F\u0430\u0437\u0438"), /* @__PURE__ */ React.createElement(Button, { size: "sm", disabled: busy, onClick: () => {
    setEditing(false);
    setDesc(d.description || "");
  } }, "\u041E\u0442\u043A\u0430\u0437"))) : /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13.5, fontWeight: 600, color: T.text0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } }, d.description || /* @__PURE__ */ React.createElement("span", { style: { color: T.text2, fontWeight: 400 } }, "\u0411\u0435\u0437 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, marginTop: 6, flexWrap: "wrap", alignItems: "center" } }, /* @__PURE__ */ React.createElement(Chip, { tone: repaired ? "green" : "yellow", size: "sm" }, repaired ? "\u043E\u0442\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0430" : "\u0430\u043A\u0442\u0438\u0432\u043D\u0430"), /* @__PURE__ */ React.createElement(Chip, { tone: "outline", size: "sm" }, DAMAGE_ORIGIN_LABELS[d.origin] || d.origin, d.contractNo ? " \xB7 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u2116 " + d.contractNo : ""), d.imported && /* @__PURE__ */ React.createElement(Chip, { tone: "orange", size: "sm" }, "\u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u0430\u043D\u0430 \u2014 \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u0439")), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 11, color: T.text2, marginTop: 6 } }, fmtDateBG(d.createdAt), d.repairedAt ? " \xB7 \u043E\u0442\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0430 " + fmtDateBG(d.repairedAt) : "")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 6, flexShrink: 0 } }, !editing && /* @__PURE__ */ React.createElement(IconBtn, { icon: "edit", size: 32, title: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0430\u0439 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u0442\u043E", onClick: () => setEditing(true) }), !repaired && /* @__PURE__ */ React.createElement(Button, { size: "sm", disabled: busy, onClick: markRepaired }, "\u041E\u0442\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0430"), /* @__PURE__ */ React.createElement(IconBtn, { icon: "trash", size: 32, title: "\u0418\u0437\u0442\u0440\u0438\u0439 (\u0441\u0430\u043C\u043E \u0433\u0440\u0435\u0448\u043D\u043E \u0432\u044A\u0432\u0435\u0434\u0435\u043D\u0438)", onClick: onDelete })));
}
function ManualDamagePanel({ v, onSaved, onCancel }) {
  const [record, setRecord] = useState(null);
  const [desc, setDesc] = useState("");
  const [busy, setBusy] = useState(false);
  const save = () => {
    if (!record || busy) return;
    setBusy(true);
    window.store.addManualVehicleDamage(v.id, record, desc).then(() => {
      setBusy(false);
      window.toast && window.toast.success("\u0429\u0435\u0442\u0430\u0442\u0430 \u0435 \u0434\u043E\u0431\u0430\u0432\u0435\u043D\u0430 \u0432 \u0440\u0435\u0433\u0438\u0441\u0442\u044A\u0440\u0430 \u043D\u0430 " + v.plate + ".", { title: "\u0414\u043E\u0431\u0430\u0432\u0435\u043D\u0430 \u0449\u0435\u0442\u0430", duration: 3500 });
      onSaved();
    }).catch((err) => {
      setBusy(false);
      window.toast && window.toast.error("\u0429\u0435\u0442\u0430\u0442\u0430 \u043D\u0435 \u0431\u0435 \u0434\u043E\u0431\u0430\u0432\u0435\u043D\u0430: " + (err && err.message ? err.message : "\u0433\u0440\u0435\u0448\u043A\u0430"), { title: "\u0413\u0440\u0435\u0448\u043A\u0430", duration: 6e3 });
    });
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      onClick: onCancel,
      style: {
        position: "fixed",
        inset: 0,
        background: "rgba(5,7,11,0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 300
      }
    },
    /* @__PURE__ */ React.createElement("div", { onClick: (e) => e.stopPropagation(), style: {
      background: T.bg1,
      border: `1px solid ${T.border}`,
      borderRadius: 14,
      maxWidth: 520,
      width: "calc(100% - 40px)",
      maxHeight: "90%",
      overflow: "auto",
      padding: 20
    } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 16, fontWeight: 700, marginBottom: 4 } }, "\u041D\u043E\u0432\u0430 \u0449\u0435\u0442\u0430 \u2014 ", v.plate), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginBottom: 14 } }, "\u0420\u044A\u0447\u043D\u043E \u0432\u043F\u0438\u0441\u0432\u0430\u043D\u0435 \u0432 \u0440\u0435\u0433\u0438\u0441\u0442\u044A\u0440\u0430 (\u0438\u0437\u0432\u044A\u043D \u043D\u0430\u0435\u043C). \u0421\u043D\u0438\u043C\u043A\u0430\u0442\u0430 \u0441\u0435 \u043F\u0435\u0447\u0430\u0442\u0430 \u0441 \u0434\u0430\u0442\u0430/\u0447\u0430\u0441 \u0438 \u0440\u0435\u0433. \u043D\u043E\u043C\u0435\u0440."), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10, marginBottom: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement(CaptureTrigger, { contractNo: v.plate, slotLabel: "\u0429\u0435\u0442\u0430", onCapture: setRecord, block: true }, ({ busy: capBusy }) => /* @__PURE__ */ React.createElement("div", { style: {
      position: "relative",
      aspectRatio: record ? "4 / 3" : "auto",
      height: record ? void 0 : 96,
      border: `1.5px dashed ${T.border}`,
      borderRadius: 12,
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 10,
      color: T.text1,
      fontWeight: 600
    } }, record ? /* @__PURE__ */ React.createElement("img", { src: record.dataUrl, alt: "\u0449\u0435\u0442\u0430", style: { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" } }) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, { name: capBusy ? "refresh" : "add_photo", size: 20, color: T.accent }), capBusy ? "\u041E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u2026" : "\u0421\u043D\u0438\u043C\u0430\u0439 \u0449\u0435\u0442\u0430\u0442\u0430")))), /* @__PURE__ */ React.createElement(
      GalleryTrigger,
      {
        contractNo: v.plate,
        slotLabel: "\u0429\u0435\u0442\u0430",
        onCapture: setRecord,
        onError: (err) => window.toast && window.toast.error(err.message)
      },
      ({ busy: busy2 }) => /* @__PURE__ */ React.createElement("div", { style: {
        height: 96,
        padding: "0 14px",
        border: `1.5px dashed ${T.border}`,
        borderRadius: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        color: T.text1,
        fontWeight: 600
      } }, /* @__PURE__ */ React.createElement(Icon, { name: busy2 ? "refresh" : "image", size: 18, color: T.accent }), "\u0413\u0430\u043B\u0435\u0440\u0438\u044F")
    )), /* @__PURE__ */ React.createElement(Field, { label: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435" }, /* @__PURE__ */ React.createElement(Textarea, { value: desc, onChange: (e) => setDesc(e.target.value), rows: 2, placeholder: "\u043D\u0430\u043F\u0440. \u201E\u0434\u0440\u0430\u0441\u043A\u043E\u0442\u0438\u043D\u0430 \u0437\u0430\u0434\u043D\u0430 \u043B\u044F\u0432\u0430 \u0432\u0440\u0430\u0442\u0430\u201C" })), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 16 } }, /* @__PURE__ */ React.createElement(Button, { disabled: busy, onClick: onCancel }, "\u041E\u0442\u043A\u0430\u0437"), /* @__PURE__ */ React.createElement(Button, { kind: "primary", disabled: !record || busy, onClick: save }, busy ? "\u0417\u0430\u043F\u0430\u0437\u0432\u0430\u043D\u0435\u2026" : "\u0414\u043E\u0431\u0430\u0432\u0438 \u0449\u0435\u0442\u0430\u0442\u0430")))
  );
}
Object.assign(window, { FleetScreen });

/* ══════════ components/payments.jsx ══════════ */
function PaymentsScreen({ isPhone }) {
  store.useStore();
  const inflow = PAYMENTS.filter((p) => p.amount > 0).reduce((a, b) => a + b.amount, 0);
  const outflow = PAYMENTS.filter((p) => p.amount < 0).reduce((a, b) => a + Math.abs(b.amount), 0);
  const net = inflow - outflow;
  return /* @__PURE__ */ React.createElement("div", { className: "scroll-y", style: { flex: 1, padding: isPhone ? 16 : 24, background: T.bg0 } }, /* @__PURE__ */ React.createElement(
    SectionHeader,
    {
      title: "Payments",
      subtitle: "All rental transactions and deposits",
      right: /* @__PURE__ */ React.createElement(Button, { kind: "primary", icon: "plus", size: "sm", onClick: () => window.toast && window.toast.info(
        "Add payment \u0449\u0435 \u043E\u0442\u0432\u043E\u0440\u0438 \u0444\u043E\u0440\u043C\u0430 \u0437\u0430 \u0432\u044A\u0432\u0435\u0436\u0434\u0430\u043D\u0435 \u043D\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435 (\u0441\u0443\u043C\u0430 \u0432 \u20AC, \u0434\u0430\u0442\u0430, \u043C\u0435\u0442\u043E\u0434 \u2014 \u0432 \u0431\u0440\u043E\u0439/\u043F\u043E \u0431\u0430\u043D\u043A\u0430, \u0446\u0435\u043B \u2014 \u043D\u0430\u0435\u043C/km/\u0433\u043E\u0440\u0438\u0432\u043E/\u0449\u0435\u0442\u0430, \u0441\u0432\u044A\u0440\u0437\u0430\u043D \u0434\u043E\u0433\u043E\u0432\u043E\u0440).",
        { title: "Add payment", duration: 4200 }
      ) }, "Add payment")
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: isPhone ? "1fr" : "repeat(3, 1fr)", gap: 12, marginBottom: 20 } }, /* @__PURE__ */ React.createElement(MiniStat, { label: "Inflow \xB7 July", value: fmtEuro(inflow, { dp: 0 }) }), /* @__PURE__ */ React.createElement(MiniStat, { label: "Outflow \xB7 July", value: fmtEuro(outflow, { dp: 0 }) }), /* @__PURE__ */ React.createElement(MiniStat, { label: "Net \xB7 July", value: fmtEuro(net, { dp: 0 }) })), /* @__PURE__ */ React.createElement(Card, { pad: 0 }, /* @__PURE__ */ React.createElement("div", { style: { padding: "14px 20px", borderBottom: `1px solid ${T.border}`, display: "flex", alignItems: "center", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1, fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 } }, "All payments"), /* @__PURE__ */ React.createElement(Segmented, { value: "all", onChange: () => {
  }, size: "sm", options: [
    { value: "all", label: "All" },
    { value: "due", label: "Outstanding" },
    { value: "deposits", label: "Deposits" }
  ] })), /* @__PURE__ */ React.createElement("div", null, PAYMENTS.map((p) => {
    const r = RENTALS.find((x) => x.id === p.rentalId);
    const c = r ? CUSTOMERS.find((cc) => cc.id === r.customerId) : null;
    const isIn = p.amount > 0;
    return /* @__PURE__ */ React.createElement("div", { key: p.id, style: {
      display: "flex",
      alignItems: "center",
      gap: 14,
      padding: "14px 20px",
      borderBottom: `1px solid ${T.border}`
    } }, /* @__PURE__ */ React.createElement("div", { style: {
      width: 36,
      height: 36,
      borderRadius: 10,
      background: isIn ? T.greenTint : T.blueTint,
      color: isIn ? T.green : T.blue,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    } }, /* @__PURE__ */ React.createElement(Icon, { name: isIn ? "arrowRight" : "arrowLeft", size: 16, color: isIn ? T.green : T.blue })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13.5, fontWeight: 600 } }, c ? c.name : "\u2014", " ", /* @__PURE__ */ React.createElement("span", { style: { color: T.text2, fontWeight: 400, fontSize: 12 } }, " \xB7 ", p.purpose)), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 11.5, color: T.text2, marginTop: 2 } }, r ? r.contractNo : "\u2014", " \xB7 ", fmtDateBG(p.date), " \xB7 ", p.method === "cash" ? "\u0412 \u0431\u0440\u043E\u0439" : "\u041F\u043E \u0431\u0430\u043D\u043A\u0430")), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: {
      fontSize: 16,
      fontWeight: 700,
      color: isIn ? "#86EFAC" : "#93C5FD"
    } }, isIn ? "+" : "", fmtEuro(p.amount)));
  }))));
}
Object.assign(window, { PaymentsScreen });

/* ══════════ components/settings.jsx ══════════ */
function SettingsScreen({ isPhone }) {
  const [section, setSection] = useState("template");
  const sections = [
    { id: "company", label: "Company", icon: "info" },
    { id: "operator", label: "Operator profile", icon: "users" },
    { id: "template", label: "Contract template", icon: "file" },
    { id: "legal", label: "Legal texts", icon: "filePdf" },
    { id: "email", label: "\u0418\u043C\u0435\u0439\u043B\u0438", icon: "mail" },
    { id: "integrations", label: "Integrations", icon: "drive" },
    { id: "operations", label: "Operations", icon: "cog" },
    { id: "data", label: "Data & GDPR", icon: "trash" },
    { id: "errorlog", label: "Error log", icon: "warn" },
    { id: "scans", label: "Scanned documents", icon: "camera" }
  ];
  const [errorLogUnread, setErrorLogUnread] = useState(0);
  const [errorLogRefreshTick, setErrorLogRefreshTick] = useState(0);
  React.useEffect(() => {
    let cancelled = false;
    store.fetchErrorLog().then((rows) => {
      if (cancelled) return;
      const lastView = localStorage.getItem("bnc-error-log-last-view");
      const lastViewMs = lastView ? new Date(lastView).getTime() : 0;
      const unread = rows.filter((r) => new Date(r.createdAt).getTime() > lastViewMs).length;
      setErrorLogUnread(unread);
    }).catch(() => {
    });
    return () => {
      cancelled = true;
    };
  }, [errorLogRefreshTick]);
  return /* @__PURE__ */ React.createElement("div", { style: { flex: 1, display: "flex", overflow: "hidden", background: T.bg0, position: "relative" } }, /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    right: 10,
    bottom: 6,
    fontSize: 10.5,
    pointerEvents: "none",
    userSelect: "none",
    color: window.__BNC_BUNDLE_BUILD_ID__ && window.__BNC_BUILD_ID__ && window.__BNC_BUNDLE_BUILD_ID__ !== window.__BNC_BUILD_ID__ ? T.red : T.text3
  } }, window.__BNC_BUNDLE_BUILD_ID__ && window.__BNC_BUILD_ID__ && window.__BNC_BUNDLE_BUILD_ID__ !== window.__BNC_BUILD_ID__ ? "\u26A0 \u043D\u0435\u0441\u044A\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435: \u043A\u043E\u0434 " + window.__BNC_BUNDLE_BUILD_ID__ + " / \u043E\u0431\u0432\u0438\u0432\u043A\u0430 " + window.__BNC_BUILD_ID__ : (window.__BNC_VERSION__ || "dev") + " \xB7 " + (window.__BNC_BUNDLE_BUILD_ID__ || window.__BNC_BUILD_ID__ || "?") + (window.__BNC_BUILT_AT__ ? " \xB7 " + fmtDateBG(new Date(window.__BNC_BUILT_AT__), { withYearSuffix: false }) : "")), !isPhone && /* @__PURE__ */ React.createElement("div", { style: {
    width: 240,
    borderRight: `1px solid ${T.border}`,
    padding: "18px 12px",
    flexShrink: 0
  } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 22, fontWeight: 700, letterSpacing: -0.2, padding: "4px 8px 14px" } }, "Settings"), sections.map((s) => /* @__PURE__ */ React.createElement("button", { key: s.id, onClick: () => setSection(s.id), style: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    width: "100%",
    padding: "10px 12px",
    background: section === s.id ? T.bg2 : "transparent",
    border: `1px solid ${section === s.id ? T.border : "transparent"}`,
    borderRadius: 10,
    textAlign: "left",
    color: section === s.id ? T.text0 : T.text1,
    fontWeight: section === s.id ? 600 : 500,
    fontSize: 13.5,
    marginBottom: 2
  } }, /* @__PURE__ */ React.createElement(Icon, { name: s.icon, size: 16 }), " ", s.label, s.id === "errorlog" && errorLogUnread > 0 && /* @__PURE__ */ React.createElement("span", { style: {
    marginLeft: "auto",
    background: "#EF4444",
    color: "#fff",
    fontSize: 10.5,
    fontWeight: 700,
    borderRadius: 999,
    padding: "1px 6px",
    minWidth: 16,
    textAlign: "center"
  } }, errorLogUnread > 99 ? "99+" : errorLogUnread)))), /* @__PURE__ */ React.createElement("div", { className: "scroll-y", style: { flex: 1, padding: isPhone ? 16 : 32 } }, section === "template" && /* @__PURE__ */ React.createElement(SectionTemplate, null), section === "company" && /* @__PURE__ */ React.createElement(SectionCompany, null), section === "operator" && /* @__PURE__ */ React.createElement(SectionOperator, null), section === "legal" && /* @__PURE__ */ React.createElement(SectionLegal, null), section === "email" && /* @__PURE__ */ React.createElement(SectionEmail, null), section === "integrations" && /* @__PURE__ */ React.createElement(SectionIntegrations, null), section === "operations" && /* @__PURE__ */ React.createElement(SectionOperations, null), section === "data" && /* @__PURE__ */ React.createElement(SectionData, null), section === "errorlog" && /* @__PURE__ */ React.createElement(SectionErrorLog, { onViewed: () => setErrorLogRefreshTick((t) => t + 1) }), section === "scans" && /* @__PURE__ */ React.createElement(SectionScans, null)));
}
function SectionTemplate() {
  store.useStore();
  const template = store.contractTemplate();
  const fileInputRef = React.useRef(null);
  const [busy, setBusy] = useState(false);
  const [validation, setValidation] = useState(null);
  const [previewing, setPreviewing] = useState(false);
  const openPicker = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
    }
  };
  const handleFile = async (file) => {
    if (!file) return;
    const name = file.name || "";
    const isDocxByName = /\.docx$/i.test(name);
    const isDocxByMime = file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    if (!isDocxByName && !isDocxByMime) {
      window.toast && window.toast.warn(
        '\u0424\u0430\u0439\u043B\u044A\u0442 "' + name + '" \u043D\u0435 \u0438\u0437\u0433\u043B\u0435\u0436\u0434\u0430 \u043A\u0430\u0442\u043E .docx. \u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 Word \u0444\u0430\u0439\u043B (.docx).',
        { title: "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u0435\u043D \u0444\u043E\u0440\u043C\u0430\u0442", duration: 4500 }
      );
      return;
    }
    setBusy(true);
    try {
      const buffer = await file.arrayBuffer();
      const parsed = await window.templateModule.parseDocx(buffer);
      const cat = window.templateModule.categorize(parsed.tokens);
      const base64 = window.templateModule.arrayBufferToBase64(buffer);
      const nextTemplate = {
        name,
        size: file.size,
        uploadedAt: (/* @__PURE__ */ new Date()).toISOString(),
        base64,
        paragraphs: parsed.paragraphs,
        tokens: parsed.tokens,
        recognized: cat.recognized,
        unrecognized: cat.unrecognized,
        unused: cat.unused
      };
      store.setContractTemplate(nextTemplate);
      setValidation({
        recognized: cat.recognized,
        unrecognized: cat.unrecognized,
        unused: cat.unused,
        name,
        size: file.size
      });
      if (cat.unrecognized.length > 0) {
        window.toast && window.toast.warn(
          "\u041A\u0430\u0447\u0435\u043D: " + name + " \u2014 " + cat.recognized.length + " \u0432\u0430\u043B\u0438\u0434\u043D\u0438 placeholders, " + cat.unrecognized.length + " \u043D\u0435\u043F\u043E\u0437\u043D\u0430\u0442\u0438 (\u0432\u0438\u0436 \u0441\u043F\u0438\u0441\u044A\u043A\u0430).",
          { title: "\u0428\u0430\u0431\u043B\u043E\u043D\u044A\u0442 \u0435 \u043A\u0430\u0447\u0435\u043D \u0441 \u043F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u044F", duration: 5500 }
        );
      } else {
        window.toast && window.toast.success(
          "\u041A\u0430\u0447\u0435\u043D: " + name + " \u2014 " + cat.recognized.length + " placeholders \u0440\u0430\u0437\u043F\u043E\u0437\u043D\u0430\u0442\u0438.",
          { title: "\u0428\u0430\u0431\u043B\u043E\u043D\u044A\u0442 \u0435 \u043E\u0431\u043D\u043E\u0432\u0435\u043D", duration: 4500 }
        );
      }
    } catch (err) {
      console.error(err);
      window.toast && window.toast.error(
        "\u0413\u0440\u0435\u0448\u043A\u0430 \u043F\u0440\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430: " + (err && err.message || err),
        { title: "\u041D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043A\u0430\u0447\u0432\u0430\u043D\u0435", duration: 6e3 }
      );
    } finally {
      setBusy(false);
    }
  };
  const removeTemplate = () => {
    store.clearContractTemplate();
    setValidation(null);
    window.toast && window.toast.info(
      "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u0438\u044F\u0442 \u0448\u0430\u0431\u043B\u043E\u043D \u0435 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0430\u0442. \u041F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0442\u043E \u0449\u0435 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430 \u0432\u0433\u0440\u0430\u0434\u0435\u043D\u0438\u044F layout, \u0434\u043E\u043A\u0430\u0442\u043E \u043D\u0435 \u043A\u0430\u0447\u0438\u0442\u0435 \u043D\u043E\u0432.",
      { title: "\u0428\u0430\u0431\u043B\u043E\u043D\u044A\u0442 \u0435 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0430\u0442", duration: 4e3 }
    );
  };
  return /* @__PURE__ */ React.createElement("div", { style: { maxWidth: 720 } }, /* @__PURE__ */ React.createElement(
    SectionHeader,
    {
      title: "Contract template",
      subtitle: "Upload the DOCX contract template. It uses {{PLACEHOLDER}} tags \u2014 see reference below."
    }
  ), /* @__PURE__ */ React.createElement(
    "input",
    {
      ref: fileInputRef,
      type: "file",
      accept: ".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      style: { position: "absolute", width: 1, height: 1, opacity: 0, pointerEvents: "none" },
      onChange: (e) => handleFile(e.target.files && e.target.files[0])
    }
  ), /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginBottom: 16 } }, template ? /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 14 } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 48,
    height: 48,
    borderRadius: 12,
    background: T.blueTint,
    color: T.blue,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "file", size: 22, color: T.blue })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } }, template.name), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginTop: 2 } }, "Uploaded ", fmtDateBG(new Date(template.uploadedAt)), " \xB7 ", template.tokens.length, " placeholder", template.tokens.length === 1 ? "" : "s", " detected \xB7 ", (template.size / 1024).toFixed(1), " KB")), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "sm", icon: "eye", disabled: busy, onClick: () => setPreviewing(true) }, "Preview"), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "sm", icon: busy ? "refresh" : null, disabled: busy, onClick: openPicker }, busy ? "Working\u2026" : "Replace"), /* @__PURE__ */ React.createElement(IconBtn, { icon: "trash", size: 32, title: "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0438 \u0448\u0430\u0431\u043B\u043E\u043D\u0430", onClick: removeTemplate })) : (
    // No custom template — show a builtin-fallback card + the upload button.
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 14 } }, /* @__PURE__ */ React.createElement("div", { style: {
      width: 48,
      height: 48,
      borderRadius: 12,
      background: T.bg2,
      color: T.text2,
      border: `1px solid ${T.border}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0
    } }, /* @__PURE__ */ React.createElement(Icon, { name: "file", size: 22, color: T.text2 })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 700 } }, "Built-in template"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginTop: 2 } }, "\u041D\u044F\u043C\u0430 \u043A\u0430\u0447\u0435\u043D \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D .docx. \u041F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0442\u043E \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430 \u0432\u0433\u0440\u0430\u0434\u0435\u043D\u0438\u044F layout \u0437\u0430 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0438. \u041A\u0430\u0447\u0435\u0442\u0435 \u0441\u0432\u043E\u0439 \u0448\u0430\u0431\u043B\u043E\u043D, \u0437\u0430 \u0434\u0430 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u0438\u0440\u0430\u0442\u0435 \u0442\u043E\u0447\u043D\u0438\u044F \u0442\u0435\u043A\u0441\u0442 \u0438 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435.")), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "sm", icon: "eye", disabled: busy, onClick: () => setPreviewing(true) }, "Preview"), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "sm", icon: busy ? "refresh" : "plus", disabled: busy, onClick: openPicker }, busy ? "Working\u2026" : "Upload"))
  )), validation && /* @__PURE__ */ React.createElement(TemplateValidationCard, { v: validation, onDismiss: () => setValidation(null) }), previewing && /* @__PURE__ */ React.createElement(
    TemplatePreviewModal,
    {
      template,
      onClose: () => setPreviewing(false)
    }
  ), /* @__PURE__ */ React.createElement(Card, { pad: 16, style: { marginBottom: 20, background: T.blueTint, borderColor: "rgba(59,118,240,0.3)" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 12, alignItems: "flex-start" } }, /* @__PURE__ */ React.createElement(Icon, { name: "info", size: 20, color: T.blue }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600, color: "#93C5FD" } }, "Edit contracts in Word"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text1, marginTop: 4, lineHeight: 1.5 } }, "Open the DOCX in Word. Edit any wording you like. Use the placeholders below inside ", /* @__PURE__ */ React.createElement("span", { className: "mono" }, `{{ }}`), " tags. Save and re-upload \u2014 next rental will use the new version.")))), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 12 } }, "Supported placeholders (", PLACEHOLDERS.length, ")"), /* @__PURE__ */ React.createElement(Card, { pad: 0 }, PLACEHOLDERS.map((p, i) => /* @__PURE__ */ React.createElement("div", { key: p.key, style: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    padding: "10px 14px",
    borderBottom: i < PLACEHOLDERS.length - 1 ? `1px solid ${T.border}` : "none"
  } }, /* @__PURE__ */ React.createElement("div", { className: "mono", style: {
    fontSize: 12,
    fontWeight: 600,
    background: T.accentTint,
    color: "#7EA8FF",
    padding: "4px 8px",
    borderRadius: 5,
    width: 220,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  } }, `{{${p.key}}}`), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text1, flex: 1 } }, p.desc), /* @__PURE__ */ React.createElement(IconBtn, { icon: "copy", size: 30, title: "Copy placeholder", onClick: () => {
    const text = "{{" + p.key + "}}";
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(
        () => window.toast && window.toast.success("\u041A\u043E\u043F\u0438\u0440\u0430\u043D\u043E \u0432 clipboard: " + text, { duration: 2e3 }),
        () => window.toast && window.toast.warn("Clipboard API \u043D\u0435 \u0435 \u0434\u043E\u0441\u0442\u044A\u043F\u0435\u043D. \u0420\u044A\u0447\u043D\u043E \u043A\u043E\u043F\u0438\u0440\u0430\u043D\u0435: " + text, { duration: 3e3 })
      );
    } else {
      window.toast && window.toast.info("Placeholder: " + text, { duration: 3e3 });
    }
  } })))), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 12, fontSize: 12, color: T.text2 } }, "Unknown placeholders in a template are left empty and reported after generation. Missing placeholders cause no error."));
}
function SectionCompany() {
  store.useStore();
  const stored = store.companySettings();
  const [draft, setDraft] = useState(stored);
  React.useEffect(() => {
    const clean = JSON.stringify(draft) === JSON.stringify(stored);
    if (clean) setDraft(stored);
  }, [stored.legal, stored.brand, stored.eik, stored.vatId, stored.address, stored.phone, stored.email, stored.reviewLink, stored.handoverAddress]);
  const dirty = JSON.stringify(draft) !== JSON.stringify(stored);
  const set = (k, v) => setDraft((d) => ({ ...d, [k]: v }));
  const save = () => {
    store.updateCompany(draft);
    window.toast && window.toast.success(
      "\u0414\u0430\u043D\u043D\u0438\u0442\u0435 \u043D\u0430 \u0444\u0438\u0440\u043C\u0430\u0442\u0430 \u0441\u0430 \u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0438. \u0412\u0441\u0438\u0447\u043A\u0438 \u043D\u043E\u0432\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u0449\u0435 \u0433\u0438 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0442.",
      { title: "Company data saved", duration: 3500 }
    );
  };
  const revert = () => setDraft(stored);
  return /* @__PURE__ */ React.createElement("div", { style: { maxWidth: 720 } }, /* @__PURE__ */ React.createElement(
    SectionHeader,
    {
      title: "Company data",
      subtitle: "Used on all generated documents and emails.",
      right: dirty ? /* @__PURE__ */ React.createElement(Chip, { tone: "yellow", size: "sm" }, "\u041D\u0435\u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u0438") : /* @__PURE__ */ React.createElement(Chip, { tone: "green", size: "sm", icon: "check" }, "Saved")
    }
  ), /* @__PURE__ */ React.createElement(Card, { pad: 24 }, /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 } }, /* @__PURE__ */ React.createElement(Field, { label: "Legal name" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", value: draft.legal, onChange: (e) => set("legal", e.target.value) })), /* @__PURE__ */ React.createElement(Field, { label: "Brand" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", value: draft.brand, onChange: (e) => set("brand", e.target.value) })), /* @__PURE__ */ React.createElement(Field, { label: "\u0415\u0418\u041A" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: draft.eik, onChange: (e) => set("eik", e.target.value) })), /* @__PURE__ */ React.createElement(Field, { label: "VAT / \u0414\u0414\u0421 \u2116" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: draft.vatId, onChange: (e) => set("vatId", e.target.value) })), /* @__PURE__ */ React.createElement(Field, { label: "Address", style: { gridColumn: "1 / -1" } }, /* @__PURE__ */ React.createElement(Input, { size: "lg", value: draft.address, onChange: (e) => set("address", e.target.value) })), /* @__PURE__ */ React.createElement(Field, { label: "Phone" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: draft.phone, onChange: (e) => set("phone", e.target.value) })), /* @__PURE__ */ React.createElement(Field, { label: "Email" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", value: draft.email, onChange: (e) => set("email", e.target.value) })), /* @__PURE__ */ React.createElement(Field, { label: "Handover address", hint: "\u041C\u044F\u0441\u0442\u043E \u043D\u0430 \u043F\u0440\u0435\u0434\u0430\u0432\u0430\u043D\u0435 \u2014 \u043F\u043E\u043F\u044A\u043B\u0432\u0430 \u0441\u0435 \u0432 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 ({{HANDOVER_ADDRESS}})", style: { gridColumn: "1 / -1" } }, /* @__PURE__ */ React.createElement(Input, { size: "lg", value: draft.handoverAddress, onChange: (e) => set("handoverAddress", e.target.value) })), /* @__PURE__ */ React.createElement(Field, { label: "Google Review link", style: { gridColumn: "1 / -1" } }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: draft.reviewLink, onChange: (e) => set("reviewLink", e.target.value) }))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10, marginTop: 16, justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "md", disabled: !dirty, onClick: revert }, "\u041E\u0442\u043C\u0435\u043D\u0438"), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "md", icon: "check", disabled: !dirty, onClick: save }, "\u0417\u0430\u043F\u0430\u0437\u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435"))));
}
function SectionOperator() {
  store.useStore();
  const stored = store.operatorProfile();
  const [draft, setDraft] = useState(stored);
  const [savedOnce, setSavedOnce] = useState(false);
  const [pendingSig, setPendingSig] = useState(null);
  const [recapture, setRecapture] = useState(false);
  React.useEffect(() => {
    const clean = JSON.stringify(draft) === JSON.stringify(stored);
    if (clean) setDraft(stored);
  }, [stored.name, stored.role, stored.phone, stored.email]);
  const dirty = draft.name !== stored.name || draft.role !== stored.role || (draft.phone || "") !== (stored.phone || "") || (draft.email || "") !== (stored.email || "");
  const set = (k, v) => setDraft((d) => ({ ...d, [k]: v }));
  const saveIdentity = () => {
    store.updateOperatorProfile({
      name: draft.name.trim(),
      role: draft.role.trim(),
      phone: (draft.phone || "").trim(),
      email: (draft.email || "").trim()
    });
    setSavedOnce(true);
    window.toast && window.toast.success(
      "\u041F\u0440\u043E\u0444\u0438\u043B\u044A\u0442 \u0435 \u0437\u0430\u043F\u0430\u0437\u0435\u043D. \u0429\u0435 \u0441\u0435 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430 \u0432 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0438 \u0438 sidebar.",
      { title: "Operator profile saved", duration: 3500 }
    );
  };
  const revertIdentity = () => setDraft(stored);
  const commitSignature = () => {
    if (!pendingSig || pendingSig === true) return;
    store.setOperatorSignature(pendingSig);
    setPendingSig(null);
    setRecapture(false);
    window.toast && window.toast.success(
      "\u041F\u043E\u0434\u043F\u0438\u0441\u044A\u0442 \u0435 \u0437\u0430\u043F\u0438\u0441\u0430\u043D. \u0429\u0435 \u0441\u0435 \u0432\u0433\u0440\u0430\u0436\u0434\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u0432 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u0442\u0435.",
      { title: "Signature saved", duration: 3500 }
    );
  };
  const deleteSignature = () => {
    store.setOperatorSignature(null);
    setPendingSig(null);
    setRecapture(false);
    window.toast && window.toast.warn(
      "\u041F\u043E\u0434\u043F\u0438\u0441\u044A\u0442 \u0435 \u0438\u0437\u0442\u0440\u0438\u0442. \u0413\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0438 \u0449\u0435 \u0431\u044A\u0434\u0435 \u0431\u043B\u043E\u043A\u0438\u0440\u0430\u043D\u043E, \u0434\u043E\u043A\u0430\u0442\u043E \u043D\u0435 \u0437\u0430\u043F\u0438\u0448\u0435\u0442\u0435 \u043D\u043E\u0432.",
      { title: "Signature removed", duration: 4200 }
    );
  };
  const hasStoredSig = !!stored.signatureDataUrl;
  const showCapture = !hasStoredSig || recapture;
  return /* @__PURE__ */ React.createElement("div", { style: { maxWidth: 720 } }, /* @__PURE__ */ React.createElement(
    SectionHeader,
    {
      title: "Operator profile",
      subtitle: "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0438 \u043F\u043E\u0434\u043F\u0438\u0441, \u043A\u043E\u0438\u0442\u043E \u0441\u0435 \u0432\u0433\u0440\u0430\u0436\u0434\u0430\u0442 \u0432 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u0442\u0435 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0430 \u043D\u0430 \u041D\u0410\u0415\u041C\u041E\u0414\u0410\u0422\u0415\u041B.",
      right: dirty ? /* @__PURE__ */ React.createElement(Chip, { tone: "yellow", size: "sm" }, "\u041D\u0435\u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u0438") : savedOnce ? /* @__PURE__ */ React.createElement(Chip, { tone: "green", size: "sm", icon: "check" }, "Saved") : null
    }
  ), /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 10 } }, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 } }, /* @__PURE__ */ React.createElement(Field, { label: "\u041F\u044A\u043B\u043D\u043E \u0438\u043C\u0435" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", value: draft.name, onChange: (e) => set("name", e.target.value), placeholder: "\u041D\u0438\u043A\u043E\u043B\u0430\u0439 \u041C\u0443\u0442\u0430\u0444\u0447\u0438\u0435\u0432" })), /* @__PURE__ */ React.createElement(Field, { label: "\u0414\u043B\u044A\u0436\u043D\u043E\u0441\u0442 / \u0440\u043E\u043B\u044F" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", value: draft.role, onChange: (e) => set("role", e.target.value), placeholder: "\u0423\u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B" })), /* @__PURE__ */ React.createElement(Field, { label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: draft.phone || "", onChange: (e) => set("phone", e.target.value), placeholder: "+359 \u2026" })), /* @__PURE__ */ React.createElement(Field, { label: "Email" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", value: draft.email || "", onChange: (e) => set("email", e.target.value), placeholder: "office@\u2026" }))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10, marginTop: 16, justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "md", disabled: !dirty, onClick: revertIdentity }, "\u041E\u0442\u043C\u0435\u043D\u0438"), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "md", icon: "check", disabled: !dirty, onClick: saveIdentity }, "\u0417\u0430\u043F\u0430\u0437\u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435"))), /* @__PURE__ */ React.createElement(Card, { pad: 20 }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "baseline", justifyContent: "space-between", marginBottom: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 } }, "\u041F\u043E\u0434\u043F\u0438\u0441 \u043D\u0430 \u043D\u0430\u0435\u043C\u043E\u0434\u0430\u0442\u0435\u043B\u044F"), hasStoredSig && !recapture && /* @__PURE__ */ React.createElement(Chip, { tone: "green", size: "sm", icon: "check" }, "\u0417\u0430\u043F\u0438\u0441\u0430\u043D"), !hasStoredSig && /* @__PURE__ */ React.createElement(Chip, { tone: "red", size: "sm", icon: "warn" }, "\u041B\u0438\u043F\u0441\u0432\u0430")), hasStoredSig && !recapture && /* @__PURE__ */ React.createElement("div", { style: {
    padding: 16,
    background: "#F7F6F2",
    borderRadius: 10,
    border: `1px solid ${T.border}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 130
  } }, /* @__PURE__ */ React.createElement(
    "img",
    {
      src: stored.signatureDataUrl,
      alt: "Operator signature",
      style: { maxHeight: 110, maxWidth: "80%", objectFit: "contain" }
    }
  )), hasStoredSig && !recapture && stored.signatureCapturedAt && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, marginTop: 8 } }, "\u0417\u0430\u043F\u0438\u0441\u0430\u043D ", fmtDateBG(new Date(stored.signatureCapturedAt)), " \xB7 \u0429\u0435 \u0441\u0435 \u0432\u0433\u0440\u0430\u0436\u0434\u0430 \u0432 \u041D\u0410\u0415\u041C\u041E\u0414\u0410\u0422\u0415\u041B \u043F\u043E\u043B\u0435\u0442\u043E \u043D\u0430 \u0434\u043E\u0433\u043E\u0432\u043E\u0440, \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B \u0438 addendum."), showCapture && /* @__PURE__ */ React.createElement("div", { style: { background: "#F7F6F2", padding: 16, borderRadius: 10, border: `1px solid ${T.border}` } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: "#0F1420", marginBottom: 8, fontWeight: 600 } }, "\u041F\u043E\u0434\u043F\u0438\u0448\u0435\u0442\u0435 \u0432 \u043F\u043E\u043B\u0435\u0442\u043E (\u0432\u0435\u0434\u043D\u044A\u0436, \u0449\u0435 \u0441\u0435 \u0437\u0430\u043F\u0430\u0437\u0438 \u0437\u0430 \u0432\u0441\u0438\u0447\u043A\u0438 \u0431\u044A\u0434\u0435\u0449\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0438)"), window.SignaturePad ? /* @__PURE__ */ React.createElement(SignaturePad, { value: pendingSig, onChange: setPendingSig }) : /* @__PURE__ */ React.createElement("div", { style: { color: T.red, fontSize: 13 } }, "SignaturePad \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u044A\u0442 \u043D\u0435 \u0435 \u0437\u0430\u0440\u0435\u0434\u0435\u043D.")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10, marginTop: 14, justifyContent: "flex-end", flexWrap: "wrap" } }, hasStoredSig && !recapture && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "md", icon: "edit", onClick: () => {
    setRecapture(true);
    setPendingSig(null);
  } }, "\u041F\u043E\u0434\u043F\u0438\u0448\u0438 \u043D\u0430\u043D\u043E\u0432\u043E"), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "md", icon: "trash", danger: true, onClick: deleteSignature }, "\u0418\u0437\u0442\u0440\u0438\u0439")), showCapture && /* @__PURE__ */ React.createElement(React.Fragment, null, recapture && /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "md", onClick: () => {
    setRecapture(false);
    setPendingSig(null);
  } }, "\u041E\u0442\u043A\u0430\u0437"), /* @__PURE__ */ React.createElement(
    Button,
    {
      kind: "primary",
      size: "md",
      icon: "check",
      disabled: !pendingSig || pendingSig === true,
      onClick: commitSignature
    },
    "\u0417\u0430\u043F\u0430\u0437\u0438 \u043F\u043E\u0434\u043F\u0438\u0441\u0430"
  ))), !hasStoredSig && /* @__PURE__ */ React.createElement("div", { style: {
    marginTop: 12,
    padding: "10px 12px",
    background: T.redTint,
    border: "1px solid rgba(239,68,68,0.28)",
    borderRadius: 8,
    display: "flex",
    gap: 10,
    alignItems: "flex-start"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "warn", size: 16, color: T.red, style: { marginTop: 2, flexShrink: 0 } }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text1, lineHeight: 1.5 } }, /* @__PURE__ */ React.createElement("strong", { style: { color: "#FCA5A5" } }, "\u041D\u044F\u043C\u0430 \u0437\u0430\u043F\u0438\u0441\u0430\u043D \u043F\u043E\u0434\u043F\u0438\u0441."), " ", '\u0413\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0438 \u0449\u0435 \u0431\u044A\u0434\u0435 \u0431\u043B\u043E\u043A\u0438\u0440\u0430\u043D\u043E, \u0434\u043E\u043A\u0430\u0442\u043E \u043D\u0435 \u0437\u0430\u043F\u0438\u0448\u0435\u0442\u0435 \u043F\u043E\u0434\u043F\u0438\u0441. \u0422\u043E\u0437\u0438 \u043F\u043E\u0434\u043F\u0438\u0441 \u0449\u0435 \u0437\u0430\u043C\u0435\u0441\u0442\u0438 \u043F\u043E\u043B\u0435\u0442\u043E \u201E\u041D\u0410\u0415\u041C\u041E\u0414\u0410\u0422\u0415\u041B" \u0432\u044A\u0432 \u0432\u0441\u0435\u043A\u0438 \u0431\u044A\u0434\u0435\u0449 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442.'))), /* @__PURE__ */ React.createElement(SectionChangePassword, null));
}
function SectionChangePassword() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNext, setShowNext] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const filled = current.length > 0 && next.length > 0 && confirm.length > 0;
  const matches = next === confirm;
  const canSave = filled && matches && !submitting;
  const eyeToggle = (show, setShow) => /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: () => setShow((v) => !v),
      style: { background: "transparent", border: "none", cursor: "pointer", display: "flex", alignItems: "center", padding: 0 },
      title: show ? "Hide password" : "Show password"
    },
    /* @__PURE__ */ React.createElement(Icon, { name: show ? "eyeOff" : "eye", size: 16, color: T.text2 })
  );
  const submit = async () => {
    setError(null);
    if (!filled) return;
    if (!matches) {
      setError("New password and confirmation do not match.");
      return;
    }
    if (next.length < 10) {
      setError("New password must be at least 10 characters.");
      return;
    }
    if (next === current) {
      setError("New password must be different from the current password.");
      return;
    }
    setSubmitting(true);
    try {
      await window.store.changePassword(current, next);
      setCurrent("");
      setNext("");
      setConfirm("");
      setShowCurrent(false);
      setShowNext(false);
      setShowConfirm(false);
      window.toast && window.toast.success("Password changed", { title: "Password changed", duration: 3500 });
    } catch (err) {
      setError(err && err.message || "Failed to change password.");
    } finally {
      setSubmitting(false);
    }
  };
  return /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginTop: 16, maxWidth: 480 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 14 } }, "Change password"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 14 } }, /* @__PURE__ */ React.createElement(Field, { label: "Current password" }, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: showCurrent ? "text" : "password",
      size: "lg",
      value: current,
      onChange: (e) => {
        setCurrent(e.target.value);
        setError(null);
      },
      placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
      suffix: eyeToggle(showCurrent, setShowCurrent)
    }
  )), /* @__PURE__ */ React.createElement(Field, { label: "New password" }, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: showNext ? "text" : "password",
      size: "lg",
      value: next,
      onChange: (e) => {
        setNext(e.target.value);
        setError(null);
      },
      placeholder: "min. 10 characters",
      suffix: eyeToggle(showNext, setShowNext)
    }
  )), /* @__PURE__ */ React.createElement(Field, { label: "Confirm new password" }, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: showConfirm ? "text" : "password",
      size: "lg",
      value: confirm,
      onChange: (e) => {
        setConfirm(e.target.value);
        setError(null);
      },
      placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
      suffix: eyeToggle(showConfirm, setShowConfirm)
    }
  )), error && /* @__PURE__ */ React.createElement("div", { style: {
    fontSize: 12.5,
    color: "#F87171",
    background: T.redTint,
    border: "1px solid rgba(239,68,68,0.4)",
    borderRadius: 10,
    padding: "10px 12px"
  } }, error), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "md", icon: "check", disabled: !canSave, onClick: submit }, submitting ? "Saving\u2026" : "Save"))));
}
function SectionLegal() {
  store.useStore();
  const texts = store.legalTexts();
  const [gdpr, setGdpr] = useState(texts.gdpr);
  const [decl, setDecl] = useState(texts.declaration);
  const dirtyGdpr = gdpr !== texts.gdpr;
  const dirtyDecl = decl !== texts.declaration;
  const save = (which) => {
    if (which === "gdpr") store.updateLegalTexts({ gdpr });
    else store.updateLegalTexts({ declaration: decl });
    window.toast && window.toast.success(
      "\u0422\u0435\u043A\u0441\u0442\u044A\u0442 \u0435 \u0437\u0430\u043F\u0430\u0437\u0435\u043D. \u0421\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F\u0442 \u043A\u043B\u0438\u0435\u043D\u0442 \u0449\u0435 \u043F\u043E\u0434\u043F\u0438\u0448\u0435 \u0430\u043A\u0442\u0443\u0430\u043B\u043D\u0430\u0442\u0430 \u0432\u0435\u0440\u0441\u0438\u044F.",
      { title: which === "gdpr" ? "GDPR \u0442\u0435\u043A\u0441\u0442 \u043E\u0431\u043D\u043E\u0432\u0435\u043D" : "\u0414\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0438\u044F \u043E\u0431\u043D\u043E\u0432\u0435\u043D\u0430", duration: 3500 }
    );
  };
  const resetAll = () => {
    store.resetLegalTexts();
    const fresh = store.legalTexts();
    setGdpr(fresh.gdpr);
    setDecl(fresh.declaration);
    window.toast && window.toast.info("\u0422\u0435\u043A\u0441\u0442\u043E\u0432\u0435\u0442\u0435 \u0441\u0430 \u0432\u044A\u0440\u043D\u0430\u0442\u0438 \u043A\u044A\u043C default \u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442\u0438\u0442\u0435.", { duration: 3e3 });
  };
  return /* @__PURE__ */ React.createElement("div", { style: { maxWidth: 720 } }, /* @__PURE__ */ React.createElement(
    SectionHeader,
    {
      title: "Legal texts",
      subtitle: "Edit the customer-facing consent and declaration texts (Bulgarian). The next customer will sign the version you save here.",
      right: /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "sm", icon: "refresh", onClick: resetAll }, "Reset to default")
    }
  ), /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "baseline", justifyContent: "space-between", marginBottom: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700 } }, "GDPR consent"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center" } }, dirtyGdpr && /* @__PURE__ */ React.createElement(Chip, { tone: "yellow", size: "sm" }, "\u041D\u0435\u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u0438"), !dirtyGdpr && /* @__PURE__ */ React.createElement(Chip, { tone: "green", size: "sm" }, "Active"))), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2, marginBottom: 8 } }, "\u041E\u0442\u0434\u0435\u043B\u043D\u0438 \u0430\u0431\u0437\u0430\u0446\u0438 \u0441\u044A\u0441 \u043F\u0440\u0430\u0437\u0435\u043D \u0440\u0435\u0434 \u043C\u0435\u0436\u0434\u0443 \u0442\u044F\u0445. \u0422\u043E\u0437\u0438 \u0442\u0435\u043A\u0441\u0442 \u0435 \u0442\u043E\u0447\u043D\u043E \u0442\u043E\u0432\u0430, \u043A\u043E\u0435\u0442\u043E \u043A\u043B\u0438\u0435\u043D\u0442\u044A\u0442 \u0432\u0438\u0436\u0434\u0430 \u0432 GDPR \u0435\u043A\u0440\u0430\u043D\u0430."), /* @__PURE__ */ React.createElement(Textarea, { rows: 12, value: gdpr, onChange: (e) => setGdpr(e.target.value) }), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, marginTop: 10, justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "sm", disabled: !dirtyGdpr, onClick: () => setGdpr(texts.gdpr) }, "\u041E\u0442\u043C\u0435\u043D\u0438"), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "sm", icon: "check", disabled: !dirtyGdpr, onClick: () => save("gdpr") }, "\u0417\u0430\u043F\u0430\u0437\u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435"))), /* @__PURE__ */ React.createElement(Card, { pad: 20 }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "baseline", justifyContent: "space-between", marginBottom: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700 } }, "Returning-customer declaration"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "center" } }, dirtyDecl && /* @__PURE__ */ React.createElement(Chip, { tone: "yellow", size: "sm" }, "\u041D\u0435\u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u0438"), !dirtyDecl && /* @__PURE__ */ React.createElement(Chip, { tone: "green", size: "sm" }, "Active"))), /* @__PURE__ */ React.createElement(Textarea, { rows: 9, value: decl, onChange: (e) => setDecl(e.target.value) }), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, marginTop: 10, justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "sm", disabled: !dirtyDecl, onClick: () => setDecl(texts.declaration) }, "\u041E\u0442\u043C\u0435\u043D\u0438"), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "sm", icon: "check", disabled: !dirtyDecl, onClick: () => save("declaration") }, "\u0417\u0430\u043F\u0430\u0437\u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435"))));
}
function SectionEmail() {
  store.useStore();
  const stored = store.smtpSettings();
  const templates = store.emailTemplates();
  const [tab, setTab] = useState("sent");
  const [draft, setDraft] = useState(stored);
  const [showPwd, setShowPwd] = useState(false);
  const [editingTemplateId, setEditingTemplateId] = useState(null);
  const [savedOnce, setSavedOnce] = useState(false);
  React.useEffect(() => {
    const clean = JSON.stringify(draft) === JSON.stringify(stored);
    if (clean) setDraft(stored);
  }, [stored.host, stored.port, stored.username, stored.password, stored.senderName, stored.replyTo]);
  const dirty = JSON.stringify(draft) !== JSON.stringify(stored);
  const set = (k, v) => setDraft((d) => ({ ...d, [k]: v }));
  const save = () => {
    store.updateSMTP(draft);
    setSavedOnce(true);
    window.toast && window.toast.success(
      "SMTP \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u0442\u0435 \u0441\u0430 \u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0438. \u0420\u0435\u0430\u043B\u043D\u043E\u0442\u043E \u0438\u0437\u043F\u0440\u0430\u0449\u0430\u043D\u0435 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430 \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044F\u0442\u0430 \u043D\u0430 \u0441\u044A\u0440\u0432\u044A\u0440\u0430.",
      { title: "SMTP settings saved", duration: 3500 }
    );
  };
  const revert = () => setDraft(stored);
  const tabs = [
    { id: "sent", label: "\u0418\u0437\u043F\u0440\u0430\u0442\u0435\u043D\u0438" },
    { id: "templates", label: "\u0428\u0430\u0431\u043B\u043E\u043D\u0438" },
    { id: "smtp", label: "SMTP" }
  ];
  return /* @__PURE__ */ React.createElement("div", { style: { maxWidth: 720 } }, /* @__PURE__ */ React.createElement(
    SectionHeader,
    {
      title: "\u0418\u043C\u0435\u0439\u043B\u0438",
      subtitle: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0438 \u0438\u043C\u0435\u0439\u043B\u0438 \u043A\u044A\u043C \u043A\u043B\u0438\u0435\u043D\u0442\u0438\u0442\u0435 \u2014 \u0434\u043D\u0435\u0432\u043D\u0438\u043A, \u0448\u0430\u0431\u043B\u043E\u043D\u0438 \u0438 SMTP.",
      right: tab === "smtp" && dirty ? /* @__PURE__ */ React.createElement(Chip, { tone: "yellow", size: "sm" }, "\u041D\u0435\u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u0438") : tab === "smtp" && savedOnce ? /* @__PURE__ */ React.createElement(Chip, { tone: "green", size: "sm", icon: "check" }, "Saved") : null
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6, marginBottom: 16 } }, tabs.map((t) => /* @__PURE__ */ React.createElement("button", { key: t.id, onClick: () => setTab(t.id), style: {
    padding: "8px 16px",
    borderRadius: 10,
    fontSize: 13,
    fontWeight: 600,
    background: tab === t.id ? T.bg2 : "transparent",
    border: `1px solid ${tab === t.id ? T.border : "transparent"}`,
    color: tab === t.id ? T.text0 : T.text1,
    cursor: "pointer"
  } }, t.label))), tab === "sent" && /* @__PURE__ */ React.createElement(SentEmailsPanel, null), tab === "templates" && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "baseline", justifyContent: "space-between", marginBottom: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 } }, "\u0428\u0430\u0431\u043B\u043E\u043D\u0438 (\u043D\u0430 \u0431\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438) \u2014 \u043F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435 \u0432\u0430\u0436\u0430\u0442 \u0432\u0435\u0434\u043D\u0430\u0433\u0430"), /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "sm", icon: "refresh", onClick: () => {
    store.resetEmailTemplates();
    window.toast && window.toast.info("\u0428\u0430\u0431\u043B\u043E\u043D\u0438\u0442\u0435 \u0441\u0430 \u0432\u044A\u0440\u043D\u0430\u0442\u0438 \u043A\u044A\u043C default.", { duration: 3e3 });
  } }, "Reset all")), /* @__PURE__ */ React.createElement(Card, { pad: 0 }, Object.values(templates).map((tmpl, i, arr) => /* @__PURE__ */ React.createElement("div", { key: tmpl.id, style: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    padding: "14px 18px",
    borderBottom: i < arr.length - 1 ? `1px solid ${T.border}` : "none"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "mail", size: 18, color: T.text2 }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13.5, fontWeight: 600 } }, tmpl.name), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2, marginTop: 2 } }, tmpl.trigger)), /* @__PURE__ */ React.createElement(
    Toggle,
    {
      value: tmpl.enabled,
      onChange: (v) => {
        store.updateEmailTemplate(tmpl.id, { enabled: v });
        window.toast && window.toast.info(
          (v ? "\u0410\u043A\u0442\u0438\u0432\u0438\u0440\u0430\u043D" : "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0430\u043D") + ": " + tmpl.name,
          { duration: 2500 }
        );
      }
    }
  ), /* @__PURE__ */ React.createElement(IconBtn, { icon: "edit", size: 32, title: "Edit template", onClick: () => setEditingTemplateId(tmpl.id) })))), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2, marginTop: 10, lineHeight: 1.5 } }, "\u0422\u0435\u043A\u0441\u0442\u043E\u0432\u0435\u0442\u0435 (\u0432\u043A\u043B. \u0432\u0441\u0438\u0447\u043A\u0438 \u0446\u0435\u043D\u0438 \u2014 25 \u20AC, 20 \u20AC, 20% \u0438 EV \u0440\u0435\u0434\u044A\u0442) \u0441\u0435 \u043F\u0430\u0437\u044F\u0442 \u0432 \u0431\u0430\u0437\u0430\u0442\u0430 \u0438 \u0441\u0435 \u043F\u0440\u0438\u043B\u0430\u0433\u0430\u0442 \u043F\u0440\u0438 \u0441\u043B\u0435\u0434\u0432\u0430\u0449\u043E\u0442\u043E \u0438\u0437\u043F\u0440\u0430\u0449\u0430\u043D\u0435, \u0431\u0435\u0437 \u043D\u0443\u0436\u0434\u0430 \u043E\u0442 deploy. \u0414\u0438\u0437\u0430\u0439\u043D\u044A\u0442 (\u0446\u0432\u0435\u0442\u043E\u0432\u0435/\u0440\u0430\u043C\u043A\u0430) \u0435 \u0444\u0438\u043A\u0441\u0438\u0440\u0430\u043D \u0432 \u043A\u043E\u0434\u0430.")), tab === "smtp" && /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 } }, /* @__PURE__ */ React.createElement(Field, { label: "SMTP host" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: draft.host, onChange: (e) => set("host", e.target.value), placeholder: "mail.example.com" })), /* @__PURE__ */ React.createElement(Field, { label: "Port" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: draft.port, onChange: (e) => set("port", e.target.value), placeholder: "587" })), /* @__PURE__ */ React.createElement(Field, { label: "Username" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: draft.username, onChange: (e) => set("username", e.target.value), placeholder: "office@example.com" })), /* @__PURE__ */ React.createElement(Field, { label: "Password" }, /* @__PURE__ */ React.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React.createElement(
    Input,
    {
      size: "lg",
      mono: true,
      value: draft.password,
      onChange: (e) => set("password", e.target.value),
      type: showPwd ? "text" : "password",
      style: { paddingRight: 44 },
      placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022"
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: () => setShowPwd((s) => !s),
      title: showPwd ? "Hide password" : "Show password",
      style: {
        position: "absolute",
        right: 6,
        top: "50%",
        transform: "translateY(-50%)",
        background: "transparent",
        border: "none",
        cursor: "pointer",
        padding: 6,
        borderRadius: 6,
        color: T.text2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    },
    /* @__PURE__ */ React.createElement(Icon, { name: showPwd ? "eyeOff" : "eye", size: 16, color: T.text2 })
  ))), /* @__PURE__ */ React.createElement(Field, { label: "Sender name" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", value: draft.senderName, onChange: (e) => set("senderName", e.target.value) })), /* @__PURE__ */ React.createElement(Field, { label: "Reply-to" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", value: draft.replyTo, onChange: (e) => set("replyTo", e.target.value) }))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10, marginTop: 16, alignItems: "center" } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }), /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "md", disabled: !dirty, onClick: revert }, "\u041E\u0442\u043C\u0435\u043D\u0438"), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "md", icon: "check", disabled: !dirty, onClick: save }, "\u0417\u0430\u043F\u0430\u0437\u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435")), /* @__PURE__ */ React.createElement("div", { style: {
    marginTop: 12,
    padding: "10px 12px",
    background: T.yellowTint,
    border: "1px solid rgba(245,165,36,0.28)",
    borderRadius: 8,
    display: "flex",
    gap: 10,
    alignItems: "flex-start"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "info", size: 16, color: T.yellow, style: { marginTop: 2, flexShrink: 0 } }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text1, lineHeight: 1.5 } }, /* @__PURE__ */ React.createElement("strong", { style: { color: "#FBBF24" } }, "\u0420\u0435\u0430\u043B\u043D\u043E\u0442\u043E \u0438\u0437\u043F\u0440\u0430\u0449\u0430\u043D\u0435 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430 SMTP \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044F\u0442\u0430 \u043D\u0430 \u0441\u044A\u0440\u0432\u044A\u0440\u0430 (env)."), " ", "\u041F\u0440\u043E\u0434\u0443\u043A\u0446\u0438\u043E\u043D\u043D\u0438\u0442\u0435 \u0434\u0430\u043D\u043D\u0438 (SMTP_HOST/PORT/USER/PASS, Reply-To) \u0441\u0435 \u0437\u0430\u0434\u0430\u0432\u0430\u0442 \u0434\u0438\u0440\u0435\u043A\u0442\u043D\u043E \u043D\u0430 \u0441\u044A\u0440\u0432\u044A\u0440\u0430 \u043E\u0442 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u0438\u043A\u0430 \u2014 \u043D\u0438\u043A\u043E\u0433\u0430 \u043F\u0440\u0435\u0437 \u0431\u0440\u0430\u0443\u0437\u044A\u0440\u0430. \u0422\u0430\u0437\u0438 \u043A\u0430\u0440\u0442\u0430 \u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0432\u043D\u0430 \u0438 \u0441\u0435 \u043F\u0430\u0437\u0438 \u0437\u0430 \u0441\u043F\u0440\u0430\u0432\u043A\u0430."))), editingTemplateId && /* @__PURE__ */ React.createElement(
    EmailTemplateEditor,
    {
      template: templates[editingTemplateId],
      onClose: () => setEditingTemplateId(null),
      onSave: (patch) => {
        store.updateEmailTemplate(editingTemplateId, patch);
        setEditingTemplateId(null);
        window.toast && window.toast.success(
          '\u0428\u0430\u0431\u043B\u043E\u043D\u044A\u0442 "' + templates[editingTemplateId].name + '" \u0435 \u0437\u0430\u043F\u0430\u0437\u0435\u043D.',
          { title: "Template saved", duration: 3200 }
        );
      }
    }
  ));
}
function Toggle({ value, onChange }) {
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: () => onChange(!value),
      role: "switch",
      "aria-checked": value,
      style: {
        width: 40,
        height: 22,
        borderRadius: 12,
        position: "relative",
        border: `1px solid ${value ? T.accent : T.border}`,
        background: value ? T.accent : T.bg2,
        transition: "background 0.15s, border-color 0.15s",
        cursor: "pointer",
        padding: 0,
        flexShrink: 0
      }
    },
    /* @__PURE__ */ React.createElement("span", { style: {
      position: "absolute",
      top: 2,
      left: value ? 20 : 2,
      width: 16,
      height: 16,
      borderRadius: "50%",
      background: "#fff",
      transition: "left 0.15s",
      boxShadow: "0 1px 3px rgba(0,0,0,0.3)"
    } })
  );
}
function EmailTemplateEditor({ template, onClose, onSave }) {
  const [subject, setSubject] = useState(template.subject);
  const [body, setBody] = useState(template.body);
  const dirty = subject !== template.subject || body !== template.body;
  const contextPlaceholders = {
    contract: ["{{CUSTOMER_NAME}}", "{{CONTRACT_NUMBER}}", "{{VEHICLE_MAKE_MODEL}}", "{{PLATE}}", "{{DATE_FROM}}", "{{DATE_TO}}"],
    reminder: ["{{CUSTOMER_NAME}}", "{{VEHICLE_MAKE_MODEL}}", "{{PLATE}}", "{{DATE_TO}}", "{{RETURN_TIME}}", "{{EXTENSION_URL}}"],
    thankyou: ["{{CUSTOMER_NAME}}", "{{VEHICLE_MAKE_MODEL}}", "{{PLATE}}"]
  }[template.id] || [];
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      onClick: onClose,
      style: {
        position: "absolute",
        inset: 0,
        background: "rgba(5,7,11,0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 300
      }
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        onClick: (e) => e.stopPropagation(),
        style: {
          width: "min(720px, calc(100% - 40px))",
          maxHeight: "90%",
          background: T.bg1,
          border: `1px solid ${T.border}`,
          borderRadius: 14,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden"
        }
      },
      /* @__PURE__ */ React.createElement("div", { style: {
        padding: "14px 20px",
        borderBottom: `1px solid ${T.border}`,
        display: "flex",
        alignItems: "center",
        gap: 12
      } }, /* @__PURE__ */ React.createElement("div", { style: {
        width: 36,
        height: 36,
        borderRadius: 10,
        background: T.accentTint,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      } }, /* @__PURE__ */ React.createElement(Icon, { name: "mail", size: 18, color: T.accent })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 700 } }, "Edit email template"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2, marginTop: 2 } }, template.name, " \xB7 ", template.trigger)), /* @__PURE__ */ React.createElement(IconBtn, { icon: "x", onClick: onClose })),
      /* @__PURE__ */ React.createElement("div", { style: { flex: 1, overflowY: "auto", padding: 20 } }, /* @__PURE__ */ React.createElement(Field, { label: "Subject" }, /* @__PURE__ */ React.createElement(Input, { size: "lg", value: subject, onChange: (e) => setSubject(e.target.value) })), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 14 } }, /* @__PURE__ */ React.createElement(Field, { label: "Body (Bulgarian)" }, /* @__PURE__ */ React.createElement(Textarea, { rows: 14, value: body, onChange: (e) => setBody(e.target.value) }))), contextPlaceholders.length > 0 && /* @__PURE__ */ React.createElement("div", { style: { marginTop: 14 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 8 } }, "\u0414\u043E\u0441\u0442\u044A\u043F\u043D\u0438 placeholders \u0432 \u0442\u043E\u0437\u0438 \u043A\u043E\u043D\u0442\u0435\u043A\u0441\u0442"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 6 } }, contextPlaceholders.map((ph) => /* @__PURE__ */ React.createElement(
        "button",
        {
          key: ph,
          type: "button",
          onClick: () => setBody((b) => b + ph),
          title: "Insert into body",
          className: "mono",
          style: {
            background: T.accentTint,
            color: "#7EA8FF",
            padding: "3px 8px",
            borderRadius: 5,
            fontSize: 11,
            fontWeight: 600,
            border: "none",
            cursor: "pointer"
          }
        },
        ph
      ))), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2, marginTop: 6, lineHeight: 1.4 } }, "\u041A\u043B\u0438\u043A\u043D\u0438 \u0432\u044A\u0440\u0445\u0443 placeholder \u0437\u0430 \u0434\u0430 \u0433\u043E \u0434\u043E\u0431\u0430\u0432\u0438\u0448 \u0432 body-\u0442\u043E."))),
      /* @__PURE__ */ React.createElement("div", { style: {
        padding: "12px 20px",
        borderTop: `1px solid ${T.border}`,
        display: "flex",
        gap: 10,
        justifyContent: "flex-end"
      } }, /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "md", onClick: onClose }, "\u041E\u0442\u043A\u0430\u0437"), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "md", icon: "check", disabled: !dirty, onClick: () => onSave({ subject, body }) }, "\u0417\u0430\u043F\u0430\u0437\u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435"))
    )
  );
}
function SentEmailsPanel() {
  store.useStore();
  const rows = store.emailLog();
  const emailsEnabled = store.emailsEnabled();
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState(null);
  React.useEffect(() => {
    let cancelled = false;
    store.fetchEmails().finally(() => {
      if (!cancelled) setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  const TYPE_LABELS = {
    contract: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440\u044A\u0442 \u0432\u0438",
    reminder: "\u041E\u0447\u0430\u043A\u0432\u0430\u043C\u0435 \u0432\u0438",
    thankyou: "\u0411\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C",
    office_extension: "\u0418\u0437\u0432\u0435\u0441\u0442\u0438\u0435 \u0434\u043E \u043E\u0444\u0438\u0441\u0430",
    test: "\u0422\u0435\u0441\u0442"
  };
  const resend = (row) => {
    setBusyId(row.id);
    store.resendEmail(row.id).then(() => {
      window.toast && window.toast.success("\u0418\u043C\u0435\u0439\u043B\u044A\u0442 \u0435 \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D \u043E\u0442\u043D\u043E\u0432\u043E.", { duration: 3e3 });
    }).catch(() => {
    }).finally(() => setBusyId(null));
  };
  const sendTests = () => {
    setBusyId("test");
    store.sendTestEmails().then((res) => {
      window.toast && window.toast.success(
        "\u0422\u0435\u0441\u0442\u043E\u0432\u0438 \u0438\u043C\u0435\u0439\u043B\u0438: " + (res.sent || 0) + " \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D\u0438" + (res.failed ? ", " + res.failed + " \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u0438" : "") + ".",
        { title: "\u0422\u0435\u0441\u0442 \u043A\u044A\u043C office@", duration: 4e3 }
      );
    }).catch(() => {
    }).finally(() => setBusyId(null));
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !emailsEnabled && /* @__PURE__ */ React.createElement("div", { style: {
    marginBottom: 14,
    padding: "10px 12px",
    background: T.yellowTint,
    border: "1px solid rgba(245,165,36,0.28)",
    borderRadius: 8,
    display: "flex",
    gap: 10,
    alignItems: "flex-start"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "info", size: 16, color: T.yellow, style: { marginTop: 2, flexShrink: 0 } }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text1, lineHeight: 1.5 } }, /* @__PURE__ */ React.createElement("strong", { style: { color: "#FBBF24" } }, "\u0418\u0437\u043F\u0440\u0430\u0449\u0430\u043D\u0435\u0442\u043E \u0435 \u0418\u0417\u041A\u041B\u042E\u0427\u0415\u041D\u041E (EMAILS_ENABLED=false)."), " ", "\u041D\u0438\u043A\u0430\u043A\u0432\u0438 \u0438\u043C\u0435\u0439\u043B\u0438 \u043D\u0435 \u0441\u0435 \u0438\u0437\u043F\u0440\u0430\u0449\u0430\u0442 \u043A\u044A\u043C \u043A\u043B\u0438\u0435\u043D\u0442\u0438. \u0421\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u0438\u043A\u044A\u0442 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0430 \u0438\u0437\u043F\u0440\u0430\u0449\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0441\u044A\u0440\u0432\u044A\u0440\u0430, \u0441\u043B\u0435\u0434 \u043A\u0430\u0442\u043E \u043E\u0434\u043E\u0431\u0440\u0438 \u0432\u0438\u0437\u0438\u044F\u0442\u0430 \u0447\u0440\u0435\u0437 \u0442\u0435\u0441\u0442\u043E\u0432\u043E \u0438\u0437\u043F\u0440\u0430\u0449\u0430\u043D\u0435 \u043A\u044A\u043C office@.")), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "baseline", justifyContent: "space-between", marginBottom: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 } }, "\u0414\u043D\u0435\u0432\u043D\u0438\u043A \u043D\u0430 \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D\u0438\u0442\u0435 \u0438\u043C\u0435\u0439\u043B\u0438"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8 } }, /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "sm", icon: "refresh", onClick: () => store.fetchEmails() }, "\u041E\u0431\u043D\u043E\u0432\u0438"), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "sm", icon: "mail", disabled: busyId === "test", onClick: sendTests }, "\u0422\u0435\u0441\u0442\u043E\u0432\u0438 \u0438\u043C\u0435\u0439\u043B\u0438 \u2192 office@"))), /* @__PURE__ */ React.createElement(Card, { pad: 0 }, loading && /* @__PURE__ */ React.createElement("div", { style: { padding: "18px", fontSize: 13, color: T.text2 } }, "\u0417\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435\u2026"), !loading && rows.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { padding: "18px", fontSize: 13, color: T.text2 } }, "\u041D\u044F\u043C\u0430 \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D\u0438 \u0438\u043C\u0435\u0439\u043B\u0438 \u0432\u0441\u0435 \u043E\u0449\u0435. \u041F\u044A\u0440\u0432\u0438\u0442\u0435 \u0449\u0435 \u0441\u0435 \u043F\u043E\u044F\u0432\u044F\u0442 \u0442\u0443\u043A \u0441\u043B\u0435\u0434 \u0444\u0438\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u043D\u0430\u0435\u043C (\u043F\u0440\u0438 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0430\u043D\u043E \u0438\u0437\u043F\u0440\u0430\u0449\u0430\u043D\u0435)."), !loading && rows.map((row, i) => /* @__PURE__ */ React.createElement("div", { key: row.id, style: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "12px 16px",
    borderBottom: i < rows.length - 1 ? `1px solid ${T.border}` : "none",
    flexWrap: "wrap"
  } }, /* @__PURE__ */ React.createElement(Chip, { tone: row.status === "sent" ? "green" : "red", size: "sm" }, row.status === "sent" ? "\u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D" : "\u041D\u0415\u0423\u0421\u041F\u0415\u0428\u0415\u041D"), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 180 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600 } }, TYPE_LABELS[row.type] || row.type, " \xB7 ", row.to), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2, marginTop: 2 } }, row.subject, row.error ? /* @__PURE__ */ React.createElement("span", { style: { color: "#EF4444" } }, " \u2014 ", row.error) : null)), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2, whiteSpace: "nowrap" } }, new Date(row.createdAt).toLocaleString("bg-BG")), ["contract", "reminder", "thankyou", "test"].includes(row.type) && /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "sm", icon: "refresh", disabled: busyId === row.id, onClick: () => resend(row) }, "\u0418\u0437\u043F\u0440\u0430\u0442\u0438 \u043E\u0442\u043D\u043E\u0432\u043E")))));
}
function SectionIntegrations() {
  return /* @__PURE__ */ React.createElement("div", { style: { maxWidth: 720 } }, /* @__PURE__ */ React.createElement(SectionHeader, { title: "Integrations", subtitle: "Optional Phase-2 connections. All are non-blocking \u2014 the app works without them." }), /* @__PURE__ */ React.createElement(
    IntegrationCard,
    {
      icon: "drive",
      title: "Google Drive",
      subtitle: "Auto-archive contracts, protocols, and photos.",
      status: "disconnected",
      detail: "Structure: banicharka.bg / Customers / {Name_EGN} / {Date_Contract}",
      cta: "Connect Google Drive"
    }
  ), /* @__PURE__ */ React.createElement(
    IntegrationCard,
    {
      icon: "sheet",
      title: "Google Sheets (OCR feed)",
      subtitle: "Load scanned customer documents from a Sheet.",
      status: "disconnected",
      detail: "Reads the last 5 rows from the configured sheet ID.",
      cta: "Connect Sheets"
    }
  ), /* @__PURE__ */ React.createElement(Card, { pad: 16, style: { background: T.yellowTint, borderColor: "rgba(245,165,36,0.3)", marginTop: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 12, alignItems: "flex-start" } }, /* @__PURE__ */ React.createElement(Icon, { name: "warn", size: 20, color: T.yellow }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600, color: "#FBBF24" } }, "Setup guide"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text1, marginTop: 4, lineHeight: 1.5 } }, "A step-by-step Google Cloud Console guide is generated as part of the deliverable. Both Drive and Sheets share the same OAuth credentials (Client ID + Secret) with restricted ", /* @__PURE__ */ React.createElement("span", { className: "mono" }, "drive.file"), " scope.")), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "sm", icon: "file", onClick: () => window.toast && window.toast.phase2(
    "Guide-\u044A\u0442 \u0441\u044A\u0434\u044A\u0440\u0436\u0430 step-by-step \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438 \u0437\u0430 \u0441\u044A\u0437\u0434\u0430\u0432\u0430\u043D\u0435 \u043D\u0430 OAuth credentials \u0432 Google Cloud Console, enable-\u0432\u0430\u043D\u0435 \u043D\u0430 Drive \u0438 Sheets APIs, \u0438 copy-paste \u043D\u0430 Client ID + Secret \u0432 \u0442\u0435\u0437\u0438 \u043F\u043E\u043B\u0435\u0442\u0430.",
    { title: "Setup guide", duration: 6e3 }
  ) }, "Open guide"))));
}
function IntegrationCard({ icon, title, subtitle, status, detail, cta }) {
  return /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginBottom: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "flex-start", gap: 14 } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 44,
    height: 44,
    borderRadius: 10,
    background: T.bg2,
    border: `1px solid ${T.border}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  } }, /* @__PURE__ */ React.createElement(Icon, { name: icon, size: 22, color: T.text1 })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 8 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700 } }, title), /* @__PURE__ */ React.createElement(Chip, { tone: status === "connected" ? "green" : "gray", size: "sm" }, status === "connected" ? "Connected" : "Not connected")), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: T.text2, marginTop: 4 } }, subtitle), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text3, marginTop: 6, fontFamily: "var(--font-mono)" } }, detail)), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "sm", onClick: () => window.toast && window.toast.phase2(
    cta + " \u0449\u0435 \u0437\u0430\u043F\u043E\u0447\u043D\u0435 Google OAuth flow: \u0431\u0440\u0430\u0443\u0437\u044A\u0440\u044A\u0442 \u0449\u0435 \u043E\u0442\u0432\u043E\u0440\u0438 Google sign-in, \u0449\u0435 \u043F\u043E\u0438\u0441\u043A\u0430 \u0441\u044A\u0433\u043B\u0430\u0441\u0438\u0435 \u0437\u0430 drive.file scope-a, \u0438 \u0449\u0435 \u0437\u0430\u043F\u0430\u0437\u0438 refreshable access token \u0432 \u0442\u0435\u0437\u0438 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438.",
    { title: cta, duration: 5500 }
  ) }, cta)));
}
function SectionOperations() {
  store.useStore();
  const ops = store.operations();
  const nextContract = store.peekNextContractNumber();
  const [draft, setDraft] = useState(ops);
  const [confirmingSeq, setConfirmingSeq] = useState(false);
  const [newSeqInput, setNewSeqInput] = useState("");
  const [savedOnce, setSavedOnce] = useState(false);
  React.useEffect(() => {
    const clean = JSON.stringify(draft) === JSON.stringify(ops);
    if (clean) setDraft(ops);
  }, [ops.bufferHours, ops.overdueMinutes, ops.defaultKmLimit, ops.cleaningFee]);
  const dirty = JSON.stringify(draft) !== JSON.stringify(ops);
  const set = (k, v) => setDraft((d) => ({ ...d, [k]: v }));
  const save = () => {
    store.updateOperations(draft);
    setSavedOnce(true);
    window.toast && window.toast.success(
      "Operations settings saved. Buffer, \u043A\u043C limit \u0438 overdue alert \u0441\u0430 \u0430\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u0438 \u043D\u0430\u0432\u0441\u044F\u043A\u044A\u0434\u0435.",
      { title: "Saved", duration: 3500 }
    );
  };
  const revert = () => setDraft(ops);
  const openSeqDialog = () => {
    const m = /^(\d+)\//.exec(nextContract);
    setNewSeqInput(m ? m[1] : "");
    setConfirmingSeq(true);
  };
  const commitNewSeq = () => {
    const n = parseInt(newSeqInput, 10);
    if (!Number.isFinite(n) || n < 1) {
      window.toast && window.toast.warn("\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0432\u0430\u043B\u0438\u0434\u043D\u043E \u043F\u043E\u043B\u043E\u0436\u0438\u0442\u0435\u043B\u043D\u043E \u0447\u0438\u0441\u043B\u043E.", { duration: 3e3 });
      return;
    }
    store.setNextContractSeq(n);
    setConfirmingSeq(false);
    window.toast && window.toast.warn(
      "\u0421\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F\u0442 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0449\u0435 \u043F\u043E\u043B\u0443\u0447\u0438 \u043D\u043E\u043C\u0435\u0440 " + String(n).padStart(3, "0") + "/" + (window.TODAY || /* @__PURE__ */ new Date()).getFullYear() + ". \u0412\u043D\u0438\u043C\u0430\u0432\u0430\u0439\u0442\u0435 \u0434\u0430 \u043D\u0435 \u0441\u0435 \u043F\u043E\u043B\u0443\u0447\u0430\u0442 \u0434\u0443\u0431\u043B\u0438\u0440\u0430\u043D\u0438\u044F \u0441 \u0445\u0430\u0440\u0442\u0438\u0435\u043D\u0438\u0442\u0435 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0438.",
      { title: "Contract sequence updated", duration: 5500 }
    );
  };
  return /* @__PURE__ */ React.createElement("div", { style: { maxWidth: 720 } }, /* @__PURE__ */ React.createElement(
    SectionHeader,
    {
      title: "Operations",
      subtitle: "Rules that apply across all rentals.",
      right: dirty ? /* @__PURE__ */ React.createElement(Chip, { tone: "yellow", size: "sm" }, "\u041D\u0435\u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u0438") : savedOnce ? /* @__PURE__ */ React.createElement(Chip, { tone: "green", size: "sm", icon: "check" }, "Saved") : null
    }
  ), /* @__PURE__ */ React.createElement(Card, { pad: 20 }, /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 } }, /* @__PURE__ */ React.createElement(Field, { label: "Buffer between rentals", hint: "Cleaning/prep time enforced in calendar" }, /* @__PURE__ */ React.createElement(
    NumberInput,
    {
      size: "lg",
      decimals: 1,
      min: 0,
      max: 24,
      value: draft.bufferHours,
      onChange: (n) => set("bufferHours", n == null ? 0 : n),
      suffix: "hours"
    }
  )), /* @__PURE__ */ React.createElement(Field, { label: "Contract numbering", hint: "Auto-increments per year" }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "stretch" } }, /* @__PURE__ */ React.createElement(Input, { size: "lg", mono: true, value: nextContract, readOnly: true, style: { flex: 1 } }), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "md", icon: "edit", onClick: openSeqDialog }, "Set next")), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, marginTop: 6, lineHeight: 1.4 } }, '\u041F\u043E\u043A\u0430\u0437\u0432\u0430 \u043D\u043E\u043C\u0435\u0440\u0430, \u043A\u043E\u0439\u0442\u043E \u0449\u0435 \u043F\u043E\u043B\u0443\u0447\u0438 \u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F\u0442 \u0441\u043A\u043B\u044E\u0447\u0435\u043D \u0434\u043E\u0433\u043E\u0432\u043E\u0440. \u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u201ESet next" \u0441\u0430\u043C\u043E \u043F\u0440\u0438 \u043D\u0443\u0436\u0434\u0430 (\u043D\u0430\u043F\u0440. \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u0441 \u0445\u0430\u0440\u0442\u0438\u0435\u043D\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0438 \u043E\u0442\u043F\u0440\u0435\u0434\u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0442\u043E).')), /* @__PURE__ */ React.createElement(Field, { label: "Overdue return alert", hint: "\u041A\u043E\u0433\u0430 dashboard-\u044A\u0442 \u0434\u0430 \u043C\u0430\u0440\u043A\u0438\u0440\u0430 \u0432\u0440\u044A\u0449\u0430\u043D\u0435 \u043A\u0430\u0442\u043E \u0437\u0430\u043A\u044A\u0441\u043D\u0435\u043D\u0438\u0435" }, /* @__PURE__ */ React.createElement(
    Segmented,
    {
      block: true,
      value: String(draft.overdueMinutes),
      onChange: (v) => set("overdueMinutes", parseInt(v, 10)),
      options: [
        { value: "15", label: "15 min" },
        { value: "30", label: "30 min" },
        { value: "60", label: "1 hour" }
      ]
    }
  )), /* @__PURE__ */ React.createElement(Field, { label: "Default km limit", hint: "Pre-fill \u0437\u0430 \u043D\u043E\u0432\u0438 \u043D\u0430\u0435\u043C\u0438, \u043F\u0440\u0435\u0434\u0438 \u0434\u0430 \u0435 \u0438\u0437\u0431\u0440\u0430\u043D \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B" }, /* @__PURE__ */ React.createElement(
    NumberInput,
    {
      size: "lg",
      decimals: 0,
      min: 0,
      max: 9999,
      value: draft.defaultKmLimit,
      onChange: (n) => set("defaultKmLimit", n == null ? 0 : n),
      suffix: "\u043A\u043C/day"
    }
  )), /* @__PURE__ */ React.createElement(Field, { label: "No-show grace period", hint: "\u0410\u043A\u043E \u0440\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F\u0442\u0430 \u043D\u0435 \u0431\u044A\u0434\u0435 \u0441\u0442\u0430\u0440\u0442\u0438\u0440\u0430\u043D\u0430 \u0441\u043B\u0435\u0434 \u0441\u0442\u0430\u0440\u0442\u0430 + \u0442\u043E\u0437\u0438 \u043F\u0435\u0440\u0438\u043E\u0434, \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u0441\u0435 \u043C\u0430\u0440\u043A\u0438\u0440\u0430 \u043A\u0430\u0442\u043E no-show" }, /* @__PURE__ */ React.createElement(
    NumberInput,
    {
      size: "lg",
      decimals: 1,
      min: 0,
      max: 48,
      value: draft.noShowGraceHours != null ? draft.noShowGraceHours : 2,
      onChange: (n) => set("noShowGraceHours", n == null ? 0 : n),
      suffix: "hours"
    }
  )), /* @__PURE__ */ React.createElement(Field, { label: "Cleaning fee", hint: "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0430 \u0442\u0430\u043A\u0441\u0430 \u043F\u0440\u0438 \u0432\u044A\u0440\u043D\u0430\u0442 \u043D\u0435\u043F\u043E\u0447\u0438\u0441\u0442\u0435\u043D \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B \u2014 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u044A\u0442 \u0432\u0438\u043D\u0430\u0433\u0438 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0430\u0432\u0430, \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0430 \u0438\u043B\u0438 \u043E\u043F\u0440\u043E\u0449\u0430\u0432\u0430; \u043D\u0438\u0449\u043E \u043D\u0435 \u0441\u0435 \u043D\u0430\u0447\u0438\u0441\u043B\u044F\u0432\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E" }, /* @__PURE__ */ React.createElement(
    NumberInput,
    {
      size: "lg",
      decimals: 2,
      min: 0,
      max: 9999,
      value: draft.cleaningFee != null ? draft.cleaningFee : 25,
      onChange: (n) => set("cleaningFee", n == null ? 0 : n),
      suffix: "\u20AC"
    }
  ))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10, marginTop: 16, justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "md", disabled: !dirty, onClick: revert }, "\u041E\u0442\u043C\u0435\u043D\u0438"), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "md", icon: "check", disabled: !dirty, onClick: save }, "\u0417\u0430\u043F\u0430\u0437\u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435"))), /* @__PURE__ */ React.createElement(UpdateCheckCard, null), confirmingSeq && /* @__PURE__ */ React.createElement(
    "div",
    {
      onClick: () => setConfirmingSeq(false),
      style: {
        position: "absolute",
        inset: 0,
        background: "rgba(5,7,11,0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 300
      }
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        onClick: (e) => e.stopPropagation(),
        style: {
          width: "min(460px, calc(100% - 40px))",
          background: T.bg1,
          border: `1px solid ${T.border}`,
          borderRadius: 14,
          padding: 22
        }
      },
      /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 12 } }, /* @__PURE__ */ React.createElement("div", { style: {
        width: 38,
        height: 38,
        borderRadius: 10,
        background: T.yellowTint,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      } }, /* @__PURE__ */ React.createElement(Icon, { name: "warn", size: 18, color: T.yellow })), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700 } }, "Set next contract number")),
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: T.text1, lineHeight: 1.5, marginBottom: 14 } }, "\u0422\u0430\u0437\u0438 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u0449\u0435 \u043F\u0440\u0435\u043D\u0430\u0441\u043E\u0447\u0438 \u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u043A\u044A\u043C \u0438\u0437\u0431\u0440\u0430\u043D\u0438\u044F \u043D\u043E\u043C\u0435\u0440. \u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u044F \u0441\u0430\u043C\u043E \u043F\u0440\u0438 \u043B\u0435\u0433\u0438\u0442\u0438\u043C\u0435\u043D \u0441\u043B\u0443\u0447\u0430\u0439 \u2014 \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440 \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u0441 \u0436\u0443\u0440\u043D\u0430\u043B\u0430 \u043D\u0430 \u0445\u0430\u0440\u0442\u0438\u0435\u043D\u0438\u0442\u0435 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0438 \u043E\u0442\u043F\u0440\u0435\u0434\u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0442\u043E. \u0427\u0438\u0441\u043B\u043E\u0442\u043E \u043D\u0435 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0431\u044A\u0434\u0435 \u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 1."),
      /* @__PURE__ */ React.createElement(Field, { label: "\u041D\u043E\u0432 \u043D\u043E\u043C\u0435\u0440 (\u0442\u0435\u043A. \u0433\u043E\u0434\u0438\u043D\u0430 " + (window.TODAY || /* @__PURE__ */ new Date()).getFullYear() + ")" }, /* @__PURE__ */ React.createElement(
        NumberInput,
        {
          size: "lg",
          decimals: 0,
          min: 1,
          value: newSeqInput ? parseInt(newSeqInput, 10) : 0,
          onChange: (n) => setNewSeqInput(String(n || ""))
        }
      )),
      /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10, marginTop: 16, justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(Button, { kind: "ghost", size: "md", onClick: () => setConfirmingSeq(false) }, "\u041E\u0442\u043A\u0430\u0437"), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "md", icon: "check", onClick: commitNewSeq }, "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0438"))
    )
  ));
}
function UpdateCheckCard() {
  const [checking, setChecking] = useState(false);
  const [lastResult, setLastResult] = useState(null);
  const [waitingNow, setWaitingNow] = useState(
    !!(window.__BNC_PWA__ && window.__BNC_PWA__.waiting())
  );
  React.useEffect(() => {
    if (!window.__BNC_PWA__) return void 0;
    const t = setInterval(() => {
      setWaitingNow(!!window.__BNC_PWA__.waiting());
    }, 2e3);
    return () => clearInterval(t);
  }, []);
  if (!window.__BNC_PWA__) return null;
  const check = async () => {
    setChecking(true);
    setLastResult(null);
    try {
      await window.__BNC_PWA__.check();
      for (let i = 0; i < 15; i++) {
        await new Promise((r) => setTimeout(r, 400));
        if (window.__BNC_PWA__.waiting()) break;
      }
      const w = !!window.__BNC_PWA__.waiting();
      setWaitingNow(w);
      setLastResult(w ? "waiting" : "none");
    } catch (e) {
      setLastResult("error");
    } finally {
      setChecking(false);
    }
  };
  return /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginTop: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13.5, fontWeight: 700, marginBottom: 4 } }, "\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u043D\u0430 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0442\u043E"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, lineHeight: 1.5 } }, waitingNow ? "\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0447\u0430\u043A\u0430 \u2014 \u043D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u041F\u0440\u0435\u0437\u0430\u0440\u0435\u0434\u0438." : "\u0422\u0435\u043A\u0443\u0449\u0430 \u0432\u0435\u0440\u0441\u0438\u044F: " + (window.__BNC_VERSION__ || "dev") + " \xB7 " + (window.__BNC_BUNDLE_BUILD_ID__ || window.__BNC_BUILD_ID__ || "?") + (lastResult === "none" ? " \u2014 \u043D\u044F\u043C\u0430 \u043D\u043E\u0432\u0430 \u0432\u0435\u0440\u0441\u0438\u044F." : "") + (lastResult === "error" ? " \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430\u0442\u0430 \u043D\u0435 \u0443\u0441\u043F\u044F (\u043D\u044F\u043C\u0430 \u0432\u0440\u044A\u0437\u043A\u0430?)." : ""))), waitingNow ? /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "md", icon: "check", onClick: () => window.__BNC_PWA__.reload() }, "\u041F\u0440\u0435\u0437\u0430\u0440\u0435\u0434\u0438") : /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "md", disabled: checking, onClick: check }, checking ? "\u041F\u0440\u043E\u0432\u0435\u0440\u044F\u0432\u0430\u2026" : "\u041F\u0440\u043E\u0432\u0435\u0440\u0438 \u0437\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435")));
}
function SectionData() {
  return /* @__PURE__ */ React.createElement("div", { style: { maxWidth: 720 } }, /* @__PURE__ */ React.createElement(SectionHeader, { title: "Data & GDPR", subtitle: "Backup, export, and customer deletion." }), /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700, marginBottom: 6 } }, "Export all data"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: T.text2, marginBottom: 14 } }, "Downloads a JSON archive of all customers, vehicles, rentals, payments, and PDFs. Take this before major operations."), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10 } }, /* @__PURE__ */ React.createElement(Button, { kind: "outline", icon: "file", onClick: () => {
    const data = {
      exportedAt: (/* @__PURE__ */ new Date()).toISOString(),
      company: window.COMPANY,
      vehicles: window.VEHICLES,
      customers: window.CUSTOMERS,
      rentals: window.RENTALS,
      payments: window.PAYMENTS,
      leads: window.LEADS
    };
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "banicharka-backup-" + (/* @__PURE__ */ new Date()).toISOString().slice(0, 10) + ".json";
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 5e3);
    window.toast && window.toast.success("\u0418\u0437\u0442\u0435\u0433\u043B\u0435\u043D JSON backup \u0444\u0430\u0439\u043B.", { title: "Export complete", duration: 3e3 });
  } }, "Download JSON"), /* @__PURE__ */ React.createElement(Button, { kind: "outline", icon: "sheet", onClick: () => {
    const rows = [["contractNo", "customer", "vehicle", "plate", "start", "end", "total_eur", "status"]];
    window.RENTALS.forEach((r) => {
      const c = window.CUSTOMERS.find((x) => x.id === r.customerId);
      const v = window.VEHICLES.find((x) => x.id === r.vehicleId);
      rows.push([r.contractNo, c && c.name, v && v.make + " " + v.model, v && v.plate, r.start.toISOString(), r.end.toISOString(), r.total, r.status]);
    });
    const csv = rows.map((row) => row.map((cell) => {
      const s = String(cell == null ? "" : cell);
      return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
    }).join(",")).join("\n");
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "banicharka-rentals-" + (/* @__PURE__ */ new Date()).toISOString().slice(0, 10) + ".csv";
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 5e3);
    window.toast && window.toast.success("\u0418\u0437\u0442\u0435\u0433\u043B\u0435\u043D CSV \u0444\u0430\u0439\u043B (Rentals).", { title: "Export complete", duration: 3e3 });
  } }, "Export to CSV"))), /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { borderColor: "rgba(239,68,68,0.35)" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700, color: "#FCA5A5", marginBottom: 6 } }, "Delete customer data (GDPR)"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: T.text2 } }, "Anonymizes a customer's personal data (name, EGN, ID, DL, phone, address, email) while preserving anonymized financial records. Signed contracts remain in the archive under their original hash.")));
}
function SectionErrorLog({ onViewed }) {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);
  const [severityFilter, setSeverityFilter] = useState("all");
  const [expandedId, setExpandedId] = useState(null);
  const load = () => {
    setError(null);
    store.fetchErrorLog().then((data) => setRows(data)).catch((err) => setError(err && err.message || "Failed to load error log."));
  };
  React.useEffect(() => {
    load();
    localStorage.setItem("bnc-error-log-last-view", (/* @__PURE__ */ new Date()).toISOString());
    if (onViewed) onViewed();
  }, []);
  const filtered = (rows || []).filter((r) => severityFilter === "all" || r.severity === severityFilter);
  const copyDetails = (r) => {
    const text = [
      "Time: " + fmtDateTimeBG(new Date(r.occurredAt)),
      "Severity: " + r.severity,
      "Message: " + r.message,
      r.context ? "Context: " + r.context : null,
      r.url ? "URL: " + r.url : null,
      r.userAgent ? "User agent: " + r.userAgent : null,
      r.serverText ? "Server response: " + r.serverText : null,
      r.stack ? "Stack:\n" + r.stack : null
    ].filter(Boolean).join("\n");
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(
        () => window.toast && window.toast.success("\u041A\u043E\u043F\u0438\u0440\u0430\u043D\u043E \u0432 clipboard.", { duration: 2e3 }),
        () => window.toast && window.toast.warn("Clipboard API \u043D\u0435 \u0435 \u0434\u043E\u0441\u0442\u044A\u043F\u0435\u043D.", { duration: 3e3 })
      );
    } else {
      window.toast && window.toast.info("Clipboard API \u043D\u0435 \u0435 \u0434\u043E\u0441\u0442\u044A\u043F\u0435\u043D.", { duration: 3e3 });
    }
  };
  return /* @__PURE__ */ React.createElement("div", { style: { maxWidth: 820 } }, /* @__PURE__ */ React.createElement(
    SectionHeader,
    {
      title: "Error log",
      subtitle: "Client-side errors and warnings captured automatically. Auto-pruned after 90 days.",
      right: /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 6 } }, ["all", "error", "warn"].map((f) => /* @__PURE__ */ React.createElement("button", { key: f, onClick: () => setSeverityFilter(f), style: {
        padding: "6px 12px",
        borderRadius: 8,
        fontSize: 12.5,
        fontWeight: 600,
        border: `1px solid ${severityFilter === f ? T.border : "transparent"}`,
        background: severityFilter === f ? T.bg2 : "transparent",
        color: severityFilter === f ? T.text0 : T.text2,
        cursor: "pointer"
      } }, f === "all" ? "All" : f === "error" ? "Errors" : "Warnings")), /* @__PURE__ */ React.createElement(IconBtn, { icon: "refresh", size: 32, title: "Refresh", onClick: load }))
    }
  ), error && /* @__PURE__ */ React.createElement(Card, { pad: 16, style: { marginBottom: 14, borderColor: "rgba(239,68,68,0.35)" } }, /* @__PURE__ */ React.createElement("div", { style: { color: "#FCA5A5", fontSize: 13 } }, error)), rows === null && !error && /* @__PURE__ */ React.createElement("div", { style: { color: T.text2, fontSize: 13, padding: 20 } }, "Loading\u2026"), rows !== null && filtered.length === 0 && /* @__PURE__ */ React.createElement("div", { style: { color: T.text2, fontSize: 13, padding: 20 } }, "No entries."), /* @__PURE__ */ React.createElement(Card, { pad: 0 }, filtered.map((r, i) => {
    const expanded = expandedId === r.id;
    return /* @__PURE__ */ React.createElement("div", { key: r.id, style: {
      borderBottom: i < filtered.length - 1 ? `1px solid ${T.border}` : "none"
    } }, /* @__PURE__ */ React.createElement(
      "div",
      {
        onClick: () => setExpandedId(expanded ? null : r.id),
        style: {
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 14px",
          cursor: "pointer"
        }
      },
      /* @__PURE__ */ React.createElement(
        Icon,
        {
          name: r.severity === "warn" ? "warn" : "block",
          size: 16,
          color: r.severity === "warn" ? T.yellow : "#F87171"
        }
      ),
      /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 11.5, color: T.text3, width: 130, flexShrink: 0 } }, fmtDateTimeBG(new Date(r.occurredAt))),
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text1, flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, r.message),
      r.context && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text3, flexShrink: 0 } }, r.context),
      /* @__PURE__ */ React.createElement(Icon, { name: expanded ? "chevronU" : "chevronD", size: 16, color: T.text3 })
    ), expanded && /* @__PURE__ */ React.createElement("div", { style: { padding: "0 14px 14px 42px" } }, /* @__PURE__ */ React.createElement("div", { className: "mono", style: {
      fontSize: 11.5,
      color: T.text2,
      background: T.bg0,
      borderRadius: 8,
      padding: 12,
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
      maxHeight: 260,
      overflow: "auto"
    } }, "Message: " + r.message, r.context ? "\nContext: " + r.context : "", r.url ? "\nURL: " + r.url : "", r.userAgent ? "\nUser agent: " + r.userAgent : "", r.serverText ? "\nServer response: " + r.serverText : "", r.stack ? "\nStack:\n" + r.stack : ""), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 8 } }, /* @__PURE__ */ React.createElement(Button, { kind: "outline", icon: "copy", size: "sm", onClick: () => copyDetails(r) }, "Copy details"))));
  })));
}
function TemplateValidationCard({ v, onDismiss }) {
  const anyIssues = v.unrecognized.length > 0;
  return /* @__PURE__ */ React.createElement(Card, { pad: 20, style: {
    marginBottom: 20,
    borderColor: anyIssues ? "rgba(245,165,36,0.35)" : "rgba(34,197,94,0.35)",
    background: anyIssues ? T.yellowTint : T.greenTint
  } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "flex-start", gap: 12, marginBottom: 14 } }, /* @__PURE__ */ React.createElement(Icon, { name: anyIssues ? "warn" : "check", size: 20, color: anyIssues ? T.yellow : T.green }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 700, color: anyIssues ? "#FBBF24" : "#86EFAC" } }, anyIssues ? "\u0428\u0430\u0431\u043B\u043E\u043D\u044A\u0442 \u0435 \u043F\u0440\u0438\u0435\u0442 \u0441 \u043F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u044F" : "\u0428\u0430\u0431\u043B\u043E\u043D\u044A\u0442 \u0435 \u043F\u0440\u0438\u0435\u0442 \u2014 \u0432\u0441\u0438\u0447\u043A\u0438 placeholders \u0441\u0430 \u0432\u0430\u043B\u0438\u0434\u043D\u0438"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text1, marginTop: 4 } }, v.name, " \xB7 ", (v.size / 1024).toFixed(1), " KB \xB7 ", v.recognized.length + v.unrecognized.length, " placeholder", v.recognized.length + v.unrecognized.length === 1 ? "" : "s", " \u043E\u0431\u0449\u043E")), /* @__PURE__ */ React.createElement(IconBtn, { icon: "x", size: 30, onClick: onDismiss })), v.recognized.length > 0 && /* @__PURE__ */ React.createElement(
    PlaceholderList,
    {
      title: "\u0420\u0430\u0437\u043F\u043E\u0437\u043D\u0430\u0442\u0438 placeholders (" + v.recognized.length + ")",
      items: v.recognized.map((r) => r.canonical),
      tone: "green",
      hint: "\u0422\u0435\u0437\u0438 \u0442\u0430\u0433\u043E\u0432\u0435 \u0449\u0435 \u0431\u044A\u0434\u0430\u0442 \u0437\u0430\u043C\u0435\u0441\u0442\u0435\u043D\u0438 \u0441 \u0440\u0435\u0430\u043B\u043D\u0438 \u0434\u0430\u043D\u043D\u0438 \u043F\u0440\u0438 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435."
    }
  ), v.unrecognized.length > 0 && /* @__PURE__ */ React.createElement(
    PlaceholderList,
    {
      title: "\u041D\u0435\u043F\u043E\u0437\u043D\u0430\u0442\u0438 placeholders (" + v.unrecognized.length + ")",
      items: v.unrecognized.map((r) => r.raw),
      tone: "red",
      hint: "\u0422\u0435\u0437\u0438 \u0442\u0430\u0433\u043E\u0432\u0435 \u041D\u0415 \u043E\u0442\u0433\u043E\u0432\u0430\u0440\u044F\u0442 \u043D\u0430 \u043F\u043E\u0434\u0434\u044A\u0440\u0436\u0430\u043D placeholder \u2014 \u043D\u0430\u0439-\u0432\u0435\u0440\u043E\u044F\u0442\u043D\u043E \u043F\u0435\u0447\u0430\u0442\u043D\u0430 \u0433\u0440\u0435\u0448\u043A\u0430. \u0429\u0435 \u0431\u044A\u0434\u0430\u0442 \u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0438 \u043F\u0440\u0430\u0437\u043D\u0438 \u0432 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0438\u0442\u0435 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0438."
    }
  ), v.unused.length > 0 && /* @__PURE__ */ React.createElement(
    PlaceholderList,
    {
      title: "\u041D\u0435\u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0438 \u043F\u043E\u0434\u0434\u044A\u0440\u0436\u0430\u043D\u0438 placeholders (" + v.unused.length + ")",
      items: v.unused,
      tone: "gray",
      hint: "\u0422\u0435\u0437\u0438 \u0442\u0430\u0433\u043E\u0432\u0435 \u0441\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u0438, \u043D\u043E \u0442\u043E\u0437\u0438 \u0448\u0430\u0431\u043B\u043E\u043D \u043D\u0435 \u0433\u0438 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430. \u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0432\u043D\u043E \u2014 \u043D\u0435 \u0435 \u0433\u0440\u0435\u0448\u043A\u0430.",
      collapsed: true
    }
  ));
}
function PlaceholderList({ title, items, tone, hint, collapsed }) {
  const [open, setOpen] = useState(!collapsed);
  const chipColor = { green: "#86EFAC", red: "#F87171", gray: T.text2 }[tone];
  const chipBg = { green: "rgba(34,197,94,0.18)", red: "rgba(239,68,68,0.18)", gray: "rgba(122,134,153,0.16)" }[tone];
  return /* @__PURE__ */ React.createElement("div", { style: { marginTop: 12 } }, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: () => setOpen((o) => !o),
      style: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        background: "transparent",
        border: "none",
        padding: 0,
        color: T.text0,
        fontWeight: 700,
        fontSize: 12.5,
        cursor: "pointer"
      }
    },
    /* @__PURE__ */ React.createElement(Icon, { name: open ? "chevronD" : "chevronR", size: 14, color: T.text2 }),
    title
  ), open && /* @__PURE__ */ React.createElement(React.Fragment, null, hint && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2, marginTop: 6, lineHeight: 1.45 } }, hint), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 6, marginTop: 8 } }, items.map((t, i) => /* @__PURE__ */ React.createElement("span", { key: i, className: "mono", style: {
    background: chipBg,
    color: chipColor,
    padding: "3px 8px",
    borderRadius: 5,
    fontSize: 11,
    fontWeight: 600
  } }, "{{" + t + "}}")))));
}
function TemplatePreviewModal({ template, onClose }) {
  const sample = window.templateModule.buildSampleRental();
  const values = window.templateModule.buildSampleValues(sample);
  const paragraphs = template ? template.paragraphs : BUILTIN_TEMPLATE_PARAGRAPHS;
  const substituted = paragraphs.map(
    (p) => window.templateModule.substitutePlaceholders(p, values)
  );
  const unknownFound = /* @__PURE__ */ new Set();
  for (const p of paragraphs) {
    const re = /\{\{\s*([A-Za-z][A-Za-z0-9_]*)\s*\}\}/g;
    let m;
    while ((m = re.exec(p)) !== null) {
      const upper = m[1].toUpperCase();
      if (!(upper in values) && !(m[1] in values)) unknownFound.add(m[1]);
    }
  }
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      onClick: onClose,
      style: {
        position: "absolute",
        inset: 0,
        background: "rgba(5,7,11,0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 300
      }
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        onClick: (e) => e.stopPropagation(),
        style: {
          width: "min(760px, calc(100% - 40px))",
          maxHeight: "90%",
          background: T.bg1,
          border: `1px solid ${T.border}`,
          borderRadius: 14,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden"
        }
      },
      /* @__PURE__ */ React.createElement("div", { style: {
        padding: "14px 20px",
        borderBottom: `1px solid ${T.border}`,
        display: "flex",
        alignItems: "center",
        gap: 12,
        background: T.bg0
      } }, /* @__PURE__ */ React.createElement("div", { style: {
        width: 34,
        height: 34,
        borderRadius: 8,
        background: T.blueTint,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      } }, /* @__PURE__ */ React.createElement(Icon, { name: "eye", size: 16, color: T.blue })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 700 } }, template ? "Template preview" : "Built-in template preview"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, marginTop: 2 } }, template ? template.name : "Built-in fallback (no custom .docx uploaded)", " \xB7 sample data: ", sample.c.name, " + ", sample.v.make, " ", sample.v.model)), /* @__PURE__ */ React.createElement(IconBtn, { icon: "x", onClick: onClose })),
      /* @__PURE__ */ React.createElement("div", { style: {
        padding: "10px 20px",
        borderBottom: `1px solid ${T.border}`,
        background: T.yellowTint,
        display: "flex",
        alignItems: "flex-start",
        gap: 10
      } }, /* @__PURE__ */ React.createElement(Icon, { name: "info", size: 16, color: T.yellow, style: { marginTop: 2 } }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text1, lineHeight: 1.5 } }, /* @__PURE__ */ React.createElement("strong", { style: { color: "#FBBF24" } }, "Preview (layout approximation)."), " ", "\u0422\u043E\u0437\u0438 \u043F\u0440\u0435\u0433\u043B\u0435\u0434 \u0438\u0437\u0432\u043B\u0438\u0447\u0430 \u0442\u0435\u043A\u0441\u0442\u0430 \u043E\u0442 .docx \u0438 \u043F\u043E\u043F\u044A\u043B\u0432\u0430 placeholder-\u0438\u0442\u0435 \u0441 \u043F\u0440\u0438\u043C\u0435\u0440\u043D\u0438 \u0434\u0430\u043D\u043D\u0438. \u0420\u0435\u0430\u043B\u043D\u043E\u0442\u043E \u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u0430\u043D\u0435 (\u0448\u0440\u0438\u0444\u0442\u043E\u0432\u0435, \u0442\u0430\u0431\u043B\u0438\u0446\u0438, \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0438, header/footer, \u0441\u0442\u0438\u043B\u043E\u0432\u0435) \u0449\u0435 \u0441\u0435 \u0440\u0435\u043D\u0434\u0438\u0440\u0430 \u043E\u0442 production pipeline (server-side DOCX \u2192 PDF). \u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u0435 \u0442\u0435\u043A\u0441\u0442\u0430 \u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u043D\u043E\u0442\u043E \u0437\u0430\u043C\u0435\u0441\u0442\u0432\u0430\u043D\u0435, \u043F\u0440\u0435\u0434\u0438 \u0434\u0430 \u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0441 \u0440\u0435\u0430\u043B\u0435\u043D \u043A\u043B\u0438\u0435\u043D\u0442.")),
      /* @__PURE__ */ React.createElement("div", { style: { flex: 1, overflowY: "auto", padding: 24, background: "#0A0D12" } }, /* @__PURE__ */ React.createElement("div", { style: {
        background: "#F7F6F2",
        color: "#0F1420",
        padding: "48px 52px",
        borderRadius: 6,
        fontFamily: "var(--font-serif)",
        fontSize: 13,
        lineHeight: 1.55,
        boxShadow: "0 4px 20px rgba(0,0,0,0.4)",
        minHeight: 300
      } }, substituted.length === 0 ? /* @__PURE__ */ React.createElement("div", { style: { color: T.kioskInkSoft, fontStyle: "italic", textAlign: "center", padding: 40 } }, "\u041F\u0440\u0430\u0437\u0435\u043D \u0448\u0430\u0431\u043B\u043E\u043D \u2014 \u043D\u044F\u043C\u0430 \u0438\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438 \u043F\u0430\u0440\u0430\u0433\u0440\u0430\u0444\u0438.") : substituted.map((p, i) => /* @__PURE__ */ React.createElement("p", { key: i, style: {
        margin: 0,
        marginBottom: p.trim() ? 12 : 6,
        whiteSpace: "pre-wrap",
        fontWeight: /^(Чл\.\s|Договор|ДОГОВОР|ДЕКЛАРАЦИЯ|Наемодател:|Наемател:)/i.test(p.trim()) ? 700 : 400,
        fontSize: /^(ДОГОВОР|ДЕКЛАРАЦИЯ)/.test(p.trim()) ? 18 : 13,
        textAlign: /^(ДОГОВОР|ДЕКЛАРАЦИЯ)/.test(p.trim()) ? "center" : "left",
        letterSpacing: /^(ДОГОВОР|ДЕКЛАРАЦИЯ)/.test(p.trim()) ? "0.05em" : "normal"
      } }, p || "\xA0"))), unknownFound.size > 0 && /* @__PURE__ */ React.createElement("div", { style: { marginTop: 16, padding: "10px 14px", background: T.redTint, border: "1px solid rgba(239,68,68,0.35)", borderRadius: 8, fontSize: 12, color: T.text1 } }, /* @__PURE__ */ React.createElement("strong", { style: { color: "#FCA5A5" } }, "\u041D\u0435\u043F\u043E\u043F\u044A\u043B\u043D\u0435\u043D\u0438 placeholders \u0432 \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430:"), " ", [...unknownFound].map((t) => /* @__PURE__ */ React.createElement("span", { key: t, className: "mono", style: {
        background: "rgba(239,68,68,0.2)",
        color: "#FCA5A5",
        padding: "2px 6px",
        borderRadius: 4,
        marginLeft: 4,
        fontSize: 11
      } }, "{{" + t + "}}")), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 6, fontSize: 11.5, color: T.text2 } }, "\u0422\u0435\u0437\u0438 tag-\u043E\u0432\u0435 \u0449\u0435 \u0431\u044A\u0434\u0430\u0442 \u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0438 \u043F\u0440\u0430\u0437\u043D\u0438 \u0432 \u0440\u0435\u0430\u043B\u043D\u0438\u0442\u0435 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0438. \u0410\u043A\u043E \u0435 \u043F\u0435\u0447\u0430\u0442\u043D\u0430 \u0433\u0440\u0435\u0448\u043A\u0430 \u2014 \u043A\u043E\u0440\u0438\u0433\u0438\u0440\u0430\u0439\u0442\u0435 \u0432 Word \u0438 \u043A\u0430\u0447\u0435\u0442\u0435 \u043E\u0442\u043D\u043E\u0432\u043E."))),
      /* @__PURE__ */ React.createElement("div", { style: {
        padding: "12px 20px",
        borderTop: `1px solid ${T.border}`,
        display: "flex",
        gap: 10,
        alignItems: "center"
      } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1, fontSize: 11.5, color: T.text2 } }, template ? `${template.paragraphs.length} paragraph${template.paragraphs.length === 1 ? "" : "s"} extracted from your .docx` : `${paragraphs.length} paragraph${paragraphs.length === 1 ? "" : "s"} from built-in template`), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "md", icon: "check", onClick: onClose }, "\u0413\u043E\u0442\u043E\u0432\u043E"))
    )
  );
}
var BUILTIN_TEMPLATE_PARAGRAPHS = [
  "\u0414\u041E\u0413\u041E\u0412\u041E\u0420 \u0417\u0410 \u041D\u0410\u0415\u041C \u041D\u0410 \u041C\u041F\u0421",
  "\u2116 {{CONTRACT_NUMBER}} \xB7 {{DATE_TODAY}} \xB7 \u0433\u0440. \u0421\u043E\u0444\u0438\u044F",
  "",
  "\u0414\u043D\u0435\u0441, {{DATE_TODAY}}, \u0432 \u0433\u0440. \u0421\u043E\u0444\u0438\u044F, \u043C\u0435\u0436\u0434\u0443:",
  '\u201E\u0413\u0415\u041D\u0423\u0421-2017" \u0415\u041E\u041E\u0414, \u0415\u0418\u041A 204812445, \u0414\u0414\u0421 \u2116 BG204812445, \u0441\u0435\u0434\u0430\u043B\u0438\u0449\u0435 \u0433\u0440. \u0421\u043E\u0444\u0438\u044F, \u0443\u043B. \u041F\u0438\u0440\u043E\u0442\u0441\u043A\u0430 12, \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u0432\u0430\u043D\u043E \u043E\u0442 {{OPERATOR_NAME}} \u2014 \u0443\u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B, \u043D\u0430\u0440\u0438\u0447\u0430\u043D \u043F\u043E-\u0434\u043E\u043B\u0443 \u0437\u0430 \u043A\u0440\u0430\u0442\u043A\u043E\u0441\u0442 \u201E\u041D\u0410\u0415\u041C\u041E\u0414\u0410\u0422\u0415\u041B",',
  "\u0438",
  '{{CUSTOMER_NAME}}, \u0415\u0413\u041D {{EGN}}, \u041B\u041A \u2116 {{ID_NUMBER}}, \u0432\u0430\u043B\u0438\u0434\u043D\u0430 \u0434\u043E {{ID_VALID_UNTIL}}, \u0421\u0423\u041C\u041F\u0421 \u2116 {{DL_NUMBER}}, \u0432\u0430\u043B\u0438\u0434\u043D\u043E \u0434\u043E {{DL_VALID_UNTIL}}, \u0430\u0434\u0440\u0435\u0441: {{CUSTOMER_ADDRESS}}, \u0442\u0435\u043B. {{CUSTOMER_PHONE}}, \u043D\u0430\u0440\u0438\u0447\u0430\u043D \u043F\u043E-\u0434\u043E\u043B\u0443 \u0437\u0430 \u043A\u0440\u0430\u0442\u043A\u043E\u0441\u0442 \u201E\u041D\u0410\u0415\u041C\u0410\u0422\u0415\u041B",',
  "\u0441\u0435 \u0441\u043A\u043B\u044E\u0447\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u044F\u0442 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u0437\u0430 \u0441\u043B\u0435\u0434\u043D\u043E\u0442\u043E:",
  "",
  "\u0427\u043B. 1. \u041F\u0440\u0435\u0434\u043C\u0435\u0442 \u043D\u0430 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430",
  "\u041D\u0430\u0435\u043C\u043E\u0434\u0430\u0442\u0435\u043B\u044F\u0442 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u044F \u0437\u0430 \u0432\u044A\u0437\u043C\u0435\u0437\u0434\u043D\u043E \u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0435, \u0430 \u041D\u0430\u0435\u043C\u0430\u0442\u0435\u043B\u044F\u0442 \u043F\u0440\u0438\u0435\u043C\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B {{VEHICLE_MAKE_MODEL}}, \u0440\u0435\u0433. \u2116 {{PLATE}}, VIN {{VIN}}, \u043F\u0440\u0438 \u043A\u0438\u043B\u043E\u043C\u0435\u0442\u0440\u0430\u0436 {{ODOMETER}} \u0438 \u043D\u0438\u0432\u043E \u043D\u0430 \u0433\u043E\u0440\u0438\u0432\u043E {{FUEL_LEVEL}}.",
  "",
  "\u0427\u043B. 2. \u0421\u0440\u043E\u043A",
  "\u041D\u0430\u0435\u043C\u044A\u0442 \u0441\u0435 \u0441\u043A\u043B\u044E\u0447\u0432\u0430 \u0437\u0430 \u0441\u0440\u043E\u043A \u043E\u0442 {{DATE_FROM}} \u0434\u043E {{DATE_TO}}.",
  "",
  "\u0427\u043B. 3. \u041D\u0430\u0435\u043C\u043D\u0430 \u0446\u0435\u043D\u0430 \u0438 \u0434\u0435\u043F\u043E\u0437\u0438\u0442",
  "\u0414\u043D\u0435\u0432\u043D\u0430 \u043D\u0430\u0435\u043C\u043D\u0430 \u0446\u0435\u043D\u0430: {{DAILY_RATE}}. \u041E\u0431\u0449\u0430 \u043D\u0430\u0435\u043C\u043D\u0430 \u0446\u0435\u043D\u0430: {{TOTAL_PRICE}}. \u0414\u0435\u043F\u043E\u0437\u0438\u0442: {{DEPOSIT}}.",
  "",
  "\u0427\u043B. 4. \u0414\u043D\u0435\u0432\u0435\u043D \u043F\u0440\u043E\u0431\u0435\u0433",
  "\u0421\u0440\u0435\u0434\u043D\u0438\u044F\u0442 \u0434\u043D\u0435\u0432\u0435\u043D \u043F\u0440\u043E\u0431\u0435\u0433 \u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D \u0434\u043E {{KM_LIMIT_PER_DAY}}. \u0412\u0441\u0435\u043A\u0438 \u0434\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u0435\u043D \u043A\u0438\u043B\u043E\u043C\u0435\u0442\u044A\u0440 \u0441\u0435 \u0437\u0430\u043F\u043B\u0430\u0449\u0430 \u043F\u043E {{EXTRA_KM_PRICE}}.",
  "",
  "\u0427\u043B. 5. \u0417\u0430\u0434\u044A\u043B\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u041D\u0430\u0435\u043C\u0430\u0442\u0435\u043B\u044F",
  "\u041D\u0430\u0435\u043C\u0430\u0442\u0435\u043B\u044F\u0442 \u0441\u0435 \u0437\u0430\u0434\u044A\u043B\u0436\u0430\u0432\u0430 \u0434\u0430 \u043F\u043E\u043B\u0437\u0432\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0430 \u0441\u044A\u043E\u0431\u0440\u0430\u0437\u043D\u043E \u043F\u0440\u0435\u0434\u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0442\u043E \u043C\u0443, \u0434\u0430 \u0433\u043E \u043F\u043E\u0434\u0434\u044A\u0440\u0436\u0430 \u0432 \u0438\u0437\u043F\u0440\u0430\u0432\u043D\u043E \u0441\u044A\u0441\u0442\u043E\u044F\u043D\u0438\u0435, \u0438 \u0434\u0430 \u0433\u043E \u0432\u044A\u0440\u043D\u0435 \u0432 \u043C\u044F\u0441\u0442\u043E\u0442\u043E \u0438 \u0447\u0430\u0441\u0430, \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438 \u0432 \u0447\u043B. 2.",
  "",
  "\u041D\u0430\u0435\u043C\u043E\u0434\u0430\u0442\u0435\u043B: _________________     \u041D\u0430\u0435\u043C\u0430\u0442\u0435\u043B: _________________",
  "                        {{OPERATOR_NAME}}                                     {{CUSTOMER_NAME}}"
];
Object.assign(window, { SettingsScreen });

/* ══════════ components/skeletons.jsx ══════════ */
function DamageScreen({ isPhone }) {
  const damages = [
    { id: "d1", vehicle: "Dacia Dokker \xB7 CB 7743 MN", zone: "\u041F\u0440\u0435\u0434\u043D\u0430 \u0434\u044F\u0441\u043D\u0430 \u0432\u0440\u0430\u0442\u0430", cost: 180, status: "to-repair", date: "02.07.2026", desc: "\u0414\u0440\u0430\u0441\u043A\u043E\u0442\u0438\u043D\u0430 ~15\u0441\u043C" },
    { id: "d2", vehicle: "Ford Transit \xB7 CB 3388 TC", zone: "\u0417\u0430\u0434\u0435\u043D \u0431\u0430\u043C\u043F\u0435\u0440", cost: 320, status: "to-charge", date: "28.06.2026", desc: "\u0412\u0434\u043B\u044A\u0431\u043D\u0430\u0442\u0438\u043D\u0430 \u0441\u043B\u0435\u0434 \u0432\u0440\u044A\u0449\u0430\u043D\u0435, \u0441\u043D\u0438\u043C\u0430\u043D\u0430." },
    { id: "d3", vehicle: "Renault Express \xB7 CB 4821 KM", zone: "\u041B\u044F\u0432\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0447\u043D\u043E \u043E\u0433\u043B\u0435\u0434\u0430\u043B\u043E", cost: 95, status: "repaired", date: "18.06.2026", desc: "\u0421\u0447\u0443\u043F\u0435\u043D \u043A\u043E\u0440\u043F\u0443\u0441" }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "scroll-y", style: { flex: 1, padding: isPhone ? 16 : 24, background: T.bg0 } }, /* @__PURE__ */ React.createElement(
    SectionHeader,
    {
      title: "Damage register",
      subtitle: "Phase 2 \xB7 Vehicle damage tracking",
      right: /* @__PURE__ */ React.createElement(Button, { kind: "primary", icon: "plus", size: "sm", onClick: () => window.toast && window.toast.phase2(
        "Log damage \u0449\u0435 \u043E\u0442\u0432\u043E\u0440\u0438 \u0444\u043E\u0440\u043C\u0430 \u0437\u0430 \u043D\u043E\u0432\u0430 \u0449\u0435\u0442\u0430: \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0437\u043E\u043D\u0430 (\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u0430 \u0438\u043B\u0438 dropdown), \u043E\u043F\u0438\u0448\u0435\u0442\u0435 \u0449\u0435\u0442\u0430\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0441\u043D\u0438\u043C\u043A\u0438, \u0441\u0432\u044A\u0440\u0436\u0435\u0442\u0435 \u0441 \u043D\u0430\u0435\u043C/\u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B, \u043E\u0446\u0435\u043D\u0435\u0442\u0435 \u0440\u0430\u0437\u0445\u043E\u0434\u0438\u0442\u0435.",
        { title: "Log damage", duration: 5e3 }
      ) }, "Log damage")
    }
  ), /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 14 } }, "Zone diagram"), /* @__PURE__ */ React.createElement(VanTopDown, null), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2, marginTop: 10, textAlign: "center" } }, "Tap a zone to filter damage records. Fallback: dropdown list if diagram is unstable on the device.")), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 12 } }, "Recent records (", damages.length, ")"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 10 } }, damages.map((d) => /* @__PURE__ */ React.createElement(Card, { key: d.id, pad: 16 }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "flex-start", gap: 14 } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 60,
    height: 60,
    borderRadius: 10,
    background: T.bg2,
    border: `1px solid ${T.border}`,
    overflow: "hidden"
  }, className: "img-placeholder" }, "photo"), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 700 } }, d.zone), /* @__PURE__ */ React.createElement(Chip, { tone: d.status === "repaired" ? "green" : d.status === "to-charge" ? "yellow" : "red", size: "sm" }, d.status === "repaired" ? "Repaired" : d.status === "to-charge" ? "To charge customer" : "To repair")), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: T.text2, marginTop: 4 } }, d.vehicle), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: T.text1, marginTop: 4 } }, d.desc), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 11, color: T.text3, marginTop: 6 } }, d.date)), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 16, fontWeight: 700 } }, fmtEuro(d.cost, { dp: 0 })))))));
}
function VanTopDown() {
  const zones = [
    { id: "front", label: "\u041F\u0440\u0435\u0434\u043D\u0430", x: 45, y: 12, w: 260, h: 26, count: 0 },
    { id: "rear", label: "\u0417\u0430\u0434\u043D\u0430", x: 45, y: 142, w: 260, h: 26, count: 1 },
    { id: "left", label: "\u041B\u044F\u0432\u0430 \u0441\u0442\u0440\u0430\u043D\u0430", x: 45, y: 42, w: 260, h: 40, count: 1 },
    { id: "right", label: "\u0414\u044F\u0441\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0430", x: 45, y: 98, w: 260, h: 40, count: 0 },
    { id: "roof", label: "\u041F\u043E\u043A\u0440\u0438\u0432", x: 100, y: 85, w: 150, h: 12, count: 0 }
  ];
  const [hover, setHover] = useState(null);
  const [sel, setSel] = useState(null);
  return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", justifyContent: "center", padding: 10 } }, /* @__PURE__ */ React.createElement("svg", { width: "360", height: "200", viewBox: "0 0 360 200" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", { id: "body", x1: "0", x2: "0", y1: "0", y2: "1" }, /* @__PURE__ */ React.createElement("stop", { offset: "0", stopColor: "#1A2130" }), /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#0F1420" }))), /* @__PURE__ */ React.createElement("rect", { x: "40", y: "8", width: "270", height: "164", rx: "20", fill: "url(#body)", stroke: T.borderStrong, strokeWidth: "1.5" }), /* @__PURE__ */ React.createElement("path", { d: "M60 22 Q175 12 290 22 L290 38 L60 38 Z", fill: "#0A0D12", opacity: "0.65" }), /* @__PURE__ */ React.createElement("path", { d: "M60 158 Q175 168 290 158 L290 142 L60 142 Z", fill: "#0A0D12", opacity: "0.65" }), /* @__PURE__ */ React.createElement("rect", { x: "70", y: "46", width: "210", height: "88", rx: "12", fill: "none", stroke: T.border, strokeWidth: "0.75", strokeDasharray: "2 3" }), [[30, 40], [30, 140], [320, 40], [320, 140]].map(([x, y], i) => /* @__PURE__ */ React.createElement("rect", { key: i, x: x - 6, y: y - 14, width: "12", height: "28", rx: "3", fill: "#05070B" })), zones.map((z) => {
    const active = hover === z.id || sel === z.id;
    const hasDamage = z.count > 0;
    return /* @__PURE__ */ React.createElement(
      "g",
      {
        key: z.id,
        onMouseEnter: () => setHover(z.id),
        onMouseLeave: () => setHover(null),
        onClick: () => setSel(sel === z.id ? null : z.id),
        style: { cursor: "pointer" }
      },
      /* @__PURE__ */ React.createElement(
        "rect",
        {
          x: z.x,
          y: z.y,
          width: z.w,
          height: z.h,
          fill: active ? "rgba(26,92,230,0.28)" : hasDamage ? "rgba(239,68,68,0.18)" : "transparent",
          stroke: active ? T.accent : hasDamage ? T.red : "rgba(122,134,153,0.35)",
          strokeDasharray: active ? "none" : "3 3",
          rx: "6",
          strokeWidth: "1.2"
        }
      ),
      hasDamage && /* @__PURE__ */ React.createElement("circle", { cx: z.x + z.w - 12, cy: z.y + 12, r: "8", fill: T.red }),
      hasDamage && /* @__PURE__ */ React.createElement("text", { x: z.x + z.w - 12, y: z.y + 16, textAnchor: "middle", fontSize: "10", fontWeight: "700", fill: "#fff" }, z.count),
      /* @__PURE__ */ React.createElement("text", { x: z.x + z.w / 2, y: z.y + z.h / 2 + 4, textAnchor: "middle", fontSize: "9.5", fontWeight: "600", fill: active ? "#fff" : hasDamage ? "#FCA5A5" : T.text2, letterSpacing: "0.5" }, z.label.toUpperCase())
    );
  })));
}
function VouchersScreen({ isPhone }) {
  return /* @__PURE__ */ React.createElement("div", { className: "scroll-y", style: { flex: 1, padding: isPhone ? 16 : 24, background: T.bg0 } }, /* @__PURE__ */ React.createElement(
    SectionHeader,
    {
      title: "Vouchers",
      subtitle: "Phase 2 \xB7 Turned-away leads & VIP recovery",
      right: /* @__PURE__ */ React.createElement(Button, { kind: "primary", icon: "plus", size: "sm", onClick: () => window.toast && window.toast.phase2(
        "New voucher \u0449\u0435 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430 \u0443\u043D\u0438\u043A\u0430\u043B\u0435\u043D \u043A\u043E\u0434 (BAN-XXXX), \u0449\u0435 \u043F\u043E\u0437\u0432\u043E\u043B\u0438 \u0438\u0437\u0431\u043E\u0440 \u043D\u0430 \u043E\u0442\u0441\u0442\u044A\u043F\u043A\u0430 (\u20AC \u0438\u043B\u0438 %) \u0438 \u0432\u0430\u043B\u0438\u0434\u043D\u043E\u0441\u0442, \u0438 \u0449\u0435 \u0441\u044A\u0437\u0434\u0430\u0434\u0435 PNG \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0441 \u0431\u0440\u0430\u043D\u0434\u0438\u043D\u0433\u0430 \u043D\u0430 banicharka.bg \u0437\u0430 \u0434\u0438\u0440\u0435\u043A\u0442\u043D\u043E \u0441\u043F\u043E\u0434\u0435\u043B\u044F\u043D\u0435.",
        { title: "New voucher", duration: 5e3 }
      ) }, "New voucher")
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: isPhone ? "1fr" : "1fr 1fr", gap: 20 } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 12 } }, "Preview"), /* @__PURE__ */ React.createElement(VoucherCard, null), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10, marginTop: 12 } }, /* @__PURE__ */ React.createElement(Button, { kind: "outline", icon: "share", style: { flex: 1 }, onClick: () => window.toast && window.toast.phase2(
    "Share via Viber \u0449\u0435 \u043E\u0442\u0432\u043E\u0440\u0438 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u0438\u044F share sheet \u0441 \u043F\u0440\u0438\u043A\u0430\u0447\u0435\u043D\u043E voucher \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 (PNG) \u2014 \u0435\u0434\u0438\u043D tap \u043A\u044A\u043C Viber, WhatsApp \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u043E installed \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435.",
    { title: "Share voucher", duration: 4500 }
  ) }, "Share via Viber"), /* @__PURE__ */ React.createElement(Button, { kind: "outline", icon: "mail", style: { flex: 1 }, onClick: () => window.toast && window.toast.phase2(
    "Email \u0449\u0435 \u043F\u0440\u0430\u0442\u0438 \u0432\u0430\u0443\u0447\u0435\u0440\u0430 \u043E\u0442 office@banicharka.bg \u0441 \u043F\u0440\u0438\u043A\u0430\u0447\u0435\u043D PNG \u0438 Bulgarian template. \u0418\u0437\u0438\u0441\u043A\u0432\u0430 SMTP setup.",
    { title: "Email voucher", duration: 4500 }
  ) }, "Email"))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 12 } }, "Turned-away leads"), LEADS.map((l) => /* @__PURE__ */ React.createElement(Card, { key: l.id, pad: 14, style: { marginBottom: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, marginBottom: 6 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 700 } }, l.name), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }), /* @__PURE__ */ React.createElement(Chip, { tone: l.status === "waiting" ? "yellow" : l.status === "contacted" ? "blue" : "green", size: "sm" }, l.status)), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 11.5, color: T.text2 } }, l.phone, " \xB7 ", l.period, " \xB7 ", l.vehicleType), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, marginTop: 10 } }, /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "xs", icon: "phone", onClick: () => {
    window.location.href = "tel:" + l.phone.replace(/\s/g, "");
  } }, "Call"), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "xs", icon: "voucher", onClick: () => window.toast && window.toast.phase2(
    "Issue voucher \u0437\u0430 " + l.name + " \u0449\u0435 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430 VIP recovery \u043A\u043E\u0434 \u0441 \u043E\u0442\u0441\u0442\u044A\u043F\u043A\u0430 \u0438 \u0449\u0435 \u0433\u043E \u0438\u0437\u043F\u0440\u0430\u0442\u0438 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u043D\u0430 " + l.phone + ".",
    { title: "Issue voucher", duration: 4500 }
  ) }, "Issue voucher"), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "xs", icon: "plus", onClick: () => window.toast && window.toast.info(
    "Convert to rental \u0449\u0435 \u043E\u0442\u0432\u043E\u0440\u0438 wizard-\u0430 \u0441\u044A\u0441 \u0441\u0442\u044A\u043F\u043A\u0430 Customer \u043F\u043E\u043F\u044A\u043B\u043D\u0435\u043D\u0430 \u0441 \u0434\u0430\u043D\u043D\u0438\u0442\u0435 \u043D\u0430 " + l.name + " (" + l.phone + ").",
    { title: "Convert lead", duration: 4e3 }
  ) }, "Convert to rental")))))), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 24, fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 12 } }, "Issued vouchers \xB7 past 30 days"), /* @__PURE__ */ React.createElement(Card, { pad: 0 }, [
    { code: "BAN-9K3F", discount: "15%", validUntil: "2026-08-31", status: "issued", customer: "\u041A\u0440\u0430\u0441\u0438\u043C\u0438\u0440 \u0422\u043E\u0434\u043E\u0440\u043E\u0432" },
    { code: "BAN-7X2A", discount: "25 \u20AC", validUntil: "2026-07-15", status: "used", customer: "\u0421\u0442\u0435\u0444\u0430\u043D \u0418\u043B\u0438\u0435\u0432" },
    { code: "BAN-4M8P", discount: "10%", validUntil: "2026-06-30", status: "expired", customer: "\u041F\u0435\u0442\u044F \u041D\u0438\u043A\u043E\u043B\u043E\u0432\u0430" }
  ].map((v, i) => /* @__PURE__ */ React.createElement("div", { key: i, style: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    padding: "12px 18px",
    borderBottom: i < 2 ? `1px solid ${T.border}` : "none"
  } }, /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 13, fontWeight: 700, letterSpacing: 0.5, color: T.accent, width: 90 } }, v.code), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 14, fontWeight: 700, width: 60 } }, v.discount), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, flex: 1 } }, v.customer), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 12, color: T.text2 } }, "\u0434\u043E ", fmtDateBG(v.validUntil)), /* @__PURE__ */ React.createElement(Chip, { tone: v.status === "issued" ? "blue" : v.status === "used" ? "green" : "gray", size: "sm" }, v.status)))));
}
function VoucherCard() {
  return /* @__PURE__ */ React.createElement("div", { style: {
    aspectRatio: "16 / 9",
    background: `linear-gradient(135deg, ${T.accent} 0%, #0F3E9E 100%)`,
    borderRadius: 14,
    padding: 22,
    color: "#fff",
    position: "relative",
    overflow: "hidden",
    boxShadow: "0 20px 40px rgba(26,92,230,0.35)"
  } }, /* @__PURE__ */ React.createElement("div", { style: { position: "absolute", right: -20, bottom: -30, opacity: 0.15 } }, /* @__PURE__ */ React.createElement(VanGlyph, { size: 220, color: "#fff" })), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 8, marginBottom: 4 } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 28,
    height: 28,
    borderRadius: 6,
    background: "#fff",
    color: T.accent,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 800
  } }, "b."), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, fontWeight: 700, letterSpacing: 0.4, textTransform: "uppercase" } }, "banicharka.bg")), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, opacity: 0.7, marginBottom: 20 } }, "VIP RECOVERY VOUCHER"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 42, fontWeight: 800, letterSpacing: -1, fontFamily: "var(--font-serif)" } }, "15% \u043E\u0442\u0441\u0442\u044A\u043F\u043A\u0430"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, opacity: 0.85, marginTop: 4, maxWidth: 260, lineHeight: 1.4 } }, "\u0418\u0437\u0432\u0438\u043D\u044F\u0432\u0430\u043C\u0435 \u0441\u0435, \u0447\u0435 \u043D\u044F\u043C\u0430\u0445\u043C\u0435 \u0441\u0432\u043E\u0431\u043E\u0434\u0435\u043D \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B! \u041F\u0440\u0438 \u0441\u043B\u0435\u0434\u0432\u0430\u0449 \u043D\u0430\u0435\u043C \u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435:"), /* @__PURE__ */ React.createElement("div", { style: {
    marginTop: 12,
    display: "inline-block",
    background: "#fff",
    color: T.accent,
    fontFamily: "var(--font-mono)",
    fontWeight: 800,
    fontSize: 20,
    letterSpacing: 2,
    padding: "8px 14px",
    borderRadius: 8
  } }, "BAN-9K3F"), /* @__PURE__ */ React.createElement("div", { style: { position: "absolute", bottom: 22, right: 22, fontSize: 11, opacity: 0.85 }, className: "mono" }, "valid \u0434\u043E 31.08.2026"));
}
function ReportsScreen({ isPhone }) {
  const months = ["\u0444\u0435\u0432", "\u043C\u0430\u0440", "\u0430\u043F\u0440", "\u043C\u0430\u0439", "\u044E\u043D\u0438", "\u044E\u043B\u0438"];
  const revenue = [3210, 3980, 4200, 4750, 5120, 4820];
  const max = Math.max(...revenue);
  return /* @__PURE__ */ React.createElement("div", { className: "scroll-y", style: { flex: 1, padding: isPhone ? 16 : 24, background: T.bg0 } }, /* @__PURE__ */ React.createElement(
    SectionHeader,
    {
      title: "Reports",
      subtitle: "Phase 2 \xB7 Revenue, utilization, profitability",
      right: /* @__PURE__ */ React.createElement(Button, { kind: "outline", icon: "sheet", size: "sm", onClick: () => window.toast && window.toast.info(
        "Export CSV \u0449\u0435 \u0438\u0437\u0442\u0435\u0433\u043B\u0438 \u0442\u0435\u043A\u0443\u0449\u0438\u044F \u043E\u0442\u0447\u0435\u0442 \u043A\u0430\u0442\u043E CSV \u0444\u0430\u0439\u043B \u0441 UTF-8 BOM \u0437\u0430 \u043A\u043E\u0440\u0435\u043A\u0442\u043D\u043E \u043E\u0442\u0432\u0430\u0440\u044F\u043D\u0435 \u0432 Excel/Google Sheets. \u041F\u0440\u043E\u0432\u0435\u0440\u0435\u0442\u0435 Settings \u2192 Data export \u0437\u0430 \u043F\u044A\u043B\u0435\u043D backup.",
        { title: "Export report", duration: 4500 }
      ) }, "Export CSV")
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: isPhone ? "1fr" : "repeat(3, 1fr)", gap: 12, marginBottom: 20 } }, /* @__PURE__ */ React.createElement(MiniStat, { label: "Revenue \xB7 6 mo", value: fmtEuro(revenue.reduce((a, b) => a + b, 0), { dp: 0 }) }), /* @__PURE__ */ React.createElement(MiniStat, { label: "Rentals \xB7 6 mo", value: "142" }), /* @__PURE__ */ React.createElement(MiniStat, { label: "Avg utilization", value: "68%" })), /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 20 } }, "Revenue by month (\u20AC)"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "flex-end", gap: 12, height: 180 } }, revenue.map((r, i) => /* @__PURE__ */ React.createElement("div", { key: i, style: { flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 8 } }, /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 11, color: T.text2 } }, fmtEuro(r, { dp: 0, showSymbol: false })), /* @__PURE__ */ React.createElement("div", { style: {
    width: "100%",
    height: `${r / max * 140}px`,
    background: `linear-gradient(180deg, ${T.accent}, ${T.accent}77)`,
    borderRadius: "6px 6px 0 0",
    border: `1px solid ${T.accent}`,
    borderBottom: "none"
  } }), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, fontWeight: 600 } }, months[i]))))), /* @__PURE__ */ React.createElement(Card, { pad: 20 }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 16 } }, "Utilization by vehicle \xB7 past 30 days"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 10 } }, VEHICLES.map((v, i) => {
    const util = [72, 88, 68, 45, 30, 78][i];
    const tone = util > 80 ? "red" : util < 40 ? "yellow" : "green";
    return /* @__PURE__ */ React.createElement("div", { key: v.id, style: { display: "flex", alignItems: "center", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { width: 160, fontSize: 12.5 } }, v.make, " ", v.model, /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 11, color: T.text2 } }, v.plate)), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, height: 22, background: T.bg2, borderRadius: 6, position: "relative", overflow: "hidden" } }, /* @__PURE__ */ React.createElement("div", { style: {
      width: `${util}%`,
      height: "100%",
      background: tone === "red" ? T.red : tone === "yellow" ? T.yellow : T.green,
      opacity: 0.85
    } })), /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { width: 44, textAlign: "right", fontSize: 13, fontWeight: 700 } }, util, "%"), util > 80 && /* @__PURE__ */ React.createElement(Chip, { tone: "red", size: "sm" }, "overflow"), util < 40 && /* @__PURE__ */ React.createElement(Chip, { tone: "yellow", size: "sm" }, "underused"));
  }))));
}
function NotificationsScreen({ isPhone }) {
  const notifs = [
    { icon: "warn", tone: "red", title: "Overdue return: \u0421\u0442\u043E\u044F\u043D \u0414\u0438\u043C\u0438\u0442\u0440\u043E\u0432", time: "2 hours ago", body: "Renault Kangoo \xB7 CB 4821 KM \xB7 was due at 17:00" },
    { icon: "euro", tone: "yellow", title: "Outstanding balance", time: "5 hours ago", body: "\u041D\u0438\u043A\u043E\u043B\u0430\u0439 \u0425\u0440\u0438\u0441\u0442\u043E\u0432 \xB7 Contract 149/2026 \xB7 60,25 \u20AC" },
    { icon: "file", tone: "yellow", title: "Vehicle document expiring", time: "today", body: "Dacia Dokker \xB7 CB 7743 MN \xB7 Insurance expires in 22 days" },
    { icon: "clock", tone: "blue", title: "Today's handovers ready", time: "today \xB7 08:00", body: "1 handover at 10:00 \xB7 \u0418\u0432\u0430\u043D \u041F\u0435\u0442\u0440\u043E\u0432 \xB7 Renault Express" },
    { icon: "voucher", tone: "blue", title: "Waiting lead", time: "yesterday", body: "\u041F\u0435\u0442\u044A\u0440 \u041D\u0438\u043A\u043E\u043B\u043E\u0432 \xB7 +359 88 445 1123 \xB7 requested 10\u201314.07" },
    { icon: "file", tone: "gray", title: "Customer document expiring", time: "2 days ago", body: "\u041D\u0438\u043A\u043E\u043B\u0430\u0439 \u0418\u0432\u0430\u043D\u043E\u0432 \xB7 \u0421\u0423\u041C\u041F\u0421 expires 01.08.2026" }
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "scroll-y", style: { flex: 1, padding: isPhone ? 16 : 24, background: T.bg0 } }, /* @__PURE__ */ React.createElement(
    SectionHeader,
    {
      title: "Notifications",
      subtitle: "Phase 2 \xB7 Alerts and reminders",
      right: /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "sm", icon: "check", onClick: () => window.toast && window.toast.success(
        "\u0412\u0441\u0438\u0447\u043A\u0438 \u043D\u043E\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438 \u0441\u0430 \u043C\u0430\u0440\u043A\u0438\u0440\u0430\u043D\u0438 \u043A\u0430\u0442\u043E \u043F\u0440\u043E\u0447\u0435\u0442\u0435\u043D\u0438.",
        { title: "Marked all read", duration: 2500 }
      ) }, "Mark all read")
    }
  ), /* @__PURE__ */ React.createElement(Card, { pad: 0 }, notifs.map((n, i) => /* @__PURE__ */ React.createElement("div", { key: i, style: {
    display: "flex",
    alignItems: "flex-start",
    gap: 14,
    padding: "14px 18px",
    borderBottom: i < notifs.length - 1 ? `1px solid ${T.border}` : "none",
    background: i < 2 ? "rgba(26,92,230,0.04)" : "transparent"
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 40,
    height: 40,
    borderRadius: 10,
    background: T[n.tone + "Tint"],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
  } }, /* @__PURE__ */ React.createElement(Icon, { name: n.icon, size: 18, color: T[n.tone] })), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 12 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13.5, fontWeight: 700 } }, n.title), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text3, whiteSpace: "nowrap" } }, n.time)), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: T.text2, marginTop: 3 } }, n.body))))));
}
Object.assign(window, { DamageScreen, VouchersScreen, ReportsScreen, NotificationsScreen });

/* ══════════ components/rental-detail.jsx ══════════ */
var PHOTO_KIND_LABELS = {
  front: "\u041E\u0442\u043F\u0440\u0435\u0434",
  rear: "\u041E\u0442\u0437\u0430\u0434",
  left: "\u041B\u044F\u0432\u0430 \u0441\u0442\u0440\u0430\u043D\u0430",
  right: "\u0414\u044F\u0441\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0430",
  odometer: "\u041A\u0438\u043B\u043E\u043C\u0435\u0442\u0440\u0430\u0436",
  cargo: "\u0422\u043E\u0432\u0430\u0440\u0435\u043D \u043E\u0442\u0441\u0435\u043A",
  damage_close_up: "\u0429\u0435\u0442\u0430 (\u0434\u0435\u0442\u0430\u0439\u043B)",
  return_front: "\u0412\u0440\u044A\u0449\u0430\u043D\u0435 \xB7 \u043E\u0442\u043F\u0440\u0435\u0434",
  return_rear: "\u0412\u0440\u044A\u0449\u0430\u043D\u0435 \xB7 \u043E\u0442\u0437\u0430\u0434",
  return_left: "\u0412\u0440\u044A\u0449\u0430\u043D\u0435 \xB7 \u043B\u044F\u0432\u0430 \u0441\u0442\u0440\u0430\u043D\u0430",
  return_right: "\u0412\u0440\u044A\u0449\u0430\u043D\u0435 \xB7 \u0434\u044F\u0441\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0430",
  return_odometer: "\u0412\u0440\u044A\u0449\u0430\u043D\u0435 \xB7 \u043A\u0438\u043B\u043E\u043C\u0435\u0442\u0440\u0430\u0436",
  return_cargo: "\u0412\u0440\u044A\u0449\u0430\u043D\u0435 \xB7 \u0442\u043E\u0432\u0430\u0440\u0435\u043D \u043E\u0442\u0441\u0435\u043A",
  return_damage_close_up: "\u0412\u0440\u044A\u0449\u0430\u043D\u0435 \xB7 \u0449\u0435\u0442\u0430 (\u0434\u0435\u0442\u0430\u0439\u043B)",
  gdpr_signature: "\u041F\u043E\u0434\u043F\u0438\u0441 \xB7 GDPR",
  declaration_signature: "\u041F\u043E\u0434\u043F\u0438\u0441 \xB7 \u0434\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0438\u044F",
  contract_signature: "\u041F\u043E\u0434\u043F\u0438\u0441 \xB7 \u0434\u043E\u0433\u043E\u0432\u043E\u0440"
};
function PhotoThumb({ photo, onOpen }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let cancelled = false;
    window.store.getPhotoUrl(photo.id).then((u) => {
      if (!cancelled) setUrl(u);
    }).catch(() => {
      if (!cancelled) setFailed(true);
    });
    return () => {
      cancelled = true;
    };
  }, [photo.id]);
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: () => onOpen(photo),
      title: PHOTO_KIND_LABELS[photo.kind] || photo.kind,
      style: {
        position: "relative",
        aspectRatio: "4 / 3",
        borderRadius: 10,
        border: `1px solid ${T.border}`,
        background: T.bg2,
        overflow: "hidden",
        padding: 0,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    },
    failed ? /* @__PURE__ */ React.createElement(Icon, { name: "warn", size: 16, color: T.text2 }) : url ? /* @__PURE__ */ React.createElement(
      "img",
      {
        src: url,
        alt: PHOTO_KIND_LABELS[photo.kind] || photo.kind,
        style: { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }
      }
    ) : /* @__PURE__ */ React.createElement(Icon, { name: "refresh", size: 16, color: T.text2 }),
    /* @__PURE__ */ React.createElement("div", { style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      padding: "4px 6px",
      background: "rgba(0,0,0,0.6)",
      fontSize: 10,
      fontWeight: 600,
      color: "#fff",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    } }, PHOTO_KIND_LABELS[photo.kind] || photo.kind)
  );
}
function PhotoLightbox({ photo, onClose }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let cancelled = false;
    window.store.getPhotoUrl(photo.id).then((u) => {
      if (!cancelled) setUrl(u);
    }).catch(() => {
      if (!cancelled) setFailed(true);
    });
    return () => {
      cancelled = true;
    };
  }, [photo.id]);
  return /* @__PURE__ */ React.createElement("div", { onClick: onClose, style: {
    position: "absolute",
    inset: 0,
    background: "rgba(5,7,11,0.94)",
    zIndex: 300,
    display: "flex",
    flexDirection: "column"
  } }, /* @__PURE__ */ React.createElement("div", { style: { padding: "14px 24px", display: "flex", alignItems: "center", gap: 12, borderBottom: `1px solid ${T.border}` } }, /* @__PURE__ */ React.createElement("div", { style: { flex: 1, fontSize: 15, fontWeight: 700 } }, PHOTO_KIND_LABELS[photo.kind] || photo.kind), /* @__PURE__ */ React.createElement(IconBtn, { icon: "x", onClick: onClose, title: "Close" })), /* @__PURE__ */ React.createElement("div", { onClick: (e) => e.stopPropagation(), style: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    minHeight: 0
  } }, failed ? /* @__PURE__ */ React.createElement("div", { style: { color: T.text2, fontSize: 13 } }, "\u0413\u0440\u0435\u0448\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435 \u043D\u0430 \u0441\u043D\u0438\u043C\u043A\u0430\u0442\u0430.") : url ? /* @__PURE__ */ React.createElement(
    "img",
    {
      src: url,
      alt: PHOTO_KIND_LABELS[photo.kind] || photo.kind,
      style: { maxWidth: "100%", maxHeight: "100%", objectFit: "contain", borderRadius: 8 }
    }
  ) : /* @__PURE__ */ React.createElement(Icon, { name: "refresh", size: 22, color: T.text2 })));
}
function RentalDetail({ rental, isPhone, onClose, onOpenSettlement, onStartHandover, onEditReservation }) {
  store.useStore();
  const r = window.store.findRental(rental.id) || rental;
  const v = VEHICLES.find((x) => x.id === r.vehicleId);
  const c = CUSTOMERS.find((x) => x.id === r.customerId) || {
    id: null,
    name: r.reservationName || "\u2014",
    phone: r.reservationPhone || "",
    egn: "\u2014",
    idCard: { expiry: null, number: "\u2014" },
    driverLicense: { expiry: null, number: "\u2014", categories: "\u2014" },
    address: "\u2014",
    rentalsCount: 0,
    blacklisted: false
  };
  const days = daysBetween(r.start, r.end);
  const status = STATUS_COLORS[r.status];
  const buildRentalStateForPdfs = () => ({
    ...r,
    customer: c,
    vehicle: v,
    startAt: r.start,
    endAt: r.end,
    kmPerDay: r.kmPerDay || v && v.kmPerDay || 200,
    extraKmPrice: r.extraKmPrice || v && v.extraKmPrice || 0.18,
    depositMethod: r.depositMethod || "cash",
    handoverPhotos: {},
    extraPhotos: [],
    gdprSigned: true,
    gdprSignedAt: r.start.toISOString(),
    declarationSigned: false,
    contractSigned: true,
    contractSignedAt: r.start.toISOString()
  });
  const pdfCacheRef = useRef({ key: null, promise: null });
  const pdfCacheKey = r.id + "|" + String(r.end) + "|" + r.status;
  const getPdfsOnce = () => {
    if (pdfCacheRef.current.key !== pdfCacheKey || !pdfCacheRef.current.promise) {
      const promise = window.generateRentalDocuments(buildRentalStateForPdfs()).catch((err) => {
        pdfCacheRef.current = { key: null, promise: null };
        throw err;
      });
      pdfCacheRef.current = { key: pdfCacheKey, promise };
    }
    return pdfCacheRef.current.promise;
  };
  const [pdfsReady, setPdfsReady] = useState(false);
  useEffect(() => {
    let alive = true;
    setPdfsReady(false);
    getPdfsOnce().then(() => {
      if (alive) setPdfsReady(true);
    }).catch(() => {
    });
    return () => {
      alive = false;
    };
  }, [pdfCacheKey]);
  const previewOne = async (nameKey, label) => {
    try {
      window.toast && window.toast.info("\u0413\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 " + label + "\u2026", { duration: 2e3 });
      const pdfs = await getPdfsOnce();
      const doc = pdfs.find((p) => p.name.includes(nameKey)) || pdfs[0];
      const blob = new Blob([doc.bytes], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
      setTimeout(() => URL.revokeObjectURL(url), 6e4);
    } catch (err) {
      window.store.reportError(err, "\u0413\u0440\u0435\u0448\u043A\u0430 \u043F\u0440\u0438 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442");
    }
  };
  const shareOne = async (nameKey, label) => {
    try {
      if (!pdfsReady) {
        await getPdfsOnce();
        window.toast && window.toast.info(label + " \u0435 \u0433\u043E\u0442\u043E\u0432 \u2014 \u043D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u201E\u0421\u043F\u043E\u0434\u0435\u043B\u0438\u201C \u043E\u0442\u043D\u043E\u0432\u043E.", { duration: 4e3 });
        return;
      }
      const pdfs = await getPdfsOnce();
      const doc = pdfs.find((p) => p.name.includes(nameKey)) || pdfs[0];
      const result = await window.shareRentalPdfs([doc], {
        title: "banicharka.bg \xB7 " + doc.name,
        text: label + " \xB7 " + c.name + " \xB7 " + r.contractNo
      });
      if (result.ok && result.method === "share") {
        window.toast && window.toast.success("\u041E\u0442\u0432\u043E\u0440\u0435\u043D \u0435 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u0438\u044F\u0442 share sheet.");
      } else if (result.ok && result.method === "download") {
        window.toast && window.toast.success("\u0418\u0437\u0442\u0435\u0433\u043B\u0435\u043D: " + doc.name);
      } else if (result.cancelled) {
      } else {
        window.toast && window.toast.error("\u0413\u0440\u0435\u0448\u043A\u0430 \u043F\u0440\u0438 \u0441\u043F\u043E\u0434\u0435\u043B\u044F\u043D\u0435.");
      }
    } catch (err) {
      window.store.reportError(err, "\u0413\u0440\u0435\u0448\u043A\u0430 \u043F\u0440\u0438 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435/\u0441\u043F\u043E\u0434\u0435\u043B\u044F\u043D\u0435 \u043D\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442");
    }
  };
  const attachedDocBytes = (doc) => {
    const binary = atob(doc.base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return bytes.buffer;
  };
  const openAttachedDoc = (doc) => {
    try {
      const blob = new Blob([attachedDocBytes(doc)], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
      setTimeout(() => URL.revokeObjectURL(url), 6e4);
    } catch (err) {
      window.toast && window.toast.error("\u0413\u0440\u0435\u0448\u043A\u0430 \u043F\u0440\u0438 \u043F\u0440\u0435\u0433\u043B\u0435\u0434: " + (err && err.message || err));
    }
  };
  const shareAttachedDoc = async (doc) => {
    try {
      const bytes = attachedDocBytes(doc);
      const result = await window.shareRentalPdfs([{ bytes, name: doc.name }], {
        title: "banicharka.bg \xB7 " + doc.name,
        text: doc.name + " \xB7 " + r.contractNo
      });
      if (result.ok && result.method === "share") {
        window.toast && window.toast.success("\u041E\u0442\u0432\u043E\u0440\u0435\u043D \u0435 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u0438\u044F\u0442 share sheet.");
      } else if (result.ok && result.method === "download") {
        window.toast && window.toast.success("\u0418\u0437\u0442\u0435\u0433\u043B\u0435\u043D: " + doc.name);
      }
    } catch (err) {
      window.toast && window.toast.error("\u0413\u0440\u0435\u0448\u043A\u0430 \u043F\u0440\u0438 \u0441\u043F\u043E\u0434\u0435\u043B\u044F\u043D\u0435: " + (err && err.message || err));
    }
  };
  const shareAll = async () => {
    try {
      if (!pdfsReady) {
        window.toast && window.toast.info("\u0413\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u0432\u0441\u0438\u0447\u043A\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438\u2026", { duration: 2500 });
        await getPdfsOnce();
        window.toast && window.toast.info("\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438\u0442\u0435 \u0441\u0430 \u0433\u043E\u0442\u043E\u0432\u0438 \u2014 \u043D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u201EShare\u201C \u043E\u0442\u043D\u043E\u0432\u043E.", { duration: 4e3 });
        return;
      }
      const pdfs = await getPdfsOnce();
      const result = await window.shareRentalPdfs(pdfs, {
        title: "banicharka.bg \xB7 \u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u2116 " + r.contractNo,
        text: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u043F\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440 " + r.contractNo + " \xB7 " + c.name + " \xB7 " + v.make + " " + v.model
      });
      if (result.ok && result.method === "share") {
        window.toast && window.toast.success("\u041E\u0442\u0432\u043E\u0440\u0435\u043D \u0435 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u0438\u044F\u0442 share sheet.");
      } else if (result.ok && result.method === "download") {
        window.toast && window.toast.success("\u0418\u0437\u0442\u0435\u0433\u043B\u0435\u043D\u0438 " + pdfs.length + " PDF \u0444\u0430\u0439\u043B\u0430.");
      }
    } catch (err) {
      window.store.reportError(err, "\u0413\u0440\u0435\u0448\u043A\u0430 \u043F\u0440\u0438 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D\u0435/\u0441\u043F\u043E\u0434\u0435\u043B\u044F\u043D\u0435 \u043D\u0430 \u0432\u0441\u0438\u0447\u043A\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438");
    }
  };
  const [confirmingCancel, setConfirmingCancel] = useState(false);
  const [extending, setExtending] = useState(false);
  const [openPhoto, setOpenPhoto] = useState(null);
  const startHandover = () => {
    if (typeof onStartHandover === "function") {
      onStartHandover(r);
    } else {
      window.toast && window.toast.warn("Start handover \u043D\u0435 \u0435 \u0441\u0432\u044A\u0440\u0437\u0430\u043D. \u041E\u0442\u0432\u043E\u0440\u0438 rental detail \u043E\u0442 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u0430.");
    }
  };
  const doCancelRental = () => {
    setConfirmingCancel(false);
    const reason = r.status === "no-show" ? "no-show-cancelled" : "operator-cancelled";
    window.store.cancelRental(r.id, { reason });
    const stillBusy = window.store.rentals().some(
      (x) => x.vehicleId === r.vehicleId && x.id !== r.id && (x.status === "active" || x.status === "reserved")
    );
    if (!stillBusy) {
      window.store.updateVehicle(r.vehicleId, { status: "available" });
    }
    window.toast && window.toast.warn(
      "\u0420\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F " + r.contractNo + " \u0435 \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u0430. \u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044A\u0442 \u0435 \u043E\u0441\u0432\u043E\u0431\u043E\u0434\u0435\u043D.",
      { title: "\u0420\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F\u0442\u0430 \u0435 \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u0430", duration: 4e3 }
    );
    setTimeout(onClose, 700);
  };
  return /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    inset: 0,
    background: T.bg0,
    zIndex: 100,
    display: "flex",
    flexDirection: "column"
  }, "data-screen-label": "Rental detail" }, /* @__PURE__ */ React.createElement(
    TopBar,
    {
      title: `${r.contractNo}`,
      subtitle: `${c.name} \xB7 ${v.make} ${v.model}`,
      right: /* @__PURE__ */ React.createElement(IconBtn, { icon: "x", onClick: onClose })
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "scroll-y", style: { flex: 1, padding: isPhone ? 16 : 24 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, marginBottom: 20 } }, /* @__PURE__ */ React.createElement(StatusDot, { status: r.status, size: 12 }), /* @__PURE__ */ React.createElement(Chip, { tone: r.status === "overdue" ? "red" : r.status === "active" ? "blue" : r.status === "reserved" ? "yellow" : "gray", size: "lg" }, status.label), r.status === "overdue" && /* @__PURE__ */ React.createElement(Chip, { tone: "red", size: "lg", icon: "warn" }, Math.floor((TODAY - r.end) / (1e3 * 60 * 60)), "h past due")), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: isPhone ? "1fr" : "1fr 1fr", gap: 16, marginBottom: 16 } }, /* @__PURE__ */ React.createElement(Card, { pad: 18 }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 10 } }, "Customer"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700 } }, c.name), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 12, color: T.text2, marginTop: 4 } }, c.phone, " \xB7 \u0415\u0413\u041D ", c.egn)), /* @__PURE__ */ React.createElement(Card, { pad: 18 }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 10 } }, "Vehicle"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700 } }, v.make, " ", v.model), /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 12, color: T.text2, marginTop: 4 } }, v.plate))), /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12 } }, /* @__PURE__ */ React.createElement(MiniStat, { label: "Start", value: fmtDateTimeBG(r.start) + " \u0447." }), /* @__PURE__ */ React.createElement(MiniStat, { label: "End", value: fmtDateTimeBG(r.end) + " \u0447." }), /* @__PURE__ */ React.createElement(MiniStat, { label: "Days", value: days }), /* @__PURE__ */ React.createElement(MiniStat, { label: "Daily rate", value: fmtEuro(r.dailyRate, { dp: 0 }) }))), /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 14 } }, "Handover"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 } }, /* @__PURE__ */ React.createElement(MiniStat, { label: "Odometer", value: fmtKm(r.handoverOdo || 0) }), /* @__PURE__ */ React.createElement(MiniStat, { label: "Fuel", value: (r.handoverFuel || 0) + "%" }), /* @__PURE__ */ React.createElement(MiniStat, { label: "Photos", value: r.handoverOdo ? "6/6 \u2713" : "\u2014" }))), Array.isArray(r.photos) && r.photos.length > 0 && /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 12 } }, "Photos (", r.photos.length, ")"), /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: isPhone ? "repeat(3, 1fr)" : "repeat(6, 1fr)",
    gap: 10
  } }, r.photos.map((photo) => /* @__PURE__ */ React.createElement(PhotoThumb, { key: photo.id, photo, onOpen: setOpenPhoto })))), /* @__PURE__ */ React.createElement(Card, { pad: 20, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text2, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 12 } }, "Documents"), [
    { name: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u0437\u0430 \u043D\u0430\u0435\u043C.pdf", nameKey: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440", label: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440" },
    { name: "\u041F\u0440\u0438\u0435\u043C\u043E-\u043F\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u0435\u043B\u0435\u043D \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B.pdf", nameKey: "\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B", label: "\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B" },
    { name: "\u0414\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0438\u044F GDPR.pdf", nameKey: "GDPR", label: "\u0414\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0438\u044F GDPR" }
  ].map((doc) => /* @__PURE__ */ React.createElement("div", { key: doc.name, style: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "10px 12px",
    background: T.bg2,
    borderRadius: 10,
    border: `1px solid ${T.border}`,
    marginBottom: 8
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "filePdf", size: 18, color: T.red }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, fontSize: 13 } }, doc.name), /* @__PURE__ */ React.createElement(IconBtn, { icon: "eye", size: 30, title: "\u041F\u0440\u0435\u0433\u043B\u0435\u0434 \u043D\u0430 PDF", onClick: () => previewOne(doc.nameKey, doc.label) }), /* @__PURE__ */ React.createElement(IconBtn, { icon: "share", size: 30, title: "\u0421\u043F\u043E\u0434\u0435\u043B\u0438", onClick: () => shareOne(doc.nameKey, doc.label) }))), (r.attachedDocuments || []).map((doc) => /* @__PURE__ */ React.createElement("div", { key: doc.id, style: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "10px 12px",
    background: T.bg2,
    borderRadius: 10,
    border: `1px solid ${T.border}`,
    marginBottom: 8
  } }, /* @__PURE__ */ React.createElement(Icon, { name: "filePdf", size: 18, color: T.orange }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, minWidth: 0 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } }, doc.name), doc.meta && /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: T.text2, marginTop: 2 } }, doc.kind === "addendum" ? `+${doc.meta.extraDays} ${doc.meta.extraDays === 1 ? "\u0434\u0435\u043D" : "\u0434\u043D\u0438"} \xB7 +${fmtEuro(doc.meta.extraCost)} \xB7 ${fmtDateBG(new Date(doc.generatedAt))}` : fmtDateBG(new Date(doc.generatedAt)))), /* @__PURE__ */ React.createElement(IconBtn, { icon: "eye", size: 30, title: "\u041F\u0440\u0435\u0433\u043B\u0435\u0434 \u043D\u0430 PDF", onClick: () => openAttachedDoc(doc) }), /* @__PURE__ */ React.createElement(IconBtn, { icon: "share", size: 30, title: "\u0421\u043F\u043E\u0434\u0435\u043B\u0438", onClick: () => shareAttachedDoc(doc) })))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10 } }, r.status === "active" || r.status === "overdue" ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "lg", icon: "refresh", style: { flex: 2 }, onClick: onOpenSettlement }, "Start return"), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "lg", icon: "clock", onClick: () => setExtending(true) }, "Extend"), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "lg", icon: "share", onClick: shareAll }, "Share")) : r.status === "reserved" ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "lg", icon: "key", style: { flex: 2 }, onClick: startHandover }, "Start handover"), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "lg", icon: "edit", onClick: () => onEditReservation && onEditReservation(r) }, "Edit"), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "lg", icon: "x", onClick: () => setConfirmingCancel(true), danger: true }, "Cancel")) : r.status === "no-show" ? /* @__PURE__ */ React.createElement(React.Fragment, null, r.reservationPhone && /* @__PURE__ */ React.createElement(
    Button,
    {
      kind: "outline",
      size: "lg",
      icon: "phone",
      style: { flex: 1 },
      onClick: () => {
        window.location.href = "tel:" + r.reservationPhone.replace(/\s+/g, "");
      }
    },
    "\u041F\u043E\u0437\u0432\u044A\u043D\u0438"
  ), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "lg", icon: "edit", onClick: () => onEditReservation && onEditReservation(r) }, "Edit"), /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "lg", icon: "x", style: { flex: 1 }, onClick: () => setConfirmingCancel(true), danger: true }, "\u041E\u0442\u043C\u0435\u043D\u0438 \u0440\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F\u0442\u0430")) : /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "lg", icon: "share", style: { flex: 1 }, onClick: shareAll }, "Share documents")), /* @__PURE__ */ React.createElement("div", { style: { height: 20 } })), confirmingCancel && /* @__PURE__ */ React.createElement(
    ConfirmSheet,
    {
      title: "\u041E\u0442\u043C\u044F\u043D\u0430 \u043D\u0430 \u0440\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F?",
      body: `${r.contractNo} \xB7 ${r.reservationName || c.name || "\u043A\u043B\u0438\u0435\u043D\u0442"}. \u041E\u0441\u0432\u043E\u0431\u043E\u0436\u0434\u0430\u0432\u0430 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u0430 \u2014 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044A\u0442 \u0441\u0442\u0430\u0432\u0430 \u0441\u0432\u043E\u0431\u043E\u0434\u0435\u043D.`,
      confirmLabel: "\u041E\u0442\u043C\u0435\u043D\u0438 \u0440\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F\u0442\u0430",
      confirmTone: "danger",
      onConfirm: doCancelRental,
      onCancel: () => setConfirmingCancel(false)
    }
  ), extending && /* @__PURE__ */ React.createElement(
    ExtendRentalPanel,
    {
      rental: r,
      onClose: () => setExtending(false)
    }
  ), openPhoto && /* @__PURE__ */ React.createElement(PhotoLightbox, { photo: openPhoto, onClose: () => setOpenPhoto(null) }));
}
function ExtendRentalPanel({ rental, onClose }) {
  const r = rental;
  const [newEnd, setNewEnd] = useState(() => {
    const d = new Date(r.end);
    d.setDate(d.getDate() + 1);
    return d;
  });
  const conflict = window.checkVehicleConflict ? window.checkVehicleConflict(r.vehicleId, r.end, newEnd, r.id) : null;
  const extraDays = Math.max(0, Math.ceil((newEnd - r.end) / (1e3 * 60 * 60 * 24)));
  const extraCost = extraDays * (r.dailyRate || 0);
  const confirm = async () => {
    if (conflict) {
      window.toast && window.toast.error(
        "\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044A\u0442 \u0438\u043C\u0430 \u043A\u043E\u043D\u0444\u043B\u0438\u043A\u0442 \u0441 \u0434\u0440\u0443\u0433 \u043D\u0430\u0435\u043C/\u0431\u0443\u0444\u0435\u0440 \u0432 \u0438\u0437\u0431\u0440\u0430\u043D\u0438\u044F \u043F\u0435\u0440\u0438\u043E\u0434. \u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0434\u0440\u0443\u0433\u0430 \u0434\u0430\u0442\u0430.",
        { title: "Extension conflict", duration: 4500 }
      );
      return;
    }
    const originalEnd = new Date(r.end);
    window.store.extendRental(r.id, newEnd);
    window.store.addPayment({
      rentalId: r.id,
      amount: extraCost,
      method: "cash",
      purpose: "rent",
      date: /* @__PURE__ */ new Date()
    });
    let addendumMsg = "";
    try {
      const c = window.store.findCustomer(r.customerId) || { name: r.reservationName || "\u2014", phone: r.reservationPhone || "" };
      const v = window.store.findVehicle(r.vehicleId);
      const prevAddendums = (r.attachedDocuments || []).filter((d) => d.kind === "addendum");
      const seq = prevAddendums.length + 1;
      const now = window.TODAY || /* @__PURE__ */ new Date();
      const addendum = await window.generateExtensionAddendumPdf({
        contractNo: r.contractNo,
        customer: c,
        vehicle: v,
        originalEnd,
        newEnd,
        extraDays,
        extraCost,
        sequenceNumber: seq,
        requestedAt: now
      });
      const base64 = btoa(String.fromCharCode.apply(null, new Uint8Array(addendum.bytes)));
      window.store.attachDocument(r.id, {
        id: "doc" + Date.now() + Math.random().toString(36).slice(2, 6),
        kind: "addendum",
        name: addendum.name,
        base64,
        bytes: addendum.bytes.byteLength,
        generatedAt: now.toISOString(),
        // Metadata that the Documents list can display
        meta: {
          extraDays,
          extraCost,
          originalEnd: originalEnd.toISOString(),
          newEnd: newEnd.toISOString(),
          sequenceNumber: seq
        }
      });
      const blob = new Blob([addendum.bytes], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
      setTimeout(() => URL.revokeObjectURL(url), 6e4);
      addendumMsg = " \u201E" + addendum.name + '" \u0435 \u0434\u043E\u0431\u0430\u0432\u0435\u043D \u0432 Documents.';
    } catch (err) {
      addendumMsg = " \u0410\u043D\u0435\u043A\u0441\u044A\u0442 \u041D\u0415 \u0435 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D: " + (err && err.message || err);
      window.store.logClientError({
        message: "Extension addendum PDF generation failed: " + (err && err.message || err),
        context: "rental-detail.jsx confirm() \u2014 generateExtensionAddendumPdf",
        severity: "error",
        stack: err && err.stack
      });
    }
    window.toast && window.toast.success(
      "\u041D\u0430\u0435\u043C " + r.contractNo + " \u0435 \u0443\u0434\u044A\u043B\u0436\u0435\u043D \u0441 " + extraDays + " \u0434\u043D\u0438 \u0434\u043E " + fmtDateBG(newEnd) + ". \u0414\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u043D\u0430 \u0441\u0443\u043C\u0430: " + fmtEuro(extraCost) + "." + addendumMsg,
      { title: "\u041D\u0430\u0435\u043C\u044A\u0442 \u0435 \u0443\u0434\u044A\u043B\u0436\u0435\u043D", duration: 6e3 }
    );
    onClose();
  };
  return /* @__PURE__ */ React.createElement("div", { onClick: onClose, style: {
    position: "absolute",
    inset: 0,
    background: "rgba(5,7,11,0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 250
  } }, /* @__PURE__ */ React.createElement("div", { onClick: (e) => e.stopPropagation(), style: {
    background: T.bg1,
    border: `1px solid ${T.border}`,
    borderRadius: 14,
    padding: 24,
    maxWidth: 500,
    width: "calc(100% - 40px)"
  } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 17, fontWeight: 700, marginBottom: 8 } }, "\u0423\u0434\u044A\u043B\u0436\u0430\u0432\u0430\u043D\u0435 \u043D\u0430 \u043D\u0430\u0435\u043C ", r.contractNo), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2, marginBottom: 20 } }, "\u0422\u0435\u043A\u0443\u0449 \u043A\u0440\u0430\u0439: ", /* @__PURE__ */ React.createElement("span", { className: "mono" }, fmtDateTimeBG(r.end))), /* @__PURE__ */ React.createElement(Field, { label: "\u041D\u043E\u0432 \u043A\u0440\u0430\u0439" }, /* @__PURE__ */ React.createElement(PeriodPicker, { value: newEnd, onChange: setNewEnd, minDate: r.end })), /* @__PURE__ */ React.createElement("div", { style: {
    marginTop: 14,
    padding: 12,
    background: conflict ? T.redTint : T.bg2,
    border: `1px solid ${conflict ? "rgba(239,68,68,0.35)" : T.border}`,
    borderRadius: 8
  } }, conflict ? /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: "#FCA5A5" } }, /* @__PURE__ */ React.createElement("strong", null, "\u041A\u043E\u043D\u0444\u043B\u0438\u043A\u0442:"), " \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044A\u0442 \u0435 \u0437\u0430\u0435\u0442 \u0438\u043B\u0438 \u0432 \u0431\u0443\u0444\u0435\u0440\u0430 \u043D\u0430 \u0434\u0440\u0443\u0433 \u043D\u0430\u0435\u043C \u0432 \u043D\u043E\u0432\u0438\u044F \u043F\u0435\u0440\u0438\u043E\u0434.") : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", fontSize: 13, marginBottom: 4 } }, /* @__PURE__ */ React.createElement("span", { style: { color: T.text2 } }, "\u0414\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u043D\u0438 \u0434\u043D\u0438:"), /* @__PURE__ */ React.createElement("span", { className: "mono tabular", style: { fontWeight: 700 } }, extraDays)), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", fontSize: 13 } }, /* @__PURE__ */ React.createElement("span", { style: { color: T.text2 } }, "\u0414\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u043D\u0430 \u0441\u0443\u043C\u0430:"), /* @__PURE__ */ React.createElement("span", { className: "mono tabular", style: { fontWeight: 700, color: T.accent } }, fmtEuro(extraCost))))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10, marginTop: 20 } }, /* @__PURE__ */ React.createElement(Button, { kind: "secondary", size: "md", style: { flex: 1 }, onClick: onClose }, "\u041E\u0442\u043A\u0430\u0437"), /* @__PURE__ */ React.createElement(Button, { kind: "primary", size: "md", style: { flex: 1 }, icon: "check", onClick: confirm, disabled: !!conflict || extraDays === 0 }, "\u0423\u0434\u044A\u043B\u0436\u0438 \u043D\u0430\u0435\u043C\u0430"))));
}
function ConfirmSheet({ title, body, confirmLabel, confirmTone = "primary", onConfirm, onCancel }) {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      onClick: onCancel,
      style: {
        position: "absolute",
        inset: 0,
        background: "rgba(5,7,11,0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 250
      }
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        onClick: (e) => e.stopPropagation(),
        style: {
          background: T.bg1,
          border: `1px solid ${T.border}`,
          borderRadius: 14,
          padding: 24,
          maxWidth: 460,
          width: "calc(100% - 40px)",
          boxShadow: "0 12px 40px rgba(0,0,0,0.6)"
        }
      },
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 17, fontWeight: 700, marginBottom: 8 } }, title),
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text1, lineHeight: 1.55, marginBottom: 20 } }, body),
      /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 10 } }, /* @__PURE__ */ React.createElement(Button, { kind: "secondary", size: "md", style: { flex: 1 }, onClick: onCancel }, "\u041D\u0430\u0437\u0430\u0434"), /* @__PURE__ */ React.createElement(Button, { kind: confirmTone === "danger" ? "danger" : "primary", size: "md", style: { flex: 1 }, onClick: onConfirm, danger: confirmTone === "danger" }, confirmLabel))
    )
  );
}
Object.assign(window, { RentalDetail, ConfirmSheet });

/* ══════════ components/journal.jsx ══════════ */
var JOURNAL_STATUS_FILTERS = [
  { value: "all", label: "All" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
  { value: "overdue", label: "Overdue" },
  { value: "no-show", label: "No-show" }
];
var JOURNAL_STATUS_TONE = {
  reserved: "yellow",
  active: "green",
  overdue: "red",
  "no-show": "orange",
  completed: "gray",
  cancelled: "gray"
};
function JournalScreen({ isPhone, onOpenRental }) {
  store.useStore();
  const [statusFilter, setStatusFilter] = useState("all");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  let rows = RENTALS.slice();
  if (statusFilter !== "all") {
    rows = rows.filter((r) => r.status === statusFilter);
  }
  if (dateFrom) {
    const from = /* @__PURE__ */ new Date(dateFrom + "T00:00:00");
    rows = rows.filter((r) => new Date(r.start) >= from);
  }
  if (dateTo) {
    const to = /* @__PURE__ */ new Date(dateTo + "T23:59:59");
    rows = rows.filter((r) => new Date(r.start) <= to);
  }
  rows.sort((a, b) => new Date(b.start) - new Date(a.start));
  const hasFilters = statusFilter !== "all" || !!dateFrom || !!dateTo;
  const clearFilters = () => {
    setStatusFilter("all");
    setDateFrom("");
    setDateTo("");
  };
  const colTemplate = "1.3fr 1.1fr 1.9fr 0.9fr 0.9fr";
  return /* @__PURE__ */ React.createElement("div", { className: "scroll-y", style: { flex: 1, padding: isPhone ? 16 : 24, background: T.bg0 } }, /* @__PURE__ */ React.createElement(
    SectionHeader,
    {
      title: "Journal",
      subtitle: rows.length === RENTALS.length ? `${RENTALS.length} rentals` : `${rows.length} of ${RENTALS.length} rentals`
    }
  ), /* @__PURE__ */ React.createElement(Card, { pad: 16, style: { marginBottom: 16 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", alignItems: "flex-end", gap: 12 } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2, marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.4, fontWeight: 600 } }, "Status"), /* @__PURE__ */ React.createElement(
    "select",
    {
      value: statusFilter,
      onChange: (e) => setStatusFilter(e.target.value),
      style: {
        height: 36,
        padding: "0 12px",
        borderRadius: 10,
        background: T.bg2,
        border: `1px solid ${T.border}`,
        color: T.text0,
        fontSize: 13.5,
        fontWeight: 600,
        minWidth: 150,
        cursor: "pointer"
      }
    },
    JOURNAL_STATUS_FILTERS.map((o) => /* @__PURE__ */ React.createElement("option", { key: o.value, value: o.value }, o.label))
  )), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2, marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.4, fontWeight: 600 } }, "From"), /* @__PURE__ */ React.createElement(Input, { type: "date", size: "sm", value: dateFrom, onChange: (e) => setDateFrom(e.target.value), style: { width: 150 } })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11.5, color: T.text2, marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.4, fontWeight: 600 } }, "To"), /* @__PURE__ */ React.createElement(Input, { type: "date", size: "sm", value: dateTo, onChange: (e) => setDateTo(e.target.value), style: { width: 150 } })), hasFilters && /* @__PURE__ */ React.createElement(Button, { kind: "outline", size: "sm", icon: "x", onClick: clearFilters }, "Clear filters"))), /* @__PURE__ */ React.createElement(Card, { pad: 0 }, !isPhone && /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: colTemplate,
    gap: 12,
    padding: "12px 20px",
    borderBottom: `1px solid ${T.border}`,
    fontSize: 11,
    color: T.text2,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    fontWeight: 600
  } }, /* @__PURE__ */ React.createElement("div", null, "Customer"), /* @__PURE__ */ React.createElement("div", null, "Vehicle"), /* @__PURE__ */ React.createElement("div", null, "Period"), /* @__PURE__ */ React.createElement("div", null, "Status"), /* @__PURE__ */ React.createElement("div", { style: { textAlign: "right" } }, "Total")), rows.length === 0 ? /* @__PURE__ */ React.createElement("div", { style: { padding: "40px 20px", textAlign: "center", color: T.text2, fontSize: 13.5 } }, "No rentals match the current filters.") : rows.map((r) => {
    const c = CUSTOMERS.find((cc) => cc.id === r.customerId) || { name: r.reservationName || "\u2014", phone: r.reservationPhone || "" };
    const v = VEHICLES.find((vv) => vv.id === r.vehicleId);
    const stat = STATUS_COLORS[r.status];
    const tone = JOURNAL_STATUS_TONE[r.status] || "gray";
    if (isPhone) {
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          key: r.id,
          onClick: () => onOpenRental && onOpenRental(r),
          title: c.name + " \xB7 " + r.contractNo,
          style: {
            display: "flex",
            flexDirection: "column",
            gap: 4,
            width: "100%",
            textAlign: "left",
            padding: "14px 16px",
            borderBottom: `1px solid ${T.border}`,
            background: "transparent",
            border: "none",
            font: "inherit",
            cursor: onOpenRental ? "pointer" : "default"
          }
        },
        /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 10 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13.5, fontWeight: 600, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, c.name, " ", /* @__PURE__ */ React.createElement("span", { className: "mono", style: { color: T.text2, fontWeight: 400, fontSize: 11 } }, "\xB7 ", r.contractNo)), /* @__PURE__ */ React.createElement(Chip, { tone, size: "sm" }, stat && stat.label || r.status)),
        /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: T.text2 } }, v ? v.make + " \xB7 " + v.plate : "\u2014"),
        /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 11.5, color: T.text2 } }, fmtDateTimeBG(r.start), " \u2192 ", fmtDateTimeBG(r.end)),
        /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 14, fontWeight: 700 } }, fmtEuro(r.total))
      );
    }
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: r.id,
        onClick: () => onOpenRental && onOpenRental(r),
        title: c.name + " \xB7 " + r.contractNo,
        style: {
          display: "grid",
          gridTemplateColumns: colTemplate,
          gap: 12,
          width: "100%",
          textAlign: "left",
          alignItems: "center",
          padding: "13px 20px",
          borderBottom: `1px solid ${T.border}`,
          background: "transparent",
          border: "none",
          font: "inherit",
          cursor: onOpenRental ? "pointer" : "default"
        }
      },
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13.5, fontWeight: 600, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, c.name, /* @__PURE__ */ React.createElement("span", { className: "mono", style: { color: T.text2, fontWeight: 400, fontSize: 11.5 } }, " \xB7 ", r.contractNo)),
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, color: T.text1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, v ? v.make + " \xB7 " + v.plate : "\u2014"),
      /* @__PURE__ */ React.createElement("div", { className: "mono", style: { fontSize: 12.5, color: T.text2 } }, fmtDateTimeBG(r.start), " \u2192 ", fmtDateTimeBG(r.end)),
      /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Chip, { tone, size: "sm" }, stat && stat.label || r.status)),
      /* @__PURE__ */ React.createElement("div", { className: "mono tabular", style: { fontSize: 13.5, fontWeight: 700, textAlign: "right" } }, fmtEuro(r.total))
    );
  })));
}
Object.assign(window, { JournalScreen });

/* ══════════ components/app.jsx ══════════ */
function App() {
  const [route, setRoute] = useState("dashboard");
  const [modal, setModal] = useState(null);
  const [kiosk, setKiosk] = useState(null);
  const [tweaks, setTweaks] = useTweaks(TWEAK_DEFAULTS);
  const [phoneNav, setPhoneNav] = useState(false);
  const isPhone = tweaks.device === "phone";
  useEffect(() => {
    const saved = localStorage.getItem("bnc-route");
    if (saved) setRoute(saved);
  }, []);
  useEffect(() => {
    localStorage.setItem("bnc-route", route);
  }, [route]);
  useEffect(() => {
    const handler = (e) => {
      if (e.detail && e.detail.route) setRoute(e.detail.route);
    };
    window.addEventListener("__nav", handler);
    return () => window.removeEventListener("__nav", handler);
  }, []);
  const openWizard = (initial = {}) => setModal({ type: "wizard", initial });
  const openRental = (rental) => setModal({ type: "rental", rental });
  const openSettlement = (rental) => setModal({ type: "settlement", rental });
  const openQuickReservation = (initial = {}) => setModal({ type: "quick-reservation", initial });
  const editReservation = (rental) => setModal({ type: "edit-reservation", rental });
  const openKiosk = (step, onComplete, state) => setKiosk({ step, onComplete, state });
  const closeKiosk = () => setKiosk(null);
  const closeModal = () => setModal(null);
  return /* @__PURE__ */ React.createElement("div", { className: "stage" }, /* @__PURE__ */ React.createElement("div", { "data-user-scale": tweaks.scale || 1, style: { transformOrigin: "center" } }, /* @__PURE__ */ React.createElement("div", { className: isPhone ? "frame-phone" : "frame-tablet" }, /* @__PURE__ */ React.createElement("div", { className: "screen" }, !isPhone && /* @__PURE__ */ React.createElement("div", { className: "cam" }), isPhone && /* @__PURE__ */ React.createElement("div", { className: "notch" }), /* @__PURE__ */ React.createElement("div", { className: "app" }, isPhone ? /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", height: "100%", width: "100%" } }, /* @__PURE__ */ React.createElement(PhoneHeader, { route, onMenu: () => setPhoneNav(true) }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, display: "flex", overflow: "hidden" } }, /* @__PURE__ */ React.createElement(
    MainContent,
    {
      route,
      isPhone,
      onGo: setRoute,
      openWizard,
      openRental,
      openQuickReservation
    }
  )), /* @__PURE__ */ React.createElement(BottomTabs, { route, onGo: (r) => {
    if (r === "wizard-launcher") openWizard();
    else if (r === "more") setPhoneNav(true);
    else setRoute(r);
  } }), phoneNav && /* @__PURE__ */ React.createElement(PhoneNavDrawer, { route, onGo: (r) => {
    setRoute(r);
    setPhoneNav(false);
  }, onClose: () => setPhoneNav(false) })) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(LeftRail, { route, onGo: setRoute }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" } }, /* @__PURE__ */ React.createElement(
    MainContent,
    {
      route,
      isPhone,
      onGo: setRoute,
      openWizard,
      openRental,
      openQuickReservation
    }
  ))), modal && modal.type === "wizard" && /* @__PURE__ */ React.createElement(
    Wizard,
    {
      isPhone,
      initial: modal.initial,
      onClose: () => {
        const resvId = modal.initial && modal.initial.reservationId;
        if (resvId) window.store.cancelHandover(resvId);
        closeModal();
      },
      onOpenKiosk: (step, onComplete, kioskState) => openKiosk(step, (payload) => {
        onComplete && onComplete(payload);
        closeKiosk();
      }, kioskState),
      onFinish: (finalState) => {
        try {
          let customer = finalState.customer;
          if (finalState.isNewCustomer && customer && (!customer.id || customer.id === "new1")) {
            customer = window.store.addCustomer({ ...customer, id: void 0 });
          }
          const days = window.daysBetween(finalState.startAt, finalState.endAt);
          const now = /* @__PURE__ */ new Date();
          const resvId = modal.initial && modal.initial.reservationId;
          const rentalBase = {
            customerId: customer.id,
            vehicleId: finalState.vehicle && finalState.vehicle.id,
            start: finalState.startAt,
            end: finalState.endAt,
            dailyRate: finalState.dailyRate,
            total: finalState.dailyRate * days,
            deposit: finalState.deposit,
            depositMethod: finalState.depositMethod,
            kmPerDay: finalState.kmPerDay,
            extraKmPrice: finalState.extraKmPrice,
            unlimited: finalState.unlimited,
            handoverOdo: finalState.handoverOdo,
            handoverFuel: finalState.handoverFuel,
            handoverNotes: finalState.handoverNotes,
            gdprSignature: finalState.gdprSignature,
            gdprSignedAt: finalState.gdprSignedAt,
            declarationSignature: finalState.declarationSignature,
            declarationSignedAt: finalState.declarationSignedAt,
            contractSignature: finalState.contractSignature,
            contractSignedAt: finalState.contractSignedAt,
            handoverPhotos: finalState.handoverPhotos,
            extraPhotos: finalState.extraPhotos
          };
          let rental;
          if (resvId) {
            window.store.updateRental(resvId, {
              ...rentalBase,
              handoverCompletedAt: now,
              handoverStartedAt: null
            });
            rental = window.store.findRental(resvId);
          } else {
            rental = window.store.addRental({
              ...rentalBase,
              contractNo: finalState.contractNo
              // may be undefined → store generates one
            });
          }
          window.store.addPayment({ rentalId: rental.id, amount: finalState.dailyRate * days, method: finalState.depositMethod, purpose: "rent" });
          if (finalState.deposit > 0) {
            window.store.addPayment({ rentalId: rental.id, amount: finalState.deposit, method: finalState.depositMethod, purpose: "deposit" });
          }
          window.store.updateVehicle(finalState.vehicle.id, { status: "rented" });
          window.store.archiveRentalDocuments(rental.id, { ...finalState, contractNo: rental.contractNo }).catch((err) => {
            console.error("Document persistence failed:", err);
            window.toast && window.toast.error(
              "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438\u0442\u0435 \u043D\u0435 \u0441\u0435 \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u0430\u0445\u0430 \u2014 \u043E\u0442\u0432\u043E\u0440\u0435\u0442\u0435 \u043D\u0430\u0435\u043C\u0430 \u0438 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 Share/Preview \u0437\u0430 \u0434\u0430 \u0433\u0438 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u0442\u0435 \u043D\u0430\u043D\u043E\u0432\u043E",
              { title: "\u0413\u0440\u0435\u0448\u043A\u0430 \u043F\u0440\u0438 \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u0430\u043D\u0435", duration: 6e3 }
            );
          });
          window.toast && window.toast.success(
            "\u041D\u0430\u0435\u043C " + rental.contractNo + " \u0435 \u0430\u043A\u0442\u0438\u0432\u0435\u043D. \u041A\u043B\u0438\u0435\u043D\u0442: " + customer.name + ".",
            { title: "\u041D\u0430\u0435\u043C\u044A\u0442 \u0435 \u0444\u0438\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D", duration: 4200 }
          );
        } catch (err) {
          console.error(err);
          window.toast && window.toast.error("\u0413\u0440\u0435\u0448\u043A\u0430 \u043F\u0440\u0438 \u0444\u0438\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u0435: " + (err && err.message || err));
        }
        closeModal();
      }
    }
  ), modal && modal.type === "rental" && /* @__PURE__ */ React.createElement(
    RentalDetail,
    {
      rental: modal.rental,
      isPhone,
      onClose: closeModal,
      onOpenSettlement: () => openSettlement(modal.rental),
      onEditReservation: () => editReservation(modal.rental),
      onStartHandover: () => {
        window.store.startHandover(modal.rental.id);
        const r = modal.rental;
        const linkedCustomer = r.customerId ? window.store.findCustomer(r.customerId) : null;
        openWizard({
          reservationId: r.id,
          contractNo: r.contractNo,
          vehicle: window.store.findVehicle(r.vehicleId),
          date: r.start,
          startAt: r.start,
          endAt: r.end,
          customer: linkedCustomer || null,
          // Anonymous reservation → pre-fill search + new
          // customer form with the name/phone the operator
          // captured on the phone.
          reservationName: r.reservationName || null,
          reservationPhone: r.reservationPhone || null,
          reservationNote: r.reservationNote || null,
          dailyRate: r.dailyRate || (window.store.findVehicle(r.vehicleId) || {}).dailyRate,
          kmPerDay: r.kmPerDay,
          extraKmPrice: r.extraKmPrice,
          agreedPrice: r.agreedPrice
        });
      }
    }
  ), modal && modal.type === "quick-reservation" && /* @__PURE__ */ React.createElement(
    QuickReservationPanel,
    {
      initial: modal.initial,
      onClose: closeModal
    }
  ), modal && modal.type === "edit-reservation" && /* @__PURE__ */ React.createElement(
    QuickReservationPanel,
    {
      mode: "edit",
      rental: modal.rental,
      onClose: closeModal,
      onStartHandoverNow: (r) => {
        closeModal();
        setTimeout(() => {
          window.store.startHandover(r.id);
          const linkedCustomer = r.customerId ? window.store.findCustomer(r.customerId) : null;
          openWizard({
            reservationId: r.id,
            contractNo: r.contractNo,
            vehicle: window.store.findVehicle(r.vehicleId),
            date: r.start,
            startAt: r.start,
            endAt: r.end,
            customer: linkedCustomer || null,
            reservationName: r.reservationName || null,
            reservationPhone: r.reservationPhone || null,
            reservationNote: r.reservationNote || null,
            dailyRate: r.dailyRate,
            kmPerDay: r.kmPerDay,
            extraKmPrice: r.extraKmPrice,
            agreedPrice: r.agreedPrice
          });
        }, 100);
      }
    }
  ), modal && modal.type === "settlement" && /* @__PURE__ */ React.createElement(
    SettlementScreen,
    {
      rental: modal.rental,
      isPhone,
      onClose: closeModal,
      onFinalize: closeModal,
      onOpenKiosk: (step, onComplete, kioskState) => openKiosk(step, (payload) => {
        onComplete && onComplete(payload);
        closeKiosk();
      }, kioskState)
    }
  ), kiosk && /* @__PURE__ */ React.createElement(
    KioskMode,
    {
      step: kiosk.step,
      state: kiosk.state,
      onComplete: kiosk.onComplete,
      onCancel: closeKiosk
    }
  ))))), /* @__PURE__ */ React.createElement(TweaksPanel, { title: "Tweaks" }, /* @__PURE__ */ React.createElement(TweakSection, { label: "Device frame" }, /* @__PURE__ */ React.createElement(
    TweakRadio,
    {
      label: "Frame",
      value: tweaks.device,
      onChange: (v) => setTweaks({ device: v }),
      options: [
        { value: "tablet", label: "Tablet" },
        { value: "phone", label: "Phone" }
      ]
    }
  )), /* @__PURE__ */ React.createElement(TweakSuggestionBar, { suggestions: [
    "Show the rental wizard on phone",
    "Show the customer-facing GDPR kiosk screen",
    "Design the return settlement for the electric van",
    "Show the damage register with a real van diagram"
  ] })));
}
var TWEAK_DEFAULTS = (
  /*EDITMODE-BEGIN*/
  {
    "device": "tablet",
    "scale": 1
  }
);
function PhoneHeader({ route, onMenu }) {
  const item = [...NAV_ITEMS, ...[
    { id: "damage", label: "Damage", icon: "warn" },
    { id: "vouchers", label: "Vouchers", icon: "voucher" },
    { id: "reports", label: "Reports", icon: "chart" },
    { id: "settings", label: "Settings", icon: "cog" },
    { id: "notifications", label: "Notifications", icon: "bell" }
  ]].find((x) => x.id === route) || { label: "banicharka.bg", icon: "dashboard" };
  return /* @__PURE__ */ React.createElement("div", { style: {
    height: 60,
    padding: "0 12px",
    display: "flex",
    alignItems: "center",
    gap: 8,
    borderBottom: `1px solid ${T.border}`,
    background: T.bg1,
    flexShrink: 0,
    marginTop: 26
    // room for notch
  } }, /* @__PURE__ */ React.createElement(IconBtn, { icon: "menu", onClick: onMenu }), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 15, fontWeight: 700, letterSpacing: -0.2 } }, item.label)), /* @__PURE__ */ React.createElement(IconBtn, { icon: "bell", title: "Notifications", onClick: () => {
    window.dispatchEvent(new CustomEvent("__nav", { detail: { route: "notifications" } }));
  } }), /* @__PURE__ */ React.createElement("div", { style: {
    width: 30,
    height: 30,
    borderRadius: 999,
    background: T.accent,
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: 11
  } }, (() => {
    const name = window.store && window.store.operatorProfile && window.store.operatorProfile().name || "\u041D\u041C";
    return name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "\u041D\u041C";
  })()));
}
function PhoneNavDrawer({ route, onGo, onClose }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    inset: 0,
    zIndex: 200,
    display: "flex"
  } }, /* @__PURE__ */ React.createElement("div", { onClick: onClose, style: { flex: 1, background: "rgba(0,0,0,0.6)" } }), /* @__PURE__ */ React.createElement("div", { style: {
    width: 260,
    background: T.bg1,
    borderLeft: `1px solid ${T.border}`,
    padding: 12,
    display: "flex",
    flexDirection: "column"
  } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, padding: "4px 8px 20px" } }, /* @__PURE__ */ React.createElement(BrandMark, { size: 32 }), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 800, fontSize: 15 } }, "banicharka.bg"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10.5, color: T.text2, letterSpacing: 0.4, textTransform: "uppercase" } }, "Rental Ops"))), [
    ...NAV_ITEMS,
    { id: "damage", label: "Damage", icon: "warn" },
    { id: "vouchers", label: "Vouchers", icon: "voucher" },
    { id: "reports", label: "Reports", icon: "chart" },
    { id: "notifications", label: "Notifications", icon: "bell" },
    { id: "settings", label: "Settings", icon: "cog" }
  ].map((it) => /* @__PURE__ */ React.createElement("button", { key: it.id, onClick: () => onGo(it.id), style: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "10px 12px",
    borderRadius: 10,
    background: route === it.id ? T.accentTint : "transparent",
    color: route === it.id ? T.text0 : T.text1,
    fontWeight: 600,
    fontSize: 14,
    textAlign: "left",
    marginBottom: 2
  } }, /* @__PURE__ */ React.createElement(Icon, { name: it.icon, size: 18, color: route === it.id ? T.accent : "currentColor" }), it.label))));
}
function MainContent({ route, isPhone, onGo, openWizard, openRental, openQuickReservation }) {
  const wrap = (child) => /* @__PURE__ */ React.createElement("div", { style: { flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" } }, child);
  switch (route) {
    case "dashboard":
      return wrap(/* @__PURE__ */ React.createElement(Dashboard, { isPhone, onGo, onOpenRental: openRental, onNewRental: () => openWizard() }));
    case "calendar":
      return wrap(/* @__PURE__ */ React.createElement(
        CalendarScreen,
        {
          isPhone,
          onGo,
          onOpenRental: openRental,
          onNewRental: (initial) => {
            const today = window.TODAY || /* @__PURE__ */ new Date();
            const todayY = today.getFullYear(), todayM = today.getMonth(), todayD = today.getDate();
            const tapped = initial && initial.date;
            const isToday = tapped ? tapped.getFullYear() === todayY && tapped.getMonth() === todayM && tapped.getDate() === todayD : true;
            if (isToday) {
              const vehicle = initial && initial.vehicleId ? window.store.findVehicle(initial.vehicleId) : null;
              openWizard({ ...initial, vehicle });
            } else {
              openQuickReservation(initial);
            }
          }
        }
      ));
    case "fleet":
      return wrap(/* @__PURE__ */ React.createElement(FleetScreen, { isPhone }));
    case "customers":
      return wrap(/* @__PURE__ */ React.createElement(CustomersScreen, { isPhone }));
    case "payments":
      return wrap(/* @__PURE__ */ React.createElement(PaymentsScreen, { isPhone }));
    case "journal":
      return wrap(/* @__PURE__ */ React.createElement(JournalScreen, { isPhone, onOpenRental: openRental }));
    case "settings":
      return wrap(/* @__PURE__ */ React.createElement(SettingsScreen, { isPhone }));
    case "damage":
      return wrap(/* @__PURE__ */ React.createElement(DamageScreen, { isPhone }));
    case "vouchers":
      return wrap(/* @__PURE__ */ React.createElement(VouchersScreen, { isPhone }));
    case "reports":
      return wrap(/* @__PURE__ */ React.createElement(ReportsScreen, { isPhone }));
    case "notifications":
      return wrap(/* @__PURE__ */ React.createElement(NotificationsScreen, { isPhone }));
    default:
      return wrap(/* @__PURE__ */ React.createElement(Dashboard, { isPhone, onGo, onOpenRental: openRental, onNewRental: () => openWizard() }));
  }
}
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
    if (window.store && window.store.logClientError) {
      window.store.logClientError({
        message: error && error.message || String(error),
        context: "ErrorBoundary",
        severity: "error",
        stack: error && error.stack || errorInfo && errorInfo.componentStack
      });
    }
    this.setState({ errorInfo });
  }
  render() {
    if (this.state.error) {
      const err = this.state.error;
      return /* @__PURE__ */ React.createElement("div", { style: {
        position: "fixed",
        inset: 0,
        background: "#0B0E14",
        color: "#E7EAF0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        fontFamily: '"Noto Sans", -apple-system, system-ui, sans-serif',
        zIndex: 99999
      } }, /* @__PURE__ */ React.createElement("div", { style: {
        maxWidth: 520,
        background: "#12161F",
        border: "1px solid rgba(239,68,68,0.35)",
        borderRadius: 14,
        padding: 28,
        textAlign: "center"
      } }, /* @__PURE__ */ React.createElement("div", { style: {
        width: 56,
        height: 56,
        borderRadius: 14,
        background: "rgba(239,68,68,0.15)",
        margin: "0 auto 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 28
      } }, "\u26A0"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 20, fontWeight: 700, marginBottom: 8 } }, "\u0412\u044A\u0437\u043D\u0438\u043A\u043D\u0430 \u0433\u0440\u0435\u0448\u043A\u0430"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, color: "#9AA3B2", lineHeight: 1.55, marginBottom: 18 } }, "\u041F\u0440\u0435\u0437\u0430\u0440\u0435\u0434\u0435\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0442\u043E. \u0414\u0430\u043D\u043D\u0438\u0442\u0435 \u0441\u0430 \u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0438."), /* @__PURE__ */ React.createElement("div", { style: {
        padding: "10px 14px",
        background: "#0B0E14",
        borderRadius: 10,
        fontFamily: "ui-monospace, Menlo, monospace",
        fontSize: 11.5,
        color: "#F87171",
        marginBottom: 18,
        textAlign: "left",
        wordBreak: "break-word",
        maxHeight: 90,
        overflow: "auto"
      } }, err && err.message || String(err)), /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: () => window.location.reload(),
          style: {
            background: "#1A5CE6",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "12px 22px",
            fontSize: 14,
            fontWeight: 600,
            cursor: "pointer",
            width: "100%"
          }
        },
        "\u041F\u0440\u0435\u0437\u0430\u0440\u0435\u0434\u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0442\u043E"
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: () => this.setState({ error: null, errorInfo: null }),
          style: {
            background: "transparent",
            color: "#9AA3B2",
            border: "none",
            marginTop: 10,
            fontSize: 12,
            cursor: "pointer",
            padding: 6
          }
        },
        "\u041E\u043F\u0438\u0442\u0430\u0439 \u043F\u0430\u043A \u0431\u0435\u0437 reload"
      )));
    }
    return this.props.children;
  }
}
ReactDOM.createRoot(document.getElementById("root")).render(
  /* @__PURE__ */ React.createElement(ErrorBoundary, null, /* @__PURE__ */ React.createElement(ToastProvider, null, /* @__PURE__ */ React.createElement(AuthGate, null, /* @__PURE__ */ React.createElement(App, null))))
);
